{
 "viewBox": "0 0 1622.67 1031.47",
 "territories": {
  "sivas": {
   "paths": [
    "m1003.48,308.04c-.99,2.86-4.51,4.07-3.41,7.93,1.1,3.85-2.42,9.91-2.64,12.66-.22,2.75-1.43,6.45.11,9.66,1.54,3.22,4.29,6.41,2.86,7.62-1.43,1.21-3.19,3.75-2.75,6.94s1.76,9.47.33,10.57c-.32.25-.87.73-1.57,1.34-2.43,2.11-6.68,5.7-9.33,5.7-3.41,0-9.8.29-13.54,2.18-3.75,1.9-6.06,4.54-9.03,4.32-2.97-.22-8.81-.66-8.37,2.42.44,3.08.55,10.08-2.04,11.86-2.58,1.79-9.52,8.84-12.6,10.49-.11.06-.21.11-.31.17,0,0-5.3.93-7.42.93s-5.4.61-6.83-.61c-1.43-1.21-6-1.76-8.06-1.45-2.07.3-7.23.31-8.92,3.95-1.69,3.63-2.11,9.66-4.38,10.94-2.27,1.28-4.46,5.45-6.56,3.3-2.11-2.15-3.94-7.35-6.43-7.85-2.49-.49-9.3,1.66-11.32,5.78-2.03,4.13-4.87,10.33-5.91,11.89-1.03,1.57-13.46,11.56-15.19,12.55-1.73,1-5.28,2.65-5.61,4.3-.33,1.65,1.48,10.4.57,11.39-.9.99-2.83,2.26-4.46,1.52-1.62-.75-7.92-3-12.33-3.44-4.4-.44-6.11-.33-6.79-.03-.69.3-5.32,5.17-5.89,5.7-.58.52-3.8.99-4.35,1.04-.55.06-4.16.21-5.6-.16-1.45-.38-2.6,1.73-2.73,3.26-.12,1.53,2.52,6.07,1.03,7.97-1.48,1.89-4.12,4.7-2.14,10.56h0c-2.68.34-7.4.56-9.75,1.1-2.29.54-6.17,1.56-8.19,2.1.18-1.91-2.62-6.73-4.52-10.38-2.15-4.13,2.31-10.9,1.65-13.87-.66-2.97-6.77-10.4-10.57-14.04-3.8-3.63-.16-9.24,3.14-13.61,3.3-4.36,9.91-14.63,8.09-18.33-1.82-3.7-3.74-8.74-2.81-11.54.94-2.81.43-3.83-3.74-3.86-4.17-.03-4.84-5.12-3.52-7.65,1.25-2.39-.21-9.93-.38-10.77,5.78-.01,9.18-6.3,12.05-7.72,3.37-1.68,10.35-5.62,9.69-8.7-.66-3.08.22-3.63-.67-7.49-.88-3.85-2.31-7.59.22-10.02,2.54-2.42-6.49-8.91-8.36-12.55-1.87-3.63-4.3-6.27-7.71-8.25-3.41-1.98-6.27-4.19-11.45-6.72-5.17-2.53-3.74-7.15-3.63-11.04.11-3.89,2.75-6.9,1.1-10.16-1.65-3.25,1.21-4.78-3.85-9.5-.3-.28-.65-.56-1.05-.83,14.57-2.7,8.53-13.5,7.1-17.9-1.43-4.4-4.29-8.15-2.64-13.98.74-2.63.42-5.35-.92-8.11.27-.04.85-.13,1.63-.28.16-.03.34-.06.53-.1.17-.03.35-.07.54-.11.14-.03.28-.06.43-.1.17-.03.35-.08.53-.12.18-.04.36-.08.54-.13.09-.02.18-.05.27-.07.55-.14,1.12-.3,1.69-.48.48-.15.95-.31,1.4-.49.37-.14.73-.29,1.07-.45.17-.08.34-.16.5-.24.16-.08.32-.17.47-.26.15-.08.29-.17.43-.25.01-.01.02-.02.02-.02.14-.09.27-.18.4-.28.13-.09.25-.19.36-.3.09-.07.18-.15.26-.24.03-.03.06-.07.1-.1.07-.07.13-.15.19-.23.02-.03.04-.05.06-.08.07-.1.14-.19.19-.29.01-.01.02-.03.02-.04.01-.02.02-.04.03-.05.05-.1.1-.2.13-.3.02-.04.03-.07.04-.11.02-.04.02-.08.03-.12h0c.03-.09.04-.18.05-.27.02-.08.02-.16.02-.25,0-4.19-4.52-6.83-2.09-9.14,2.42-2.31,6.16-8.37,7.59-11.67,1.43-3.3,4.85-5.17,10.9-2.86,6.06,2.31,9.02,3.49,11.89,3.52,2.87.03,8.16,2.31,8.87,5.95.71,3.63,2.14,5.06,11.17,6.27,9.03,1.21,10.57.66,13.98,1.98,3.41,1.32,7.71,9.14,11.56,9.36,3.85.22,11.45-.44,14.75,1.65,3.31,2.09,8.37-3.3,11.01-7.26,2.64-3.97,5.62-2.1,7.16-.11,1.54,1.98,4.73,8.14,8.58,7.37,3.86-.77,7.82-2.97,9.25-2.2,1.43.77,1.76,7.05,8.7,9.03,6.94,1.98,8.26,4.68,12.11,4.54,3.85-.14,9.91-.25,13.32,2.94,3.41,3.2,4.84,5.2,8.92,5.46,4.07.27,6.89,2.76,8.4,7.95,1.51,5.2,5.47,8.61,7.56,8.28,2.09-.33,4.79-4.51,6.39-4.4,1.59.11,5.94.22,5.56-.77-.39-.99-1.27-4.31.49-4.61,1.76-.29,4.9-.92,5.53-1.87.1.45.16.85.2,1.19.22,2.09,2.86,5.62,3.74,9.58.88,3.96.88,9.36,6.5,13.76,3.43,2.69,6.16,4.85,7.53,6.77.88,1.23,1.22,2.36.83,3.47Z"
   ],
   "label": [
    886,
    350
   ],
   "bbox": [
    768,
    219.5,
    1004,
    486.5
   ],
   "geoNeighbors": [
    "adana",
    "ankara",
    "elazig",
    "erzurum",
    "kastamonu",
    "konya",
    "maras",
    "samsun",
    "trabzon"
   ],
   "poly": [
    [
     [
      1003.5,
      308
     ],
     [
      1000,
      313.5
     ],
     [
      1000.2,
      319.2
     ],
     [
      997.7,
      327.5
     ],
     [
      996.8,
      333.3
     ],
     [
      996.8,
      335.8
     ],
     [
      997.5,
      338.3
     ],
     [
      1000.8,
      344.7
     ],
     [
      1000.8,
      345.4
     ],
     [
      998.3,
      348.6
     ],
     [
      997.7,
      350.6
     ],
     [
      998.6,
      361.8
     ],
     [
      998,
      363.4
     ],
     [
      996.4,
      364.8
     ],
     [
      991.8,
      368.4
     ],
     [
      989.3,
      369.9
     ],
     [
      987.1,
      370.5
     ],
     [
      980.4,
      370.8
     ],
     [
      976.8,
      371.5
     ],
     [
      973.5,
      372.6
     ],
     [
      966.6,
      376.6
     ],
     [
      959,
      376.9
     ],
     [
      956.8,
      377.7
     ],
     [
      956.3,
      378.4
     ],
     [
      956.1,
      379.4
     ],
     [
      956.3,
      385.8
     ],
     [
      954.9,
      390.3
     ],
     [
      944.4,
      399.6
     ],
     [
      941.2,
      401.9
     ],
     [
      935.8,
      402.7
     ],
     [
      930.1,
      403
     ],
     [
      928.3,
      402.8
     ],
     [
      925.4,
      401.4
     ],
     [
      920.8,
      400.7
     ],
     [
      914.3,
      401.5
     ],
     [
      911.8,
      402.6
     ],
     [
      910,
      404.7
     ],
     [
      906.4,
      415
     ],
     [
      902.2,
      418.6
     ],
     [
      900.6,
      419.5
     ],
     [
      899,
      419
     ],
     [
      894.3,
      412.2
     ],
     [
      892.6,
      411.1
     ],
     [
      890.1,
      411.2
     ],
     [
      886.8,
      412.3
     ],
     [
      883.5,
      414.2
     ],
     [
      881.3,
      416.9
     ],
     [
      876.4,
      426.8
     ],
     [
      874.5,
      429.7
     ],
     [
      863.1,
      439.2
     ],
     [
      855.3,
      444.4
     ],
     [
      854.6,
      445.6
     ],
     [
      854.5,
      446.6
     ],
     [
      855.4,
      455.1
     ],
     [
      855.1,
      457
     ],
     [
      853.2,
      458.4
     ],
     [
      851.9,
      458.8
     ],
     [
      841.9,
      455.7
     ],
     [
      838.3,
      455.1
     ],
     [
      832.3,
      454.9
     ],
     [
      831.6,
      455.1
     ],
     [
      825.7,
      460.8
     ],
     [
      824.8,
      461.1
     ],
     [
      821.3,
      461.8
     ],
     [
      814.7,
      461.8
     ],
     [
      813.9,
      462.6
     ],
     [
      813,
      464.9
     ],
     [
      814.5,
      471
     ],
     [
      814.4,
      472.1
     ],
     [
      811.6,
      476.7
     ],
     [
      811.3,
      478
     ],
     [
      811.3,
      481.4
     ],
     [
      811.9,
      483.4
     ],
     [
      802.1,
      484.5
     ],
     [
      793.9,
      486.6
     ],
     [
      793.6,
      484.7
     ],
     [
      788.9,
      474.6
     ],
     [
      788.9,
      472.8
     ],
     [
      790.8,
      465.2
     ],
     [
      791.1,
      462.4
     ],
     [
      789.7,
      459.5
     ],
     [
      787,
      455.6
     ],
     [
      780.5,
      448.4
     ],
     [
      779.4,
      446.9
     ],
     [
      778.9,
      445.3
     ],
     [
      779.4,
      441.8
     ],
     [
      781.2,
      438.2
     ],
     [
      786.5,
      430.6
     ],
     [
      789.6,
      425.3
     ],
     [
      791.7,
      420.2
     ],
     [
      792,
      418.1
     ],
     [
      791.7,
      416.4
     ],
     [
      789.3,
      410.3
     ],
     [
      788.7,
      407.3
     ],
     [
      789.3,
      403.1
     ],
     [
      789,
      401.9
     ],
     [
      787.6,
      401.2
     ],
     [
      783.8,
      400.8
     ],
     [
      782.7,
      400.2
     ],
     [
      781.4,
      398.1
     ],
     [
      781.1,
      395.6
     ],
     [
      782.1,
      390.8
     ],
     [
      781.3,
      382.6
     ],
     [
      785.2,
      381.6
     ],
     [
      788.4,
      379.3
     ],
     [
      792.2,
      375.6
     ],
     [
      799.7,
      371
     ],
     [
      802.2,
      368.6
     ],
     [
      802.9,
      367.4
     ],
     [
      803,
      366.2
     ],
     [
      802.7,
      361
     ],
     [
      801.2,
      353.1
     ],
     [
      801.3,
      350.7
     ],
     [
      803,
      347.6
     ],
     [
      801.5,
      344.6
     ],
     [
      795.2,
      337.6
     ],
     [
      790.9,
      331.4
     ],
     [
      786.5,
      327.9
     ],
     [
      775,
      321.1
     ],
     [
      772.3,
      318.9
     ],
     [
      771.2,
      316.1
     ],
     [
      771.4,
      310.1
     ],
     [
      773,
      302.4
     ],
     [
      772.9,
      301.2
     ],
     [
      771.2,
      293.5
     ],
     [
      767.6,
      289.6
     ],
     [
      772.2,
      288.2
     ],
     [
      775.1,
      286.3
     ],
     [
      776.6,
      283.9
     ],
     [
      777.2,
      281.3
     ],
     [
      776.3,
      276
     ],
     [
      772.2,
      265.3
     ],
     [
      771.6,
      261.8
     ],
     [
      772.4,
      253.7
     ],
     [
      771.2,
      249.6
     ],
     [
      778.7,
      247.7
     ],
     [
      781.2,
      246.5
     ],
     [
      782.6,
      245.3
     ],
     [
      783.1,
      244.1
     ],
     [
      782.9,
      242.4
     ],
     [
      780.3,
      236.5
     ],
     [
      780.4,
      235.6
     ],
     [
      785.2,
      229.3
     ],
     [
      790,
      220.9
     ],
     [
      792.3,
      219.5
     ],
     [
      795.4,
      219.2
     ],
     [
      799.5,
      220.2
     ],
     [
      806.6,
      222.8
     ],
     [
      813.9,
      224.1
     ],
     [
      816.6,
      225.3
     ],
     [
      819,
      227.2
     ],
     [
      819.8,
      228.4
     ],
     [
      821,
      232
     ],
     [
      822.7,
      233.7
     ],
     [
      828.4,
      235.5
     ],
     [
      843,
      237.2
     ],
     [
      845.4,
      237.9
     ],
     [
      848.1,
      239.9
     ],
     [
      854,
      245.9
     ],
     [
      857,
      247.3
     ],
     [
      868.5,
      247.8
     ],
     [
      873,
      249.4
     ],
     [
      874.4,
      249.2
     ],
     [
      877.5,
      247.6
     ],
     [
      880.3,
      244.8
     ],
     [
      883.7,
      240.4
     ],
     [
      885.7,
      239.4
     ],
     [
      886.7,
      239.4
     ],
     [
      888.5,
      240.2
     ],
     [
      893.3,
      246.3
     ],
     [
      895.7,
      248.4
     ],
     [
      897,
      248.9
     ],
     [
      898.5,
      248.9
     ],
     [
      906.2,
      246.6
     ],
     [
      907.7,
      246.7
     ],
     [
      911,
      252.2
     ],
     [
      914.1,
      254.8
     ],
     [
      920.7,
      257.3
     ],
     [
      926,
      259.9
     ],
     [
      935.3,
      260.5
     ],
     [
      938.9,
      261.4
     ],
     [
      941.8,
      263.2
     ],
     [
      946,
      267.1
     ],
     [
      948.1,
      268.2
     ],
     [
      953.6,
      269.3
     ],
     [
      955.9,
      270.8
     ],
     [
      957.8,
      273.2
     ],
     [
      960.7,
      280.2
     ],
     [
      962.7,
      282.9
     ],
     [
      965.8,
      284.9
     ],
     [
      966.7,
      284.9
     ],
     [
      968.4,
      284.1
     ],
     [
      972.5,
      280.7
     ],
     [
      976.6,
      280.5
     ],
     [
      978.6,
      280.1
     ],
     [
      978.1,
      277.2
     ],
     [
      978.6,
      275.4
     ],
     [
      982.3,
      274.5
     ],
     [
      984.7,
      273.3
     ],
     [
      985.4,
      276.3
     ],
     [
      988.6,
      284
     ],
     [
      990.1,
      290.8
     ],
     [
      991.9,
      294.4
     ],
     [
      993.3,
      296.1
     ],
     [
      999.7,
      301.5
     ],
     [
      1002.6,
      304.6
     ],
     [
      1003.5,
      306.3
     ],
     [
      1003.5,
      308
     ]
    ]
   ]
  },
  "baghdad": {
   "paths": [
    "m1530.17,947.35s-2.31,7.16-14.75,0c-12.44-7.15-14.53-1.65-17.4-.55-.53.2-1.18.23-1.95.11-3.39-.49-9.22-3.65-18.19-6.16-11.01-3.09-20.04,4.18-21.8,6.38s-7.71,16.96-7.71,16.96l-7.04,14.31s-1.48,2.07-3.05,4.28c-1.62,2.29-3.34,4.74-3.56,5.19-.31.63-5.3,6.92-8.16,10.51-1.16,1.46-1.97,2.48-1.97,2.48l-9.91,2.42-86.97-7.71-136.84-114.88-88.43-51.19-49.79-9.97-12.47-2.5,5.7-3.47-1.88-5.23-1.43-3.99-10.67,2.6-2.95-10.47,5.57-.78-15.64-54.13c.16-.1.31-.19.46-.29.86-.55,1.71-1.1,2.55-1.63,3.59-2.3,7.01-4.49,10.21-6.53.26-.16.5-.32.75-.48,6.44-4.12,11.94-7.63,16.03-10.23.35-.22.69-.44,1.02-.65,1.05-.67,1.99-1.27,2.82-1.79.19-.13.38-.25.57-.36,1.83-1.16,3-1.9,3.38-2.12,4.83-2.86,55.81-33.91,57.46-34.9,1.66-.99,18.2-5.71,18.9-6.08.7-.37,1.49-1.78,1.9-2.77.41-.99,9.86-19.5,10.47-20.38.01-.01.02-.03.03-.06.02-.06.04-.14.05-.24.07-.43.13-1.26.18-2.37.01-.28.02-.58.03-.89.01-.16.01-.33.02-.5,0-.32.02-.67.03-1.02,8.01-3.18,16.33-7.47,25.48-11.82,7.25-3.06,31.03,1.54,35.92,1.02,18.47-8.55,31.73-21.39,50.77-23.75,72.11,19.02,68.41-7.94,108.87-38.81,3-.31,7.92-.16,13.12,6.28,6.49,8.03,12.11,1.87,23.34,3.52,11.22,1.65,5.17,5.95,2.75,7.27-2.42,1.32-7.49,3.19-9.58,8.14-2.09,4.96,4.18,12.55,7.6,22.35,3.41,9.8-8.04,10.35-11.01,9.8-2.98-.55-2.98,8.81-4.85,11.23-1.87,2.42-4.65,4.02-6.05,5.01-1.41.99-4.54,5.37-2.97,7.18,1.56,1.82,3.88,10.24,3.88,11.23s-5.6-.72-6.84-.49c-1.24.22-3.09-2.27-3.84-2.56-.74-.29-1.34,1.17-1.15,3.71.18,2.54.02,2.01-1.96,3.88-1.98,1.87.22,6.28,3.19,8.04,2.97,1.76,1.98,9.47,1.1,12.11-.88,2.64-4.07,6.5-5.39,9.25-1.33,2.75,2.31,3.19,7.15,11.56,4.85,8.36,12.33,11.89,16.08,13.76,3.74,1.87,10.23,15.96,14.03,20.75,3.8,4.79-1.24,8.97-2.01,9.39-.77.41-4.04-.77-4.18.77-.14,1.54,2.64,1.98,3.94,2.42,1.29.44,1.04,2.31.79,3-.24.69-2.47.58-2.58,1.87-.11,1.29,1.87,1.62,2.67,1.9.79.27,5.56.08,9.3.19,3.74.11,8.34,1.93,10.65,4.12,2.31,2.19,8.26,4.7,11.93,8.63,3.68,3.92,14.86,13.99,18.04,16.72,3.18,2.72,6.53,1.77,7.85,1.44,1.32-.33,2.18-1.44,3.96-1.36,1.78.08,4.43,2.49,5.39,3.26.97.77,1.88,2.89,1.52,4.21-.36,1.32-.99,1.4.85,3.08,1.85,1.68,1.96,3.72,2.62,4.46.66.75,2.45,1.43,1.81,2.48-.63,1.04-2.14,1.9-1.26,3.8.88,1.9,5.5,1.95,5.38,2.57-.13.62,3.3,4.62,3.55,6.32.25,1.69,4.75,6.44,6.89,9.7,2.15,3.26.5,5.82.5,5.82l-9.25,17.98-.74,25,17.58.04s-.31,31.91.13,32.04c.44.12,8.79-.09,8.83,3.63.04,3.71,1.41,4.79,2.89,4.37,1.49-.41,3.68.83,4.17,1.9.5,1.08,5.33,3.8,5,5.99-.65,4.28.2,4.55.64,6.32.44,1.76,2.43,6.49,3.86,7.04,1.43.55,4.07,1.32,4.07,1.32Z"
   ],
   "label": [
    1275,
    770
   ],
   "bbox": [
    1019.5,
    575,
    1530.5,
    1003
   ],
   "geoNeighbors": [
    "aleppo",
    "mosul"
   ],
   "poly": [
    [
     [
      1530.2,
      947.4
     ],
     [
      1528.8,
      949.2
     ],
     [
      1527.5,
      950
     ],
     [
      1525.6,
      950.5
     ],
     [
      1523,
      950.4
     ],
     [
      1519.6,
      949.4
     ],
     [
      1511.2,
      945.2
     ],
     [
      1507.9,
      944.1
     ],
     [
      1505.2,
      943.7
     ],
     [
      1503.1,
      944
     ],
     [
      1498,
      946.8
     ],
     [
      1496.1,
      946.9
     ],
     [
      1477.9,
      940.8
     ],
     [
      1473.9,
      940
     ],
     [
      1470.1,
      940.1
     ],
     [
      1466.6,
      940.8
     ],
     [
      1463.5,
      942
     ],
     [
      1458.7,
      944.8
     ],
     [
      1456.1,
      947.1
     ],
     [
      1455.2,
      948.5
     ],
     [
      1448.4,
      964.1
     ],
     [
      1437.7,
      985.5
     ],
     [
      1438.5,
      982.4
     ],
     [
      1433.7,
      989.3
     ],
     [
      1424.6,
      1000.9
     ],
     [
      1414.7,
      1003.3
     ],
     [
      1327.7,
      995.6
     ],
     [
      1190.9,
      880.7
     ],
     [
      1102.4,
      829.5
     ],
     [
      1040.2,
      817
     ],
     [
      1045.9,
      813.6
     ],
     [
      1042.6,
      804.3
     ],
     [
      1031.9,
      806.9
     ],
     [
      1028.9,
      796.5
     ],
     [
      1034.5,
      795.7
     ],
     [
      1018.9,
      741.6
     ],
     [
      1056.2,
      717.7
     ],
     [
      1114.1,
      682.6
     ],
     [
      1133,
      676.5
     ],
     [
      1134.1,
      675.3
     ],
     [
      1145.4,
      653.3
     ],
     [
      1145.7,
      648.3
     ],
     [
      1171.2,
      636.5
     ],
     [
      1174.6,
      635.6
     ],
     [
      1179.2,
      635.4
     ],
     [
      1207.1,
      637.5
     ],
     [
      1213.8,
      634.1
     ],
     [
      1238.3,
      620
     ],
     [
      1244.5,
      617.2
     ],
     [
      1251,
      615.1
     ],
     [
      1257.9,
      613.7
     ],
     [
      1276.3,
      617.9
     ],
     [
      1291.3,
      619.8
     ],
     [
      1303.4,
      619.8
     ],
     [
      1313.4,
      617.9
     ],
     [
      1319.1,
      615.8
     ],
     [
      1324.2,
      613
     ],
     [
      1329,
      609.7
     ],
     [
      1338.1,
      601.4
     ],
     [
      1353.4,
      586.2
     ],
     [
      1366.8,
      574.9
     ],
     [
      1369.4,
      574.9
     ],
     [
      1372.5,
      575.5
     ],
     [
      1374.3,
      576.3
     ],
     [
      1378,
      579.1
     ],
     [
      1382.3,
      583.6
     ],
     [
      1384.7,
      584.9
     ],
     [
      1387.2,
      585.4
     ],
     [
      1389.8,
      585.3
     ],
     [
      1399.3,
      584.4
     ],
     [
      1403.2,
      584.7
     ],
     [
      1407.9,
      585.9
     ],
     [
      1409.7,
      587.4
     ],
     [
      1409.7,
      588.5
     ],
     [
      1409.1,
      589.5
     ],
     [
      1406,
      592
     ],
     [
      1401.1,
      594.7
     ],
     [
      1398.4,
      596.9
     ],
     [
      1396.4,
      600.1
     ],
     [
      1396,
      602.1
     ],
     [
      1397,
      606.8
     ],
     [
      1404,
      622.5
     ],
     [
      1404.6,
      625.7
     ],
     [
      1404.1,
      628.2
     ],
     [
      1402.8,
      630
     ],
     [
      1400.9,
      631.3
     ],
     [
      1396.5,
      632.3
     ],
     [
      1392,
      632.5
     ],
     [
      1390.6,
      634.9
     ],
     [
      1389.3,
      640.6
     ],
     [
      1388.1,
      643.5
     ],
     [
      1386.6,
      645.2
     ],
     [
      1382.1,
      648.5
     ],
     [
      1379.5,
      651.8
     ],
     [
      1378.7,
      654.9
     ],
     [
      1380.4,
      658.1
     ],
     [
      1381.7,
      661.6
     ],
     [
      1383,
      666.9
     ],
     [
      1382.1,
      667.2
     ],
     [
      1375.2,
      666.2
     ],
     [
      1372.3,
      663.9
     ],
     [
      1371.8,
      664
     ],
     [
      1371.4,
      664.7
     ],
     [
      1371,
      669.8
     ],
     [
      1369.2,
      671.5
     ],
     [
      1368.5,
      673.3
     ],
     [
      1369,
      675.5
     ],
     [
      1370.4,
      677.8
     ],
     [
      1373.3,
      680.4
     ],
     [
      1374,
      681.8
     ],
     [
      1374.4,
      685.2
     ],
     [
      1374.1,
      688.9
     ],
     [
      1373.5,
      691.6
     ],
     [
      1372.5,
      693.8
     ],
     [
      1368.1,
      700.9
     ],
     [
      1368,
      702.6
     ],
     [
      1371.9,
      707.5
     ],
     [
      1377.2,
      715.3
     ],
     [
      1379.3,
      717.8
     ],
     [
      1383.7,
      721.7
     ],
     [
      1392.9,
      727.4
     ],
     [
      1396.4,
      732.3
     ],
     [
      1406.4,
      748.7
     ],
     [
      1406.8,
      750.4
     ],
     [
      1406.6,
      751.9
     ],
     [
      1406.1,
      753.3
     ],
     [
      1404.5,
      755.3
     ],
     [
      1403.4,
      756.3
     ],
     [
      1399.8,
      756.4
     ],
     [
      1399.2,
      757.1
     ],
     [
      1399.6,
      758.1
     ],
     [
      1403.1,
      759.5
     ],
     [
      1403.8,
      760.1
     ],
     [
      1404.1,
      760.9
     ],
     [
      1403.9,
      762.5
     ],
     [
      1401.8,
      763.6
     ],
     [
      1401.3,
      764.4
     ],
     [
      1401.6,
      765.2
     ],
     [
      1404.5,
      766.4
     ],
     [
      1413.3,
      766.5
     ],
     [
      1416.2,
      766.9
     ],
     [
      1421.8,
      769
     ],
     [
      1432.8,
      776.5
     ],
     [
      1453.9,
      795.9
     ],
     [
      1456.3,
      797.4
     ],
     [
      1458.6,
      797.8
     ],
     [
      1461.8,
      797.4
     ],
     [
      1464.6,
      796.2
     ],
     [
      1465.7,
      796
     ],
     [
      1468.7,
      797.4
     ],
     [
      1471.8,
      800.1
     ],
     [
      1472.7,
      802.4
     ],
     [
      1472.3,
      804.9
     ],
     [
      1472.5,
      805.6
     ],
     [
      1474.6,
      807.9
     ],
     [
      1476.1,
      811
     ],
     [
      1478,
      812.8
     ],
     [
      1476.4,
      816.1
     ],
     [
      1476.7,
      817.3
     ],
     [
      1477.9,
      818.4
     ],
     [
      1481.9,
      819.7
     ],
     [
      1484.9,
      824.6
     ],
     [
      1486.5,
      828
     ],
     [
      1492.5,
      835.9
     ],
     [
      1493.5,
      838.2
     ],
     [
      1493.2,
      841.3
     ],
     [
      1483.7,
      859.7
     ],
     [
      1483,
      884.7
     ],
     [
      1500.6,
      884.7
     ],
     [
      1502.7,
      898.5
     ],
     [
      1503.9,
      911.2
     ],
     [
      1503.6,
      915.6
     ],
     [
      1502.9,
      917.6
     ],
     [
      1502.5,
      917.9
     ],
     [
      1501.6,
      917.8
     ],
     [
      1500.7,
      916.8
     ],
     [
      1505.3,
      917.2
     ],
     [
      1508.2,
      918.3
     ],
     [
      1509.2,
      919.2
     ],
     [
      1509.8,
      922.7
     ],
     [
      1510.4,
      924.1
     ],
     [
      1511.4,
      924.8
     ],
     [
      1513.6,
      924.8
     ],
     [
      1514.9,
      925.2
     ],
     [
      1519.4,
      929.3
     ],
     [
      1521.5,
      931.8
     ],
     [
      1521.5,
      936.8
     ],
     [
      1522.8,
      940.8
     ],
     [
      1525,
      944.9
     ],
     [
      1526.1,
      946
     ],
     [
      1530.2,
      947.4
     ]
    ]
   ]
  },
  "mosul": {
   "paths": [
    "m1366.77,574.91c-40.46,30.87-36.76,57.83-108.87,38.81-19.04,2.36-32.3,15.2-50.77,23.75-4.89.52-28.67-4.08-35.92-1.02-9.15,4.35-17.47,8.64-25.48,11.82.26-8.64.26-25.31.43-26.46.22-1.54,1.93-7.4,2.18-8.31.24-.91.41-7.18,1.07-8.01s5.23-7.18,5.23-8.39-.66-14.87-.94-15.25c-.27-.39-5.5-11.67-5.45-12.5.06-.82,1.49-18.93,1.49-18.93l5.78-10.85s18.91-3.4,20.52-4.18c1.61-.78,13.21-11.85,14.03-13.17.62-.99,12.39-14.63,18.26-21.42,1.9-.77,6.67-1.96,7.57-1.85.94.11,2.76-3.08,3.09-4.18.33-1.11,3.68-1.93,4.68-2.65.99-.71-.83-5.34,1.04-6.33,1.87-.99,7.43.17,9.58,1.32,2.15,1.16,4.57-.27,6.38-1.21,1.82-.93,9.47-.38,12.94,1.52,3.47,1.9,3.14-.99,4.95-.17,1.82.83,3.89,4.13,6.2,4.96,2.31.82,4.87-.58,6.44.49,1.57,1.08,5.14,1.24,7.46.91,2.31-.33,3.63.88,4.68.88s5.2-.22,5.44-2.28c.25-2.07.75-2.89,2.07-3.47s6.36-1.82,8.67-.91c2.31.91,5.65,4.05,6.07,5.57.41,1.53,1.24,3.18-.54,3.97-1.77.78-3.88,3.38-3.01,5.49.86,2.1,2.06,3.88,2.31,5.03.25,1.16,1.65,2.23,2.72,2.03,1.08-.21,3.31-2.11,3.14-3.55-.16-1.45.17-1.37.95-1.45.79-.08,3.63-.2,4.05-.74.41-.54,6.89-6.4,7.47-6.94.58-.53,2.23-1.57,3.38-.58,1.16,1,6.28.38,6.28.38,0,0-.62,1.36-.83,3.46-.2,2.11,2.07,4.34,3.84,5.08,1.78.75,3.55,2.73,2.89,4.01-.66,1.28.42,3.59,1.04,5.86s-1.94,1.44-3.14,5.16c-1.2,3.72,4.54,1.49,5.49,2.93.95,1.45,3.76.04,5.04,3.1,1.28,3.05.2,7.14-1.12,9.25-1.32,2.1-.66,3.75.37,4.41,1.03.66,1.2,2.03,2.31,4.83,1.12,2.81,3.64,1.24,6.65.7,3.02-.53,3.55,3.84,3.63,6.86.09,3.01-.74,3.84.38,4.99,1.11,1.16.86,3.55,1.61,4.92.74,1.36,3.48,3.84,2.27,6.97-1.21,3.14-.28,5.78,2.14,5.56.48-.04,1.11-.15,1.86-.22Z"
   ],
   "label": [
    1256,
    570
   ],
   "bbox": [
    1145.5,
    485.5,
    1366.5,
    648.5
   ],
   "geoNeighbors": [
    "aleppo",
    "baghdad",
    "van"
   ],
   "poly": [
    [
     [
      1366.8,
      574.9
     ],
     [
      1353.4,
      586.2
     ],
     [
      1338.1,
      601.4
     ],
     [
      1329,
      609.7
     ],
     [
      1324.2,
      613
     ],
     [
      1319.1,
      615.8
     ],
     [
      1313.4,
      617.9
     ],
     [
      1303.4,
      619.8
     ],
     [
      1291.3,
      619.8
     ],
     [
      1276.3,
      617.9
     ],
     [
      1257.9,
      613.7
     ],
     [
      1251,
      615.1
     ],
     [
      1244.5,
      617.2
     ],
     [
      1238.3,
      620
     ],
     [
      1213.8,
      634.1
     ],
     [
      1207.1,
      637.5
     ],
     [
      1184.5,
      635.6
     ],
     [
      1179.2,
      635.4
     ],
     [
      1172.8,
      636
     ],
     [
      1145.7,
      648.3
     ],
     [
      1146.2,
      621.8
     ],
     [
      1148.3,
      613.5
     ],
     [
      1149.2,
      606
     ],
     [
      1153.9,
      598.8
     ],
     [
      1154.6,
      597.1
     ],
     [
      1153.7,
      581.9
     ],
     [
      1148.3,
      569.4
     ],
     [
      1149.7,
      550.4
     ],
     [
      1155.5,
      539.6
     ],
     [
      1156.7,
      537.7
     ],
     [
      1159.4,
      535.2
     ],
     [
      1160.9,
      534.4
     ],
     [
      1164.1,
      533.7
     ],
     [
      1167.3,
      533.7
     ],
     [
      1176,
      535.4
     ],
     [
      1178.8,
      533.2
     ],
     [
      1189.3,
      523.1
     ],
     [
      1208.3,
      500.8
     ],
     [
      1216.7,
      498.5
     ],
     [
      1219.7,
      494
     ],
     [
      1223.7,
      492.1
     ],
     [
      1224,
      491
     ],
     [
      1223.9,
      487.1
     ],
     [
      1224.7,
      485.8
     ],
     [
      1226.7,
      485.4
     ],
     [
      1229.4,
      485.6
     ],
     [
      1235.9,
      487.5
     ],
     [
      1243,
      485.5
     ],
     [
      1250.4,
      486.3
     ],
     [
      1255.6,
      488.1
     ],
     [
      1257.5,
      487.2
     ],
     [
      1258.6,
      487.3
     ],
     [
      1263.1,
      491.2
     ],
     [
      1264.8,
      492.2
     ],
     [
      1269.9,
      492.3
     ],
     [
      1274.6,
      493.7
     ],
     [
      1280.2,
      493.6
     ],
     [
      1283.3,
      494.5
     ],
     [
      1286.4,
      494.1
     ],
     [
      1288,
      493.4
     ],
     [
      1288.5,
      492.9
     ],
     [
      1289.4,
      489.9
     ],
     [
      1290.9,
      488.7
     ],
     [
      1294.8,
      487.7
     ],
     [
      1297.4,
      487.5
     ],
     [
      1299.5,
      487.8
     ],
     [
      1303.3,
      490.4
     ],
     [
      1305.6,
      493.4
     ],
     [
      1306.1,
      495.7
     ],
     [
      1305.9,
      496.6
     ],
     [
      1303.7,
      498.3
     ],
     [
      1302.6,
      499.6
     ],
     [
      1301.9,
      501.2
     ],
     [
      1302,
      502.9
     ],
     [
      1304.7,
      508.7
     ],
     [
      1306.2,
      509.9
     ],
     [
      1307.1,
      509.9
     ],
     [
      1309.1,
      508.6
     ],
     [
      1309.9,
      507.5
     ],
     [
      1310.3,
      505.1
     ],
     [
      1315.2,
      504.2
     ],
     [
      1322.7,
      497.2
     ],
     [
      1324.2,
      496.4
     ],
     [
      1325.1,
      496.3
     ],
     [
      1327.5,
      497.1
     ],
     [
      1332.3,
      497
     ],
     [
      1331.5,
      500.5
     ],
     [
      1331.8,
      502.1
     ],
     [
      1332.7,
      503.6
     ],
     [
      1334,
      504.8
     ],
     [
      1336.6,
      506.3
     ],
     [
      1338.3,
      508.5
     ],
     [
      1338,
      510.7
     ],
     [
      1339.4,
      516.2
     ],
     [
      1336.6,
      519.4
     ],
     [
      1336,
      521.7
     ],
     [
      1337.1,
      522.8
     ],
     [
      1341.1,
      523.2
     ],
     [
      1342.6,
      524.2
     ],
     [
      1345.5,
      525.1
     ],
     [
      1346.1,
      525.7
     ],
     [
      1347.2,
      529.1
     ],
     [
      1347.1,
      531.6
     ],
     [
      1346.5,
      534
     ],
     [
      1344.9,
      537.4
     ],
     [
      1345.2,
      539.6
     ],
     [
      1346.6,
      540.9
     ],
     [
      1348.2,
      545.1
     ],
     [
      1349.3,
      546.5
     ],
     [
      1350.8,
      546.7
     ],
     [
      1355.9,
      545.8
     ],
     [
      1356.7,
      546.3
     ],
     [
      1357.8,
      547.9
     ],
     [
      1358.5,
      552.7
     ],
     [
      1358.4,
      556.8
     ],
     [
      1359.5,
      558.7
     ],
     [
      1360.5,
      562.6
     ],
     [
      1362.4,
      565.4
     ],
     [
      1363,
      567.4
     ],
     [
      1362.3,
      571.8
     ],
     [
      1362.5,
      573.6
     ],
     [
      1363.4,
      574.8
     ],
     [
      1364.9,
      575.1
     ],
     [
      1366.8,
      574.9
     ]
    ]
   ]
  },
  "aleppo": {
   "paths": [
    "m1208.34,500.8c-5.87,6.79-17.64,20.43-18.26,21.42-.83,1.32-12.42,12.39-14.03,13.17-1.61.78-20.52,4.18-20.52,4.18l-5.78,10.85s-1.43,18.11-1.5,18.93c-.04.83,5.19,12.11,5.46,12.5.28.38.94,14.04.94,15.25s-4.57,7.56-5.23,8.39c-.67.83-.83,7.1-1.07,8.01-.25.91-1.96,6.77-2.18,8.31-.17,1.16-.18,17.82-.43,26.46-.01.35-.02.7-.03,1.02-.01.17-.01.34-.02.5-.01.31-.02.61-.03.89-.05,1.11-.11,1.94-.18,2.37-.02.1-.03.18-.05.24-.01.03-.02.05-.03.06-.61.88-10.06,19.39-10.47,20.38-.41.99-1.2,2.4-1.9,2.77-.7.37-17.24,5.09-18.9,6.08-1.65.99-52.63,32.04-57.46,34.9-.38.22-1.55.96-3.38,2.12-.19.11-.38.23-.57.36-.83.52-1.77,1.12-2.82,1.79-.33.2-.67.42-1.02.65-4.09,2.6-9.59,6.11-16.03,10.23-.25.16-.5.32-.75.47h0c-3.2,2.05-6.62,4.24-10.21,6.54-.84.53-1.69,1.08-2.55,1.63-.15.1-.3.19-.46.29-41.35,26.45-101.87,65.19-102.86,65.37-1.48.28-18.05-3.58-20.2-3.47-2.14.11-4.13-3.35-5.34-4.4-1.21-1.05-6.27-5.23-7.54-5.45-1.26-.22-3.63.28-5.94.44-2.32.17-4.08-8.42-5.29-9.85-1.21-1.43-3.36-2.01-6.33-2.92-2.97-.91-2.81-4.21-2.06-5.2.74-.99,3.96-7.43,4.29-9.25.33-1.82-.91-3.8-1.48-5.86-.58-2.07-.67-5.45,0-6.69.66-1.24-.75-5.86-1.74-8.01-.99-2.15-1.65-3.8-1.32-4.18.33-.39,1.1-2.76,1.76-3.25.66-.5,2.92-2.04,4.3-2.97.81-.55.99-1.14,1.07-1.91.07-.53.09-1.14.25-1.89.38-1.82,2.2-1.49,4.34-1.9,1.12-.21,1.17-1.07.42-2.02-.68-.88-2.05-1.84-3.88-2.44-3.8-1.24.99-7.27,2.89-9.66,1.9-2.39,6.19-3.39,7.97-4.21,1.78-.83,6.75.08,9.61.41,2.87.33,1.22-1.81-2.53-3.58-3.74-1.76.55-4.78,2.09-6,1.55-1.21,2.43-4.45,3.86-3.79,1.43.66,3.85-.99,4.02-2.15.16-1.16,2.64-4.21,4.5-6.19,1.85-1.99.99-.29.7-2.23-.29-1.94-.46-5.2-.83-6.11-.37-.91-.91-1.49-1.5-2.31-.6-.83-.93-1.9-.11-3.39.83-1.49-3.38-3.32-4.15-3.67-.76-.36-1.34-2.65-1.4-3.14-.06-.5-2.99-.15-4.76-.26-1.76-.11.06-2.04,1.71-3,1.65-.97,3.22-3.47,2.01-4.27-1.21-.8-4.51-2.01-6.08-2.15-1.57-.13-4.63.97-5.54,1.16-.89.19-10.81-.02-12.39-.03h-.07c-.24-.11-.93-2.57-1.68-5.85-.01-.02-.01-.03-.01-.04h0c-1.07-4.66-2.25-10.92-2.44-14.42-.33-5.99,2.1-14.78,3.05-16.1.95-1.32-.74-7.06-.7-9.37.04-2.31-2.97-7.02-5.61-8.63-2.65-1.61-3.46-3.77-3.76-4.4-.3-.64-1.32-1.99-.11-2.51,1.21-.52,1.43-2.7,1.24-3.22s-.33-1.65.82-1.95c1.16-.31,2.18-2.56,2.62-3.31.44-.74.01-4.68-.4-5.79-.41-1.11-.25-1.98.87-2.15,1.11-.16,2.8-3.57,2.92-3.93.07-.23.2-.52.34-.81,1.14,0,2.76-.66,2.9-.77s1.46-.78,1.96-.2c.49.58-.69,3.36.19,3.69.88.33,2.31.44,3.27.39.97-.06,2.29.99,2.73,1.76s1.76,1.07,1.87-.39c.11-1.46.55-5.17,1.4-5.56.86-.38,3.61-.85,4.11-1.98.49-1.13,2.03-2.17,3.85-2.06,1.81.11,2.2-5.82,2.08-8.3-.13-2.48.9-5.91,2.72-5.41s2.44-.37,3.39-1.11c.95-.75,2.06-.75,4.29-.25,2.23.49,6.23.49,5.24-2.19-.99-2.68-.57-4-2.02-4.25-1.44-.25-3.47-3.22-3.34-4.96.12-1.73-1.24-11.68.3-15.31,1.54-3.64.56-3.06,1.51-3.84.95-.79-.25-2.77.54-3.55.78-.79,2.35-5.62,5.41-4.05,3.05,1.57,4.66,1.78,6.23,1.82s3.51.37,4.63.86c1.11.5,2.26-.04,2.93,1.33.66,1.36,2.56,1.44,2.06,2.97-.49,1.53-.12,4.13,1.02,4.13s2.32-.87,3.15-1.32c.83-.46,7.75-.72,10.39.38,2.64,1.1,5.39,1.93,7.16,1.6,1.76-.33,2.25-1.21,3.63-2.37,1.38-1.16,4.95-3.63,6.99-4.35,2.04-.71,5.34,0,6.72-.55,1.37-.55,6.88-4.29,9.74-4.57,2.86-.27,4.4-2.14,5.67-3.08,1.26-.94,4.73-2.97,8.09-3.14,3.36-.16,11.73,1.54,15.25,3.47,3.52,1.93,9.41,9.58,11.06,10.02,1.65.44,16.3-.39,20.92,1.04,4.62,1.44,19.05-.22,25.32-2.09,6.28-1.87,5.66-.66,14.41-4.13,8.77-3.46,16.86-5.94,19-8.42,2.15-2.48,4.13-4.46,8.25-5.94,4.14-1.49,12.89-3.64,16.85-5.95,3.97-2.31,14.54-1.48,19.15-.33,4.63,1.16,8.1,1.65,13.06,1.32,4.94-.33,5.94,1.98,11.72-.49,5.78-2.48,6.77-.17,14.2-2.81,7.43-2.64,13.38-6.77,15.36-8.26,1.98-1.48,6.28-1.43,7.93-.49,1.65.93,3.02,3.85,3.02,6.05s1.6,4.63,3.36,3.86c.06-.03.12-.05.19-.08Z"
   ],
   "label": [
    1034,
    660
   ],
   "bbox": [
    859.5,
    490.5,
    1208.5,
    807.5
   ],
   "geoNeighbors": [
    "baghdad",
    "diyarbakir",
    "hatay",
    "maras",
    "mosul",
    "van"
   ],
   "poly": [
    [
     [
      1208.3,
      500.8
     ],
     [
      1189.3,
      523.1
     ],
     [
      1177.1,
      534.7
     ],
     [
      1174.7,
      535.8
     ],
     [
      1155.5,
      539.6
     ],
     [
      1148,
      554.3
     ],
     [
      1147.1,
      557.8
     ],
     [
      1146.9,
      563.6
     ],
     [
      1148.5,
      570.1
     ],
     [
      1153.7,
      581.8
     ],
     [
      1154.7,
      597.1
     ],
     [
      1153.9,
      598.8
     ],
     [
      1149.2,
      606
     ],
     [
      1148.4,
      613.5
     ],
     [
      1146.2,
      621.8
     ],
     [
      1145.4,
      653.3
     ],
     [
      1134.1,
      675.3
     ],
     [
      1133,
      676.5
     ],
     [
      1114.1,
      682.6
     ],
     [
      1055.5,
      718.2
     ],
     [
      916,
      806.9
     ],
     [
      894.3,
      803
     ],
     [
      890.5,
      799.1
     ],
     [
      883.6,
      793.9
     ],
     [
      881.8,
      793.6
     ],
     [
      877,
      794
     ],
     [
      876.2,
      793.7
     ],
     [
      875.4,
      792.8
     ],
     [
      871.7,
      784.2
     ],
     [
      869.2,
      782.5
     ],
     [
      865.4,
      781.3
     ],
     [
      863.7,
      780.2
     ],
     [
      863,
      778.7
     ],
     [
      862.9,
      777.2
     ],
     [
      866.9,
      768.9
     ],
     [
      867.6,
      766.8
     ],
     [
      867.6,
      765.4
     ],
     [
      866.1,
      761
     ],
     [
      865.7,
      757.3
     ],
     [
      866.3,
      752.8
     ],
     [
      865.9,
      750.6
     ],
     [
      863.2,
      743.5
     ],
     [
      863.1,
      742.1
     ],
     [
      864.8,
      738.8
     ],
     [
      869.9,
      735
     ],
     [
      870.4,
      732.1
     ],
     [
      871,
      731.1
     ],
     [
      874.8,
      730.2
     ],
     [
      875.7,
      729.4
     ],
     [
      875.2,
      728.1
     ],
     [
      873.7,
      726.8
     ],
     [
      870.3,
      725
     ],
     [
      869.9,
      724
     ],
     [
      870.6,
      721.3
     ],
     [
      874.2,
      716
     ],
     [
      876,
      714.5
     ],
     [
      878.2,
      713.4
     ],
     [
      884,
      711.5
     ],
     [
      891.8,
      712.2
     ],
     [
      893.1,
      712.1
     ],
     [
      893,
      711.2
     ],
     [
      891.7,
      710
     ],
     [
      888.2,
      708
     ],
     [
      887.9,
      706.3
     ],
     [
      894.2,
      699
     ],
     [
      896.4,
      699
     ],
     [
      898.7,
      697.6
     ],
     [
      900.9,
      693.9
     ],
     [
      904.9,
      689.4
     ],
     [
      904.4,
      688.3
     ],
     [
      903.6,
      682.2
     ],
     [
      901.5,
      678.4
     ],
     [
      902.1,
      675.9
     ],
     [
      901.8,
      675.3
     ],
     [
      897.8,
      672.8
     ],
     [
      896.9,
      671.3
     ],
     [
      896.4,
      669.7
     ],
     [
      891.7,
      669.4
     ],
     [
      891,
      669
     ],
     [
      891.3,
      668.2
     ],
     [
      894.6,
      665.5
     ],
     [
      895.5,
      664.2
     ],
     [
      895.8,
      663
     ],
     [
      895.4,
      662.2
     ],
     [
      892.5,
      660.8
     ],
     [
      889.3,
      660
     ],
     [
      883.1,
      661.2
     ],
     [
      871.3,
      661.1
     ],
     [
      871.1,
      660.6
     ],
     [
      868.1,
      647.6
     ],
     [
      867.2,
      640.8
     ],
     [
      867.4,
      636
     ],
     [
      868.2,
      631
     ],
     [
      870.5,
      624
     ],
     [
      869.5,
      615.4
     ],
     [
      869.1,
      613.3
     ],
     [
      867.7,
      610.8
     ],
     [
      865.9,
      608.4
     ],
     [
      861.2,
      604.2
     ],
     [
      859.5,
      600.3
     ],
     [
      860.8,
      599.2
     ],
     [
      861.2,
      598.2
     ],
     [
      861.5,
      595
     ],
     [
      863,
      594.1
     ],
     [
      864.7,
      591.3
     ],
     [
      864.9,
      588.6
     ],
     [
      864.2,
      584.1
     ],
     [
      866.1,
      582.8
     ],
     [
      868.5,
      578.7
     ],
     [
      872.8,
      577.5
     ],
     [
      873.3,
      577.7
     ],
     [
      873.2,
      580.7
     ],
     [
      873.5,
      581.4
     ],
     [
      876.8,
      581.8
     ],
     [
      878.4,
      582.3
     ],
     [
      880,
      584
     ],
     [
      881.1,
      583.9
     ],
     [
      881.8,
      580
     ],
     [
      882.8,
      577.6
     ],
     [
      886.2,
      576.3
     ],
     [
      888.3,
      574.1
     ],
     [
      891.4,
      573.3
     ],
     [
      891.9,
      572.6
     ],
     [
      892.5,
      570.4
     ],
     [
      893,
      563.3
     ],
     [
      893.5,
      561.4
     ],
     [
      894.3,
      560.1
     ],
     [
      897.6,
      559.7
     ],
     [
      899,
      558.7
     ],
     [
      900.6,
      558.1
     ],
     [
      905.1,
      558.7
     ],
     [
      907.1,
      558.6
     ],
     [
      908.4,
      557.8
     ],
     [
      908.5,
      556.3
     ],
     [
      907.2,
      552.4
     ],
     [
      905.3,
      551.4
     ],
     [
      903.4,
      548.5
     ],
     [
      902.7,
      535.4
     ],
     [
      903.4,
      531.8
     ],
     [
      904.9,
      527.9
     ],
     [
      905.5,
      524.4
     ],
     [
      907.3,
      521.5
     ],
     [
      908.9,
      520.2
     ],
     [
      909.8,
      520
     ],
     [
      914.5,
      521.8
     ],
     [
      919.6,
      522.4
     ],
     [
      924.1,
      523.6
     ],
     [
      926.7,
      526.4
     ],
     [
      926.6,
      529.9
     ],
     [
      927,
      531
     ],
     [
      927.7,
      531.4
     ],
     [
      931.5,
      529.9
     ],
     [
      935.4,
      529.7
     ],
     [
      940.1,
      530.1
     ],
     [
      945.2,
      531.8
     ],
     [
      948.4,
      532.1
     ],
     [
      950.4,
      531.2
     ],
     [
      955.3,
      527.4
     ],
     [
      959.1,
      525.4
     ],
     [
      965.8,
      524.8
     ],
     [
      973,
      521
     ],
     [
      977.4,
      519.8
     ],
     [
      984.5,
      515.3
     ],
     [
      986.8,
      514.5
     ],
     [
      990.8,
      514.1
     ],
     [
      996.9,
      515
     ],
     [
      1001.1,
      516.1
     ],
     [
      1004.5,
      517.5
     ],
     [
      1007.5,
      519.8
     ],
     [
      1013.7,
      526
     ],
     [
      1015.6,
      527.5
     ],
     [
      1031.5,
      527.9
     ],
     [
      1038.7,
      529
     ],
     [
      1044.9,
      529
     ],
     [
      1059.1,
      527.2
     ],
     [
      1073.4,
      523.4
     ],
     [
      1092.6,
      515.8
     ],
     [
      1094.2,
      514.9
     ],
     [
      1098.6,
      510.6
     ],
     [
      1100.8,
      509.2
     ],
     [
      1103.5,
      508
     ],
     [
      1116.6,
      503.7
     ],
     [
      1122.1,
      501.3
     ],
     [
      1124.4,
      500.8
     ],
     [
      1129.7,
      500.6
     ],
     [
      1135.1,
      500.9
     ],
     [
      1145.9,
      502.9
     ],
     [
      1154.2,
      503
     ],
     [
      1160.7,
      503.6
     ],
     [
      1167.9,
      501.4
     ],
     [
      1173.9,
      500.9
     ],
     [
      1178.5,
      499.7
     ],
     [
      1188.2,
      495.2
     ],
     [
      1193.8,
      491.5
     ],
     [
      1195.7,
      490.6
     ],
     [
      1197.9,
      490.3
     ],
     [
      1201.8,
      491
     ],
     [
      1202.9,
      492
     ],
     [
      1204.6,
      495.3
     ],
     [
      1205.1,
      498.7
     ],
     [
      1205.8,
      500.1
     ],
     [
      1206.9,
      500.9
     ],
     [
      1208.3,
      500.8
     ]
    ]
   ]
  },
  "western-thrace": {
   "paths": [
    "m382.25,215.55c-1.38,1.49-6.48-2.09-6.55,1.54-.11.82-1.18.44-1.35,1.18.16,1.79-3.19,1.78-3.63,3.06-.25.33-3.22-.09-3.8.16-.58.25.66,1.32-.33,2.15-1.63,2.2.47,5.74-.33,8.01-2.26,3.51,2.08,4.86,1.48,6.52-2.51,1.05,1.18,3.83-.16,4.62-3.62-.24-.5,1.46-6.03,4.96-.82,1.15.15,2.9-2.12,3.6-5.65,2.48-6.36,4.06-7.47,5.7-.1.15-.11.5-.04.98-.37-1.8-1.42-5.82-3.64-7.05-2.88-1.61-7.92-1.15-9.45-1.2-1.53-.04-9.37-.45-12.59-1.4-3.22-.95-10.17-4.07-14.79-5.06-4.63-.99-5.62-1.54-6.22-5.07-.61-3.52-1.27-5.5-3.2-3.03-1.92,2.48-2.8,6.56-5.39,7.77-2.59,1.21-4.79,2.58-6.77,4.18-1.98,1.6-6.55,2.97-9.75,1.27-3.19-1.71-5.39-4.96-6.05-5.89-.66-.94-3.61-.36-5.63.22-2.02.57-6.87,3.68-7.2,5.01-.33,1.32-1.84,5.8-4.28,6.71-2.43.91-5.16,2.6-6.02,3.26-.87.66-3.27,1.03-5.04.13-1.2-.62-3.73-2.08-5.75-3.09,2.96-2.04,6.51-4.65,7.89-6.37,2.54-3.16,3.52-5.72,0-8.94-3.53-3.21-10.91-5.85-12.5-9.59-1.6-3.75-9.97-8.01-8.42-12.49.56-1.64.21-3.86-.46-6.03.16-.09.33-.2.51-.31,1.38-.83,2.53-.23,4.68-.39,2.15-.16,2.86-2.8,4.57-3.3,1.7-.49,1.92-.38,3.03-1.21,1.1-.83,2.75,1.76,4.78,1.32,2.04-.44,3.86-.99,3.86-2.64s1.92-3.85,3.47-3.74c1.54.11,2.8.05,5.28-.94,2.48-.99.99,2.53,3.85,2.26,2.87-.28,4.63-.06,6.28-.99,1.65-.94,2.09-1.77,4.4-1.88,2.31-.11,4.02,2.76,4.3,4.3.27,1.54-.22,4.13,1.37,4.29,1.6.17,2.09,1.65,4.35,1.98,2.26.33,5.92,1.85,8.15,1.64,2.23-.21,3.26-.49,6.02.87,2.77,1.36,3.35,2.23,6.2,1.9,2.85-.33,4.21-1.53,7.39-.13,3.18,1.41,4.41,2.52,6.64,1.86,2.23-.66,5.91-.95,9.05-.12,3.13.82,6.77,1.77,7.96.95,1.2-.83,1.86-.66,4.54-.87,2.69-.21,4.13.45,6.53.33,2.39-.12,9.7-1.32,11.64-2.48,1.94-1.15,3.22-3.13,2.97-5.45-.25-2.31-1.61-2.76-.29-4.58,1.32-1.82.5-7.51-1.32-8.46-1.81-.95-4.42-3.02-3.67-5.78.74-2.77,2.19-2.31,4.04-2.69,1.09-.22,6.22.09,10.25.39,0,.02,0,.04,0,.06,2.43,3.38,3.94,4.54,7.63,4.58.42,1.95,3.45,4.22,5.29,4.83-.2,3,2.55,15.15,1.83,18.58Z"
   ],
   "label": [
    298,
    224
   ],
   "bbox": [
    227,
    187.5,
    383,
    258.5
   ],
   "geoNeighbors": [
    "burgas",
    "edirne",
    "plovdiv",
    "salonica"
   ],
   "poly": [
    [
     [
      382.3,
      215.6
     ],
     [
      380.7,
      215.9
     ],
     [
      376.6,
      215.5
     ],
     [
      373.9,
      219.3
     ],
     [
      370.7,
      221.3
     ],
     [
      366.9,
      221.5
     ],
     [
      367,
      223
     ],
     [
      366,
      225.5
     ],
     [
      366.4,
      229.8
     ],
     [
      365.6,
      233.9
     ],
     [
      367.8,
      237.6
     ],
     [
      367.7,
      238.2
     ],
     [
      366.8,
      239.2
     ],
     [
      367.9,
      242.4
     ],
     [
      367.6,
      242.8
     ],
     [
      365.9,
      243
     ],
     [
      364.3,
      245.5
     ],
     [
      361.6,
      247.8
     ],
     [
      360.6,
      250.7
     ],
     [
      354,
      254.5
     ],
     [
      352,
      257.1
     ],
     [
      351.9,
      258
     ],
     [
      350.8,
      254.3
     ],
     [
      349.7,
      252.3
     ],
     [
      348.3,
      251
     ],
     [
      345.8,
      250.1
     ],
     [
      343,
      249.8
     ],
     [
      336.7,
      249.7
     ],
     [
      327.6,
      248.7
     ],
     [
      315.3,
      244.4
     ],
     [
      308.6,
      242.6
     ],
     [
      306.8,
      241.7
     ],
     [
      305.8,
      240.4
     ],
     [
      304.1,
      234.5
     ],
     [
      303.3,
      234.2
     ],
     [
      302,
      235.2
     ],
     [
      298.3,
      241.6
     ],
     [
      296.6,
      243
     ],
     [
      288,
      248.3
     ],
     [
      285.5,
      249
     ],
     [
      282.7,
      249.2
     ],
     [
      280.1,
      248.4
     ],
     [
      277.9,
      246.9
     ],
     [
      274.1,
      242.6
     ],
     [
      273.2,
      242.1
     ],
     [
      268.4,
      242.8
     ],
     [
      264.2,
      245
     ],
     [
      261.6,
      247.2
     ],
     [
      259.9,
      251.3
     ],
     [
      258.6,
      253.2
     ],
     [
      250.9,
      257.8
     ],
     [
      248.8,
      258.4
     ],
     [
      245.9,
      257.9
     ],
     [
      240.2,
      254.8
     ],
     [
      244.7,
      251.5
     ],
     [
      248,
      248.4
     ],
     [
      249.6,
      246.1
     ],
     [
      250.3,
      244
     ],
     [
      249.9,
      241.8
     ],
     [
      248,
      239.5
     ],
     [
      237.7,
      232.5
     ],
     [
      236.4,
      231.2
     ],
     [
      234.7,
      228.5
     ],
     [
      228.7,
      222.3
     ],
     [
      227,
      219.1
     ],
     [
      227.4,
      214.6
     ],
     [
      226.7,
      211.4
     ],
     [
      228.2,
      210.7
     ],
     [
      231.9,
      210.7
     ],
     [
      233.2,
      210.2
     ],
     [
      235.3,
      208.1
     ],
     [
      239.5,
      206.2
     ],
     [
      240.4,
      206.1
     ],
     [
      242.8,
      207.3
     ],
     [
      244.2,
      207.5
     ],
     [
      246.9,
      206.6
     ],
     [
      247.8,
      205.9
     ],
     [
      248.4,
      203.5
     ],
     [
      250.4,
      201.4
     ],
     [
      253.8,
      201
     ],
     [
      257.6,
      200
     ],
     [
      258.1,
      200.1
     ],
     [
      259.2,
      202
     ],
     [
      259.8,
      202.4
     ],
     [
      264.3,
      202.2
     ],
     [
      267,
      201.4
     ],
     [
      269.9,
      199.8
     ],
     [
      271.4,
      199.6
     ],
     [
      273,
      200
     ],
     [
      275.2,
      202.5
     ],
     [
      276.2,
      207.6
     ],
     [
      280,
      209.7
     ],
     [
      287.6,
      211.6
     ],
     [
      293.8,
      211.9
     ],
     [
      300,
      214.6
     ],
     [
      307.1,
      213.8
     ],
     [
      314.3,
      216.4
     ],
     [
      320,
      215.6
     ],
     [
      322.4,
      215.7
     ],
     [
      331.5,
      217.4
     ],
     [
      334.5,
      216.4
     ],
     [
      343.9,
      216.6
     ],
     [
      349.9,
      215.7
     ],
     [
      355.5,
      214.1
     ],
     [
      357.8,
      211.8
     ],
     [
      358.4,
      210.3
     ],
     [
      358.5,
      208.6
     ],
     [
      357.6,
      205.2
     ],
     [
      358.8,
      202.1
     ],
     [
      358.7,
      199.5
     ],
     [
      357.5,
      196.1
     ],
     [
      354.1,
      193.4
     ],
     [
      353.2,
      191.7
     ],
     [
      353.2,
      189.8
     ],
     [
      353.9,
      188.3
     ],
     [
      354.8,
      187.6
     ],
     [
      358.7,
      187
     ],
     [
      367.5,
      187.5
     ],
     [
      370.8,
      191.1
     ],
     [
      372.7,
      191.9
     ],
     [
      375.1,
      192.1
     ],
     [
      375.9,
      193.6
     ],
     [
      377.2,
      195.1
     ],
     [
      380.4,
      197
     ],
     [
      382.2,
      211.6
     ],
     [
      382.2,
      215.6
     ]
    ]
   ]
  },
  "salonica": {
   "paths": [
    "m263.46,298.69c-1.05.77-3.25,0-4.9-1.92-1.65-1.93-4.63-7.49-7.21-8.04-2.59-.55-7.82-2.59-9.42-4.13-1.59-1.54-5.12-.77-7.04-.16-1.93.6-6.28,2.03-4.08,5.78,2.21,3.74,2.48,4.4,5.07,5.11,2.58.72,8.47,4.3,8.86,6.06.39,1.76,1.65,5.5.28,7.1-1.38,1.6-3.25,2.2-5.07.83-1.82-1.38-6.05-6.55-6.99-8.7-.94-2.15-4.46-6.55-5.45-7.21-.99-.66-7.65-2.09-8.97-3.03-1.32-.94-3.36-1.21-4.96-.55-1.59.66-4.07,3.96-2.69,5.78,1.37,1.82,6.33,10.13,9.68,11.34,3.36,1.21,7.44,4.07,8.1,5.06.66.99.05,2.54-1.43,2.1-1.49-.45-9.2-3.64-11.29-3.8-2.09-.17-3.19-1.49-4.13-3.91-.93-2.42-3.69-8.15-3.58-11.45.11-3.3-2.09-3.52-3.74-4.13-1.65-.6-8.17-3.38-11.64-6.6-3.47-3.22-8.34-8.43-8.09-9.67.25-1.23,4.7-2.14,6.27-2.47,1.57-.33-1.32-5.7-2.14-7.1-.83-1.41-3.66-1.41-4.14-.17-.49,1.24-2.55,3.06-4.62,4.05-2.06.99-5.2,3.14-6.44,4.21-1.24,1.07-1.98,4.21-.74,6.85,1.24,2.64-.33,9.17-1.24,11.07-.91,1.9-3.63,9.33-2.56,11.97,1.08,2.64,4.54,7.02,6.52,8.34.35.23.66.56.96.96-1.86.18-3.88.12-6.59.15-6.36.08-7.67-3.6-9.62-5.1-1.95-1.51-4.53-8.01-4.8-9.2-.27-1.18-4.25,1.13-5.88,1.29-1.63.16-1.73-1.67-2.04-2.41-.18-.42-1.05-.98-1.77-1.38.54-.15.91.11,1.33-.41.64-.83,1.6-3.98.84-5.29-.76-1.3-2.89-5.69-3.97-7.59-1.07-1.9-3.63-2.23-5.59-3.31-1.95-1.07-3.57-3.88-4.52-6.15-.95-2.27-1.12-7.22-2.68-8.38-1.57-1.15-2.87-1.33-3.12-2.56-.26-1.23-1.01-2.72-1.83-4.73-.41-1-.64-2.14-.56-3.06.06-.93.42-1.64,1.21-1.75,1.56-.21,3.88-1.67,3.55-2.17-.33-.5-2.31-3.15-2.44-4.54-.04-.36-.21-1.03-.44-1.82.28-.02.5-.07.65-.18.58-.41,1.32-2.72,2.73-4.21,1.4-1.48,3.88-2.97,4.21-4.79.33-1.81,1.32-3.55,4.04-4.62,2.73-1.07,2.81-.99,3.72-1.98.91-.99,1.82-.17,3.14.82,1.32,1,2.06,0,3.38-.82,1.32-.83,5.2-.08,6.94.74,1.73.83,3.05,1.41,4.54,1.32,1.49-.08,3.96.42,7.02-.08,3.05-.5,5.61-1.73,6.44-2.97.82-1.24,3.3,1.4,4.04,1.24.75-.17,1.66-5.95,1.66-8.43s-.66-5.45,3.38-5.11c3.5.29,5.51-.21,6.85-.12.21.01.4.04.58.09,1.32.36,4.43,2.03,6.75,1.92,1.29-.06,3.04-.86,4.61-1.79,1.25-.74,2.39-1.56,3.09-2.17,1.6-1.38,4.57-.99,6.28-.99s2.58-.94,4.68-1.05c2.09-.11,5.28,1.27,7.1,1.44.27.02.51.04.73.04.15,0,.3-.01.43-.02.15-.02.3-.04.43-.06.09-.02.18-.05.26-.07.17-.05.32-.12.48-.19.16-.08.32-.16.49-.26.09-.06.19-.12.3-.18.67,2.17,1.02,4.39.46,6.03-1.55,4.48,6.82,8.74,8.42,12.49,1.59,3.74,8.97,6.38,12.5,9.59,3.52,3.22,2.54,5.78,0,8.94-1.38,1.72-4.93,4.33-7.89,6.37-.97-.49-1.83-.86-2.38-1-1.7-.41-3.55.91-5,1.82-1.44.9-3.01,2.31-3.55,3.5-.54,1.2-1.16,2.07,0,3.22,1.16,1.16,3.01,1.9,3.9,3.33.88,1.44,1.7,3.03,3.24,3.8s3.75.99,3.14,1.65c-.6.67-2.86,1.22-3.3,1.88s-1.16,3.9,1.1,5.72,3.19,3.58,6.38,3.36c3.2-.22,7.82.6,10.08,2.04,2.25,1.43,8.14,8.03,9.47,10.12,1.32,2.1,1.26,3.69.22,4.46Z"
   ],
   "label": [
    195,
    262
   ],
   "bbox": [
    126,
    210,
    264,
    314
   ],
   "geoNeighbors": [
    "kozani",
    "plovdiv",
    "western-thrace"
   ],
   "poly": [
    [
     [
      263.5,
      298.7
     ],
     [
      262.5,
      299
     ],
     [
      259.9,
      298
     ],
     [
      258.6,
      296.8
     ],
     [
      255.3,
      292.2
     ],
     [
      252.3,
      289.2
     ],
     [
      246.3,
      287
     ],
     [
      240.4,
      283.8
     ],
     [
      236.6,
      284
     ],
     [
      233.1,
      285.1
     ],
     [
      231.3,
      286.1
     ],
     [
      230.2,
      287.8
     ],
     [
      230.3,
      288.9
     ],
     [
      233.2,
      293.9
     ],
     [
      234.3,
      294.8
     ],
     [
      238.3,
      296.3
     ],
     [
      241.1,
      298
     ],
     [
      244.4,
      300.7
     ],
     [
      245.5,
      305
     ],
     [
      245.6,
      307
     ],
     [
      245,
      308.5
     ],
     [
      242.7,
      310
     ],
     [
      241.3,
      310
     ],
     [
      240,
      309.3
     ],
     [
      236.1,
      305.3
     ],
     [
      230.3,
      296.5
     ],
     [
      227.5,
      293.4
     ],
     [
      220.4,
      291.2
     ],
     [
      217.4,
      289.8
     ],
     [
      214.8,
      289.5
     ],
     [
      213.6,
      289.8
     ],
     [
      212.3,
      290.8
     ],
     [
      211.1,
      292.3
     ],
     [
      210.5,
      294
     ],
     [
      210.9,
      295.6
     ],
     [
      217.8,
      304.9
     ],
     [
      219.2,
      306.2
     ],
     [
      223.2,
      308.1
     ],
     [
      227.6,
      311
     ],
     [
      228.7,
      312
     ],
     [
      228.8,
      313.6
     ],
     [
      228.2,
      314.1
     ],
     [
      227.2,
      314.1
     ],
     [
      218.4,
      310.9
     ],
     [
      214.6,
      310
     ],
     [
      213.5,
      309.2
     ],
     [
      211.8,
      306.4
     ],
     [
      208.6,
      297.8
     ],
     [
      207.9,
      293
     ],
     [
      207,
      291.9
     ],
     [
      199.4,
      288.5
     ],
     [
      195.9,
      286.5
     ],
     [
      192.9,
      284.2
     ],
     [
      185.4,
      276.1
     ],
     [
      184.8,
      274.5
     ],
     [
      185,
      274.1
     ],
     [
      191.4,
      271.7
     ],
     [
      190.9,
      268.9
     ],
     [
      188.9,
      265
     ],
     [
      188,
      264.2
     ],
     [
      186.7,
      263.9
     ],
     [
      185.5,
      264.1
     ],
     [
      183,
      266.9
     ],
     [
      173.7,
      273.1
     ],
     [
      172.9,
      274.2
     ],
     [
      172.4,
      275.9
     ],
     [
      172.4,
      277.9
     ],
     [
      173.4,
      282.5
     ],
     [
      173.1,
      285.7
     ],
     [
      172.1,
      290.1
     ],
     [
      169.7,
      296.7
     ],
     [
      168.9,
      301.8
     ],
     [
      170.4,
      305.2
     ],
     [
      172.1,
      307.6
     ],
     [
      176.6,
      312.3
     ],
     [
      170.1,
      312.4
     ],
     [
      166.1,
      311.9
     ],
     [
      163.6,
      310.5
     ],
     [
      159.7,
      306.5
     ],
     [
      157.4,
      302.6
     ],
     [
      155.4,
      297.8
     ],
     [
      149.8,
      299.4
     ],
     [
      148.8,
      299.2
     ],
     [
      147.7,
      297
     ],
     [
      145.9,
      295.6
     ],
     [
      147.3,
      295.2
     ],
     [
      147.8,
      294.2
     ],
     [
      148.4,
      291.2
     ],
     [
      148.1,
      289.9
     ],
     [
      144.1,
      282.3
     ],
     [
      143.1,
      281.2
     ],
     [
      138.6,
      279
     ],
     [
      135.9,
      276.4
     ],
     [
      134,
      272.9
     ],
     [
      132.3,
      266
     ],
     [
      131.4,
      264.5
     ],
     [
      128.6,
      262.7
     ],
     [
      126.4,
      257.2
     ],
     [
      125.8,
      254.1
     ],
     [
      126.2,
      252.9
     ],
     [
      129.5,
      251.4
     ],
     [
      130.6,
      250.2
     ],
     [
      128.5,
      246.9
     ],
     [
      127.7,
      243.8
     ],
     [
      128.4,
      243.7
     ],
     [
      131.1,
      239.5
     ],
     [
      134.7,
      236
     ],
     [
      136.4,
      232.1
     ],
     [
      137.6,
      231
     ],
     [
      141.9,
      229
     ],
     [
      143.8,
      227.6
     ],
     [
      147.1,
      229.3
     ],
     [
      149.6,
      228.1
     ],
     [
      152.9,
      227.8
     ],
     [
      158.9,
      229.8
     ],
     [
      164,
      230.2
     ],
     [
      168.1,
      230
     ],
     [
      170.3,
      229.5
     ],
     [
      173.6,
      228
     ],
     [
      174.9,
      226.8
     ],
     [
      178.6,
      228.3
     ],
     [
      179.7,
      225
     ],
     [
      180.4,
      216.3
     ],
     [
      181.4,
      215.1
     ],
     [
      190.5,
      214.7
     ],
     [
      195.9,
      216.5
     ],
     [
      197.8,
      216.7
     ],
     [
      200,
      216.1
     ],
     [
      202.4,
      214.9
     ],
     [
      206.9,
      212
     ],
     [
      211.8,
      211.7
     ],
     [
      216.5,
      210.7
     ],
     [
      223.6,
      212.1
     ],
     [
      225.1,
      212.1
     ],
     [
      226.7,
      211.4
     ],
     [
      227.4,
      214.6
     ],
     [
      227,
      219.1
     ],
     [
      228.7,
      222.3
     ],
     [
      234.7,
      228.5
     ],
     [
      236.4,
      231.2
     ],
     [
      237.7,
      232.5
     ],
     [
      248.1,
      239.5
     ],
     [
      249.9,
      241.8
     ],
     [
      250.3,
      244
     ],
     [
      249.6,
      246.1
     ],
     [
      248.1,
      248.4
     ],
     [
      244.7,
      251.5
     ],
     [
      240.2,
      254.8
     ],
     [
      237.8,
      253.8
     ],
     [
      236.5,
      253.8
     ],
     [
      232.8,
      255.6
     ],
     [
      230.7,
      257.3
     ],
     [
      229.2,
      259.1
     ],
     [
      228.7,
      261.5
     ],
     [
      233.1,
      265.7
     ],
     [
      234.5,
      267.8
     ],
     [
      236.4,
      269.5
     ],
     [
      239.5,
      270.7
     ],
     [
      239.5,
      271.1
     ],
     [
      236.2,
      273
     ],
     [
      235.9,
      273.9
     ],
     [
      236.1,
      277.1
     ],
     [
      237.3,
      278.7
     ],
     [
      240.2,
      281.2
     ],
     [
      241.7,
      281.9
     ],
     [
      249.1,
      282.5
     ],
     [
      251.7,
      283.2
     ],
     [
      254.8,
      284.9
     ],
     [
      258.9,
      288.9
     ],
     [
      263.2,
      294.2
     ],
     [
      264.2,
      297
     ],
     [
      263.5,
      298.7
     ]
    ]
   ]
  },
  "kozani": {
   "paths": [
    "m147.27,295.2c-.42.52-.79.26-1.33.41-.31.08-.67.3-1.12.85-1.25,1.54-4.29,4.81-4.67,5.7-.38.89-3.38,3.8-3.8,5.23-.41,1.43-4.56,3.3-4.67,4.46-.11,1.15-.5,1.15.05,2.09.55.94,2.26,4.64.55,4.9-1.71.26-4.58.53-5.62.77-1.04.23-7.75-1.38-10.78-1.87-3.03-.5-6.22-1.16-8.42.55-2.21,1.71-1.99,2.15-5.62.93-3.63-1.21-7.33-1.86-8.64-1.32-1.31.55-4.09-3.72-3.39-5.74.69-2.02-.24-4.72-1.24-5.71-.65-.65-2.07-2.43-2.64-4.29-.3-.98-.36-1.99.06-2.86,1.21-2.53-1.48-6.46-2.73-8.09-1.26-1.64-2.78-5.68-4.18-6.34-.55-.26-2-.62-3.55-.96.32-1.49.71-3.42,1.04-4.54.56-1.87,1.6-3.69,3.53-4.29,1.92-.61,3.74.88,4.79-.44,1.04-1.32,1.92-3.2,3.46-4.35,1.55-1.16,2.87-7.96,1.22-10.18-1.66-2.23-3.64-5.29-2.81-7.85.82-2.56.41-3.71.41-3.71,0,0,1.91.09,4.05.14,2.55.08,5.42.12,5.69-.06.34-.23,2.17-.45,3.92-.68.79-.1,1.57-.2,2.19-.31,1.99-.33,3.97-2.64,7.52-2.81,3.55-.17,6.44,2.81,8.5,1.98,2.07-.82,2.31-1.73,4.79-2.48,1.82-.54,3.11-.42,3.89-.48.23.79.4,1.46.44,1.82.13,1.39,2.11,4.04,2.44,4.54.33.5-1.99,1.96-3.55,2.17-.79.11-1.15.82-1.21,1.75-.08.92.15,2.06.56,3.06.82,2.01,1.57,3.5,1.83,4.73.25,1.23,1.55,1.41,3.12,2.56,1.56,1.16,1.73,6.11,2.68,8.38.95,2.27,2.57,5.08,4.52,6.15,1.96,1.08,4.52,1.41,5.59,3.31,1.08,1.9,3.21,6.29,3.97,7.59.76,1.31-.2,4.46-.84,5.29Z"
   ],
   "label": [
    112,
    282
   ],
   "bbox": [
    75.5,
    244,
    148.5,
    320
   ],
   "geoNeighbors": [
    "salonica"
   ],
   "poly": [
    [
     [
      147.3,
      295.2
     ],
     [
      145.4,
      295.9
     ],
     [
      144.8,
      296.5
     ],
     [
      140.9,
      301.1
     ],
     [
      135.5,
      308.5
     ],
     [
      132.4,
      310.9
     ],
     [
      131.7,
      311.9
     ],
     [
      131.5,
      313
     ],
     [
      132.9,
      316.6
     ],
     [
      133,
      318.1
     ],
     [
      132.3,
      318.8
     ],
     [
      126,
      319.6
     ],
     [
      111.4,
      317.2
     ],
     [
      109.3,
      317.4
     ],
     [
      105.2,
      319.9
     ],
     [
      103.9,
      319.8
     ],
     [
      96.7,
      317.9
     ],
     [
      92.6,
      317.9
     ],
     [
      92,
      317.5
     ],
     [
      90.8,
      316
     ],
     [
      89.9,
      314
     ],
     [
      90,
      310.6
     ],
     [
      89.3,
      307.5
     ],
     [
      87.2,
      304.8
     ],
     [
      85.9,
      302.2
     ],
     [
      85.7,
      300.7
     ],
     [
      86.2,
      297.2
     ],
     [
      85.5,
      294.9
     ],
     [
      80.1,
      285.9
     ],
     [
      79.1,
      284.9
     ],
     [
      75.5,
      283.9
     ],
     [
      76.6,
      279.4
     ],
     [
      77.8,
      276.7
     ],
     [
      80.1,
      275.1
     ],
     [
      84,
      275.2
     ],
     [
      84.9,
      274.6
     ],
     [
      89.4,
      268.5
     ],
     [
      90.2,
      265.6
     ],
     [
      90.3,
      262.5
     ],
     [
      90.1,
      261.1
     ],
     [
      87.2,
      256.3
     ],
     [
      86.6,
      254.3
     ],
     [
      87.2,
      248.5
     ],
     [
      96.9,
      248.6
     ],
     [
      103,
      247.6
     ],
     [
      108.1,
      245.3
     ],
     [
      110.5,
      244.8
     ],
     [
      113.1,
      245.2
     ],
     [
      117.3,
      246.8
     ],
     [
      119,
      246.8
     ],
     [
      123.8,
      244.3
     ],
     [
      127.7,
      243.8
     ],
     [
      128.5,
      246.9
     ],
     [
      130.6,
      250.2
     ],
     [
      129.5,
      251.4
     ],
     [
      126.2,
      252.9
     ],
     [
      125.8,
      254.1
     ],
     [
      126.4,
      257.2
     ],
     [
      128.6,
      262.7
     ],
     [
      131.4,
      264.5
     ],
     [
      132.3,
      266
     ],
     [
      134,
      272.9
     ],
     [
      135.9,
      276.4
     ],
     [
      138.6,
      279
     ],
     [
      143.1,
      281.2
     ],
     [
      144.1,
      282.3
     ],
     [
      148.1,
      289.9
     ],
     [
      148.2,
      292.7
     ],
     [
      147.3,
      295.2
     ]
    ]
   ]
  },
  "sofia": {
   "paths": [
    "m307.38,63.62c-1.01,1.3-2.09,3.11-2.15,4.55-.04.68.15,1.28.67,1.7,1.61,1.31.78,8.39-3.14,12.55-3.92,4.16-6.89,6.22-7.58,8.72-.68,2.51-4.17,5.5-4.08,8.96.1,3.45,2.29,6.78,2.84,9.08.41,1.71,2.36,5.51,3.2,8.57-3.85.58-6.99,1.11-8.25,1.21-3.53.28-7.32-.38-10.93-2.8-3.61-2.42-10.21.76-11.31,2.8-1.1,2.04-.7,11.82-4.86,10.9-4.17-.93-6.81-.27-9.67,1.93-2.87,2.21-4.63,7.71-7.49,9.91-2.86,2.2-2.81,14.75-11.97,15.63-9.17.89-20.53,7.01-27.95,7.03-2.78.01-6.3.63-9.93,1.35-4.75.94-9.71,2.05-13.46,2.15-.27-.47-.53-.89-.76-1.22-1.82-2.59-5.89-3.42-9.09-5.23-1.16-.66-2.82-2.4-4.5-4.39-2.94-3.46-5.94-7.69-6.52-8.34-.91-1.03-1.16-2.81-.04-2.89.46-.03.97-.08,1.46-.21.7-.18,1.32-.52,1.64-1.19.53-1.16,1.98-3.23,3.59-3.23s1.77-6.02,1.86-7.43c.08-1.4-3.06-2.93-4.55-4.33-1.48-1.4-.95-4.87-.45-5.66.5-.78.17-4.54,1.53-5.24,1.36-.7,1.07-1.45.53-2.64-.53-1.2-2.83-4.79-2.64-5.26s1.52-1.24,2.64-1.76c1.13-.52,1.3-1.51,2.29-1.6.99-.08,1.43.34,2.15-.38.72-.72,2.75-.23,5.74.1s3.86-3.02,4.25-4.89c.38-1.87,2.25-4.02,4.07-5.45,1.82-1.43,4.84-4.73,6.99-6.83,2.15-2.09.69-5.89-2.7-7.29-3.38-1.4-4.13-5.53-5.45-8.26-1.32-2.72-11.64-7.51-14.28-9.16-2.64-1.65-3.55-9.17-3.72-12.39-.16-3.22-3.55-5.53-5.03-9.41-1.49-3.88.58-8.84.58-10.24s1.07-7.68,3.13-8.17c2.07-.5,3.8-.33,4.38-1.98.58-1.66,2.31-1.33,4.04-2.32,1.74-.99-.41-5.2.67-8.17.53-1.45,1.76-1.98,3.04-2.06.44-.03.89,0,1.32.06.86.12,1.63.37,2.08.6,1.32.66,8.58,5.78,9.82,7.43,1.24,1.65,3.96.16,5.04,1.4,1.07,1.24.25,3.8-2.15,4.54-2.39.74-3.96,4.38-6.69,6.44-2.72,2.07-.41,5.7,2.07,6.94,2.47,1.24,9.66,2.23,11.64,1.98s7.93-3.06,10.57-2.73,8.83.75,11.64,2.73c2.81,1.98,9.08.36,10.73.85,1.66.5,4.68,1.93,10.52,4.19,5.83,2.25,16.9,3.79,20.86,2.47,3.96-1.32,7.21-4.24,9.91-4.24s7.43,4.63,9.36,5.4c1.92.77,5.61-1.43,7.59-2.04,1.98-.6,10.96,1.38,12.86,1.3,1.78-.08,4.64-1.03,7.72,1.71-1.63,2.94-3.43,6.29-3.68,7.12-.46,1.55,1.5,5.2,0,7.13Z"
   ],
   "label": [
    235,
    92
   ],
   "bbox": [
    159.5,
    10,
    310.5,
    168
   ],
   "geoNeighbors": [
    "burgas",
    "plovdiv",
    "varna"
   ],
   "poly": [
    [
     [
      307.4,
      63.6
     ],
     [
      305.9,
      65.8
     ],
     [
      305.2,
      68.2
     ],
     [
      305.4,
      69.1
     ],
     [
      306.4,
      70.6
     ],
     [
      306.6,
      73.3
     ],
     [
      305.1,
      78.9
     ],
     [
      302.8,
      82.4
     ],
     [
      296.1,
      89.3
     ],
     [
      291.6,
      97.6
     ],
     [
      291.1,
      100.1
     ],
     [
      291.5,
      102.7
     ],
     [
      297.1,
      117.8
     ],
     [
      288.9,
      119
     ],
     [
      286.2,
      119
     ],
     [
      283.5,
      118.6
     ],
     [
      280.7,
      117.7
     ],
     [
      276.5,
      115.5
     ],
     [
      274.8,
      115.3
     ],
     [
      271.4,
      115.9
     ],
     [
      268.4,
      117.3
     ],
     [
      266.7,
      119
     ],
     [
      265.4,
      125.5
     ],
     [
      264.1,
      128.8
     ],
     [
      263.1,
      129.7
     ],
     [
      256.5,
      129.7
     ],
     [
      254.3,
      130.4
     ],
     [
      252.1,
      131.8
     ],
     [
      243.7,
      143
     ],
     [
      239.7,
      152.6
     ],
     [
      238,
      154.8
     ],
     [
      235.7,
      156.5
     ],
     [
      225.5,
      158.8
     ],
     [
      207.7,
      164.1
     ],
     [
      200.1,
      164.8
     ],
     [
      187.7,
      167.1
     ],
     [
      181.3,
      167.9
     ],
     [
      178.8,
      165
     ],
     [
      171.5,
      161.4
     ],
     [
      169.4,
      159.7
     ],
     [
      159.9,
      147.8
     ],
     [
      159.8,
      146.1
     ],
     [
      162.8,
      145.2
     ],
     [
      164.9,
      142.3
     ],
     [
      165.9,
      141.5
     ],
     [
      167.6,
      140.9
     ],
     [
      168.6,
      138
     ],
     [
      168.9,
      135.5
     ],
     [
      169,
      133.7
     ],
     [
      168.5,
      132.7
     ],
     [
      164.4,
      129.4
     ],
     [
      163.6,
      128
     ],
     [
      163.6,
      124.8
     ],
     [
      164.7,
      119.5
     ],
     [
      166.5,
      117.4
     ],
     [
      163.4,
      110.6
     ],
     [
      168.3,
      107.2
     ],
     [
      169.5,
      107.3
     ],
     [
      171.2,
      106.5
     ],
     [
      176.2,
      107
     ],
     [
      178.1,
      106.6
     ],
     [
      179.3,
      105.3
     ],
     [
      181,
      100.6
     ],
     [
      181.9,
      99.2
     ],
     [
      191.5,
      89.8
     ],
     [
      192.5,
      88
     ],
     [
      192.2,
      85.9
     ],
     [
      191,
      83.9
     ],
     [
      186.7,
      81
     ],
     [
      185.3,
      78.9
     ],
     [
      183.4,
      74.2
     ],
     [
      182.5,
      73.1
     ],
     [
      176.7,
      69.3
     ],
     [
      169.1,
      65.1
     ],
     [
      168.2,
      64.2
     ],
     [
      166.3,
      59.5
     ],
     [
      164.7,
      50.4
     ],
     [
      160.3,
      43.3
     ],
     [
      159.8,
      40.2
     ],
     [
      160.1,
      37.2
     ],
     [
      161.7,
      28.6
     ],
     [
      162.7,
      26.2
     ],
     [
      164,
      24.9
     ],
     [
      167.8,
      23.8
     ],
     [
      169.1,
      22
     ],
     [
      172.9,
      20.1
     ],
     [
      172.8,
      14.8
     ],
     [
      173.1,
      12.4
     ],
     [
      174.4,
      10.9
     ],
     [
      176.2,
      10.3
     ],
     [
      179.6,
      11
     ],
     [
      184.5,
      14.3
     ],
     [
      190.5,
      19.2
     ],
     [
      193.4,
      19.3
     ],
     [
      194.4,
      19.8
     ],
     [
      194.9,
      21
     ],
     [
      194.7,
      22.3
     ],
     [
      193.8,
      23.5
     ],
     [
      190.6,
      25.4
     ],
     [
      184.8,
      31.7
     ],
     [
      184.4,
      32.6
     ],
     [
      184.7,
      34.6
     ],
     [
      185.9,
      36.4
     ],
     [
      188.8,
      38.2
     ],
     [
      193.7,
      39.3
     ],
     [
      198.3,
      39.8
     ],
     [
      208.7,
      37
     ],
     [
      212.4,
      37.3
     ],
     [
      218.9,
      38.5
     ],
     [
      224.1,
      40.6
     ],
     [
      232.2,
      40.6
     ],
     [
      245.2,
      45.6
     ],
     [
      256.8,
      47.6
     ],
     [
      261.8,
      47.6
     ],
     [
      263.6,
      47.2
     ],
     [
      271.4,
      43.5
     ],
     [
      273.5,
      43
     ],
     [
      275.9,
      43.7
     ],
     [
      282.9,
      48.4
     ],
     [
      284.6,
      48.5
     ],
     [
      291.5,
      46.2
     ],
     [
      302.3,
      47.6
     ],
     [
      306.7,
      47.5
     ],
     [
      308.8,
      47.9
     ],
     [
      311.1,
      49.4
     ],
     [
      307.4,
      56.5
     ],
     [
      307.9,
      61.9
     ],
     [
      307.4,
      63.6
     ]
    ]
   ]
  },
  "varna": {
   "paths": [
    "m485.07,61.78c-.44,4.01-4.79,7.7-5.56,8.75-.77,1.04-.94.88-4.68-.88-3.74-1.76-10.68-.33-14.48,0-3.79.33-5.91,11.86-7.48,12.27-1.57.41-1.98,3.06-2.07,4.71-.08,1.65-.08,4.62-1.15,6.27-1.08,1.65-1.08,7.27-.74,9.58.17,1.2.24,5.6.25,9.66-4.8.06-10.75-.37-13.05-2.59-4.1-3.96-11.37-.88-15.33-1.54-3.97-.66-5.35-4.62-11.04-3.96-5.7.66-13.18,0-16.27,1.76-3.08,1.76-7.09,2.73-10.26,1.48-3.17-1.26-10.5-8.23-15.13-7.83-4.63.4-11.26,12.38-18.36,13.99-7.11,1.61-24.28,4.25-31.77,2.93-4.8-.85-13.94.34-20.81,1.37-.84-3.06-2.79-6.86-3.2-8.57-.55-2.3-2.74-5.63-2.84-9.08-.09-3.46,3.4-6.45,4.08-8.96.69-2.5,3.66-4.56,7.58-8.72,3.92-4.16,4.75-11.24,3.14-12.55-.52-.42-.71-1.02-.67-1.7.06-1.44,1.14-3.25,2.15-4.55,1.5-1.93-.46-5.58,0-7.13.25-.83,2.05-4.18,3.68-7.12.21.18.41.38.62.6,3.3,3.47,11.72,1.57,16.1.33,4.37-1.24,13.21-6.94,20.23-14.62,7.01-7.68,20.06-13.21,24.19-12.96s10.24-2.23,13.62-2.39c3.39-.17,7.02-2.48,9-3.06,1.98-.58,8.09-2.23,10.57-1.9,2.48.33,6.77,1.16,8.51,1.41,1.73.24,2.89,1.65,4.12,3.13,1.24,1.49,3.22,3.47,4.13,4.46.91.99,9.58-.16,11.07-.16s1.65-2.4,3.05-1.32c1.41,1.07,1.41,4.37,2.64,5.44,1.24,1.08,4.46.67,6.69-.16,2.23-.83,3.14-2.48,4.05-2.64.91-.17,1.73,1.73,2.06,3.96.33,2.23,1.74,6.03,3.8,8.51,2.06,2.47,12.22,5.69,15.03,6.11,2.81.41,14.6.33,14.6.33,0,0-.04.15-.1.47-.14.64-.41,1.96-.8,4.15-.57,3.3,1.27,8.7.83,12.72Z"
   ],
   "label": [
    388,
    70
   ],
   "bbox": [
    291,
    16,
    485,
    118
   ],
   "geoNeighbors": [
    "burgas",
    "plovdiv",
    "sofia"
   ],
   "poly": [
    [
     [
      485.1,
      61.8
     ],
     [
      484.1,
      64.7
     ],
     [
      482.4,
      67.3
     ],
     [
      479,
      71.1
     ],
     [
      478.3,
      71.1
     ],
     [
      473.3,
      69.1
     ],
     [
      467.6,
      68.9
     ],
     [
      460.4,
      69.7
     ],
     [
      459,
      70.3
     ],
     [
      457.8,
      71.6
     ],
     [
      453.5,
      81.3
     ],
     [
      451.9,
      82.6
     ],
     [
      451.3,
      83.8
     ],
     [
      450.6,
      89.8
     ],
     [
      449,
      94.8
     ],
     [
      448.7,
      97.4
     ],
     [
      449.2,
      112.1
     ],
     [
      441.7,
      111.7
     ],
     [
      438.4,
      110.9
     ],
     [
      434.4,
      108.4
     ],
     [
      432.5,
      107.7
     ],
     [
      428.4,
      107.5
     ],
     [
      420.8,
      108
     ],
     [
      418.2,
      107
     ],
     [
      413.3,
      104.3
     ],
     [
      411.7,
      104
     ],
     [
      396.5,
      104.9
     ],
     [
      391,
      107
     ],
     [
      388.4,
      107.7
     ],
     [
      385.7,
      107.8
     ],
     [
      383.2,
      107.3
     ],
     [
      381.8,
      106.6
     ],
     [
      372,
      100.3
     ],
     [
      368.1,
      99.5
     ],
     [
      366.3,
      100.1
     ],
     [
      364.3,
      101.6
     ],
     [
      354.9,
      110.6
     ],
     [
      352.4,
      112.4
     ],
     [
      349.7,
      113.5
     ],
     [
      334,
      116
     ],
     [
      325.1,
      116.7
     ],
     [
      313.6,
      116.1
     ],
     [
      308.3,
      116.4
     ],
     [
      297.1,
      117.8
     ],
     [
      291.5,
      102.7
     ],
     [
      291.1,
      100.1
     ],
     [
      291.6,
      97.6
     ],
     [
      296.1,
      89.3
     ],
     [
      302.8,
      82.4
     ],
     [
      305.1,
      78.9
     ],
     [
      306.6,
      73.3
     ],
     [
      306.4,
      70.6
     ],
     [
      305.4,
      69.1
     ],
     [
      305.2,
      68.2
     ],
     [
      305.9,
      65.8
     ],
     [
      307.4,
      63.6
     ],
     [
      307.9,
      61.9
     ],
     [
      307.4,
      56.5
     ],
     [
      311.1,
      49.4
     ],
     [
      313.1,
      51
     ],
     [
      317.1,
      51.9
     ],
     [
      323.9,
      51.3
     ],
     [
      329.6,
      49.6
     ],
     [
      336.9,
      45.4
     ],
     [
      342.5,
      41
     ],
     [
      350.9,
      32.9
     ],
     [
      354.2,
      30.4
     ],
     [
      361.2,
      26.2
     ],
     [
      367.7,
      23.6
     ],
     [
      370.3,
      22.9
     ],
     [
      375.6,
      22.5
     ],
     [
      388.4,
      19.9
     ],
     [
      394.8,
      17.3
     ],
     [
      399.9,
      16
     ],
     [
      405.4,
      15.4
     ],
     [
      415.1,
      17.2
     ],
     [
      422.2,
      24.4
     ],
     [
      422.8,
      24.6
     ],
     [
      433.2,
      24.2
     ],
     [
      435.4,
      22.6
     ],
     [
      436.3,
      22.9
     ],
     [
      438.9,
      28.3
     ],
     [
      440.2,
      28.9
     ],
     [
      441.9,
      29
     ],
     [
      445.6,
      28.2
     ],
     [
      449.7,
      25.5
     ],
     [
      450.3,
      25.8
     ],
     [
      450.9,
      26.6
     ],
     [
      452.2,
      31.4
     ],
     [
      454.1,
      35.9
     ],
     [
      455.5,
      38
     ],
     [
      458.3,
      39.9
     ],
     [
      462.7,
      41.8
     ],
     [
      470.5,
      44.1
     ],
     [
      485.1,
      44.4
     ],
     [
      484.2,
      49.1
     ],
     [
      484.2,
      51.9
     ],
     [
      485,
      58.6
     ],
     [
      485.1,
      61.8
     ]
    ]
   ]
  },
  "plovdiv": {
   "paths": [
    "m358.49,208.62c.25,2.32-1.03,4.3-2.97,5.45-1.94,1.16-9.25,2.36-11.64,2.48-2.4.12-3.84-.54-6.53-.33-2.68.21-3.34.04-4.54.87-1.19.82-4.83-.13-7.96-.95-3.14-.83-6.82-.54-9.05.12-2.23.66-3.46-.45-6.64-1.86-3.18-1.4-4.54-.2-7.39.13-2.85.33-3.43-.54-6.2-1.9-2.76-1.36-3.79-1.08-6.02-.87-2.23.21-5.89-1.31-8.15-1.64-2.26-.33-2.75-1.81-4.35-1.98-1.59-.16-1.1-2.75-1.37-4.29-.28-1.54-1.99-4.41-4.3-4.3-2.31.11-2.75.94-4.4,1.88-1.65.93-3.41.71-6.28.99-2.86.27-1.37-3.25-3.85-2.26-2.48.99-3.74,1.05-5.28.94-1.55-.11-3.47,2.09-3.47,3.74s-1.82,2.2-3.86,2.64c-2.03.44-3.68-2.15-4.78-1.32-1.11.83-1.33.72-3.03,1.21-1.71.5-2.42,3.14-4.57,3.3-2.15.16-3.3-.44-4.68.39-.18.11-.35.22-.51.31-.11.06-.21.12-.3.18-.17.1-.33.18-.49.26-.16.07-.31.14-.48.19-.08.03-.17.05-.26.07-.13.02-.28.04-.43.06-.13.01-.28.02-.43.02-.22,0-.46-.02-.73-.04-1.82-.17-5.01-1.55-7.1-1.44-2.1.11-2.98,1.05-4.68,1.05s-4.68-.39-6.28.99c-.7.61-1.84,1.43-3.09,2.17-1.57.93-3.32,1.73-4.61,1.79-2.32.11-5.43-1.56-6.75-1.92-.18-.05-.37-.08-.58-.09l-.33-5.47s.44-8.64.36-9.34c-.09-.7-.64-4.64-.21-5.28.43-.64,1.88-2.91,3.45-4.36,1.56-1.44-1.61-4.8-3.05-6.23-1.43-1.43-1.98-4.02-3.52-5.67-1.34-1.44-3.98-7.27-5.84-10.45,3.75-.1,8.71-1.21,13.46-2.15,3.63-.72,7.15-1.34,9.93-1.35,7.42-.02,18.78-6.14,27.95-7.03,9.16-.88,9.11-13.43,11.97-15.63,2.86-2.2,4.62-7.7,7.49-9.91,2.86-2.2,5.5-2.86,9.67-1.93,4.16.92,3.76-8.86,4.86-10.9,1.1-2.04,7.7-5.22,11.31-2.8,3.61,2.42,7.4,3.08,10.93,2.8,1.26-.1,4.4-.63,8.25-1.21.29,1.07.45,2.05.36,2.82-.36,2.97.26,11.45,2.59,13.9,2.34,2.44,5.63,7.15,4.65,10.53-.98,3.39-3.3,5.12.33,10.41,3.63,5.28,6.11,5.45,5.78,11.06-.33,5.62-2.15,7.39-.99,10.79,1.16,3.41,5.45,4.79,8.06,6.71,2.61,1.92,9.11,1.86,9.44,4.98.33,3.12-.02,6.66,3.05,8.36,3.06,1.69,8.18-1.7,11.32.49,3.14,2.2,3.9.77,7.4-.39,2.04-.68,5.38-1.18,8.54-1.03,1.24,1.89,1.64,6.13.53,7.66-1.32,1.82.04,2.27.29,4.58Z"
   ],
   "label": [
    270,
    166
   ],
   "bbox": [
    181,
    115,
    359,
    217
   ],
   "geoNeighbors": [
    "burgas",
    "salonica",
    "sofia",
    "varna",
    "western-thrace"
   ],
   "poly": [
    [
     [
      358.5,
      208.6
     ],
     [
      358.4,
      210.3
     ],
     [
      356.8,
      213.1
     ],
     [
      354.6,
      214.5
     ],
     [
      349.9,
      215.7
     ],
     [
      343.9,
      216.6
     ],
     [
      334.5,
      216.4
     ],
     [
      331.5,
      217.4
     ],
     [
      322.4,
      215.7
     ],
     [
      320,
      215.6
     ],
     [
      314.3,
      216.4
     ],
     [
      307.1,
      213.8
     ],
     [
      300,
      214.6
     ],
     [
      293.8,
      211.9
     ],
     [
      287.7,
      211.6
     ],
     [
      280,
      209.7
     ],
     [
      276.2,
      207.6
     ],
     [
      275.2,
      202.5
     ],
     [
      273,
      200
     ],
     [
      271.4,
      199.5
     ],
     [
      270,
      199.8
     ],
     [
      265.7,
      201.9
     ],
     [
      260.7,
      202.4
     ],
     [
      259.2,
      202
     ],
     [
      258.1,
      200.1
     ],
     [
      257.6,
      200
     ],
     [
      253.9,
      201
     ],
     [
      250.4,
      201.4
     ],
     [
      248.4,
      203.5
     ],
     [
      247.8,
      205.9
     ],
     [
      246.9,
      206.6
     ],
     [
      244.2,
      207.5
     ],
     [
      242.8,
      207.3
     ],
     [
      240.4,
      206.1
     ],
     [
      239.5,
      206.2
     ],
     [
      235.3,
      208.1
     ],
     [
      233.2,
      210.2
     ],
     [
      231.9,
      210.7
     ],
     [
      228.2,
      210.7
     ],
     [
      224.7,
      212.1
     ],
     [
      216.5,
      210.7
     ],
     [
      211.8,
      211.7
     ],
     [
      206.9,
      212
     ],
     [
      200,
      216.1
     ],
     [
      197.8,
      216.7
     ],
     [
      195.9,
      216.5
     ],
     [
      190.5,
      214.7
     ],
     [
      190,
      205.5
     ],
     [
      190.5,
      199.9
     ],
     [
      190.1,
      195.6
     ],
     [
      190.3,
      194.6
     ],
     [
      194.1,
      189.6
     ],
     [
      194.1,
      188.8
     ],
     [
      193.3,
      187.1
     ],
     [
      190.7,
      184
     ],
     [
      185.9,
      176.5
     ],
     [
      181.3,
      167.9
     ],
     [
      187.7,
      167.1
     ],
     [
      200.1,
      164.8
     ],
     [
      207.7,
      164.1
     ],
     [
      225.5,
      158.8
     ],
     [
      235.7,
      156.5
     ],
     [
      238,
      154.8
     ],
     [
      239.7,
      152.6
     ],
     [
      243.7,
      143
     ],
     [
      252.1,
      131.8
     ],
     [
      254.3,
      130.4
     ],
     [
      256.5,
      129.7
     ],
     [
      263.1,
      129.7
     ],
     [
      264.1,
      128.8
     ],
     [
      264.9,
      127.4
     ],
     [
      266.7,
      119
     ],
     [
      268.4,
      117.3
     ],
     [
      271.4,
      115.9
     ],
     [
      274.8,
      115.3
     ],
     [
      276.5,
      115.5
     ],
     [
      280.7,
      117.7
     ],
     [
      286.2,
      119
     ],
     [
      288.9,
      119
     ],
     [
      297.1,
      117.8
     ],
     [
      297.8,
      127.7
     ],
     [
      298.7,
      131.7
     ],
     [
      299.3,
      133.3
     ],
     [
      303.7,
      139.4
     ],
     [
      304.8,
      142.3
     ],
     [
      304.7,
      145
     ],
     [
      303.2,
      149.5
     ],
     [
      303.3,
      152
     ],
     [
      305.1,
      155.4
     ],
     [
      309.4,
      160.8
     ],
     [
      310.6,
      163.1
     ],
     [
      310.8,
      166.5
     ],
     [
      309.5,
      174.9
     ],
     [
      309.9,
      177.3
     ],
     [
      311.2,
      179.5
     ],
     [
      317.9,
      184
     ],
     [
      326.1,
      187.1
     ],
     [
      327,
      187.9
     ],
     [
      327.9,
      193.7
     ],
     [
      328.7,
      195.7
     ],
     [
      330.4,
      197.3
     ],
     [
      333,
      197.8
     ],
     [
      339.1,
      197
     ],
     [
      340.5,
      197.2
     ],
     [
      343.7,
      198.8
     ],
     [
      345.3,
      198.9
     ],
     [
      350.9,
      196.9
     ],
     [
      357.7,
      196.4
     ],
     [
      358.8,
      200.3
     ],
     [
      358.8,
      202.5
     ],
     [
      357.7,
      205.2
     ],
     [
      358.5,
      208.6
     ]
    ]
   ]
  },
  "burgas": {
   "paths": [
    "m456.94,171.54c-.9-1.82-3.45.93-7.45-.69-5.32-4.43-2.9,4.98-9.61-.09-18.27,13.72-16.87-16.62-28.51-5.94-13.45-5.2-1.79,4.31-24.33,6.77-7.85-2.16-7.35,4.18-8.2,8.95-2.54,2.44-13.16-.55-11.35,6.96-4.03-.3-9.16-.61-10.25-.39-1.85.38-3.3-.08-4.04,2.69-.75,2.76,1.86,4.83,3.67,5.78.29.15.56.43.79.8-3.16-.15-6.5.35-8.54,1.03-3.5,1.16-4.26,2.59-7.4.39-3.14-2.19-8.26,1.2-11.32-.49-3.07-1.7-2.72-5.24-3.05-8.36s-6.83-3.06-9.44-4.98c-2.61-1.92-6.9-3.3-8.06-6.71-1.16-3.4.66-5.17.99-10.79.33-5.61-2.15-5.78-5.78-11.06-3.63-5.29-1.31-7.02-.33-10.41.98-3.38-2.31-8.09-4.65-10.53-2.33-2.45-2.95-10.93-2.59-13.9.09-.77-.07-1.75-.36-2.82,6.87-1.03,16.01-2.22,20.81-1.37,7.49,1.32,24.66-1.32,31.77-2.93,7.1-1.61,13.73-13.59,18.36-13.99,4.63-.4,11.96,6.57,15.13,7.83,3.17,1.25,7.18.28,10.26-1.48,3.09-1.76,10.57-1.1,16.27-1.76,5.69-.66,7.07,3.3,11.04,3.96,3.96.66,11.23-2.42,15.33,1.54,2.3,2.22,8.25,2.65,13.05,2.59,0,3.73-.04,7.18-.09,7.65-.11.99-6.83-.55-8.15,0-1.32.55-.66,1.21-1.87,2.76-1.21,1.54-4.84,4.29-6.27,5.39-1.43,1.1-5.51,3.52-7.82,6.28-2.31,2.75,2.53,3.85,4.51,3.63,1.99-.22,6.72,1.21,7.6,1.98.88.77,1.1,0,1.54.99.44.99.66,1.87,1.65,3.19.99,1.32,1.98,1.77,2.09,3.86.11,2.09-.55,2.64.56,5.17,1.1,2.53,10.67,11.89,11.66,12.91.77.79,1.9,4.11,2.38,5.59Z"
   ],
   "label": [
    377,
    149
   ],
   "bbox": [
    297,
    99,
    457,
    199
   ],
   "geoNeighbors": [
    "edirne",
    "plovdiv",
    "sofia",
    "varna",
    "western-thrace"
   ],
   "poly": [
    [
     [
      456.9,
      171.5
     ],
     [
      456,
      170.9
     ],
     [
      450.9,
      171.3
     ],
     [
      447.8,
      169.8
     ],
     [
      446.7,
      169.7
     ],
     [
      444.5,
      171.8
     ],
     [
      443.5,
      172.3
     ],
     [
      442,
      172
     ],
     [
      439.9,
      170.8
     ],
     [
      436.7,
      172.8
     ],
     [
      433.9,
      174
     ],
     [
      431.5,
      174.4
     ],
     [
      429.4,
      174.1
     ],
     [
      425.9,
      172.1
     ],
     [
      420.7,
      165.6
     ],
     [
      418.2,
      163.2
     ],
     [
      416.8,
      162.6
     ],
     [
      415.2,
      162.6
     ],
     [
      413.4,
      163.3
     ],
     [
      411.4,
      164.8
     ],
     [
      407.4,
      163.5
     ],
     [
      405.1,
      163.3
     ],
     [
      403.7,
      164
     ],
     [
      400,
      167.9
     ],
     [
      396.5,
      169.6
     ],
     [
      390.9,
      171.1
     ],
     [
      387,
      171.6
     ],
     [
      384.5,
      171.2
     ],
     [
      382.6,
      171.4
     ],
     [
      381.2,
      172.2
     ],
     [
      380.3,
      173.5
     ],
     [
      378.8,
      180.5
     ],
     [
      377.5,
      181.2
     ],
     [
      369.6,
      182.6
     ],
     [
      368.1,
      183.6
     ],
     [
      367.4,
      185.1
     ],
     [
      367.5,
      187.5
     ],
     [
      358.7,
      187
     ],
     [
      354.8,
      187.6
     ],
     [
      353.9,
      188.3
     ],
     [
      353.2,
      189.8
     ],
     [
      353.2,
      191.7
     ],
     [
      354.1,
      193.4
     ],
     [
      357.7,
      196.4
     ],
     [
      350.9,
      196.9
     ],
     [
      345.3,
      198.9
     ],
     [
      343.7,
      198.8
     ],
     [
      340.5,
      197.2
     ],
     [
      339.1,
      197
     ],
     [
      331.6,
      197.7
     ],
     [
      330.4,
      197.3
     ],
     [
      328.7,
      195.7
     ],
     [
      327.8,
      193.7
     ],
     [
      327,
      187.9
     ],
     [
      326.1,
      187.1
     ],
     [
      317.9,
      184
     ],
     [
      313.3,
      181.2
     ],
     [
      311.2,
      179.5
     ],
     [
      309.9,
      177.3
     ],
     [
      309.5,
      174.9
     ],
     [
      310.8,
      166.5
     ],
     [
      310.6,
      163.1
     ],
     [
      309.4,
      160.8
     ],
     [
      305.1,
      155.4
     ],
     [
      303.3,
      152
     ],
     [
      303.2,
      149.5
     ],
     [
      304.7,
      145
     ],
     [
      304.7,
      142.3
     ],
     [
      303.7,
      139.4
     ],
     [
      299.3,
      133.3
     ],
     [
      298.6,
      131.7
     ],
     [
      297.8,
      127.7
     ],
     [
      297.1,
      117.8
     ],
     [
      308.3,
      116.4
     ],
     [
      313.6,
      116.1
     ],
     [
      325.1,
      116.7
     ],
     [
      334,
      116
     ],
     [
      349.7,
      113.5
     ],
     [
      352.3,
      112.4
     ],
     [
      354.9,
      110.6
     ],
     [
      364.2,
      101.6
     ],
     [
      366.2,
      100.1
     ],
     [
      368.1,
      99.5
     ],
     [
      371.9,
      100.3
     ],
     [
      381.8,
      106.6
     ],
     [
      383.2,
      107.3
     ],
     [
      385.7,
      107.8
     ],
     [
      388.4,
      107.7
     ],
     [
      391,
      107
     ],
     [
      396.5,
      104.9
     ],
     [
      411.7,
      104
     ],
     [
      413.3,
      104.3
     ],
     [
      418.2,
      107
     ],
     [
      420.8,
      108
     ],
     [
      428.4,
      107.5
     ],
     [
      432.5,
      107.7
     ],
     [
      434.4,
      108.4
     ],
     [
      438.4,
      110.9
     ],
     [
      441.7,
      111.7
     ],
     [
      449.2,
      112.1
     ],
     [
      449.1,
      119.8
     ],
     [
      447.9,
      120.1
     ],
     [
      441.6,
      119.7
     ],
     [
      440.2,
      120.2
     ],
     [
      439,
      122.6
     ],
     [
      437.8,
      123.9
     ],
     [
      426.9,
      132.2
     ],
     [
      425,
      134.2
     ],
     [
      424.4,
      136
     ],
     [
      425.6,
      137.1
     ],
     [
      427.6,
      137.8
     ],
     [
      433.7,
      138.5
     ],
     [
      438.3,
      140.4
     ],
     [
      442.1,
      146.6
     ],
     [
      442.4,
      151.5
     ],
     [
      442.9,
      153
     ],
     [
      445,
      156
     ],
     [
      454.6,
      166
     ],
     [
      456.9,
      171.5
     ]
    ]
   ]
  },
  "gyumri": {
   "paths": [
    "m1333.65,252.56c-2.31,1.44-2.04,4.97-1.51,7.37.13.58.01.97-.31,1.23-.99.84-3.89.38-6.95.22-4.03-.21-7.97-.12-12.04-1.99-4.07-1.87-8.81-.55-11.01,1.43-2.2,1.98-.99,7.16-.11,9.14s-3.63,5.06-6.27,6.5c-2.65,1.43-8.7-1.22-11.78-1.81-3.09-.6-6.06.15-8.04,2.44-.88,1.02-2.77,1.33-4.6,1.36-.03-.3-.24-.52-.78-.96-1.41-1.16-2.77-3.68-.37-5,2.39-1.32,5.36-5.37,6.6-7.27,1.24-1.89,2.23-6.27,1.49-8.5-.74-2.23-2.48-5.78-2.97-7.43-.5-1.65.24-5.7,0-6.11-.25-.41-10.19-5.56-10.68-6.55-.5-.99-1.3-3.66-.91-5.09.12-.44.09-1.15-.04-1.94,5.31-.8,11.63-.13,11.63-.13,11.22-.06,10.1-1.46,12.3-2.56s7.71-1.65,10.68-.99c2.97.66,1.76.33,3.41-1.65,1.65-1.98,4.84-.33,7.16.11,2.31.44,5.06.66,7.15.55,2.09-.11,3.2-1.1,4.85-.55,1.65.55,5.39-2.26,6.96-1.02,1.57,1.24,6.27,2.31,6.25-.82-.01-2,.87-2.43,2.27-2.43.5,3.29,1.68,7.02,2.35,8.68,1.21,2.97-2.09,6.82-3.3,8.3-1.21,1.49,2.97,5.35,3.85,6.47.88,1.12-2.97,7.57-5.28,9Z"
   ],
   "label": [
    1301,
    249
   ],
   "bbox": [
    1263,
    220,
    1339,
    278
   ],
   "geoNeighbors": [
    "kars",
    "trabzon",
    "vanadzor",
    "yerevan"
   ],
   "poly": [
    [
     [
      1333.7,
      252.6
     ],
     [
      1332.4,
      254
     ],
     [
      1331.8,
      255.9
     ],
     [
      1332.2,
      260.7
     ],
     [
      1330.8,
      261.6
     ],
     [
      1318.9,
      261
     ],
     [
      1315.9,
      260.5
     ],
     [
      1309.7,
      258.5
     ],
     [
      1306.6,
      258.7
     ],
     [
      1303.9,
      259.5
     ],
     [
      1301.8,
      260.8
     ],
     [
      1300.8,
      262.8
     ],
     [
      1300.6,
      265.4
     ],
     [
      1301.8,
      270.7
     ],
     [
      1301.5,
      271.6
     ],
     [
      1299.9,
      273.4
     ],
     [
      1295.5,
      276.5
     ],
     [
      1292.9,
      276.9
     ],
     [
      1283.7,
      274.7
     ],
     [
      1281.4,
      274.5
     ],
     [
      1279.2,
      274.8
     ],
     [
      1277.3,
      275.7
     ],
     [
      1274.8,
      277.7
     ],
     [
      1271,
      278.5
     ],
     [
      1269.3,
      276.4
     ],
     [
      1268.6,
      275.1
     ],
     [
      1268.7,
      273.7
     ],
     [
      1273.6,
      269.1
     ],
     [
      1276.5,
      265.2
     ],
     [
      1278,
      261.1
     ],
     [
      1278.2,
      258.7
     ],
     [
      1278,
      256.7
     ],
     [
      1275,
      249.3
     ],
     [
      1275,
      243.2
     ],
     [
      1264.3,
      236.6
     ],
     [
      1263.3,
      232.8
     ],
     [
      1263.4,
      229.6
     ],
     [
      1267.4,
      229.2
     ],
     [
      1278.7,
      229.4
     ],
     [
      1283.2,
      228.9
     ],
     [
      1289.5,
      226.2
     ],
     [
      1295.4,
      225.6
     ],
     [
      1300.2,
      226.1
     ],
     [
      1301.4,
      224.3
     ],
     [
      1302.9,
      223.4
     ],
     [
      1304.7,
      223.4
     ],
     [
      1312.2,
      224.9
     ],
     [
      1315.7,
      224.9
     ],
     [
      1319.4,
      224.2
     ],
     [
      1322.1,
      224.3
     ],
     [
      1326.8,
      223.1
     ],
     [
      1329.2,
      224.2
     ],
     [
      1332.2,
      224.5
     ],
     [
      1333.6,
      223.5
     ],
     [
      1334.4,
      220.6
     ],
     [
      1336,
      220.1
     ],
     [
      1338.6,
      229.9
     ],
     [
      1337.6,
      233.5
     ],
     [
      1334.9,
      237.7
     ],
     [
      1336.2,
      240.5
     ],
     [
      1338.9,
      243.6
     ],
     [
      1339.1,
      244.2
     ],
     [
      1337.5,
      247.9
     ],
     [
      1335.6,
      250.7
     ],
     [
      1333.7,
      252.6
     ]
    ]
   ]
  },
  "vanadzor": {
   "paths": [
    "m1393.33,299.79c-.66,4.63-4.74,6.39-9.91,5.73-3.03-.39-4.85.43-5.38,1.51-.44-.04-.79-.07-1.06-.07-2.08-.03-6.4,1.93-9.98,3.12-1.55.51-2.96.88-3.98.88-3.38-.01-5.61-.65-8.62,1.82-1.65,1.35-3.96,2.01-5.73,2.34-.17-2.51-1.3-5.54-2.57-8.8-1.71-4.42-.83-6.91-2.97-10.71-2.15-3.8-2.98-3.63-2.89-7.42.08-3.79-2.18-13.39-4.6-15.37-2.42-1.98-2.86-6.82-2.66-8.93.09-1.04-.51-2.01-1.14-2.73.32-.26.44-.65.31-1.23-.53-2.4-.8-5.93,1.51-7.37,2.31-1.43,6.16-7.88,5.28-9-.88-1.12-5.06-4.98-3.85-6.47,1.21-1.48,4.51-5.33,3.3-8.3-.67-1.66-1.85-5.39-2.35-8.68.79,0,1.74.14,2.79.2.4.02.78-.01,1.16-.07.12-.02.24-.04.36-.07.1-.02.21-.04.31-.07.2-.05.4-.1.6-.16.3-.08.6-.17.9-.26.2-.06.4-.11.6-.15.19-.04.38-.07.57-.1.16-.02.32-.03.48-.04,1.05-.05,2.17.26,3.44,1.41,3.31,2.98,7.21,8.75,6.77,9.8s-2.64.22-4.62,1.43c-1.98,1.21-2.31,2.48-2.31,2.48,5.16.88,23.78,9.8,26.53,11.56,2.75,1.76,1.21,5.06-.33,6.82-1.54,1.77-7.6,4.52-9.8,6.06-2.2,1.54,2.53,5.61,3.3,10.24.78,4.62,5.73,8.14,8.59,9.03,2.86.88,1.87,3.85,3.41,4.29,1.55.44,5.95,2.31,11.67,4.62,5.73,2.31,3.53,8.04,2.87,12.66Z"
   ],
   "label": [
    1363,
    267
   ],
   "bbox": [
    1331.5,
    219,
    1394.5,
    315
   ],
   "geoNeighbors": [
    "gyumri",
    "sevan",
    "yerevan"
   ],
   "poly": [
    [
     [
      1393.3,
      299.8
     ],
     [
      1392.2,
      302.7
     ],
     [
      1391.3,
      303.8
     ],
     [
      1388.7,
      305.2
     ],
     [
      1379.8,
      305.7
     ],
     [
      1378,
      307
     ],
     [
      1375,
      307.3
     ],
     [
      1364.8,
      310.7
     ],
     [
      1358.6,
      310.9
     ],
     [
      1356.5,
      311.5
     ],
     [
      1351.6,
      314.3
     ],
     [
      1348.7,
      315.1
     ],
     [
      1347.8,
      311
     ],
     [
      1345.2,
      303.3
     ],
     [
      1344.3,
      298.3
     ],
     [
      1340.4,
      290.4
     ],
     [
      1339.9,
      284.5
     ],
     [
      1338.9,
      279.8
     ],
     [
      1336.5,
      273.9
     ],
     [
      1334.2,
      270.9
     ],
     [
      1333.3,
      268.4
     ],
     [
      1332.7,
      262.4
     ],
     [
      1331.8,
      261.2
     ],
     [
      1332.2,
      260.7
     ],
     [
      1331.8,
      255.9
     ],
     [
      1332.4,
      254
     ],
     [
      1335.6,
      250.7
     ],
     [
      1337.5,
      247.9
     ],
     [
      1339.1,
      244.2
     ],
     [
      1338.9,
      243.6
     ],
     [
      1336.2,
      240.5
     ],
     [
      1334.9,
      237.7
     ],
     [
      1337.6,
      233.5
     ],
     [
      1338.6,
      229.9
     ],
     [
      1336,
      220.1
     ],
     [
      1340,
      220.2
     ],
     [
      1343.8,
      219.4
     ],
     [
      1345.4,
      219.6
     ],
     [
      1347.2,
      220.8
     ],
     [
      1352,
      226.4
     ],
     [
      1353.6,
      229
     ],
     [
      1354,
      230.6
     ],
     [
      1353.4,
      231.1
     ],
     [
      1349.4,
      232
     ],
     [
      1348.2,
      232.9
     ],
     [
      1347.1,
      234.5
     ],
     [
      1353,
      236.4
     ],
     [
      1361.3,
      240
     ],
     [
      1371.9,
      245.1
     ],
     [
      1374.5,
      246.8
     ],
     [
      1374.9,
      247.6
     ],
     [
      1375.1,
      249.5
     ],
     [
      1373.3,
      252.9
     ],
     [
      1371.4,
      254.4
     ],
     [
      1363.5,
      258.9
     ],
     [
      1363,
      259.6
     ],
     [
      1363,
      260.5
     ],
     [
      1365.6,
      265.9
     ],
     [
      1367.3,
      270.9
     ],
     [
      1368.1,
      272.4
     ],
     [
      1370.3,
      275.1
     ],
     [
      1372.9,
      277.1
     ],
     [
      1376.3,
      278.6
     ],
     [
      1376.9,
      279.2
     ],
     [
      1378,
      281.8
     ],
     [
      1378.8,
      282.5
     ],
     [
      1390.5,
      287.1
     ],
     [
      1392.3,
      288.1
     ],
     [
      1393.4,
      289.4
     ],
     [
      1394.3,
      292.6
     ],
     [
      1393.3,
      299.8
     ]
    ]
   ]
  },
  "yerevan": {
   "paths": [
    "m1365.58,364.47c.11,1.07-.66,2.98-1.72,5.03-3.98-3.73-9.2-7.07-10.95-7.39-2.42-.45-1.21-4.66-1.87-6.31-.66-1.65-7.68-7.76-9-10.15-1.32-2.4-4.13-9.09-7.35-12.22-2.52-2.46-8.3-7.97-10.69-10.25.36-.33.58-.53.58-.53,0,0,.65-1.99.04-2.27-.61-.27-5.67-13.49-14.97-14.48-9.31-.99-13.38,2.81-17.45,1.54-4.08-1.26-10.46-3.63-12.11-4.67-1.65-1.05-5.73-1.22-6.06-3.31-.33-2.09,1.87-3.08,2.31-3.08s-1.43-2.37-2.25-3.22c-.83-.85,1.57-2.42.16-3.91-1.4-1.48-4.37-4.13-3.88-7.55.31-2.11.72-2.78.66-3.25,1.83-.03,3.72-.34,4.6-1.36,1.98-2.29,4.95-3.04,8.04-2.44,3.08.59,9.13,3.24,11.78,1.81,2.64-1.44,7.15-4.52,6.27-6.5s-2.09-7.16.11-9.14c2.2-1.98,6.94-3.3,11.01-1.43,4.07,1.87,8.01,1.78,12.04,1.99,3.06.16,5.96.62,6.95-.22.63.72,1.23,1.69,1.14,2.73-.2,2.11.24,6.95,2.66,8.93,2.42,1.98,4.68,11.58,4.6,15.37-.09,3.79.74,3.62,2.89,7.42,2.14,3.8,1.26,6.29,2.97,10.71,1.27,3.26,2.41,6.29,2.57,8.8.04.89-.03,1.71-.26,2.45-.89,2.85-1.7,2.34.5,6.11,2.19,3.77,8.75,10.54,8.58,12.54-.16,2,6.94,9.19,9.08,13.19,2.15,4-1.3,11.92-.98,15.06Z"
   ],
   "label": [
    1316,
    282
   ],
   "bbox": [
    1270.5,
    258.5,
    1367.5,
    369.5
   ],
   "geoNeighbors": [
    "gyumri",
    "igdir",
    "kars",
    "sevan",
    "vanadzor"
   ],
   "poly": [
    [
     [
      1365.6,
      364.5
     ],
     [
      1365.2,
      366.6
     ],
     [
      1363.9,
      369.5
     ],
     [
      1357.5,
      364.5
     ],
     [
      1352.2,
      361.8
     ],
     [
      1351.3,
      359.4
     ],
     [
      1351,
      355.8
     ],
     [
      1350.5,
      355
     ],
     [
      1342.8,
      346.7
     ],
     [
      1337,
      336.3
     ],
     [
      1334.7,
      333.4
     ],
     [
      1324,
      323.2
     ],
     [
      1324.7,
      322.3
     ],
     [
      1324.6,
      320.4
     ],
     [
      1320.4,
      313.4
     ],
     [
      1315.8,
      308.5
     ],
     [
      1312.9,
      306.8
     ],
     [
      1309.6,
      305.9
     ],
     [
      1306.4,
      305.7
     ],
     [
      1301.1,
      306.3
     ],
     [
      1295.3,
      307.6
     ],
     [
      1292.2,
      307.4
     ],
     [
      1285.2,
      305
     ],
     [
      1274.9,
      300.7
     ],
     [
      1274,
      299.5
     ],
     [
      1274.2,
      298.1
     ],
     [
      1274.9,
      297.1
     ],
     [
      1276.3,
      296.4
     ],
     [
      1276.3,
      296
     ],
     [
      1274.1,
      293.2
     ],
     [
      1274,
      292.4
     ],
     [
      1274.7,
      290.4
     ],
     [
      1274.3,
      289.3
     ],
     [
      1271.6,
      286.2
     ],
     [
      1270.6,
      284.1
     ],
     [
      1270.4,
      281.7
     ],
     [
      1271,
      278.5
     ],
     [
      1274.8,
      277.7
     ],
     [
      1277.3,
      275.7
     ],
     [
      1279.2,
      274.8
     ],
     [
      1281.4,
      274.5
     ],
     [
      1283.7,
      274.7
     ],
     [
      1292.9,
      276.9
     ],
     [
      1295.4,
      276.5
     ],
     [
      1299.9,
      273.4
     ],
     [
      1301.5,
      271.6
     ],
     [
      1301.7,
      270
     ],
     [
      1300.6,
      265.4
     ],
     [
      1301.2,
      261.7
     ],
     [
      1301.8,
      260.8
     ],
     [
      1303.9,
      259.5
     ],
     [
      1306.6,
      258.7
     ],
     [
      1309.7,
      258.5
     ],
     [
      1315.9,
      260.5
     ],
     [
      1318.9,
      261
     ],
     [
      1329.1,
      261.6
     ],
     [
      1331.8,
      261.2
     ],
     [
      1332.7,
      262.4
     ],
     [
      1333.3,
      268.4
     ],
     [
      1334.2,
      270.9
     ],
     [
      1336.5,
      273.9
     ],
     [
      1338.9,
      279.8
     ],
     [
      1339.9,
      284.5
     ],
     [
      1340.3,
      290.4
     ],
     [
      1344.2,
      298.3
     ],
     [
      1345.2,
      303.3
     ],
     [
      1348.4,
      313.1
     ],
     [
      1348.7,
      315.1
     ],
     [
      1348.4,
      317.6
     ],
     [
      1347.5,
      320.3
     ],
     [
      1347.8,
      321.5
     ],
     [
      1349.9,
      325.2
     ],
     [
      1356.5,
      333.9
     ],
     [
      1358.5,
      338.6
     ],
     [
      1365.5,
      347.8
     ],
     [
      1367.1,
      351.1
     ],
     [
      1367.3,
      353
     ],
     [
      1365.6,
      364.5
     ]
    ]
   ]
  },
  "sevan": {
   "paths": [
    "m1416.78,345.65c.08,1.4,0,3.13,2.39,5.12,2.4,1.98.33,10.48.33,12.55s5.53,8.67,4.38,10.81c-1.11,2.06.44,7.92.57,8.39.01.02.01.03.01.03,0,0,.08.83-1.49,1-1.57.16-6.69-2.23-8.34-1.57-1.65.66-9.52,4.24-9.52,4.24,0,0-.11-1-5.51-2.43-.25-.07-.52-.14-.79-.2-1.2-.3-2.59-.62-4.06-.93-.41-.09-.82-.18-1.25-.27-.23-.05-.46-.1-.69-.15-.46-.1-.93-.2-1.4-.29-.46-.1-.93-.2-1.4-.3-1.43-.3-2.87-.61-4.25-.93-.68-.16-1.34-.31-1.99-.46h0c-1.75-.43-3.34-.87-4.64-1.31-5.18-1.76-8.26,0-11.45-5.06-.9-1.42-2.26-2.93-3.81-4.39,1.06-2.05,1.83-3.96,1.72-5.03-.32-3.14,3.13-11.06.98-15.06-2.14-4-9.24-11.19-9.08-13.19.17-2-6.39-8.77-8.58-12.54-2.2-3.77-1.39-3.26-.5-6.11.23-.74.3-1.56.26-2.45,1.77-.33,4.08-.99,5.73-2.34,3.01-2.47,5.24-1.83,8.62-1.82,1.02,0,2.43-.37,3.98-.88,3.58-1.19,7.9-3.15,9.98-3.12.27,0,.62.03,1.06.07-.37.76-.09,1.65.87,2.34,2.31,1.65,6.49,1.1,6.49,4.07s3.08,6.39,5.17,7.38c2.1.99,8.04,5.29,9.47,7.6,1.43,2.31,6.83,6.08,6.83,6.08,11.75-4.55,19.07,2.64,18,4.05-1.08,1.4-3.47,5.2-5.04,5.78-1.58.57-3.14-.09-3.05,1.32Z"
   ],
   "label": [
    1386,
    347
   ],
   "bbox": [
    1347.5,
    307.5,
    1424.5,
    386.5
   ],
   "geoNeighbors": [
    "vanadzor",
    "yerevan"
   ],
   "poly": [
    [
     [
      1416.8,
      345.7
     ],
     [
      1417.1,
      348
     ],
     [
      1419.9,
      351.8
     ],
     [
      1420.2,
      353.3
     ],
     [
      1420.2,
      357
     ],
     [
      1419.5,
      363.3
     ],
     [
      1419.7,
      364.3
     ],
     [
      1423.7,
      371.8
     ],
     [
      1424,
      373.1
     ],
     [
      1423.5,
      376.2
     ],
     [
      1424.5,
      382.5
     ],
     [
      1423.9,
      383.3
     ],
     [
      1422.2,
      383.5
     ],
     [
      1416.4,
      382
     ],
     [
      1414.6,
      382
     ],
     [
      1405.1,
      386.2
     ],
     [
      1403.7,
      385.2
     ],
     [
      1399.6,
      383.8
     ],
     [
      1372.7,
      377.7
     ],
     [
      1370.1,
      376.6
     ],
     [
      1363.9,
      369.5
     ],
     [
      1365.5,
      365.4
     ],
     [
      1366.8,
      357.3
     ],
     [
      1367.3,
      353
     ],
     [
      1366.6,
      349.4
     ],
     [
      1358.5,
      338.6
     ],
     [
      1356.5,
      333.9
     ],
     [
      1348.2,
      322.5
     ],
     [
      1347.5,
      320.3
     ],
     [
      1348.4,
      317.6
     ],
     [
      1348.7,
      315.1
     ],
     [
      1351.6,
      314.3
     ],
     [
      1356.5,
      311.5
     ],
     [
      1358.6,
      310.9
     ],
     [
      1364.8,
      310.7
     ],
     [
      1375,
      307.3
     ],
     [
      1378,
      307
     ],
     [
      1378,
      308.2
     ],
     [
      1378.9,
      309.4
     ],
     [
      1384.7,
      311.8
     ],
     [
      1385.2,
      312.5
     ],
     [
      1385.9,
      315.7
     ],
     [
      1387.2,
      317.9
     ],
     [
      1388.9,
      319.7
     ],
     [
      1395.6,
      324.1
     ],
     [
      1398.3,
      326.4
     ],
     [
      1401.7,
      330.3
     ],
     [
      1406.9,
      334.5
     ],
     [
      1411.1,
      333.3
     ],
     [
      1414.8,
      333
     ],
     [
      1418,
      333.4
     ],
     [
      1420.7,
      334.3
     ],
     [
      1424.2,
      336.7
     ],
     [
      1424.9,
      337.8
     ],
     [
      1424.9,
      338.6
     ],
     [
      1422.5,
      341.7
     ],
     [
      1419.8,
      344.3
     ],
     [
      1417,
      344.9
     ],
     [
      1416.8,
      345.7
     ]
    ]
   ]
  },
  "edirne": {
   "paths": [
    "m498.88,218.31c-1.42,2.81-2.85,5.87-3.16,7.44-.43,2.15-1.49,8.91-3.55,14.51-12.99-1.47-28.72-10.71-36.71-3.64-5.34,5.12-8.66,3.19-11.42,1.87-22.9-6.43-14.24,17.12-30.31,25.05-2.69.92-5.12,1.81-7.34,2.68-5.31-1.69-9.74-1.82-12.96-1.48.06-.32.09-.64.1-.98-7.56-4.73-30.2,9.41-38.33,2.31-.17-.15-.32-.34-.42-.54-1.58-2.96-3.32-8.41-2.82-9.15,1.11-1.64,1.81-3.22,7.47-5.7,2.27-.7,1.29-2.45,2.12-3.6,5.53-3.5,2.41-5.2,6.03-4.96,1.34-.79-2.35-3.57.16-4.62.59-1.66-3.74-3.01-1.48-6.52.8-2.27-1.3-5.81.33-8.01.99-.83-.25-1.9.33-2.15.57-.25,3.55.17,3.8-.16.44-1.28,3.79-1.27,3.63-3.06.16-.74,1.24-.36,1.35-1.18.07-3.63,5.17-.05,6.55-1.54.72-3.43-2.04-15.58-1.83-18.58-1.84-.61-4.88-2.88-5.29-4.83-3.69-.04-5.2-1.2-7.63-4.58-1.88-7.59,8.79-4.57,11.33-7.02.86-4.77.35-11.11,8.21-8.95,22.54-2.46,10.87-11.97,24.33-6.77,11.64-10.68,10.24,19.66,28.51,5.94,6.71,5.07,4.29-4.34,9.61.09,5.7,2.31,8.45-4.26,7.7,6.18-.95.51-4.05-.28-3.14,3.08,5.04,18.48,14.4,25.86,30.67,34.67,2.09,1.13,8.35,2.71,14.16,4.2Z"
   ],
   "label": [
    425,
    212
   ],
   "bbox": [
    351.5,
    162,
    498.5,
    268
   ],
   "geoNeighbors": [
    "burgas",
    "gelibolu",
    "istanbul",
    "western-thrace"
   ],
   "poly": [
    [
     [
      498.9,
      218.3
     ],
     [
      496.1,
      224.3
     ],
     [
      493.5,
      235.9
     ],
     [
      492.2,
      240.3
     ],
     [
      487.2,
      239.4
     ],
     [
      471.9,
      235.2
     ],
     [
      467.2,
      234.3
     ],
     [
      462.7,
      234
     ],
     [
      458.8,
      234.7
     ],
     [
      457,
      235.5
     ],
     [
      453.5,
      238.2
     ],
     [
      450.2,
      239.8
     ],
     [
      448.8,
      240
     ],
     [
      446.2,
      239.5
     ],
     [
      444,
      238.5
     ],
     [
      440.1,
      237.6
     ],
     [
      436.8,
      237.4
     ],
     [
      434.1,
      237.7
     ],
     [
      431.9,
      238.6
     ],
     [
      428.6,
      241.5
     ],
     [
      426.3,
      245.6
     ],
     [
      422,
      255.4
     ],
     [
      418.7,
      259.9
     ],
     [
      416.5,
      261.9
     ],
     [
      413.7,
      263.5
     ],
     [
      406.4,
      266.2
     ],
     [
      399.1,
      264.7
     ],
     [
      393.4,
      264.7
     ],
     [
      393.5,
      263.8
     ],
     [
      391.9,
      263.1
     ],
     [
      387.9,
      262.8
     ],
     [
      380.2,
      264.3
     ],
     [
      368.9,
      267.2
     ],
     [
      361.1,
      268.1
     ],
     [
      356.9,
      267.2
     ],
     [
      355.2,
      266.1
     ],
     [
      352.6,
      260.1
     ],
     [
      351.9,
      256.9
     ],
     [
      352.8,
      255.1
     ],
     [
      356,
      252.4
     ],
     [
      360.6,
      250
     ],
     [
      361.6,
      247.1
     ],
     [
      364.3,
      244.8
     ],
     [
      365.9,
      242.3
     ],
     [
      367.6,
      242.1
     ],
     [
      367.9,
      241.7
     ],
     [
      366.8,
      238.6
     ],
     [
      367.7,
      237.5
     ],
     [
      367.8,
      236.9
     ],
     [
      365.6,
      233.2
     ],
     [
      366.4,
      229.1
     ],
     [
      366,
      224.8
     ],
     [
      367,
      222.3
     ],
     [
      366.9,
      220.8
     ],
     [
      370.7,
      220.7
     ],
     [
      373.9,
      218.7
     ],
     [
      376.6,
      214.9
     ],
     [
      380.7,
      215.2
     ],
     [
      382.3,
      214.9
     ],
     [
      382.2,
      211
     ],
     [
      380.4,
      196.3
     ],
     [
      377.2,
      194.4
     ],
     [
      375.9,
      193
     ],
     [
      375.1,
      191.5
     ],
     [
      372.7,
      191.2
     ],
     [
      370.8,
      190.4
     ],
     [
      369.2,
      189
     ],
     [
      367.5,
      186.9
     ],
     [
      367.3,
      184.5
     ],
     [
      368.1,
      182.9
     ],
     [
      369.6,
      182
     ],
     [
      377.5,
      180.6
     ],
     [
      378.8,
      179.9
     ],
     [
      380.3,
      172.8
     ],
     [
      381.2,
      171.5
     ],
     [
      382.6,
      170.7
     ],
     [
      384.5,
      170.5
     ],
     [
      387,
      170.9
     ],
     [
      390.9,
      170.4
     ],
     [
      396.5,
      168.9
     ],
     [
      400,
      167.2
     ],
     [
      403.7,
      163.4
     ],
     [
      405.1,
      162.7
     ],
     [
      407.4,
      162.8
     ],
     [
      411.4,
      164.1
     ],
     [
      413.4,
      162.6
     ],
     [
      415.2,
      161.9
     ],
     [
      416.8,
      161.9
     ],
     [
      418.2,
      162.5
     ],
     [
      420.7,
      165
     ],
     [
      425.9,
      171.4
     ],
     [
      429.4,
      173.4
     ],
     [
      431.5,
      173.7
     ],
     [
      433.9,
      173.3
     ],
     [
      436.7,
      172.2
     ],
     [
      439.9,
      170.1
     ],
     [
      442,
      171.4
     ],
     [
      443.5,
      171.6
     ],
     [
      444.5,
      171.2
     ],
     [
      446.7,
      169
     ],
     [
      447.8,
      169.1
     ],
     [
      449.5,
      170.2
     ],
     [
      451.5,
      170.7
     ],
     [
      456.6,
      170.4
     ],
     [
      457.1,
      171.3
     ],
     [
      457.3,
      173.2
     ],
     [
      457.2,
      176.4
     ],
     [
      454.9,
      176.8
     ],
     [
      454,
      177.6
     ],
     [
      454.1,
      179.4
     ],
     [
      456.1,
      185.9
     ],
     [
      458.7,
      191.4
     ],
     [
      461.7,
      196.2
     ],
     [
      465.2,
      200.4
     ],
     [
      469.2,
      204.1
     ],
     [
      473.8,
      207.6
     ],
     [
      484.7,
      214.1
     ],
     [
      490.4,
      216.1
     ],
     [
      498.9,
      218.3
     ]
    ]
   ]
  },
  "rhodes": {
   "paths": [
    "m403.87,457.41c-2.89-1.73-10.51-2.72-13.87-2.5-2.72.18-6.83,1.38-9.08,3.52-2.26,2.15-1.06,3.91.01,4.08,2.63.41,4.42-.43,5.33-.61,1.84-.36,3.69,1.62,5.31,3.44,1.62,1.82,4.27,1.02,4.76-.28.5-1.29,2.42-2.57,5.42-3,3.61-.52,3.37-3.9,2.12-4.65Z",
    "m363.35,464.59c-.42.58-1.32,2.53-2.94,2.45-1.62-.08-2.42-.52-3.83-.47-1.4.05-4.65.63-5.92,3.55-1.27,2.92-1.05,4.16.99,3.47,2.04-.69,4.18-2.61,6.47-2.72,2.28-.11,6.3-1.27,7.35-3.22,1.05-1.95,2.64-2.34,1.95-4.05-.69-1.71-3.69.46-4.07.99Z",
    "m416.74,513.87c-.83-.08-1.79.54-2.72.87-1.97.7-4.87,1.16-6.32,2.35-1.44,1.2-3.76,3.26-4.62,4.29-.87,1.03-2.52,1.61-3.59,2.06-1.07.45-.91,3.06-.29,4,.62.95,2.15-2.11,3.55-2.85,1.4-.74,5.49.21,6.36-1.28.87-1.49,3.88-3.51,6.61-3.67,2.72-.17,5.2-.95,4.17-2.6-1.03-1.65-2.31-3.1-3.14-3.18Z",
    "m460.51,546.78c-7.88,1.35-21.03,10.88-19.65,19.6,3.04,4.71-1.93,8.77.66,12.83,5.19,5.48,36.03-38.53,18.99-32.42Z"
   ],
   "label": [
    416,
    516
   ],
   "bbox": [
    350,
    455,
    465.5,
    579.5
   ],
   "geoNeighbors": [
    "aydin"
   ],
   "poly": [
    [
     [
      403.9,
      457.4
     ],
     [
      404.6,
      458.4
     ],
     [
      404.6,
      459.8
     ],
     [
      403.8,
      461.2
     ],
     [
      398.1,
      463.2
     ],
     [
      395.6,
      465.9
     ],
     [
      394.4,
      466.4
     ],
     [
      392.9,
      466.2
     ],
     [
      387.6,
      462
     ],
     [
      380.9,
      462.5
     ],
     [
      380.2,
      462.1
     ],
     [
      379.7,
      461.2
     ],
     [
      379.8,
      460
     ],
     [
      380.9,
      458.4
     ],
     [
      382.9,
      457
     ],
     [
      387.8,
      455.2
     ],
     [
      391.4,
      454.9
     ],
     [
      397.1,
      455.4
     ],
     [
      401,
      456.3
     ],
     [
      403.9,
      457.4
     ]
    ],
    [
     [
      363.4,
      464.6
     ],
     [
      365.3,
      463.3
     ],
     [
      366.5,
      463
     ],
     [
      367.4,
      463.6
     ],
     [
      367.6,
      464.7
     ],
     [
      364.2,
      469
     ],
     [
      362.3,
      469.9
     ],
     [
      356.4,
      471.2
     ],
     [
      351.7,
      473.6
     ],
     [
      350.5,
      473.7
     ],
     [
      349.9,
      473.2
     ],
     [
      350.7,
      470.1
     ],
     [
      351.9,
      468.3
     ],
     [
      353.6,
      467.3
     ],
     [
      356.6,
      466.6
     ],
     [
      360.4,
      467
     ],
     [
      361.5,
      466.8
     ],
     [
      363.4,
      464.6
     ]
    ],
    [
     [
      416.8,
      513.9
     ],
     [
      418.2,
      514.9
     ],
     [
      419.9,
      517
     ],
     [
      420.1,
      518.1
     ],
     [
      419.2,
      518.9
     ],
     [
      413.7,
      520.1
     ],
     [
      411.7,
      521
     ],
     [
      407.9,
      524
     ],
     [
      402.8,
      524.6
     ],
     [
      399.8,
      527.5
     ],
     [
      399.2,
      527.4
     ],
     [
      398.7,
      525.3
     ],
     [
      398.9,
      524.1
     ],
     [
      399.5,
      523.4
     ],
     [
      403.1,
      521.4
     ],
     [
      407.7,
      517.1
     ],
     [
      409,
      516.3
     ],
     [
      416.7,
      513.9
     ]
    ],
    [
     [
      460.5,
      546.8
     ],
     [
      464.1,
      546.3
     ],
     [
      464.8,
      546.7
     ],
     [
      465.5,
      548
     ],
     [
      465.5,
      550
     ],
     [
      464.7,
      552.7
     ],
     [
      461.5,
      559.2
     ],
     [
      454.3,
      569.7
     ],
     [
      449.1,
      575.6
     ],
     [
      444.5,
      579.1
     ],
     [
      442.1,
      579.6
     ],
     [
      441.5,
      579.2
     ],
     [
      440.9,
      577.7
     ],
     [
      440.8,
      576.2
     ],
     [
      441.9,
      569.8
     ],
     [
      441.7,
      568.1
     ],
     [
      440.9,
      566.4
     ],
     [
      440.8,
      564.7
     ],
     [
      441,
      563.1
     ],
     [
      442.2,
      559.8
     ],
     [
      444.4,
      556.7
     ],
     [
      447.2,
      553.8
     ],
     [
      450.5,
      551.3
     ],
     [
      457.3,
      547.7
     ],
     [
      460.5,
      546.8
     ]
    ]
   ]
  },
  "izmit": {
   "paths": [
    "M539.3,254.2 L538.9,254.2 L538.5,254.1 L538.1,254.1 L537.7,254.1 L537.3,254.1 L536.9,254.1 L536.5,254.1 L536.1,254 L535.7,254 L535.3,254 L534.9,253.9 L534.5,253.9 L534.1,253.9 L533.7,253.9 L533.3,253.8 L532.9,253.8 L532.5,253.7 L532.1,253.7 L531.8,253.7 L531.4,253.6 L531,253.6 L530.6,253.5 L530.2,253.5 L529.8,253.4 L529.4,253.4 L529,253.3 L528.6,253.3 L528.2,253.2 L527.8,253.2 L527.4,253.1 L527,253 L526.6,253 L526.2,252.9 L525.8,252.8 L525.5,252.7 L525.1,252.5 L524.8,252.3 L524.4,252.1 L524.1,251.9 L523.8,251.6 L523.4,251.4 L523.1,251.2 L522.8,250.9 L522.5,250.6 L522.2,250.4 L521.9,250.1 L521.6,249.9 L521.3,249.6 L521,249.3 L520.7,249.1 L520.4,248.8 L520.1,248.5 L519.8,248.3 L519.6,248 L519.3,247.7 L519,247.5 L518.6,247.2 L518.3,247 L518,246.7 L517.7,246.5 L517.4,246.3 L517.3,245.9 L517.5,245.6 L517.6,245.2 L517.7,244.8 L517.9,244.4 L518,244.1 L518.1,243.7 L518.3,243.3 L518.4,242.9 L518.5,242.5 L518.6,242.2 L518.7,241.8 L518.8,241.4 L518.9,241 L519.1,240.6 L519.2,240.2 L519.3,239.9 L519.4,239.5 L519.5,239.1 L519.6,238.7 L519.7,238.3 L519.8,237.9 L519.9,237.6 L520,237.2 L520.1,236.8 L520.3,236.4 L520.4,236 L520.5,235.6 L520.6,235.3 L520.7,234.9 L520.8,234.5 L521,234.1 L521.1,233.8 L521.3,233.4 L521.5,233 L521.7,232.7 L521.9,232.4 L522.1,232 L522.3,231.7 L522.5,231.3 L522.7,231 L522.9,230.6 L523.1,230.3 L523.3,229.9 L523.4,229.6 L523.6,229.2 L523.8,228.9 L524,228.5 L524.2,228.2 L524.4,227.8 L524.5,227.4 L524.7,227.1 L524.9,226.7 L525.1,226.4 L525.2,226 L525.4,225.7 L525.6,225.3 L525.8,224.9 L526,224.6 L526.1,224.2 L526.4,224.1 L526.8,224.2 L527.2,224.3 L527.6,224.4 L528,224.5 L528.4,224.5 L528.8,224.6 L529.2,224.7 L529.6,224.8 L530,224.9 L530.3,224.9 L530.7,225 L531.1,225.1 L531.5,225.2 L531.9,225.3 L532.3,225.3 L532.7,225.4 L533.1,225.5 L533.5,225.6 L533.9,225.7 L534.2,225.7 L534.6,225.8 L535,225.9 L535.4,226 L535.8,226.1 L536.2,226.2 L536.6,226.2 L537,226.3 L537.4,226.4 L537.8,226.5 L538.2,226.6 L538.5,226.6 L538.9,226.7 L539.3,226.8 L539.7,226.9 L540.1,227 L540.5,227 L540.9,227.1 L541.3,227.2 L541.7,227.3 L542.1,227.4 L542.4,227.4 L542.8,227.5 L543.2,227.6 L543.6,227.7 L544,227.7 L544.4,227.8 L544.8,227.9 L545.2,228 L545.6,228.1 L546,228.1 L546.4,228.2 L546.8,228.2 L547.2,228.3 L547.5,228.3 L547.9,228.4 L557.5,228.6 L557.9,228.6 L558.3,228.6 L558.7,228.6 L559.1,228.6 L559.5,228.6 L559.9,228.5 L560.3,228.5 L560.7,228.5 L561.1,228.5 L561.5,228.4 L561.9,228.4 L562.3,228.4 L562.7,228.3 L563.1,228.3 L563.5,228.3 L563.9,228.2 L564.3,228.2 L564.7,228.2 L565.1,228.1 L565.5,228.1 L565.8,228 L566.2,228 L566.6,227.9 L567,227.9 L567.4,227.8 L567.8,227.8 L568.2,227.7 L568.6,227.6 L569,227.6 L569.4,227.5 L569.8,227.4 L570.2,227.4 L570.6,227.3 L571,227.2 L571.4,227.1 L571.7,226.9 L572.1,226.7 L572.4,226.5 L572.7,226.3 L573.1,226.1 L573.4,225.8 L573.7,225.6 L574.1,225.4 L574.4,225.2 L574.8,225.1 L575.2,225 L575.6,225.1 L576,225.2 L576.4,225.3 L576.7,225.4 L577.1,225.6 L577.5,225.7 L577.8,225.9 L578.2,226 L578.6,226.2 L578.9,226.4 L579.3,226.6 L579.6,226.7 L580,226.9 L580.4,227.1 L580.2,227.4 L580,227.8 L579.8,228.1 L579.6,228.5 L579.4,228.8 L579.2,229.2 L579,229.5 L578.8,229.9 L578.7,230.2 L578.5,230.6 L578.3,230.9 L578.1,231.3 L577.9,231.7 L577.8,232 L577.6,232.4 L577.5,232.8 L577.6,233.2 L577.8,233.5 L578.1,233.8 L578.4,234.1 L578.7,234.3 L579,234.5 L579.3,234.8 L579.7,235 L580,235.2 L580.3,235.5 L580.4,235.9 L580.5,236.3 L580.6,236.7 L580.5,237.1 L580.5,237.5 L580.4,237.9 L580.4,238.3 L580.4,238.7 L580.3,239 L580.3,239.4 L580.3,239.8 L580.3,240.2 L580.3,240.6 L580.2,241 L580.2,241.4 L580.2,241.8 L580.2,242.2 L580.1,242.6 L580.1,243 L580.1,243.4 L580,243.8 L580,244.2 L579.9,244.6 L579.9,245 L579.8,245.4 L579.8,245.8 L579.7,246.2 L579.6,246.6 L579.6,247 L579.5,247.4 L579.4,247.8 L579.2,248.1 L578.8,248.3 L578.5,248.4 L578.1,248.3 L577.7,248.2 L577.3,248 L576.9,247.9 L576.6,248.1 L576.5,248.4 L576.4,248.8 L576.3,249.2 L576.2,249.6 L576.1,250 L576,250.4 L576,250.8 L575.9,251.2 L575.8,251.6 L575.8,252 L575.7,252.4 L575.6,252.8 L575.6,253.2 L575.5,253.6 L575.5,253.9 L575.4,254.3 L575.3,254.7 L575.3,255.1 L575.2,255.5 L575.2,255.9 L575.1,256.3 L575,256.7 L575,257.1 L574.9,257.5 L574.9,257.9 L574.8,258.3 L574.8,258.7 L574.7,259.1 L574.6,259.5 L574.6,259.9 L574.5,260.3 L574.4,260.7 L574.3,261 L574.2,261.4 L574.1,261.8 L573.9,262.2 L573.8,262.6 L573.6,262.9 L573.4,263.3 L573.2,263.6 L573,263.9 L572.7,264.2 L572.4,264.5 L572.1,264.8 L571.8,265 L571.5,265.2 L571.1,265.4 L570.8,265.6 L570.4,265.8 L570.1,266 L569.7,266.2 L569.4,266.4 L569,266.6 L568.7,266.8 L568.3,266.9 L568,267.1 L567.6,267.3 L567.2,267.5 L566.9,267.7 L566.5,267.9 L566.2,268.1 L565.9,268.3 L565.5,268.5 L565.2,268.7 L564.9,269 L564.7,269.3 L564.5,269.7 L564.3,270 L564,270.3 L563.7,270.6 L563.4,270.8 L563,271 L562.7,271.2 L562.3,271.4 L562,271.6 L561.6,271.7 L561.3,271.9 L560.9,272.1 L560.5,272.2 L560.1,272.3 L559.8,272.5 L559.4,272.6 L559,272.7 L558.6,272.8 L558.2,272.9 L558,272.6 L557.8,272.2 L557.6,271.9 L557.4,271.6 L557.2,271.2 L556.9,270.9 L556.7,270.6 L556.4,270.3 L556.1,270.1 L555.8,269.8 L555.5,269.5 L555.2,269.3 L554.9,269 L554.5,268.8 L554.2,268.6 L553.9,268.3 L553.5,268.1 L553.2,267.9 L552.8,267.8 L552.5,267.6 L552.1,267.4 L551.8,267.2 L551.4,267.1 L551,267 L550.6,266.8 L550.2,266.7 L549.9,266.6 L549.5,266.6 L549.1,266.6 L548.7,266.6 L548.3,266.7 L547.9,266.9 L547.6,267 L547.2,267.2 L546.8,267.3 L546.4,267.4 L546.1,267.5 L545.7,267.6 L545.3,267.7 L544.9,267.8 L544.5,267.9 L544.1,268 L543.7,268.1 L543.3,268.2 L542.9,268.3 L542.6,268.4 L542.2,268.4 L541.8,268.5 L541.4,268.6 L541,268.7 L540.6,268.7 L540.2,268.8 L539.8,268.9 L539.4,268.9 L539,269 L538.6,269.1 L538.2,269.2 L537.8,269.2 L537.4,269.3 L537.1,269.4 L536.7,269.4 L536.3,269.5 L535.9,269.5 L535.5,269.6 L535.1,269.7 L534.7,269.7 L534.3,269.8 L533.9,269.9 L533.5,269.9 L533.1,270 L532.7,270 L532.3,270.1 L531.9,270.1 L531.5,270.2 L531.1,270.3 L530.7,270.3 L530.3,270.4 L529.9,270.5 L529.6,270.5 L529.2,270.6 L528.8,270.7 L528.4,270.8 L528,270.9 L527.6,271.1 L527.2,271.2 L526.9,271.3 L526.5,271.4 L526.1,271.6 L525.7,271.7 L525.4,271.9 L525,272 L524.6,272.2 L524.3,272.4 L523.9,272.5 L523.6,272.7 L523.2,272.9 L522.8,273.1 L522.5,273.3 L522.2,273.5 L521.8,273.7 L521.5,273.9 L521.1,274.1 L520.8,274.3 L520.5,274.5 L520.1,274.8 L519.8,275 L519.5,275.3 L519.2,275.5 L518.9,275.8 L518.6,276.1 L518.3,276.4 L518.1,276.7 L517.8,277 L517.5,277.3 L517.2,277.5 L516.9,277.7 L516.5,277.9 L516.1,278 L515.8,278.1 L515.4,278.2 L515,278.3 L514.6,278.3 L514.2,278.4 L513.8,278.4 L513.4,278.4 L513.1,278.3 L513.1,277.9 L513,277.5 L512.9,277.2 L512.8,276.8 L512.6,276.4 L512.4,276.1 L512.1,275.8 L511.8,275.5 L511.5,275.3 L511.1,275.1 L510.8,275 L510.4,274.8 L510,274.7 L509.6,274.6 L509.2,274.6 L508.8,274.5 L508.4,274.5 L508,274.6 L507.6,274.6 L507.2,274.6 L506.8,274.7 L506.4,274.8 L506.1,274.9 L505.7,275 L505.3,275.1 L504.9,275.2 L504.5,275.2 L504.1,275.2 L503.7,275.1 L503.3,275 L502.9,274.9 L502.5,274.8 L502.2,274.6 L501.8,274.5 L501.4,274.3 L501.1,274.1 L500.7,273.9 L500.4,273.7 L500.1,273.5 L499.7,273.3 L499.4,273.1 L499.1,272.8 L498.7,272.6 L498.4,272.4 L498.1,272.2 L497.8,271.9 L497.5,271.6 L497.3,271.3 L497.1,270.9 L497.1,270.5 L497.1,270.1 L497.2,269.7 L497.4,269.4 L497.7,269.1 L498,268.9 L498.4,268.7 L498.7,268.5 L499.1,268.5 L499.5,268.4 L499.9,268.2 L500.3,268.1 L500.6,267.9 L501,267.7 L501.3,267.5 L501.7,267.3 L502,267.1 L502.3,266.8 L502.6,266.6 L502.9,266.4 L503.2,266.1 L503.6,265.8 L503.9,265.6 L504.2,265.3 L504.5,265.1 L504.8,264.9 L505.1,264.6 L505.5,264.5 L505.9,264.3 L506.2,264.1 L506.6,264 L507,263.9 L507.4,263.8 L507.8,263.7 L508.2,263.7 L508.6,263.7 L509,263.6 L509.4,263.6 L509.8,263.6 L510.2,263.6 L510.6,263.6 L511,263.6 L511.4,263.6 L511.8,263.6 L512.2,263.6 L512.6,263.6 L513,263.6 L513.4,263.6 L513.8,263.6 L514.2,263.6 L514.6,263.6 L515,263.6 L515.4,263.5 L515.8,263.5 L516.2,263.4 L516.5,263.4 L516.9,263.3 L517.3,263.2 L517.7,263.1 L518.1,263.1 L518.5,263 L518.9,262.9 L519.3,262.8 L519.7,262.7 L520.1,262.6 L520.4,262.4 L520.8,262.3 L521.2,262.2 L521.6,262.1 L521.9,261.9 L522.3,261.8 L522.7,261.6 L523.1,261.5 L523.4,261.3 L523.8,261.2 L524.1,261 L524.5,260.8 L524.9,260.6 L525.2,260.4 L525.5,260.2 L525.9,260.1 L526.3,260 L526.7,259.9 L527.1,259.8 L527.5,259.8 L527.9,259.8 L528.3,259.8 L528.7,259.7 L529.1,259.7 L529.5,259.7 L529.9,259.7 L530.3,259.8 L530.7,259.8 L531.1,259.8 L531.5,259.8 L531.9,259.8 L532.3,259.8 L532.7,259.9 L533.1,259.9 L533.5,259.9 L533.9,259.9 L534.3,260 L534.7,260 L535.1,260 L535.5,260 L535.9,260.1 L536.3,260.1 L536.7,260.1 L537.1,260.1 L537.5,260.1 L537.9,260.1 L538.3,260.1 L538.7,260 L539.1,260 L539.5,260 L539.9,260 L540.3,259.9 L540.7,259.9 L541.1,259.8 L541.5,259.8 L541.9,259.8 L542.3,259.7 L542.6,259.7 L543,259.6 L543.4,259.6 L543.8,259.6 L544.2,259.5 L544.6,259.5 L545,259.4 L545.4,259.4 L545.8,259.3 L546.2,259.3 L546.6,259.2 L547,259.2 L547.4,259.1 L547.8,259.1 L548.2,259 L548.6,259 L549,258.9 L549.4,258.9 L549.8,258.8 L550.2,258.8 L550.6,258.7 L551,258.6 L551.4,258.6 L551.8,258.5 L552.2,258.5 L552.6,258.4 L552.9,258.3 L553.3,258.3 L553.7,258.2 L554.1,258.1 L554.5,258 L554.9,257.9 L555.3,257.7 L555.6,257.6 L556,257.4 L556.3,257.2 L556.6,256.9 L556.9,256.7 L557.2,256.3 L557.3,256 L557.3,255.6 L557,255.2 L556.7,255 L556.4,254.8 L556,254.7 L555.6,254.6 L555.2,254.5 L554.8,254.5 L554.4,254.4 L554,254.3 L553.6,254.3 L553.2,254.3 L552.8,254.2 L552.4,254.2 L552,254.2 L551.6,254.2 L551.2,254.1 L550.8,254.1 L550.4,254.1 L550,254.1 L549.6,254.1 L549.2,254.1 L548.8,254 L548.4,254 Z"
   ],
   "label": [
    549,
    265
   ],
   "bbox": [
    497,
    224,
    581,
    278.5
   ],
   "geoNeighbors": [
    "eskisehir",
    "istanbul",
    "sakarya"
   ],
   "poly": [
    [
     [
      539.3,
      254.2
     ],
     [
      531.8,
      253.7
     ],
     [
      525.5,
      252.7
     ],
     [
      523.1,
      251.2
     ],
     [
      517.4,
      246.3
     ],
     [
      520.8,
      234.5
     ],
     [
      526.1,
      224.2
     ],
     [
      547.9,
      228.4
     ],
     [
      559.5,
      228.6
     ],
     [
      564.7,
      228.2
     ],
     [
      571.4,
      227.1
     ],
     [
      575.2,
      225
     ],
     [
      580.4,
      227.1
     ],
     [
      577.5,
      232.8
     ],
     [
      578.4,
      234.1
     ],
     [
      580.3,
      235.5
     ],
     [
      580.6,
      236.7
     ],
     [
      579.6,
      247
     ],
     [
      578.8,
      248.3
     ],
     [
      576.6,
      248.1
     ],
     [
      574.6,
      259.9
     ],
     [
      573.8,
      262.6
     ],
     [
      572.1,
      264.8
     ],
     [
      565.2,
      268.7
     ],
     [
      563.7,
      270.6
     ],
     [
      562,
      271.6
     ],
     [
      558.2,
      272.9
     ],
     [
      556.7,
      270.6
     ],
     [
      553.9,
      268.3
     ],
     [
      550.6,
      266.8
     ],
     [
      548.7,
      266.6
     ],
     [
      542.6,
      268.4
     ],
     [
      529.6,
      270.5
     ],
     [
      526.5,
      271.4
     ],
     [
      521.1,
      274.1
     ],
     [
      516.9,
      277.7
     ],
     [
      513.4,
      278.4
     ],
     [
      512.4,
      276.1
     ],
     [
      511.1,
      275.1
     ],
     [
      508.8,
      274.5
     ],
     [
      504.9,
      275.2
     ],
     [
      502.5,
      274.8
     ],
     [
      498.1,
      272.2
     ],
     [
      497.1,
      270.9
     ],
     [
      497.2,
      269.7
     ],
     [
      497.7,
      269.1
     ],
     [
      501.7,
      267.3
     ],
     [
      505.1,
      264.6
     ],
     [
      507.8,
      263.7
     ],
     [
      515,
      263.6
     ],
     [
      518.1,
      263.1
     ],
     [
      521.6,
      262.1
     ],
     [
      527.1,
      259.8
     ],
     [
      538.3,
      260.1
     ],
     [
      552.2,
      258.5
     ],
     [
      555.6,
      257.6
     ],
     [
      557.3,
      256
     ],
     [
      557,
      255.2
     ],
     [
      555.2,
      254.5
     ],
     [
      548.4,
      254
     ]
    ]
   ]
  },
  "istanbul": {
   "paths": [
    "m510.16,221.73c-1.05-.78-5.97-2.06-11.28-3.42-1.42,2.81-2.85,5.87-3.16,7.44-.43,2.15-1.49,8.91-3.55,14.51,4.05.46,7.84.17,11.04-1.62,3.14-.6,7.61-16.42,6.95-16.91Z",
    "m520.61,223.11l-4.96-.42s-1.24-.7-1.94,1.2c-.7,1.9-5.2,14.28-5.2,14.28,0,0-.62,1.82,1.2,2.94,1.3.8,5.04,3.28,7.52,5.07h.01c2.06-5.4,3.18-11.57,4.3-13.25,1.06-1.6,2.97-5.41,4.64-8.83-2.77-.55-4.85-.93-5.57-.99Z"
   ],
   "label": [
    504,
    220
   ],
   "bbox": [
    492,
    218,
    526,
    246
   ],
   "geoNeighbors": [
    "edirne",
    "izmit"
   ],
   "poly": [
    [
     [
      510.2,
      221.7
     ],
     [
      509.8,
      224.5
     ],
     [
      508.1,
      230.1
     ],
     [
      505.7,
      235.8
     ],
     [
      504.4,
      237.8
     ],
     [
      500.7,
      239.7
     ],
     [
      498,
      240.3
     ],
     [
      492.2,
      240.3
     ],
     [
      493.5,
      235.9
     ],
     [
      496.1,
      224.3
     ],
     [
      498.9,
      218.3
     ],
     [
      506.1,
      220.2
     ],
     [
      510.2,
      221.7
     ]
    ],
    [
     [
      520.6,
      223.1
     ],
     [
      526.2,
      224.1
     ],
     [
      521.1,
      233.8
     ],
     [
      517.2,
      246.2
     ],
     [
      509.7,
      241.1
     ],
     [
      508.8,
      240.2
     ],
     [
      508.4,
      238.5
     ],
     [
      514.3,
      222.9
     ],
     [
      514.9,
      222.6
     ],
     [
      520.6,
      223.1
     ]
    ]
   ]
  },
  "sakarya": {
   "paths": [
    "m651.63,244.57c-1.13,1.43-6.17,2.57-8.86,2.15-2.7-.42-5.12,2.23-5.78,3.39-.66,1.15-.09,5.61-4.3,9.18-4.21,3.57-11.56.39-14.12.48-2.56.08-8.67-1.82-11.64,0-2.97,1.81-1.48,4.62-1.73,6.78-.25,2.17-5.12,2.55-7.68,2.96-2.56.41-5.04,7.51-3.96,9.49,1.07,1.99,1.07,5.87-.42,6.2-.02,0-.03.01-.05.01-1.49.34-4.46,1.28-9.11-1.83-4.71-3.14-9-.41-14.2-.08-5.1.32-9.56-6.25-11.6-10.39,3.09-.72,6.03-2.29,6.35-3.32.55-1.73,6.47-3.38,8.29-5.45,1.81-2.06,2.06-6.69,2.31-8.09s1.07-7.76,1.57-8.09c.49-.33,1.9,1.15,2.56,0,.66-1.16,1.07-7.52,1.07-8.92s.5-2.56,0-3.38c-.5-.83-2.64-1.57-2.81-2.73-.08-.6,1.4-3.31,2.86-5.81.43.21.86.41,1.29.61,2.14.99,6.11.33,12.05,2.97,5.95,2.64,20.31,2.31,28.4.99,3.13-.51,5.37-1.9,6.96-3.53,4.72,2.82,9.71,5.71,10.44,6.06,1.24.61,4.51,1.05,6.63,1.41,2.12.36,7.76-.14,8.31,1.21.55,1.35-1.7,6.3-2.83,7.73Z"
   ],
   "label": [
    608,
    258
   ],
   "bbox": [
    558,
    227,
    654,
    285
   ],
   "geoNeighbors": [
    "eskisehir",
    "izmit",
    "kastamonu"
   ],
   "poly": [
    [
     [
      651.6,
      244.6
     ],
     [
      650.1,
      245.6
     ],
     [
      647.8,
      246.3
     ],
     [
      640.8,
      246.9
     ],
     [
      639.1,
      247.8
     ],
     [
      637,
      250.1
     ],
     [
      636.2,
      253.8
     ],
     [
      635,
      256.5
     ],
     [
      632.7,
      259.3
     ],
     [
      631,
      260.3
     ],
     [
      629.1,
      260.9
     ],
     [
      625,
      260.8
     ],
     [
      619.7,
      259.9
     ],
     [
      609.6,
      259
     ],
     [
      606.9,
      259.8
     ],
     [
      605.4,
      261.3
     ],
     [
      604.9,
      267.3
     ],
     [
      602.2,
      268.7
     ],
     [
      597.5,
      269.5
     ],
     [
      595.7,
      270.9
     ],
     [
      594.2,
      273.7
     ],
     [
      593.4,
      276.7
     ],
     [
      593.3,
      278
     ],
     [
      594.2,
      280.8
     ],
     [
      594.3,
      282.7
     ],
     [
      594,
      284.4
     ],
     [
      593.1,
      285.2
     ],
     [
      589.7,
      285.6
     ],
     [
      587.2,
      285
     ],
     [
      582.2,
      282.5
     ],
     [
      580.5,
      282
     ],
     [
      577.1,
      282
     ],
     [
      569.8,
      283.3
     ],
     [
      567.9,
      283.1
     ],
     [
      566.1,
      282.4
     ],
     [
      562.8,
      279.8
     ],
     [
      560.1,
      276.3
     ],
     [
      558.2,
      272.9
     ],
     [
      560.4,
      272.2
     ],
     [
      563.8,
      270.4
     ],
     [
      565.8,
      268.3
     ],
     [
      570.8,
      265.6
     ],
     [
      572.8,
      264.1
     ],
     [
      573.9,
      262.2
     ],
     [
      576.5,
      248.3
     ],
     [
      576.7,
      248
     ],
     [
      578.7,
      248.4
     ],
     [
      579.3,
      248
     ],
     [
      579.7,
      246.3
     ],
     [
      580.5,
      237.1
     ],
     [
      580.3,
      235.7
     ],
     [
      578,
      233.7
     ],
     [
      577.5,
      232.9
     ],
     [
      580.4,
      227.1
     ],
     [
      583.6,
      228.2
     ],
     [
      589.6,
      229.3
     ],
     [
      596.3,
      231.6
     ],
     [
      599.5,
      232.2
     ],
     [
      607.1,
      232.7
     ],
     [
      615.1,
      232.5
     ],
     [
      622.1,
      231.7
     ],
     [
      626.2,
      230.3
     ],
     [
      629.1,
      228.2
     ],
     [
      640.8,
      234.6
     ],
     [
      646.2,
      235.6
     ],
     [
      654,
      236.4
     ],
     [
      654.5,
      236.8
     ],
     [
      654.4,
      238.4
     ],
     [
      653.7,
      240.7
     ],
     [
      651.6,
      244.6
     ]
    ]
   ]
  },
  "balikesir": {
   "paths": [
    "m504.22,341.73c-.33,3.41-2.87,9.72-5.51,12.35-2.64,2.62-7.7,4.6-7.87,7.47-.17,2.86-.21,3.49-.21,3.49,0,0-.02,0-.05-.01-.39-.08-2.97-.56-3.58-.48-.66.08-4.99,3.05-8.3,2.64-3.3-.42-5.03.66-6.03,1.98-.99,1.32-5.36,3.22-7.01,2.64-1.65-.58-2.4-.58-5.54-6.03-3.13-5.45-3.79-6.19-5.86-6.19s-4.04-.58-3.71-4.13c.33-3.55.49-2.97-2.81-3.13-3.3-.17-5.78-1.19-7.76-.75-1.98.44-2.42.06-4.13-1.1-1.71-1.15-4.79-3.97-7.35-2.84-1.42.63-2.18.5-3.05.12-.69-.31-1.44-.77-2.65-1.13-2.72-.83-4.62.05-6.85,1.01-2.23.97-8.26,3.61-9.91,6.09-1.65,2.48-4.21,5.28-6.11,6.27-1.13.59-4.53,2.04-7.52,3.76-.49-.47-.98-.88-1.44-1.2-1.98-1.36-2.68-3.96-4.29-5.78-1.61-1.81,1.28-4.5,3.96-6.35,2.69-1.86,7.23-7.1,9.54-9.91s.99-6.11-.66-5.84c-1.65.28-6.55,1.98-15.03,2.98-8.48.99-16.33,4.41-17.73,4.41s-3.1.62-7.35,1.87c-4.25,1.26-5.53-.9-5.55-1.4-.02-.49,1.35-6.54,2.39-7.47,1.05-.94,1.98-4.57,1.82-6.61-.14-1.73-.25-8.07-.34-10.44,15.85,1.33,22.8-17.4,29.34-23.3,6.82-6.17,21.79-7.05,26.75-9.8,1.75-.97,3.81-2.45,5.1-4.27.43.83,1.05,1.65,1.9,2.4,1.94,1.73,6.57,2.64,11.27,2.89,4.71.25,8.33-.36,12.62-.96,4.3-.61,2.75-3.75-.66-5.45-12.88-5.56-4.29-7.82,1.49-7.87,5.78-.06,9.19,2.53,9.41,4.51.22,1.98-4.02,2.42-4.68,4.29-.66,1.87,2.48,1.32,4.18,1.27.82-.03,6.03-.66,11.82-1.08-1.64,2.03-3.17,4.33-3.01,5.7.33,2.87-.79,7.79-.01,9.89.78,2.11,5.63,7.84,5.96,11.58s2.86,9.58,6.82,11.56c3.97,1.98,11.56,6.72,13.71,7.71,2.15.99,6.22,6.6,9.74,6.82,3.53.22,5.07,4.41,4.74,7.82Z"
   ],
   "label": [
    429,
    322
   ],
   "bbox": [
    354,
    272,
    504,
    372
   ],
   "geoNeighbors": [
    "canakkale",
    "eskisehir",
    "izmir",
    "lesbos",
    "usak"
   ],
   "poly": [
    [
     [
      504.2,
      341.7
     ],
     [
      502.3,
      348.2
     ],
     [
      500.6,
      351.5
     ],
     [
      498.7,
      354.1
     ],
     [
      493.8,
      357.7
     ],
     [
      491.1,
      360.5
     ],
     [
      490.6,
      365
     ],
     [
      487,
      364.6
     ],
     [
      481.3,
      367
     ],
     [
      474.8,
      367.5
     ],
     [
      471.4,
      370.2
     ],
     [
      467.3,
      371.8
     ],
     [
      465.7,
      371.8
     ],
     [
      463.4,
      370.6
     ],
     [
      456.8,
      360.6
     ],
     [
      455.6,
      359.8
     ],
     [
      452.8,
      359.4
     ],
     [
      451.5,
      358.9
     ],
     [
      450.5,
      356.7
     ],
     [
      450.5,
      352.6
     ],
     [
      441.6,
      351.5
     ],
     [
      437.8,
      351.6
     ],
     [
      432.5,
      348.2
     ],
     [
      430.5,
      347.4
     ],
     [
      426.8,
      348.1
     ],
     [
      420.9,
      346.3
     ],
     [
      419.2,
      346.5
     ],
     [
      416,
      347.6
     ],
     [
      410.8,
      350.1
     ],
     [
      406.8,
      352.8
     ],
     [
      401.5,
      359
     ],
     [
      392.4,
      363.8
     ],
     [
      389.7,
      361.3
     ],
     [
      386.7,
      356.8
     ],
     [
      386.2,
      355.3
     ],
     [
      387.1,
      353.6
     ],
     [
      395.6,
      345.8
     ],
     [
      400.9,
      339.5
     ],
     [
      401.3,
      336.4
     ],
     [
      400.6,
      335.1
     ],
     [
      399.5,
      334.7
     ],
     [
      390.2,
      336.8
     ],
     [
      378.3,
      338.8
     ],
     [
      358,
      344.3
     ],
     [
      355,
      343.9
     ],
     [
      353.9,
      342.5
     ],
     [
      355.4,
      336.6
     ],
     [
      357,
      333.9
     ],
     [
      358,
      330.2
     ],
     [
      357.7,
      318
     ],
     [
      360.6,
      318
     ],
     [
      365.8,
      316.9
     ],
     [
      368.1,
      315.8
     ],
     [
      372.3,
      312.8
     ],
     [
      375.9,
      309.1
     ],
     [
      384.6,
      297.5
     ],
     [
      387.1,
      294.7
     ],
     [
      390,
      292.6
     ],
     [
      393.4,
      291
     ],
     [
      401.1,
      288.5
     ],
     [
      411.5,
      285.9
     ],
     [
      413.8,
      284.9
     ],
     [
      416.5,
      283.1
     ],
     [
      418.9,
      280.7
     ],
     [
      420.8,
      283.1
     ],
     [
      422.7,
      284.2
     ],
     [
      428.6,
      285.6
     ],
     [
      435.4,
      286
     ],
     [
      446.1,
      284.6
     ],
     [
      447.3,
      283.4
     ],
     [
      447.3,
      282.7
     ],
     [
      446.2,
      281
     ],
     [
      438.9,
      276.7
     ],
     [
      437.3,
      274.6
     ],
     [
      437.8,
      273.5
     ],
     [
      439.1,
      272.7
     ],
     [
      441.1,
      272.1
     ],
     [
      445.5,
      271.7
     ],
     [
      449.4,
      272.1
     ],
     [
      452.3,
      273.2
     ],
     [
      454.2,
      274.6
     ],
     [
      454.9,
      276.2
     ],
     [
      454.8,
      276.8
     ],
     [
      451.3,
      279.3
     ],
     [
      450.3,
      280.5
     ],
     [
      450.4,
      281.5
     ],
     [
      451.5,
      281.8
     ],
     [
      454.4,
      281.7
     ],
     [
      466.3,
      280.7
     ],
     [
      463.4,
      285.2
     ],
     [
      463,
      294.2
     ],
     [
      463.2,
      296.2
     ],
     [
      468.2,
      304.7
     ],
     [
      469.9,
      310.9
     ],
     [
      471.3,
      314.3
     ],
     [
      474.6,
      318.5
     ],
     [
      490.6,
      327.7
     ],
     [
      496.8,
      332.9
     ],
     [
      501.8,
      334.7
     ],
     [
      503.3,
      336.6
     ],
     [
      504.1,
      339.1
     ],
     [
      504.2,
      341.7
     ]
    ]
   ]
  },
  "izmir": {
   "paths": [
    "m430.41,401.55c.34.88.47,1.73.46,2.55-.07,4.11-3.78,7.55-3.95,9.95-.21,2.87-4.28,14.65-4.12,21.75.17,7.1,2.15,12.88-2.8,14.53-1.18.4-2.97.74-5.01,1.02.23-1.24.9-2.66,1.35-3.3.71-1.02.35-3.52-.31-4.18-.66-.66-2.28-1.46-3.52-.99-1.24.46-3.44.24-5.42-1.19-1.98-1.43-6.36-4.92-8.15-4.46-1.79.47-2.97,1.85-3.52,2.04s-1.25-2.06-1.45-3.1c-.21-1.03-.95-3.55-1.7-4.12-.74-.58-1.01-1.68-1.87-3.1-.87-1.43-4.71-.91-6.3-.56-1.59.35-1.82,1.61-1.71,2.69.1,1.07-.23,3.57-1.26,3.59-1.04.02-3.57-1.45-4.73-3.49s-4.07-3.85-6.77-3.91c-2.7-.05-3.11-2.59-4.9-4.87-1.79-2.29.66-3.99,1.57-3.33.91.66,3,1.68,4.24,1.76,1.24.08,3.8-3.4,5.32-5.3,1.53-1.9-.41-2.85-2.1-4.04-1.7-1.2-3.35-3.6-4.67-8.1-1.32-4.5.5-5.45,3.1-5.98,2.6-.54,4.83,1.61,5.12,2.52.29.9,1.61,3.67,2.76,5.07,1.16,1.41,2.3,3.2,2.36,4.3.05,1.1-1.71,1.24-2.09,2.25-.39,1.02,2.2,4.49,2.86,8.54.66,4.04,2.97,2.39,2.97,1.73s.22-5.59.36-6.66c.14-1.07,1.62-1.07,1.7-.25.09.83,2.41,3.7,3.51,3.66,1.09-.05,6.83-2.6,8.15-3.24s4.31-1.02,5.41-.56c1.09.45,2.06,1.44,3.43,2.1,1.36.66,2.62-1.32,2.66-3.09.04-1.78-1.8-2.71-2.66-2.85-.87-.15-2.71-.62-4.3-.5-1.59.13-4.14,1.34-5.3,1.48-1.15.14-1.79-2.06-2.72-4.9-.94-2.83-2.31-4.26-5.12-5.67-2.81-1.4-3.15-4.11-2.82-6.97.33-2.87,5.09-2.19,6.76-1.09,1.66,1.1,2.4-1.2,2.8-1.91.4-.72-.68-3.17-.84-3.46-.17-.29-1.36-1.37,2.77-.93,4.13.44,3.77-7.6,2.97-7.68-.8-.08-6.03.85-8.42,1.43-2.39.58-2.59-2.18-2.59-2.18,0,0-.11-3.96,0-4.89.11-.94.11-.97,1.93-1.38,1.82-.41,2.12-1.84,1.9-3.52-.17-1.29-1.73-3.45-3.34-5,2.99-1.72,6.39-3.17,7.52-3.76,1.9-.99,4.46-3.79,6.11-6.27,1.65-2.48,7.68-5.12,9.91-6.09,2.23-.96,4.13-1.84,6.85-1.01,1.21.36,1.96.82,2.65,1.13,0,0,2.51,5.6,2.72,6.63.21,1.03,1.03,5.66,1.4,7.14.38,1.49,1.86,5.16,2.65,6.19.78,1.04-.1,9.15-1.81,14.42-1.72,5.28-2.03,14.16,0,19.41Z"
   ],
   "label": [
    396,
    396
   ],
   "bbox": [
    364,
    346.5,
    432,
    451.5
   ],
   "geoNeighbors": [
    "aydin",
    "balikesir",
    "usak"
   ],
   "poly": [
    [
     [
      430.4,
      401.6
     ],
     [
      430.9,
      404.1
     ],
     [
      430.2,
      407.1
     ],
     [
      426.9,
      414.1
     ],
     [
      423.3,
      429.8
     ],
     [
      422.8,
      435.8
     ],
     [
      423.3,
      445.1
     ],
     [
      423.1,
      446.9
     ],
     [
      422.5,
      448.4
     ],
     [
      421.5,
      449.5
     ],
     [
      420,
      450.3
     ],
     [
      415,
      451.4
     ],
     [
      416.7,
      447.1
     ],
     [
      416.7,
      445.8
     ],
     [
      416,
      443.9
     ],
     [
      414.5,
      443
     ],
     [
      413.5,
      442.7
     ],
     [
      411.4,
      443.1
     ],
     [
      408.6,
      442.5
     ],
     [
      402.9,
      438.8
     ],
     [
      399.7,
      437.2
     ],
     [
      398.9,
      437.2
     ],
     [
      395.4,
      439.3
     ],
     [
      395,
      439
     ],
     [
      392.8,
      432.8
     ],
     [
      390.4,
      428.9
     ],
     [
      389.3,
      428.2
     ],
     [
      385.6,
      428.1
     ],
     [
      383.1,
      428.8
     ],
     [
      382.6,
      429.5
     ],
     [
      381.8,
      434.3
     ],
     [
      381.1,
      434.7
     ],
     [
      380.1,
      434.4
     ],
     [
      377.5,
      432.6
     ],
     [
      375.2,
      429.7
     ],
     [
      373.6,
      428.5
     ],
     [
      371.7,
      427.6
     ],
     [
      368,
      426.8
     ],
     [
      366.8,
      425.7
     ],
     [
      364.2,
      421.6
     ],
     [
      364.1,
      420.8
     ],
     [
      364.5,
      419.6
     ],
     [
      365.4,
      419
     ],
     [
      370.5,
      420.8
     ],
     [
      371.7,
      420.3
     ],
     [
      375.9,
      415.5
     ],
     [
      376.4,
      414.3
     ],
     [
      376,
      413.2
     ],
     [
      372.5,
      410.4
     ],
     [
      371.3,
      408.7
     ],
     [
      369.1,
      403.4
     ],
     [
      368.7,
      400.6
     ],
     [
      369.2,
      398.9
     ],
     [
      370.4,
      397.9
     ],
     [
      372.2,
      397.4
     ],
     [
      374,
      397.4
     ],
     [
      376.8,
      399.1
     ],
     [
      378.4,
      402.3
     ],
     [
      381.7,
      407.3
     ],
     [
      382.4,
      409.3
     ],
     [
      382.2,
      410
     ],
     [
      380.3,
      411.5
     ],
     [
      380.3,
      412
     ],
     [
      382.4,
      417.2
     ],
     [
      383.5,
      421.4
     ],
     [
      383.9,
      422.2
     ],
     [
      384.9,
      422.7
     ],
     [
      386.2,
      421.8
     ],
     [
      386.5,
      415.2
     ],
     [
      387.4,
      414.3
     ],
     [
      388,
      414.5
     ],
     [
      389.6,
      417.1
     ],
     [
      391.7,
      418.6
     ],
     [
      399.9,
      415.3
     ],
     [
      402.7,
      414.6
     ],
     [
      405.3,
      414.8
     ],
     [
      408.7,
      416.9
     ],
     [
      409.7,
      416.9
     ],
     [
      410.6,
      416.2
     ],
     [
      411.4,
      413.8
     ],
     [
      411.1,
      412.6
     ],
     [
      409.5,
      411.2
     ],
     [
      404.4,
      410.4
     ],
     [
      399.1,
      411.9
     ],
     [
      398.4,
      411.6
     ],
     [
      395.6,
      405.1
     ],
     [
      394.6,
      403.6
     ],
     [
      389.6,
      400.1
     ],
     [
      388.7,
      398.4
     ],
     [
      388.5,
      394.4
     ],
     [
      389.4,
      392.8
     ],
     [
      391.3,
      392.3
     ],
     [
      393.5,
      392.6
     ],
     [
      396.3,
      393.5
     ],
     [
      397.1,
      393
     ],
     [
      398.1,
      390.6
     ],
     [
      397,
      387.2
     ],
     [
      401.3,
      386.8
     ],
     [
      402.3,
      386
     ],
     [
      403.3,
      383.3
     ],
     [
      403.4,
      380.6
     ],
     [
      402.9,
      379.3
     ],
     [
      393.7,
      380.8
     ],
     [
      392.3,
      379.9
     ],
     [
      391.9,
      378.5
     ],
     [
      391.9,
      373.7
     ],
     [
      392.2,
      372.8
     ],
     [
      394.9,
      371.8
     ],
     [
      395.8,
      370
     ],
     [
      395.4,
      367.7
     ],
     [
      392.4,
      363.8
     ],
     [
      401.5,
      359
     ],
     [
      408,
      351.9
     ],
     [
      413.7,
      348.7
     ],
     [
      419.2,
      346.5
     ],
     [
      422.8,
      346.6
     ],
     [
      425.5,
      347.8
     ],
     [
      428.2,
      354.4
     ],
     [
      430,
      363
     ],
     [
      432.4,
      368.4
     ],
     [
      432.2,
      373.3
     ],
     [
      429.4,
      386.7
     ],
     [
      429,
      391.9
     ],
     [
      429.3,
      397
     ],
     [
      430.4,
      401.5
     ]
    ]
   ]
  },
  "aydin": {
   "paths": [
    "m545.28,513.64s-5.67,11.83-5.78,14.03c-.11,2.21.28,4.96-1.32,6.66-1.6,1.71-5.4,5.59-5.97,9.39-.58,3.8-4.63,9.16-6.44,10.49-.44.32-1.08,1.03-1.82,1.94-.56-.22-1.17-.49-1.84-.84-3.42-1.76-8.11-8.91-7.78-9.73.33-.83-.58-6.2-.45-7.06.12-.87-1.08-1.65-1.9-1.74-.83-.08-2.52-.37-2.56-1.36-.04-.99,1.32-2.02,2.93-2.52,1.61-.49.16-3.55-.87-3.92-1.03-.37-3.51-1.86-4.91-3.22-1.4-1.36-2.81-1.49-3.22-.66-.41.83-1.65,2.11-2.85,2.52-1.2.41-.87,2.1-.62,2.85.25.74.5,2.39-.33,3.14-.82.74-1.36.33-2.02-2.15-.66-2.48-4.43-3.68-7.13-3.73-2.7-.06-3.47-1.82-3.52-3.96-.06-2.15-1.43-3.42-2.43-4.08-.99-.66-2.8.83-3.79.88-.99.06-.88-3.13-1.76-3.8-.89-.66-2.43-.22-2.92,1.6-.5,1.82-1.54,3.08-2.53,2.97-1-.11-3.14-2.58-4.41-2.91-1.26-.33-1.43,2.42-.49,4.4.93,1.98-.33,2.53-1.77,3.69-1.43,1.15-1.7,2.53-2.69,2.81-.99.27-3.58,4.4-4.35,5.5-.77,1.1-4.02,2.26-5.89,2.2-1.87-.05-.44-4.29-.5-5.5-.05-1.21,1.41-3.75,3.02-4.04,1.61-.28,2.6-1.15,3.88-1.23,1.28-.09.82-1.61,1.32-3.1.49-1.49-.37-2.52-1.16-2.11-.78.42-1.85,2.03-3.26,2.19-1.4.17-3.38.17-4.83.58-1.44.41-4.46.62-6.69.41-2.23-.2-6.02.46-7.3,1.41-1.28.95-1.12,3.05-2.44,3.3s-4.42-.08-5.94.41c-1.53.5-4.05.04-5.74-.66-1.7-.7.12-3.42,1.24-4.21,1.11-.78,3.5-1.03,5.36-.66,1.86.37,2.77-.08,3.26-1.16.5-1.07,3.39-.45,5.12-.33,1.74.13,7.23-2.14,9.21-1.98,1.98.17,7.49.77,8.48,0,.99-.77-.17-4.4-.61-6.27-.44-1.87,1.1-4.13,3.58-3.58,2.48.55,7.6-2,8.99-2.49,1.38-.5,3.94-2.11,3.19-3.2-.74-1.09-5.3.02-6.21.64-.91.62-8.05,1.24-10.24,1.32-2.19.08-8.71.29-12.34,1.57-3.63,1.28-12.98.92-15.54,1.2-2.56.27-2.2-3.5-3-3.94-.8-.44-3.16.55-5.12,2.56-1.95,2.01-2.86,1.65-3.46,1.13-.61-.52-.97-4.71-.97-5.75s.72-1.6,1.82-2.23c1.1-.64,4.79-2.23,7.46-1.41,2.67.83,6.35-1.81,6.35-2.31s.24-2.67,1.74-3.69,1.66-3.45,1.14-3.85-2.49.3-4.06,1.28-2.34-1.73-2.05-2.81c.29-1.07-2.29-1.17-3.45-1.11-1.15.06-2.45-.85-1.17-2.4,1.28-1.54,2.25-3.32.84-4.37-1.4-1.06-3.88,3.42-5.1,4.44-1.21,1.01-4.12.1-5.36-.56-1.24-.66.08-2.15.82-3.14.75-.99-1.79-5.28-1.54-6.08s-1.02-1.71-1.4-2.4c-.39-.68.49-1.84,1.84-2.8,1.35-.97-1.04-2.29-2.75-2.89-1.71-.61-5.27-2.18-6.24-2.3-.97-.13-1.14-1.1-1.05-1.72.08-.61,1.15-.41,1.15-.41,0,0,.52-.02,4.36.08,3.84.11,6.62-3.09,7.31-4.29.68-1.2.06-4.24-.69-5.4-.27-.43-.28-1.1-.13-1.82,2.04-.28,3.83-.62,5.01-1.02,4.95-1.65,2.97-7.43,2.8-14.53-.16-7.1,3.91-18.88,4.12-21.75.17-2.4,3.88-5.84,3.95-9.95.29,0,4.66-.03,5.47,1.65.85,1.73.69,4.87,2.94,5.65,2.25.79,5.04.51,6.31,3.62,1.27,3.11,3.25,3.66,5.89,3.55,2.64-.11,9.14-2.39,11.78.02,2.64,2.4,3.52,3.62,6.06,3.07,2.53-.55,7.59-.3,9.13,1.78,1.55,2.07,3.75,5.59,5.4,8.34,1.65,2.76,4.73,2.62,6.99,3.4,2.26.79,5.23,3.32,6.11,5.52.88,2.2,1.54,6.92.55,8.75-.99,1.82-.14,3.99,1.1,5.89,1.24,1.9,4.41,3.42,3.74,4.85-.66,1.43-3.08,3.02-4.95,4.97-1.87,1.96-6.77,2.73-7.21,4.39-.44,1.65-2.26,5.17-1.38,7.72.88,2.54,2.78,4.69,4.68,6.42,1.9,1.74,4.21,5.12,4.38,7.35.16,2.23,3.8,2.31,5.45,3.55,1.65,1.24,5.47,3.36,6.85,4.46,1.38,1.1,3.19,4.79,3.36,6.88.16,2.09,2.64,5.06,4.68,5.62,2.03.55,5.45-5.67,7.81-6.56.73-.27,1.34-.39,1.86-.37.12,0,.24.01.35.03s.22.04.32.07h.01c.08.02.15.05.23.08.02.01.04.02.07.03.06.03.12.06.17.09.2.11.38.26.52.43.07.07.12.15.17.23.14.2.24.43.32.68.44,1.38,6.02,2,7.67,1.58,1.65-.41,7.58,5.8,7.58,5.8Z"
   ],
   "label": [
    474,
    480
   ],
   "bbox": [
    403,
    404,
    545,
    556
   ],
   "geoNeighbors": [
    "antalya",
    "isparta",
    "izmir",
    "rhodes",
    "usak"
   ],
   "poly": [
    [
     [
      545.3,
      513.6
     ],
     [
      539.8,
      526.4
     ],
     [
      539,
      532.9
     ],
     [
      533.2,
      540.9
     ],
     [
      531.2,
      546.8
     ],
     [
      529.5,
      549.9
     ],
     [
      527.5,
      552.5
     ],
     [
      523.9,
      556.2
     ],
     [
      520.8,
      554.4
     ],
     [
      516.8,
      550.1
     ],
     [
      514.4,
      546.2
     ],
     [
      513.7,
      537.9
     ],
     [
      512,
      536.8
     ],
     [
      510.4,
      536.4
     ],
     [
      509.4,
      535.4
     ],
     [
      510.3,
      534
     ],
     [
      512.8,
      532.6
     ],
     [
      513,
      532.1
     ],
     [
      512.9,
      530.9
     ],
     [
      511.5,
      529
     ],
     [
      509.2,
      527.7
     ],
     [
      505.5,
      525
     ],
     [
      503.8,
      524.7
     ],
     [
      502.2,
      526.5
     ],
     [
      499.9,
      528.1
     ],
     [
      499.6,
      528.9
     ],
     [
      500.1,
      532
     ],
     [
      500,
      532.9
     ],
     [
      499,
      533.9
     ],
     [
      498.5,
      533.7
     ],
     [
      496.5,
      529.8
     ],
     [
      494.7,
      528.7
     ],
     [
      488.7,
      527.4
     ],
     [
      487.6,
      526.5
     ],
     [
      486,
      521.2
     ],
     [
      484.4,
      519.7
     ],
     [
      483.6,
      519.5
     ],
     [
      480.7,
      520.6
     ],
     [
      480.1,
      520.1
     ],
     [
      478.9,
      516.8
     ],
     [
      478.1,
      516.5
     ],
     [
      476.5,
      517.3
     ],
     [
      475.5,
      519.6
     ],
     [
      474.2,
      521.2
     ],
     [
      473.4,
      521.3
     ],
     [
      469,
      518.4
     ],
     [
      468.3,
      518.7
     ],
     [
      468,
      519.8
     ],
     [
      468.9,
      524.1
     ],
     [
      468.6,
      525
     ],
     [
      463.1,
      530.1
     ],
     [
      459.7,
      534.8
     ],
     [
      458.8,
      535.6
     ],
     [
      455.5,
      536.9
     ],
     [
      453.8,
      537
     ],
     [
      453,
      536.3
     ],
     [
      453.6,
      530.4
     ],
     [
      455.2,
      528.1
     ],
     [
      460.9,
      525.9
     ],
     [
      461.7,
      522.1
     ],
     [
      461,
      521
     ],
     [
      457.1,
      523.2
     ],
     [
      449.3,
      524.3
     ],
     [
      443.7,
      524.2
     ],
     [
      439.7,
      525
     ],
     [
      438.3,
      525.6
     ],
     [
      436.6,
      528.5
     ],
     [
      435.9,
      528.9
     ],
     [
      428.6,
      529.6
     ],
     [
      427.1,
      529.5
     ],
     [
      423.7,
      528.3
     ],
     [
      423.8,
      526.6
     ],
     [
      424.5,
      525.4
     ],
     [
      426.5,
      524
     ],
     [
      427.8,
      523.7
     ],
     [
      432,
      523.9
     ],
     [
      433,
      523.8
     ],
     [
      434.8,
      522.1
     ],
     [
      439.2,
      522.3
     ],
     [
      448.4,
      520.4
     ],
     [
      453,
      520.7
     ],
     [
      456.9,
      520.4
     ],
     [
      457.3,
      519.3
     ],
     [
      457.1,
      517.6
     ],
     [
      456.3,
      514.1
     ],
     [
      456.3,
      512.7
     ],
     [
      457,
      511.4
     ],
     [
      458.2,
      510.6
     ],
     [
      462.1,
      510.4
     ],
     [
      464.8,
      509.6
     ],
     [
      468.8,
      508
     ],
     [
      471.2,
      506.6
     ],
     [
      472,
      505.7
     ],
     [
      472,
      504.8
     ],
     [
      471.6,
      504.5
     ],
     [
      469,
      504.5
     ],
     [
      464.1,
      505.9
     ],
     [
      449.9,
      507.1
     ],
     [
      439.6,
      509
     ],
     [
      427.7,
      509.5
     ],
     [
      426.3,
      509.1
     ],
     [
      424.7,
      505.6
     ],
     [
      423.8,
      505.5
     ],
     [
      421.1,
      506.9
     ],
     [
      417.3,
      509.7
     ],
     [
      416.1,
      509.3
     ],
     [
      415.7,
      508.3
     ],
     [
      415.1,
      503.5
     ],
     [
      415.6,
      502.3
     ],
     [
      417,
      501.3
     ],
     [
      420.1,
      500.1
     ],
     [
      422.3,
      499.7
     ],
     [
      426.5,
      500
     ],
     [
      430.2,
      498.3
     ],
     [
      430.8,
      497.6
     ],
     [
      431.6,
      494.8
     ],
     [
      433.4,
      492.9
     ],
     [
      433.9,
      490.7
     ],
     [
      433.7,
      490.1
     ],
     [
      433,
      489.9
     ],
     [
      428.6,
      491.5
     ],
     [
      427.9,
      490.7
     ],
     [
      427.3,
      487.9
     ],
     [
      423.3,
      487.3
     ],
     [
      422.6,
      486.8
     ],
     [
      422.4,
      486
     ],
     [
      424.4,
      482.6
     ],
     [
      424.4,
      481.5
     ],
     [
      423.8,
      480.6
     ],
     [
      422.6,
      480.7
     ],
     [
      418.7,
      485.1
     ],
     [
      417.5,
      485.5
     ],
     [
      416,
      485.4
     ],
     [
      413.3,
      484.5
     ],
     [
      412.8,
      483.9
     ],
     [
      414.1,
      481.4
     ],
     [
      414.2,
      480.1
     ],
     [
      412.5,
      474.7
     ],
     [
      411.1,
      472.3
     ],
     [
      413.4,
      469.3
     ],
     [
      412.8,
      468.5
     ],
     [
      410.3,
      467.2
     ],
     [
      403.5,
      464.7
     ],
     [
      403,
      463.2
     ],
     [
      403.6,
      462.8
     ],
     [
      408.5,
      462.9
     ],
     [
      411.2,
      462.4
     ],
     [
      413.3,
      461.2
     ],
     [
      415.8,
      458.6
     ],
     [
      416.1,
      457.4
     ],
     [
      415.6,
      454.3
     ],
     [
      414.9,
      452.4
     ],
     [
      415,
      451.3
     ],
     [
      420,
      450.3
     ],
     [
      421.5,
      449.5
     ],
     [
      422.5,
      448.4
     ],
     [
      423.3,
      445.1
     ],
     [
      422.8,
      435.8
     ],
     [
      423.3,
      429.8
     ],
     [
      426.9,
      414.1
     ],
     [
      430.2,
      407.1
     ],
     [
      430.9,
      404.1
     ],
     [
      435.2,
      404.8
     ],
     [
      436.3,
      405.7
     ],
     [
      438,
      410.4
     ],
     [
      439.3,
      411.4
     ],
     [
      442.8,
      412.3
     ],
     [
      444.4,
      413.3
     ],
     [
      446.7,
      416.9
     ],
     [
      448,
      418
     ],
     [
      451.5,
      418.6
     ],
     [
      457.4,
      417.6
     ],
     [
      460.7,
      417.6
     ],
     [
      462.1,
      417.9
     ],
     [
      466.3,
      421.2
     ],
     [
      467.7,
      421.7
     ],
     [
      471.6,
      421.4
     ],
     [
      474.3,
      421.6
     ],
     [
      476.7,
      422.2
     ],
     [
      478.4,
      423.4
     ],
     [
      483.8,
      431.8
     ],
     [
      485.3,
      433.4
     ],
     [
      487.1,
      434.2
     ],
     [
      490.8,
      435.2
     ],
     [
      494.4,
      437.4
     ],
     [
      496.9,
      440.7
     ],
     [
      497.5,
      442.7
     ],
     [
      498,
      447.6
     ],
     [
      497.1,
      450.9
     ],
     [
      497.2,
      452.4
     ],
     [
      498.6,
      455.3
     ],
     [
      502.2,
      459.1
     ],
     [
      502.3,
      460.2
     ],
     [
      497.4,
      465.2
     ],
     [
      490.5,
      469
     ],
     [
      488.6,
      475.2
     ],
     [
      488.8,
      477.3
     ],
     [
      489.6,
      479.1
     ],
     [
      496.3,
      487.2
     ],
     [
      497.4,
      489.2
     ],
     [
      498.1,
      491.8
     ],
     [
      500,
      493.2
     ],
     [
      503.3,
      494.6
     ],
     [
      510.2,
      499
     ],
     [
      512.3,
      502.1
     ],
     [
      514,
      507.6
     ],
     [
      516.6,
      510.7
     ],
     [
      518.2,
      511.5
     ],
     [
      519.9,
      510.9
     ],
     [
      525.1,
      505.5
     ],
     [
      527.9,
      504.6
     ],
     [
      529,
      504.9
     ],
     [
      530.4,
      506.7
     ],
     [
      531.2,
      507.1
     ],
     [
      533.4,
      507.7
     ],
     [
      538.5,
      508
     ],
     [
      542.1,
      510.6
     ],
     [
      545.3,
      513.6
     ]
    ]
   ]
  },
  "antalya": {
   "paths": [
    "m698.69,550.19c.17,1.48-.52,8.8-2.42,11.2-.81,1.02-.94,3.27-.78,5.74-1.81-.42-3.5-.61-5.08-1.36-1.9-.91-2.56-3.39-5.12-4.38-2.56-.99-4.79-2.81-5.45-4.54-.66-1.74-5.75-9.19-9.55-13.6-3.8-4.4-9.08-7.7-13.76-7.92-4.68-.22-18.39-9.78-20.82-10.77-2.44-.99-8.38-4.58-10.28-4.54-1.9.04-7.52-1.15-11.07-2.06-3.55-.91-6.97-.25-9,.12-2.02.37-5.28.33-7.47-.58-2.19-.9-5.12-.95-6.94-.04-1.81.91-2.38,10.87-2.18,11.92.19,1.05-.5,8.48-1.2,9.01-.7.54-2.68,4.88-3.39,5.54-.7.66.21,3.63.91,5.49.7,1.85.58,2.35-.41,2.64-.99.29-.7,1.36-1.36,2.97-.66,1.61-2.69,2.64-2.81,1.94-.12-.7-1.2-1.9-2.44-1.86-1.23.05-2.8-1.52-6.19-2.1-3.38-.58-4.71.99-5.32,2.48-.62,1.48-1.78.2-3.43.28-1.65.09-2.56,2.11-4.42,2.19-1.86.09-2.97.09-4.13,1.45-1.15,1.36-2.85.95-4.29,1.28-1.45.33-2.93,2.1-3.76,2.19-.82.08-3.55.37-5.12-.5-1.57-.87-3.59-2.56-6.02-2.35-2.44.2-4.34-.29-6.24-1.7-1.53-1.12-2.94-1.26-5.2-2.18.74-.91,1.38-1.62,1.82-1.94,1.81-1.33,5.86-6.69,6.44-10.49.57-3.8,4.37-7.68,5.97-9.39,1.6-1.7,1.21-4.45,1.32-6.66.11-2.2,5.78-14.03,5.78-14.03,0,0,9.28,4.57,15.9,2.69,6.61-1.87,23.02-7.15,26.32-8.75,3.3-1.59,8.09-4.95,15.91-3.36,7.82,1.6,37.46,8.54,46.79,8.21,9.33-.33,9.25-.83,12.96-4.71,3.72-3.88,7.57-5.67,7.57-5.67,1.64,2.2,3.68,4.33,6.22,5.48,4.4,1.98,5.17,7.58,5.95,10.73.77,3.14,5.48,10.71,7.31,14.19,1.82,3.48,6.89,9.87,7.88,11.19.99,1.32,1.05,1.9,1.05,1.9,0,0-.61,3.16-.45,4.65Z"
   ],
   "label": [
    614,
    542
   ],
   "bbox": [
    524.5,
    502.5,
    699.5,
    567.5
   ],
   "geoNeighbors": [
    "adana",
    "aydin",
    "isparta",
    "konya"
   ],
   "poly": [
    [
     [
      698.7,
      550.2
     ],
     [
      698.3,
      555.4
     ],
     [
      697.5,
      558.8
     ],
     [
      695.8,
      562.4
     ],
     [
      695.5,
      563.7
     ],
     [
      695.5,
      567.1
     ],
     [
      692.9,
      566.6
     ],
     [
      690.4,
      565.8
     ],
     [
      686.9,
      562.4
     ],
     [
      681.9,
      559.4
     ],
     [
      680.6,
      558.2
     ],
     [
      676.2,
      551.1
     ],
     [
      670.3,
      543.3
     ],
     [
      667.2,
      540.2
     ],
     [
      663.7,
      537.7
     ],
     [
      660.1,
      536
     ],
     [
      654.4,
      534.8
     ],
     [
      651.6,
      533.7
     ],
     [
      637.1,
      525.3
     ],
     [
      626.3,
      520.2
     ],
     [
      611.7,
      517.5
     ],
     [
      601.7,
      518.3
     ],
     [
      594.3,
      516.8
     ],
     [
      590.9,
      517.5
     ],
     [
      589.8,
      519.6
     ],
     [
      589.1,
      523.4
     ],
     [
      588.1,
      536.9
     ],
     [
      583.9,
      544.8
     ],
     [
      585.5,
      551.3
     ],
     [
      584.1,
      552.4
     ],
     [
      583.3,
      555
     ],
     [
      581.7,
      556.9
     ],
     [
      580.9,
      557.2
     ],
     [
      579,
      555.3
     ],
     [
      574.1,
      553.6
     ],
     [
      569.7,
      552.9
     ],
     [
      568.2,
      553.5
     ],
     [
      566,
      556.1
     ],
     [
      563.1,
      555.8
     ],
     [
      558.7,
      558
     ],
     [
      555.5,
      558.6
     ],
     [
      553.6,
      560.1
     ],
     [
      550.3,
      560.7
     ],
     [
      546.5,
      562.9
     ],
     [
      544.3,
      563
     ],
     [
      541.4,
      562.4
     ],
     [
      537.1,
      560.2
     ],
     [
      532.1,
      559.8
     ],
     [
      523.9,
      556.2
     ],
     [
      527.5,
      552.5
     ],
     [
      529.5,
      549.9
     ],
     [
      531.2,
      546.8
     ],
     [
      533.2,
      540.9
     ],
     [
      539,
      532.9
     ],
     [
      539.8,
      526.4
     ],
     [
      545.3,
      513.6
     ],
     [
      550.7,
      515.7
     ],
     [
      555.9,
      516.7
     ],
     [
      561.2,
      516.3
     ],
     [
      582.9,
      509.4
     ],
     [
      593.8,
      504.7
     ],
     [
      598.1,
      503.9
     ],
     [
      603.4,
      504.2
     ],
     [
      626.2,
      509
     ],
     [
      640.1,
      511.5
     ],
     [
      650.2,
      512.4
     ],
     [
      655.6,
      512.1
     ],
     [
      658.8,
      511.4
     ],
     [
      660.9,
      510
     ],
     [
      665.9,
      505.2
     ],
     [
      670.7,
      502.1
     ],
     [
      673.5,
      505.2
     ],
     [
      678.4,
      508.4
     ],
     [
      679.6,
      509.6
     ],
     [
      681.3,
      512.5
     ],
     [
      683.4,
      519.6
     ],
     [
      686.2,
      525.2
     ],
     [
      692.1,
      535.5
     ],
     [
      699,
      545.1
     ],
     [
      698.7,
      550.2
     ]
    ]
   ]
  },
  "samsun": {
   "paths": [
    "m984.68,273.27c-.63.95-3.77,1.58-5.53,1.87-1.76.3-.88,3.62-.49,4.61.38.99-3.97.88-5.56.77-1.6-.11-4.3,4.07-6.39,4.4-2.09.33-6.05-3.08-7.56-8.28-1.51-5.19-4.33-7.68-8.4-7.95-4.08-.26-5.51-2.26-8.92-5.46-3.41-3.19-9.47-3.08-13.32-2.94-3.85.14-5.17-2.56-12.11-4.54-6.94-1.98-7.27-8.26-8.7-9.03s-5.39,1.43-9.25,2.2c-3.85.77-7.04-5.39-8.58-7.37-1.54-1.99-4.52-3.86-7.16.11-2.64,3.96-7.7,9.35-11.01,7.26-3.3-2.09-10.9-1.43-14.75-1.65-3.85-.22-8.15-8.04-11.56-9.36-3.41-1.32-4.95-.77-13.98-1.98-9.03-1.21-10.46-2.64-11.17-6.27-.71-3.64-6-5.92-8.87-5.95-2.87-.03-5.83-1.21-11.89-3.52-6.05-2.31-9.47-.44-10.9,2.86s-5.17,9.36-7.59,11.67c-2.43,2.31,2.09,4.95,2.09,9.14,0,.09,0,.17-.02.25,0,.09-.02.18-.05.26h0c-.01.05-.01.09-.03.13-.01.04-.02.07-.04.11-.03.1-.08.2-.13.3,0,.01-.02.03-.03.05,0,.01-.01.03-.02.04-.05.1-.12.19-.19.29-.02.03-.04.05-.06.08-.06.08-.12.16-.19.23-.04.03-.07.07-.1.1-.08.09-.17.17-.26.24-.11.11-.23.21-.36.3-.13.1-.26.19-.4.28,0,0-.01.01-.02.02-.14.08-.28.17-.43.25-.15.09-.31.18-.47.26s-.33.16-.5.24c-.34.16-.7.31-1.07.45-.45.18-.92.34-1.4.49-.57.18-1.14.34-1.69.48-.09.02-.18.05-.27.07-.18.05-.36.09-.54.13-.18.04-.36.09-.53.12-.15.04-.29.07-.43.1-.19.04-.37.08-.54.11-.19.04-.37.07-.53.1-.78.15-1.36.24-1.63.28h-.01s-.05.01-.07.01c-.06,0-.09,0-.09,0-1.67-3.27-4.74-6.98-9.04-11.9-8.04-9.19-12.33-2.91-30.4-8.9-18.07-5.98-11.43-16.25-11.1-21.2.33-4.96-5.4-6.28-7.71-10.13-2.31-3.85-1.1-5.62-3.19-8.59-1.23-1.75-2.31-6.89-2.99-10.83,4.74-1.41,8.78-2.56,9.81-2.93,2.76-.99,10.24-5.06,13.21-6.83,2.98-1.76,3.86-.44,10.68.11,6.83.55,25.38,1,31.98,1.33,6.61.33,21.91,1.54,24.44,2.47,2.54.94,9.83-.41,13.88-1.32,4.04-.91,7.81-7.43,8.69-8.5.88-1.08,2.98-1.24,3.47,1.26.5,2.51,3.58,2.73,4.6,2.59,1.02-.14.58,1.51-.47,2.06-1.05.55-1.68,4.49-1.43,6.64.25,2.14,3.47,5.61,5.37,8.67,1.89,3.05,10.37,6,13.03,8.09,2.66,2.09,6.04,1.71,10.94,1.65,4.9-.05,12.82-3.85,14.31-4.84,1.49-.99,1.6-.94,6.17,1.76,4.56,2.69,4.34,8.53,3.93,11.92-.41,3.38.66,4.04,3.39,7.76,2.72,3.71,9.96,11.14,13.1,11.75,3.13.6,7.76-3.25,9.91-6.06,2.14-2.8,4.01-2.36,9.3-.71,5.28,1.65,10.57,4.62,11.45,7.32.88,2.7,3.25,4.4,6.27,6,3.03,1.6,12.94,2.81,14.43,4.24,1.48,1.43,5.61,3.47,7.26,3.74,1.65.28,3.19-1.04,4.29-3.3,1.11-2.26,2.26-2.42,4.57-2.31,2.32.11,4.46,2.2,3.8,4.23-.66,2.04,2.15,3.8,4.79,4.52,2.64.71,10.46,1.93,12.44,2.42.08.02.17.04.26.05-.45,2.12-.93,3.85-1.41,4.74-1.99,3.63-2.98,8.81-1.33,15.19,1.39,5.35,2.54,9.15,3,11.47Z"
   ],
   "label": [
    846,
    220
   ],
   "bbox": [
    707,
    161.5,
    985,
    284.5
   ],
   "geoNeighbors": [
    "kastamonu",
    "sivas",
    "trabzon"
   ],
   "poly": [
    [
     [
      984.7,
      273.3
     ],
     [
      982.3,
      274.5
     ],
     [
      978.6,
      275.4
     ],
     [
      978.1,
      277.2
     ],
     [
      978.6,
      280.1
     ],
     [
      976.6,
      280.5
     ],
     [
      972.5,
      280.7
     ],
     [
      968.4,
      284.1
     ],
     [
      966.7,
      284.9
     ],
     [
      965.8,
      284.9
     ],
     [
      962.7,
      282.9
     ],
     [
      960.7,
      280.2
     ],
     [
      957.8,
      273.2
     ],
     [
      955.9,
      270.8
     ],
     [
      953.6,
      269.3
     ],
     [
      948.1,
      268.2
     ],
     [
      946,
      267.1
     ],
     [
      941.8,
      263.2
     ],
     [
      938.9,
      261.4
     ],
     [
      935.3,
      260.5
     ],
     [
      926,
      259.9
     ],
     [
      920.7,
      257.3
     ],
     [
      914.1,
      254.8
     ],
     [
      911,
      252.2
     ],
     [
      907.7,
      246.7
     ],
     [
      906.2,
      246.6
     ],
     [
      898.5,
      248.9
     ],
     [
      897,
      248.9
     ],
     [
      895.7,
      248.4
     ],
     [
      893.3,
      246.3
     ],
     [
      888.5,
      240.2
     ],
     [
      886.7,
      239.4
     ],
     [
      885.7,
      239.4
     ],
     [
      883.7,
      240.4
     ],
     [
      880.3,
      244.8
     ],
     [
      877.5,
      247.6
     ],
     [
      874.4,
      249.2
     ],
     [
      873,
      249.4
     ],
     [
      868.5,
      247.8
     ],
     [
      857,
      247.3
     ],
     [
      854,
      245.9
     ],
     [
      848.1,
      239.9
     ],
     [
      845.4,
      237.9
     ],
     [
      843,
      237.2
     ],
     [
      828.4,
      235.5
     ],
     [
      824.1,
      234.4
     ],
     [
      821.7,
      232.9
     ],
     [
      821,
      232
     ],
     [
      819.8,
      228.4
     ],
     [
      819,
      227.2
     ],
     [
      816.6,
      225.3
     ],
     [
      813.9,
      224.1
     ],
     [
      806.6,
      222.8
     ],
     [
      799.5,
      220.2
     ],
     [
      795.4,
      219.2
     ],
     [
      792.3,
      219.5
     ],
     [
      790,
      220.9
     ],
     [
      785.2,
      229.3
     ],
     [
      780.4,
      235.6
     ],
     [
      780.3,
      236.5
     ],
     [
      782.9,
      242.4
     ],
     [
      783.1,
      244.1
     ],
     [
      782.5,
      245.4
     ],
     [
      781.2,
      246.5
     ],
     [
      778.7,
      247.7
     ],
     [
      771,
      249.6
     ],
     [
      767.4,
      244.3
     ],
     [
      761.9,
      237.7
     ],
     [
      759.1,
      235
     ],
     [
      756.3,
      233.3
     ],
     [
      753.6,
      232.5
     ],
     [
      742.8,
      231.5
     ],
     [
      734.8,
      229.8
     ],
     [
      728.4,
      227.7
     ],
     [
      725.9,
      226.4
     ],
     [
      722.1,
      223.7
     ],
     [
      720,
      220.8
     ],
     [
      719.1,
      217.8
     ],
     [
      719,
      214.9
     ],
     [
      720.4,
      207.6
     ],
     [
      720.3,
      205.9
     ],
     [
      719.7,
      204.5
     ],
     [
      712.7,
      197.5
     ],
     [
      711.6,
      195
     ],
     [
      710.6,
      191
     ],
     [
      708.6,
      187
     ],
     [
      706.6,
      178.1
     ],
     [
      717.6,
      174.6
     ],
     [
      731.5,
      167.5
     ],
     [
      740.3,
      168.4
     ],
     [
      778.5,
      170.2
     ],
     [
      792.7,
      171.5
     ],
     [
      797.8,
      172.5
     ],
     [
      803,
      172.3
     ],
     [
      810.6,
      170.9
     ],
     [
      812,
      170.3
     ],
     [
      816.1,
      166.7
     ],
     [
      819.2,
      162.4
     ],
     [
      820.1,
      161.8
     ],
     [
      821.1,
      161.7
     ],
     [
      822.1,
      162.3
     ],
     [
      823.5,
      165.2
     ],
     [
      824.8,
      166
     ],
     [
      827.8,
      166.4
     ],
     [
      827.5,
      167.7
     ],
     [
      826.1,
      169.3
     ],
     [
      825.6,
      171
     ],
     [
      825.4,
      175
     ],
     [
      826.1,
      176.8
     ],
     [
      830.8,
      183.6
     ],
     [
      833.2,
      185.9
     ],
     [
      846,
      192.9
     ],
     [
      848.4,
      193.4
     ],
     [
      856.7,
      193.2
     ],
     [
      863.2,
      191.3
     ],
     [
      870,
      188
     ],
     [
      871,
      188
     ],
     [
      872.5,
      188.7
     ],
     [
      876.7,
      191.4
     ],
     [
      877.8,
      192.8
     ],
     [
      879.1,
      196
     ],
     [
      879.4,
      199.3
     ],
     [
      879.1,
      204.3
     ],
     [
      879.7,
      206
     ],
     [
      885.3,
      213.3
     ],
     [
      888.9,
      217
     ],
     [
      894.3,
      221.2
     ],
     [
      895.7,
      221.7
     ],
     [
      898.2,
      221.4
     ],
     [
      901,
      220
     ],
     [
      903.5,
      217.9
     ],
     [
      907.2,
      214.1
     ],
     [
      909,
      213.6
     ],
     [
      911.5,
      214
     ],
     [
      918.8,
      216.4
     ],
     [
      922.2,
      218.2
     ],
     [
      925.8,
      221.2
     ],
     [
      927.2,
      224.1
     ],
     [
      928.6,
      225.7
     ],
     [
      934,
      228.9
     ],
     [
      946.1,
      232
     ],
     [
      950.6,
      234.8
     ],
     [
      954.3,
      236.2
     ],
     [
      955.5,
      236.2
     ],
     [
      956.6,
      235.6
     ],
     [
      959.4,
      231.6
     ],
     [
      960.4,
      230.9
     ],
     [
      963.1,
      230.6
     ],
     [
      964.8,
      231.1
     ],
     [
      966.1,
      232
     ],
     [
      966.9,
      233.4
     ],
     [
      967,
      236.3
     ],
     [
      968.1,
      237.6
     ],
     [
      969.8,
      238.7
     ],
     [
      972.9,
      239.7
     ],
     [
      984.4,
      241.9
     ],
     [
      983.7,
      244.7
     ],
     [
      981.7,
      249.6
     ],
     [
      981,
      253.2
     ],
     [
      980.9,
      257.2
     ],
     [
      981.7,
      261.8
     ],
     [
      984.7,
      273.3
     ]
    ]
   ]
  },
  "van": {
   "paths": [
    "m1333.73,490.16c-.19.72-1.82,1.82-2.01,2.42-.19.61.62,3.79.62,3.79,0,0-5.12.62-6.28-.38-1.15-.99-2.8.05-3.38.58-.58.54-7.06,6.4-7.47,6.94-.42.54-3.26.66-4.05.74-.78.08-1.11,0-.95,1.45.17,1.44-2.06,3.34-3.14,3.55-1.07.2-2.47-.87-2.72-2.03-.25-1.15-1.45-2.93-2.31-5.03-.87-2.11,1.24-4.71,3.01-5.49,1.78-.79.95-2.44.54-3.97-.42-1.52-3.76-4.66-6.07-5.57-2.31-.91-7.35.33-8.67.91s-1.82,1.4-2.07,3.47c-.24,2.06-4.4,2.28-5.44,2.28s-2.37-1.21-4.68-.88c-2.32.33-5.89.17-7.46-.91-1.57-1.07-4.13.33-6.44-.49-2.31-.83-4.38-4.13-6.2-4.96-1.81-.82-1.48,2.07-4.95.17-3.47-1.9-11.12-2.45-12.94-1.52-1.81.94-4.23,2.37-6.38,1.21-2.15-1.15-7.71-2.31-9.58-1.32s-.05,5.62-1.04,6.33c-1,.72-4.35,1.54-4.68,2.65-.33,1.1-2.15,4.29-3.09,4.18-.93-.11-6,1.16-7.76,1.93-1.76.77-3.36-1.66-3.36-3.86s-1.37-5.12-3.02-6.05c-1.65-.94-5.95-.99-7.93.49-1.98,1.49-7.93,5.62-15.36,8.26-.32.11-.63.22-.93.31-7.86-7.82-7.43-14.76-2.95-18.52,4.87-4.08,3.47-9.29,1.74-16.3-1.74-7.02-8.84-10.24-13.88-13.05-5.03-2.81-8.5-10.57-3.3-13.54,5.2-2.97,9.75-10.57,10.74-14.12.99-3.55-1.82-12.3-2.48-15.28-.4-1.83-1.55-2.57-3.16-2.82,4.23-.52,12.66-1.8,17.47-4.17,6.61-3.24,9.06-13.9,13.43-17.2,4.38-3.3,17.09-1.9,23.7-6.6,6.6-4.71,24.52-9.75,26.17-11.56,1.65-1.82,1.57-6.44-.33-9-1.9-2.56,2.48-8.01,6.03-8.59s8.67,7.35,15.52,7.18c5.07-.12,16.66.51,29.97-.18.14.47.22.9.23,1.26.05,1.98,1.7,4.9,3.35,5.78,1.66.88,2.92,5.5,2.87,6.71-.06,1.21.22,3.86-.22,4.96-.44,1.1-.39,4.34.11,6.27.49,1.93,1.98,3.74,3.41,4.79,1.43,1.05,2.31,2.75,1.1,3.58-1.21.82-.42,3.18-1.14,3.84-.72.67-.35,1.28-.11,2.07.25.78.67,1.67.44,2.91-.23,1.24.41,1.4,1.09,1.53.68.12.87,5.78.68,6.97-.18,1.2-.55,8.94-.27,9.9.27.96,2.26,1.15,3.91,1.24,1.65.08,3.44-.77,5.23.63,1.78,1.4-.94,4.93-2.29,5.5-1.35.58-2.57,4.84-2.41,6.14.17,1.3-1.22,4.05-2.41,5.48-1.18,1.43-5.25,10.99-5.82,12.38-.58,1.38.02,2.17.53,2.66.52.5,6.46.52,6.98.76.52.25,1.16,2.05,1.18,2.48.02.43.35.91,1.03.99.68.08,1.61.7,2.02,1.24.42.54,1.38,1.4,2.15,1.09.77-.3,2.94.31,4.05.72,1.1.41,2.64,3.11,2.69,4.21.06,1.1-1.59,1.93-2.17,2.86-.58.94-.44,1.08.33,1.85.77.77.71.99.6,1.59-.11.61-.35,3.58-.02,4.24.33.66.11,1.21-.2,1.79-.3.58-.85,2.97-.68,3.33.16.36,1.1,1.1,1.23,1.6.14.49.61,1.26,1.27,1.73.66.47.55.83.85,1.43.31.61.44.72,1.05.77.6.06,1.68.28,4.07,2.56,2.4,2.29,3,3.99,2.81,4.71Z"
   ],
   "label": [
    1245,
    429
   ],
   "bbox": [
    1156.5,
    348.5,
    1333.5,
    509.5
   ],
   "geoNeighbors": [
    "aleppo",
    "diyarbakir",
    "erzurum",
    "mosul"
   ],
   "poly": [
    [
     [
      1333.7,
      490.2
     ],
     [
      1331.7,
      492.6
     ],
     [
      1332.3,
      496.4
     ],
     [
      1327.5,
      496.5
     ],
     [
      1325.1,
      495.6
     ],
     [
      1324.2,
      495.7
     ],
     [
      1322.7,
      496.6
     ],
     [
      1315.2,
      503.5
     ],
     [
      1310.3,
      504.5
     ],
     [
      1309.9,
      506.8
     ],
     [
      1309.1,
      507.9
     ],
     [
      1307.1,
      509.3
     ],
     [
      1306.2,
      509.2
     ],
     [
      1304.7,
      508.1
     ],
     [
      1302,
      502.2
     ],
     [
      1301.9,
      500.6
     ],
     [
      1302.6,
      498.9
     ],
     [
      1303.7,
      497.6
     ],
     [
      1305.9,
      496
     ],
     [
      1306.1,
      495
     ],
     [
      1305.6,
      492.7
     ],
     [
      1304.8,
      491.3
     ],
     [
      1301.4,
      488.2
     ],
     [
      1299.5,
      487.2
     ],
     [
      1297.4,
      486.8
     ],
     [
      1294.8,
      487.1
     ],
     [
      1290.8,
      488.1
     ],
     [
      1289.4,
      489.2
     ],
     [
      1288.5,
      492.2
     ],
     [
      1288,
      492.8
     ],
     [
      1286.4,
      493.5
     ],
     [
      1283.3,
      493.8
     ],
     [
      1280.2,
      492.9
     ],
     [
      1274.6,
      493
     ],
     [
      1269.9,
      491.6
     ],
     [
      1264.8,
      491.5
     ],
     [
      1263.1,
      490.5
     ],
     [
      1258.6,
      486.6
     ],
     [
      1257.5,
      486.5
     ],
     [
      1255.6,
      487.4
     ],
     [
      1250.4,
      485.6
     ],
     [
      1243,
      484.8
     ],
     [
      1235.9,
      486.9
     ],
     [
      1229.4,
      485
     ],
     [
      1225.6,
      484.8
     ],
     [
      1224.7,
      485.1
     ],
     [
      1223.9,
      486.4
     ],
     [
      1224,
      490.3
     ],
     [
      1223.7,
      491.5
     ],
     [
      1219.7,
      493.3
     ],
     [
      1217.7,
      496.6
     ],
     [
      1215.9,
      498.3
     ],
     [
      1206.9,
      500.2
     ],
     [
      1205.8,
      499.4
     ],
     [
      1205.1,
      498
     ],
     [
      1204.5,
      494.6
     ],
     [
      1202.9,
      491.3
     ],
     [
      1201.8,
      490.3
     ],
     [
      1197.9,
      489.6
     ],
     [
      1195.7,
      490
     ],
     [
      1193.8,
      490.8
     ],
     [
      1188.2,
      494.5
     ],
     [
      1183.7,
      496.9
     ],
     [
      1177.5,
      499.4
     ],
     [
      1175,
      496.5
     ],
     [
      1173.1,
      493.7
     ],
     [
      1172,
      491.1
     ],
     [
      1171.4,
      488.6
     ],
     [
      1171.5,
      486.3
     ],
     [
      1172.1,
      484.2
     ],
     [
      1173.1,
      482.4
     ],
     [
      1176.1,
      479.3
     ],
     [
      1177.7,
      475.7
     ],
     [
      1177.9,
      473.8
     ],
     [
      1177.5,
      469.5
     ],
     [
      1175.4,
      462.1
     ],
     [
      1174.1,
      459.9
     ],
     [
      1170.6,
      456.4
     ],
     [
      1160.7,
      450.2
     ],
     [
      1157.8,
      446.8
     ],
     [
      1156.6,
      442.8
     ],
     [
      1156.8,
      440.9
     ],
     [
      1157.6,
      439.3
     ],
     [
      1162.9,
      435
     ],
     [
      1166.1,
      431.1
     ],
     [
      1168.5,
      427.1
     ],
     [
      1169.9,
      423.8
     ],
     [
      1170,
      420.4
     ],
     [
      1167.4,
      408.6
     ],
     [
      1166.3,
      406.5
     ],
     [
      1164.2,
      405.7
     ],
     [
      1172.8,
      404.3
     ],
     [
      1177.6,
      403.1
     ],
     [
      1181.7,
      401.6
     ],
     [
      1184,
      400
     ],
     [
      1186,
      398
     ],
     [
      1193.6,
      385.9
     ],
     [
      1195.1,
      384.4
     ],
     [
      1197.2,
      383.3
     ],
     [
      1213,
      380.3
     ],
     [
      1216.1,
      379.3
     ],
     [
      1225.5,
      374.2
     ],
     [
      1244.5,
      366.6
     ],
     [
      1245.9,
      364.4
     ],
     [
      1246.2,
      362
     ],
     [
      1245.8,
      359.4
     ],
     [
      1244.3,
      356.1
     ],
     [
      1244.3,
      354.9
     ],
     [
      1245.7,
      352.2
     ],
     [
      1248,
      349.8
     ],
     [
      1249.4,
      349
     ],
     [
      1250.7,
      348.6
     ],
     [
      1252.1,
      348.8
     ],
     [
      1261.4,
      354.7
     ],
     [
      1263.8,
      355.5
     ],
     [
      1282.2,
      355.9
     ],
     [
      1296.2,
      355.6
     ],
     [
      1296.8,
      358.5
     ],
     [
      1297.5,
      360.2
     ],
     [
      1300.9,
      363.9
     ],
     [
      1302.5,
      367.9
     ],
     [
      1302.1,
      377.1
     ],
     [
      1302.5,
      380.6
     ],
     [
      1303.9,
      383.3
     ],
     [
      1307.5,
      387.3
     ],
     [
      1307.6,
      388.2
     ],
     [
      1306.5,
      389.8
     ],
     [
      1306.2,
      392
     ],
     [
      1305.5,
      393.8
     ],
     [
      1306.2,
      396.2
     ],
     [
      1306.2,
      398.5
     ],
     [
      1307.6,
      399.6
     ],
     [
      1308,
      402.4
     ],
     [
      1307.7,
      416.2
     ],
     [
      1309.2,
      417.1
     ],
     [
      1315.5,
      417.4
     ],
     [
      1316.9,
      418.1
     ],
     [
      1317.5,
      419.4
     ],
     [
      1316.9,
      421.1
     ],
     [
      1315.8,
      422.6
     ],
     [
      1313.6,
      424.6
     ],
     [
      1312.8,
      426.4
     ],
     [
      1311.5,
      432.4
     ],
     [
      1309.2,
      436.1
     ],
     [
      1306.6,
      441.4
     ],
     [
      1304,
      447.6
     ],
     [
      1303.8,
      449.2
     ],
     [
      1304.5,
      450.2
     ],
     [
      1311.5,
      451
     ],
     [
      1312.9,
      454.1
     ],
     [
      1314.8,
      454.9
     ],
     [
      1316.6,
      456.5
     ],
     [
      1321.9,
      457.5
     ],
     [
      1323.6,
      459.3
     ],
     [
      1324.6,
      461.7
     ],
     [
      1324.4,
      462.5
     ],
     [
      1322.4,
      464.6
     ],
     [
      1322.1,
      465.5
     ],
     [
      1323.4,
      467.3
     ],
     [
      1323.2,
      471.4
     ],
     [
      1323.5,
      473.2
     ],
     [
      1322.4,
      477.4
     ],
     [
      1326.2,
      482.7
     ],
     [
      1329.4,
      484.1
     ],
     [
      1332.4,
      487.1
     ],
     [
      1333.3,
      488.4
     ],
     [
      1333.7,
      490.2
     ]
    ]
   ]
  },
  "erzurum": {
   "paths": [
    "M1313.3,334.2 L1313.1,334.2 L1312.8,334.3 L1312.3,334.4 L1311.6,334.6 L1310.7,334.7 L1309.7,335 L1308.5,335.2 L1307.1,335.5 L1305.6,335.7 L1304,335.9 L1302.2,336 L1300.3,336 L1298.2,335.9 L1296,335.8 L1293.7,335.6 L1291.3,335.4 L1289.1,335.1 L1287.2,334.9 L1285.6,334.6 L1284.3,334.3 L1283.3,334 L1282.6,333.7 L1282.1,333.5 L1282,333.2 L1281.7,332.8 L1281.3,332.5 L1280.8,332.2 L1280.2,331.8 L1279.4,331.5 L1278.6,331.1 L1277.6,330.7 L1276.6,330.3 L1275.6,329.9 L1274.7,329.4 L1273.9,328.9 L1273.1,328.4 L1272.5,327.9 L1271.9,327.3 L1271.5,326.7 L1271.1,326.1 L1270.7,325.5 L1270.2,324.9 L1269.7,324.4 L1269.2,323.9 L1268.6,323.5 L1267.9,323 L1267.2,322.6 L1266.5,322.3 L1265.7,322 L1264.8,321.8 L1263.8,321.8 L1262.8,321.8 L1261.7,321.9 L1260.5,322.2 L1259.3,322.5 L1258,322.9 L1256.8,323.2 L1255.7,323.4 L1254.8,323.5 L1254,323.5 L1253.3,323.4 L1252.8,323.2 L1252.4,322.9 L1252.1,322.5 L1251.8,322 L1251.5,321.4 L1251.3,320.7 L1251.1,319.9 L1250.9,319 L1250.8,318.1 L1250.6,317 L1250.6,315.9 L1250.5,314.9 L1250.4,314 L1250.3,313.3 L1250.3,312.8 L1250.2,312.3 L1250.2,312 L1250.2,311.9 L1249.3,310.5 L1248.8,310.3 L1248.6,310.3 L1248.2,310.2 L1247.5,310.2 L1246.7,310.1 L1245.6,310 L1244.3,309.9 L1242.8,309.8 L1241.1,309.7 L1239.3,309.6 L1237.5,309.7 L1235.6,309.8 L1233.6,310.1 L1231.6,310.4 L1229.5,310.9 L1227.3,311.4 L1225.1,312.1 L1223,312.6 L1221,313 L1219.1,313.3 L1217.3,313.5 L1215.6,313.6 L1214.1,313.5 L1212.7,313.4 L1211.3,313.1 L1210.1,312.8 L1208.9,312.3 L1207.9,311.7 L1206.9,311.1 L1206,310.3 L1205.1,309.5 L1204.4,308.5 L1203.7,307.5 L1203,306.5 L1202.3,305.5 L1201.5,304.5 L1200.7,303.6 L1199.8,302.8 L1199,301.9 L1198,301.1 L1197.1,300.4 L1196.1,299.7 L1195.2,299 L1194.2,298.5 L1193.3,298 L1192.3,297.5 L1191.4,297.1 L1190.5,296.8 L1189.5,296.6 L1188.7,296.3 L1187.8,295.9 L1187.1,295.5 L1186.4,295 L1185.7,294.5 L1185.1,294 L1184.6,293.3 L1184.1,292.7 L1183.6,292 L1183.3,291.4 L1183.1,290.8 L1182.9,290.2 L1182.9,289.6 L1182.9,289.1 L1183,288.6 L1183.2,288.1 L1183.7,287.4 L1184.5,286.7 L1185.6,285.9 L1187,285 L1188.7,284 L1190.6,282.9 L1192.9,281.7 L1195.5,280.4 L1197.7,279.1 L1199.6,277.9 L1201.2,276.7 L1202.4,275.6 L1203.3,274.5 L1203.8,273.4 L1204,272.4 L1203.8,271.5 L1203.7,270.5 L1203.7,269.7 L1203.7,268.8 L1203.7,268 L1203.8,267.2 L1204,266.4 L1204.2,265.7 L1204.5,265.1 L1204.7,264.5 L1204.9,264 L1205.1,263.5 L1205.2,263.2 L1205.3,263 L1205.4,262.8 L1205.4,262.7 L1208.5,261.5 L1207.1,259.4 L1205.5,256.9 L1201.8,251.7 L1199.7,249.4 L1197.3,247.6 L1194.6,246.5 L1191.6,246.3 L1190.1,246.7 L1188.8,247.4 L1186.4,249.8 L1184.4,253.1 L1182.7,256.8 L1181.3,260.5 L1180.2,263.7 L1179.2,266.1 L1178.7,266.8 L1178.3,267.2 L1177.3,267.3 L1176.1,267.1 L1173.2,266.2 L1170.1,265.3 L1168.5,265.1 L1167.1,265.2 L1163.9,266.3 L1160.3,267.7 L1156.7,268.7 L1155,268.7 L1153.5,268.4 L1152.4,267.4 L1151.8,265.8 L1151.1,261.5 L1150.5,257.2 L1149.9,255.7 L1148.8,254.8 L1147.4,254.5 L1145.6,254.2 L1143.6,254.2 L1141.5,254.4 L1139.2,255 L1136.8,255.9 L1134.3,257.3 L1131.8,259.2 L1129.1,261.3 L1125.8,263.4 L1122,265.4 L1118,267.4 L1109.3,271.2 L1100.6,274.6 L1098.6,275.2 L1096.5,275.5 L1092.6,275.2 L1088.9,274.1 L1085.5,272.6 L1082.6,271 L1080.2,269.8 L1078.5,269.2 L1078,269.4 L1077.6,269.8 L1077.1,271.4 L1076.9,273.8 L1076.5,279.6 L1075.6,285.6 L1074.7,288.1 L1073.4,290 L1072.3,291.9 L1071.9,294.3 L1071.9,297 L1072.1,299.9 L1072.4,305.8 L1072,308.5 L1071,310.8 L1070.1,311.8 L1068.9,312.6 L1065.9,313.7 L1062.1,314.3 L1057.8,314.5 L1053.2,314.2 L1048.8,313.6 L1044.6,312.6 L1041.1,311.5 L1034.9,309.2 L1028.8,307 L1023,305.3 L1017.6,304.3 L1012.4,304 L1007.5,304.1 L1005.6,304.2 L1004,304.4 L1003,304.5 L1002.6,304.6 L1003.5,306.4 L1003.5,308 L1002.4,309.9 L1001,311.6 L1000,313.5 L999.9,314.6 L1000.1,316 L1000.3,317.5 L1000.2,319.2 L999.2,322.7 L998.1,326 L997.7,327.5 L997.4,328.6 L996.8,333.3 L996.8,335.8 L997.5,338.3 L1000.1,342.9 L1000.8,344.7 L1000.8,345.4 L1000.4,345.9 L999.3,347.1 L998.3,348.6 L997.7,350.6 L997.6,352.9 L998.1,355.7 L998.5,358.9 L998.6,361.8 L998.4,362.8 L998,363.4 L997.3,364 L996.4,364.8 L996.5,364.9 L997,365.1 L998.6,366 L1001.1,367 L1004.4,367.7 L1008.4,368.6 L1012.2,370.6 L1015.5,373.1 L1016.7,374.5 L1017.6,375.9 L1018.6,378.4 L1019.1,380.5 L1019.7,381.3 L1020.5,381.9 L1021.8,382.3 L1023.7,382.6 L1028.7,382.9 L1034.2,383.5 L1040.3,384.8 L1043.4,385.9 L1046.5,387.2 L1049.3,388.5 L1051.3,389.4 L1052.8,390 L1053.9,390.2 L1055.5,389.9 L1057.5,388.9 L1060.6,388.1 L1064,388 L1067.3,387.8 L1068.7,387.4 L1070,386.8 L1071.2,385.8 L1072.6,384.4 L1075.4,381 L1076.6,379 L1077.4,376.9 L1077.7,374.8 L1077.5,372.6 L1077.1,370.8 L1077.3,369.7 L1077.8,369.2 L1078.5,369 L1080.7,369.1 L1083,368.8 L1084.5,368.1 L1086.5,367 L1091.4,364.1 L1096.1,361.4 L1097.9,360.4 L1099.1,359.9 L1100.8,360.1 L1101.5,360.6 L1102,361.4 L1102.3,362.4 L1102.2,363.6 L1101.8,365 L1100.9,366.6 L1098.8,369.7 L1097.4,372.2 L1096.9,374.7 L1097,376 L1097.4,377.4 L1098.6,380.2 L1099.7,382.7 L1100.7,384.8 L1101.6,386.3 L1102,387.9 L1101.8,389.9 L1101.2,391.8 L1100.5,392.8 L1099.5,393.1 L1098.3,393.1 L1097.1,393.2 L1096.3,393.6 L1095.7,394.8 L1094.9,396.6 L1094.2,398.5 L1094.1,399.8 L1094.3,400.3 L1094.7,401.2 L1095.9,403.5 L1097.1,406 L1097.7,408 L1097.8,409.3 L1097.9,410.2 L1097.9,410.7 L1097.9,410.9 L1098.2,410.9 L1098.9,411 L1101.3,411 L1104.2,410.3 L1105.5,409.5 L1106.6,408.3 L1108.7,405.5 L1111.2,403.1 L1114.3,401.6 L1116.1,401.2 L1118.1,401.2 L1122.5,401.5 L1127.3,401.4 L1132.2,400.6 L1134.5,399.8 L1136.9,398.7 L1139,397.5 L1140.8,396.5 L1143.7,395.1 L1146,394.5 L1148,394.8 L1148.9,395.3 L1149.6,396.1 L1150.6,398.3 L1151.7,400.9 L1153.5,403.6 L1154.6,404.7 L1155.5,405.4 L1157,406 L1158.6,406 L1160.7,405.7 L1164.2,405.7 L1166,405.5 L1168.1,405.2 L1172.8,404.3 L1177.6,403.1 L1181.7,401.6 L1184,400 L1186,398 L1189.3,393 L1192.1,388 L1193.6,385.9 L1195.1,384.4 L1197.2,383.3 L1199.8,382.6 L1206.2,381.6 L1213,380.3 L1216.1,379.3 L1218.8,377.8 L1221.8,376 L1225.5,374.2 L1233.8,370.9 L1237.8,369.4 L1241.2,368.1 L1243.7,367 L1244.5,366.6 L1245,366.2 L1245.9,364.4 L1246.2,362 L1245.8,359.4 L1244.7,357.2 L1244.3,356.1 L1244.3,354.9 L1244.8,353.5 L1245.7,352.2 L1248,349.8 L1249.4,349 L1250.7,348.6 L1252.1,348.8 L1253.7,349.5 L1257.2,352 L1261.4,354.7 L1263.8,355.5 L1266.2,355.8 L1268.4,355.8 L1271.2,355.8 L1274.4,355.9 L1278.1,355.9 L1282.2,355.9 L1286.6,355.9 L1296.2,355.6 L1295,352.2 L1294.4,350.8 L1294.1,349.8 L1294.2,349 L1294.7,348.2 L1296,347.5 L1297.1,347.4 L1298.4,347.3 L1299.8,347.4 L1300.7,347.4 L1302,347.4 L1303.4,347.1 L1304.3,347.4 L1305.3,348.4 L1306.4,349.4 L1307,349.6 L1307.6,349.4 L1309.3,348 L1310,347.5 L1311.2,347.3 L1312.6,347.2 L1313.8,346.8 L1314.6,346 L1314.9,345 L1314.7,343.2 L1314.5,340.8 L1314.4,338.6 L1314.5,337.8 L1314.7,337.3 Z"
   ],
   "label": [
    1161,
    322
   ],
   "bbox": [
    996.4,
    246.3,
    1314.9,
    411
   ],
   "geoNeighbors": [
    "diyarbakir",
    "elazig",
    "igdir",
    "kars",
    "sivas",
    "trabzon",
    "van"
   ],
   "poly": [
    [
     [
      1314.7,
      337.3
     ],
     [
      1314.4,
      338.6
     ],
     [
      1314.9,
      345
     ],
     [
      1314.6,
      346
     ],
     [
      1313.8,
      346.8
     ],
     [
      1310,
      347.5
     ],
     [
      1307,
      349.6
     ],
     [
      1304.3,
      347.4
     ],
     [
      1303.4,
      347.1
     ],
     [
      1296,
      347.5
     ],
     [
      1294.7,
      348.2
     ],
     [
      1294.1,
      349.8
     ],
     [
      1296.2,
      355.6
     ],
     [
      1274.4,
      355.9
     ],
     [
      1263.8,
      355.5
     ],
     [
      1261.4,
      354.7
     ],
     [
      1253.7,
      349.5
     ],
     [
      1250.7,
      348.6
     ],
     [
      1249.4,
      349
     ],
     [
      1248,
      349.8
     ],
     [
      1245.7,
      352.2
     ],
     [
      1244.3,
      354.9
     ],
     [
      1244.3,
      356.1
     ],
     [
      1245.8,
      359.4
     ],
     [
      1246.2,
      362
     ],
     [
      1245.9,
      364.4
     ],
     [
      1244.5,
      366.6
     ],
     [
      1225.5,
      374.2
     ],
     [
      1216.1,
      379.3
     ],
     [
      1213,
      380.3
     ],
     [
      1197.2,
      383.3
     ],
     [
      1195.1,
      384.4
     ],
     [
      1193.6,
      385.9
     ],
     [
      1186,
      398
     ],
     [
      1181.7,
      401.6
     ],
     [
      1172.8,
      404.3
     ],
     [
      1164.2,
      405.7
     ],
     [
      1157,
      406
     ],
     [
      1155.5,
      405.4
     ],
     [
      1153.5,
      403.6
     ],
     [
      1151.7,
      400.9
     ],
     [
      1149.6,
      396.1
     ],
     [
      1148,
      394.8
     ],
     [
      1146,
      394.5
     ],
     [
      1143.7,
      395.1
     ],
     [
      1136.9,
      398.7
     ],
     [
      1132.2,
      400.6
     ],
     [
      1127.3,
      401.4
     ],
     [
      1116.1,
      401.2
     ],
     [
      1114.3,
      401.6
     ],
     [
      1111.2,
      403.1
     ],
     [
      1108.7,
      405.5
     ],
     [
      1105.5,
      409.5
     ],
     [
      1104.2,
      410.3
     ],
     [
      1101.3,
      411
     ],
     [
      1097.9,
      410.9
     ],
     [
      1097.7,
      408
     ],
     [
      1097.1,
      406
     ],
     [
      1094.1,
      399.8
     ],
     [
      1094.2,
      398.5
     ],
     [
      1096.3,
      393.6
     ],
     [
      1100.5,
      392.8
     ],
     [
      1101.8,
      389.9
     ],
     [
      1102,
      387.9
     ],
     [
      1101.6,
      386.3
     ],
     [
      1097.4,
      377.4
     ],
     [
      1096.9,
      374.7
     ],
     [
      1097.4,
      372.2
     ],
     [
      1101.8,
      365
     ],
     [
      1102.2,
      363.6
     ],
     [
      1102,
      361.4
     ],
     [
      1100.8,
      360.1
     ],
     [
      1099.1,
      359.9
     ],
     [
      1097.9,
      360.4
     ],
     [
      1083,
      368.8
     ],
     [
      1077.8,
      369.2
     ],
     [
      1077.3,
      369.7
     ],
     [
      1077.1,
      370.8
     ],
     [
      1077.7,
      374.8
     ],
     [
      1076.6,
      379
     ],
     [
      1072.6,
      384.4
     ],
     [
      1070,
      386.8
     ],
     [
      1067.3,
      387.8
     ],
     [
      1060.6,
      388.1
     ],
     [
      1053.9,
      390.2
     ],
     [
      1040.3,
      384.8
     ],
     [
      1034.2,
      383.5
     ],
     [
      1023.7,
      382.6
     ],
     [
      1020.5,
      381.9
     ],
     [
      1019.1,
      380.5
     ],
     [
      1018.6,
      378.4
     ],
     [
      1016.7,
      374.5
     ],
     [
      1015.5,
      373.1
     ],
     [
      1012.2,
      370.6
     ],
     [
      1008.4,
      368.6
     ],
     [
      1001.1,
      367
     ],
     [
      996.4,
      364.8
     ],
     [
      998,
      363.4
     ],
     [
      998.6,
      361.8
     ],
     [
      997.6,
      352.9
     ],
     [
      997.7,
      350.6
     ],
     [
      998.3,
      348.6
     ],
     [
      1000.8,
      345.4
     ],
     [
      1000.1,
      342.9
     ],
     [
      997.5,
      338.3
     ],
     [
      996.8,
      335.8
     ],
     [
      996.8,
      333.3
     ],
     [
      997.4,
      328.6
     ],
     [
      1000.2,
      319.2
     ],
     [
      1000,
      313.5
     ],
     [
      1003.5,
      308
     ],
     [
      1003.5,
      306.4
     ],
     [
      1002.6,
      304.6
     ],
     [
      1012.4,
      304
     ],
     [
      1017.6,
      304.3
     ],
     [
      1023,
      305.3
     ],
     [
      1028.8,
      307
     ],
     [
      1041.1,
      311.5
     ],
     [
      1048.8,
      313.6
     ],
     [
      1057.8,
      314.5
     ],
     [
      1065.9,
      313.7
     ],
     [
      1070.1,
      311.8
     ],
     [
      1071,
      310.8
     ],
     [
      1072,
      308.5
     ],
     [
      1072.4,
      305.8
     ],
     [
      1071.9,
      294.3
     ],
     [
      1072.3,
      291.9
     ],
     [
      1074.7,
      288.1
     ],
     [
      1075.6,
      285.6
     ],
     [
      1076.5,
      279.6
     ],
     [
      1077.1,
      271.4
     ],
     [
      1078,
      269.4
     ],
     [
      1078.5,
      269.2
     ],
     [
      1080.2,
      269.8
     ],
     [
      1088.9,
      274.1
     ],
     [
      1092.6,
      275.2
     ],
     [
      1096.5,
      275.5
     ],
     [
      1098.6,
      275.2
     ],
     [
      1109.3,
      271.2
     ],
     [
      1122,
      265.4
     ],
     [
      1129.1,
      261.3
     ],
     [
      1134.3,
      257.3
     ],
     [
      1136.8,
      255.9
     ],
     [
      1141.5,
      254.4
     ],
     [
      1143.6,
      254.2
     ],
     [
      1148.8,
      254.8
     ],
     [
      1149.9,
      255.7
     ],
     [
      1150.5,
      257.2
     ],
     [
      1151.8,
      265.8
     ],
     [
      1152.4,
      267.4
     ],
     [
      1153.5,
      268.4
     ],
     [
      1156.7,
      268.7
     ],
     [
      1167.1,
      265.2
     ],
     [
      1168.5,
      265.1
     ],
     [
      1176.1,
      267.1
     ],
     [
      1178.3,
      267.2
     ],
     [
      1179.2,
      266.1
     ],
     [
      1184.4,
      253.1
     ],
     [
      1186.4,
      249.8
     ],
     [
      1188.8,
      247.4
     ],
     [
      1191.6,
      246.3
     ],
     [
      1194.6,
      246.5
     ],
     [
      1197.3,
      247.6
     ],
     [
      1199.7,
      249.4
     ],
     [
      1201.8,
      251.7
     ],
     [
      1208.5,
      261.5
     ],
     [
      1205.4,
      262.7
     ],
     [
      1203.8,
      267.2
     ],
     [
      1203.8,
      273.4
     ],
     [
      1202.4,
      275.6
     ],
     [
      1197.7,
      279.1
     ],
     [
      1184.5,
      286.7
     ],
     [
      1183.2,
      288.1
     ],
     [
      1182.9,
      290.2
     ],
     [
      1183.6,
      292
     ],
     [
      1185.7,
      294.5
     ],
     [
      1187.8,
      295.9
     ],
     [
      1191.4,
      297.1
     ],
     [
      1195.2,
      299
     ],
     [
      1199,
      301.9
     ],
     [
      1201.5,
      304.5
     ],
     [
      1205.1,
      309.5
     ],
     [
      1206.9,
      311.1
     ],
     [
      1210.1,
      312.8
     ],
     [
      1215.6,
      313.6
     ],
     [
      1221,
      313
     ],
     [
      1231.6,
      310.4
     ],
     [
      1235.6,
      309.8
     ],
     [
      1239.3,
      309.6
     ],
     [
      1248.8,
      310.3
     ],
     [
      1250.2,
      311.9
     ],
     [
      1250.6,
      317
     ],
     [
      1251.5,
      321.4
     ],
     [
      1252.4,
      322.9
     ],
     [
      1253.3,
      323.4
     ],
     [
      1255.7,
      323.4
     ],
     [
      1261.7,
      321.9
     ],
     [
      1265.7,
      322
     ],
     [
      1269.2,
      323.9
     ],
     [
      1272.5,
      327.9
     ],
     [
      1274.7,
      329.4
     ],
     [
      1280.2,
      331.8
     ],
     [
      1281.7,
      332.8
     ],
     [
      1282.1,
      333.5
     ],
     [
      1287.2,
      334.9
     ],
     [
      1296,
      335.8
     ],
     [
      1302.2,
      336
     ],
     [
      1307.1,
      335.5
     ],
     [
      1313.3,
      334.2
     ]
    ]
   ]
  },
  "kastamonu": {
   "paths": [
    "m767.61,289.61h-.01c-6.24-4.27-23.21-7.18-27.41-6.56-4.47.66-3.02,3.74-12.27-.66-9.25-4.4-13.87-15.19-23.78-17.84-9.91-2.64-11.45,1.55-15.49,9.47-4.04,7.93-25.96,8.75-28.1,9.75-2.15.99-11.21.77-13.65,1.43-2.45.65-4.26,1.44-7.38,1.21-3.12-.24-4.96-3.3-6.33-2.64-1.38.66-5.67,1.48-8.42-.66-2.76-2.15-8.43-2.59-8.32.38s-3.52,9.25-7.15,10.46c-2.83.94-3.47,3.19-3.61,4.14-1.56-.69-4.08-1.01-6.25-1.85-2.82-1.09-5.82-9.5-6.35-11.03.02,0,.03-.01.05-.01,1.49-.33,1.49-4.21.42-6.2-1.08-1.98,1.4-9.08,3.96-9.49,2.56-.41,7.43-.79,7.68-2.96.25-2.16-1.24-4.97,1.73-6.78,2.97-1.82,9.08.08,11.64,0,2.56-.09,9.91,3.09,14.12-.48,4.21-3.57,3.64-8.03,4.3-9.18.66-1.16,3.08-3.81,5.78-3.39,2.69.42,7.73-.72,8.86-2.15,1.13-1.43,3.38-6.38,2.83-7.73s-6.19-.85-8.31-1.21c-2.12-.36-5.39-.8-6.63-1.41-.73-.35-5.72-3.24-10.44-6.06,2.55-2.59,3.47-5.75,3.78-6.87.49-1.82,4.95-5.62,8.26-5.62s6.93-6.27,7.76-7.76c.82-1.48,8.09-5.78,11.56-6.44,3.46-.66,10.23-5.28,12.38-7.92,2.15-2.65,13.27-6.83,14.92-8.81,1.03-1.24,10.9-4.29,18.81-6.65.68,3.94,1.76,9.08,2.99,10.83,2.09,2.97.88,4.74,3.19,8.59,2.31,3.85,8.04,5.17,7.71,10.13-.33,4.95-6.97,15.22,11.1,21.2,18.07,5.99,22.36-.29,30.4,8.9,4.3,4.92,7.37,8.63,9.04,11.9,0,0,.03,0,.09,0,.02,0,.05-.01.07-.01h.01c1.34,2.76,1.66,5.48.92,8.11-1.65,5.83,1.21,9.58,2.64,13.98,1.43,4.4,7.47,15.2-7.1,17.9Z"
   ],
   "label": [
    688,
    234
   ],
   "bbox": [
    593,
    178,
    777,
    298
   ],
   "geoNeighbors": [
    "ankara",
    "eskisehir",
    "sakarya",
    "samsun",
    "sivas"
   ],
   "poly": [
    [
     [
      767.6,
      289.6
     ],
     [
      761.3,
      286.7
     ],
     [
      749.1,
      283.7
     ],
     [
      740.2,
      283.1
     ],
     [
      734.7,
      284.7
     ],
     [
      730.9,
      283.7
     ],
     [
      724.6,
      280.5
     ],
     [
      710.7,
      267.8
     ],
     [
      707.6,
      265.9
     ],
     [
      704.1,
      264.6
     ],
     [
      700.8,
      263.9
     ],
     [
      698.1,
      263.8
     ],
     [
      695.9,
      264.3
     ],
     [
      694.2,
      265.3
     ],
     [
      691.4,
      268.8
     ],
     [
      687.7,
      275.4
     ],
     [
      686.4,
      276.7
     ],
     [
      682.9,
      278.7
     ],
     [
      673.9,
      281.5
     ],
     [
      657.9,
      284.3
     ],
     [
      648.1,
      285
     ],
     [
      643.5,
      286.1
     ],
     [
      639.5,
      286.4
     ],
     [
      637.4,
      285.8
     ],
     [
      634.3,
      283.9
     ],
     [
      629.5,
      284.5
     ],
     [
      627.1,
      284.2
     ],
     [
      622.3,
      281.8
     ],
     [
      618.3,
      281.5
     ],
     [
      616.7,
      282.5
     ],
     [
      615.9,
      286.2
     ],
     [
      614.3,
      289.4
     ],
     [
      612,
      292.2
     ],
     [
      607.6,
      294.9
     ],
     [
      606.5,
      296
     ],
     [
      605.7,
      298.1
     ],
     [
      599.4,
      296.2
     ],
     [
      597.3,
      294.3
     ],
     [
      595.4,
      290.9
     ],
     [
      593.1,
      285.2
     ],
     [
      594,
      284.4
     ],
     [
      594.3,
      282.7
     ],
     [
      594.2,
      280.8
     ],
     [
      593.3,
      278
     ],
     [
      593.4,
      276.7
     ],
     [
      594.2,
      273.7
     ],
     [
      595.7,
      270.9
     ],
     [
      596.6,
      270
     ],
     [
      602.2,
      268.7
     ],
     [
      604.9,
      267.3
     ],
     [
      605.4,
      261.3
     ],
     [
      606.9,
      259.8
     ],
     [
      609.6,
      259
     ],
     [
      619.7,
      259.9
     ],
     [
      625,
      260.8
     ],
     [
      629.1,
      260.9
     ],
     [
      631,
      260.3
     ],
     [
      632.7,
      259.3
     ],
     [
      635,
      256.5
     ],
     [
      636.2,
      253.8
     ],
     [
      637,
      250.1
     ],
     [
      639.1,
      247.8
     ],
     [
      640.8,
      246.9
     ],
     [
      647.8,
      246.3
     ],
     [
      650.1,
      245.6
     ],
     [
      651.6,
      244.6
     ],
     [
      653.7,
      240.7
     ],
     [
      654.4,
      238.4
     ],
     [
      654.5,
      236.8
     ],
     [
      654,
      236.4
     ],
     [
      646.2,
      235.6
     ],
     [
      640.8,
      234.6
     ],
     [
      629.1,
      228.2
     ],
     [
      631.8,
      224.2
     ],
     [
      633.2,
      220.5
     ],
     [
      635.9,
      217.8
     ],
     [
      638.5,
      216.3
     ],
     [
      642.4,
      215.4
     ],
     [
      643.6,
      214.7
     ],
     [
      645.9,
      212.3
     ],
     [
      648.9,
      207.9
     ],
     [
      650.5,
      206.4
     ],
     [
      657.3,
      202.5
     ],
     [
      661.9,
      201
     ],
     [
      667.1,
      198.3
     ],
     [
      670.5,
      195.8
     ],
     [
      674,
      192.5
     ],
     [
      685,
      186.6
     ],
     [
      688.5,
      184.2
     ],
     [
      694.6,
      181.8
     ],
     [
      706.5,
      178.1
     ],
     [
      708.6,
      187
     ],
     [
      710.6,
      191
     ],
     [
      711.6,
      195
     ],
     [
      712.7,
      197.5
     ],
     [
      719.7,
      204.5
     ],
     [
      720.3,
      205.9
     ],
     [
      720.4,
      207.6
     ],
     [
      719,
      214.9
     ],
     [
      719.1,
      217.9
     ],
     [
      720,
      220.8
     ],
     [
      722.1,
      223.7
     ],
     [
      725.9,
      226.4
     ],
     [
      728.4,
      227.7
     ],
     [
      734.8,
      229.8
     ],
     [
      742.8,
      231.5
     ],
     [
      753.6,
      232.5
     ],
     [
      756.3,
      233.3
     ],
     [
      759.1,
      235
     ],
     [
      761.9,
      237.7
     ],
     [
      767.4,
      244.3
     ],
     [
      771.1,
      249.6
     ],
     [
      772.4,
      253.7
     ],
     [
      771.6,
      261.8
     ],
     [
      772.2,
      265.3
     ],
     [
      776.3,
      276
     ],
     [
      777.2,
      281.3
     ],
     [
      776.6,
      283.9
     ],
     [
      775.1,
      286.3
     ],
     [
      772.2,
      288.3
     ],
     [
      767.6,
      289.6
     ]
    ]
   ]
  },
  "adana": {
   "paths": [
    "m824.91,514.9c-.57,2.56-.99,6.11-.33,8.59.25.95-.92,2.51-2.46,4.08-1.12-.61-1.97-1.05-2.33-1.16-1.43-.44-4.51-2.81-6.11-4.02-1.59-1.21-3.79-1.98-6.88-1.93-3.08.06-9.19,3.58-10.35,4.35-1.15.77-13.92,11.34-13.92,11.34,0,0-8.59,8.75-9.8,9.69-1.21.93-.99,3.8-1.05,5.39-.05,1.6-3.68,3.09-4.45,3.86-.78.77-2.48-.83-3.91-1.43-1.43-.61-5.23,2.2-6.11,3.63s-3.64,1.87-5.51,3.63c-1.87,1.76-7.92,2.2-9.52,2.26-1.6.05-4.29-.94-4.84-.33-.56.6-5.07,1.7-6.67,2.09-1.59.39-7.65-.17-8.86.39-1.21.55-1.43,1.76-3.52,1.7-2.09-.05-4.18-.44-6.55.06-2.37.49-7.29,2.89-9.61,3.38-2.31.5-3.3-2.39-5.53-3.05-.38-.11-.75-.21-1.11-.29-.16-2.47-.03-4.72.78-5.74,1.9-2.4,2.59-9.72,2.42-11.2-.16-1.49.45-4.65.45-4.65,0,0,3.7-1.08,5.06-.91,1.36.16,3.3-.04,5.2.29,1.9.33,3.38-1.78,4.91-2.03,1.53-.24,5.66-.37,6.9-.82,1.24-.46,1.44-3.68,1.69-4.4.25-.72,1.49-1.55,2.56-.6s2.85.83,3.1-.78c.24-1.61-4.3-4.05-5.66-4.5-1.36-.46-3.36-2.55-3.59-3.26-.23-.72-1.53-3.59-2.69-5-1.15-1.4-.7-2.68-.28-3.01.41-.33,2.51-.83,3.71-1.24,1.2-.41,3.8-.19,5.56.25s2.75-2.42,4.18-4.09c1.44-1.66,4.74-4.5,8.7-5.82,3.96-1.32,9.36-2.64,12.88-3.08,3.53-.43,6.5-.22,9.07-1.97,2.57-1.75,4.25-1.78,8-2.99,3.74-1.21,8.8-4.51,12.11-5.83,3.3-1.32,12-7.27,13.15-8.51.14-.15.21-.34.23-.59h0c2.02-.55,5.9-1.57,8.19-2.11,2.35-.54,7.07-.76,9.75-1.09,1.98,5.86,6.03,9.24,6.03,11.97s1.65,7.15,5.53,9.77c3.88,2.61,2.06,7.15,1.48,9.71Z"
   ],
   "label": [
    764,
    532
   ],
   "bbox": [
    696,
    483.5,
    826,
    570.5
   ],
   "geoNeighbors": [
    "antalya",
    "konya",
    "maras",
    "sivas"
   ],
   "poly": [
    [
     [
      824.9,
      514.9
     ],
     [
      824.3,
      519.2
     ],
     [
      824.5,
      524.3
     ],
     [
      822.1,
      527.6
     ],
     [
      818.5,
      525.8
     ],
     [
      813.7,
      522.4
     ],
     [
      810.8,
      521
     ],
     [
      809,
      520.6
     ],
     [
      805.5,
      520.6
     ],
     [
      800.9,
      522.4
     ],
     [
      796.1,
      525.1
     ],
     [
      782.5,
      536.2
     ],
     [
      772.7,
      545.8
     ],
     [
      772.1,
      546.9
     ],
     [
      771.7,
      551.2
     ],
     [
      771.1,
      552.4
     ],
     [
      767.2,
      555.1
     ],
     [
      766.5,
      555.3
     ],
     [
      763.3,
      553.7
     ],
     [
      761.9,
      553.8
     ],
     [
      758.3,
      556
     ],
     [
      756.2,
      558.2
     ],
     [
      750.8,
      561.5
     ],
     [
      746.8,
      562.7
     ],
     [
      742.2,
      563.2
     ],
     [
      738.1,
      562.7
     ],
     [
      730.7,
      564.9
     ],
     [
      722.5,
      565.2
     ],
     [
      719.6,
      566.9
     ],
     [
      711.7,
      567.1
     ],
     [
      702.1,
      570.5
     ],
     [
      700.6,
      570.3
     ],
     [
      698.1,
      568.2
     ],
     [
      695.5,
      567.1
     ],
     [
      695.8,
      562.4
     ],
     [
      697.5,
      558.8
     ],
     [
      698.3,
      555.4
     ],
     [
      699.1,
      545.5
     ],
     [
      702.8,
      544.7
     ],
     [
      710.8,
      544.8
     ],
     [
      714.3,
      542.9
     ],
     [
      721.2,
      542.1
     ],
     [
      722,
      541.3
     ],
     [
      722.9,
      537.7
     ],
     [
      723.9,
      536.7
     ],
     [
      724.6,
      536.7
     ],
     [
      726.4,
      537.6
     ],
     [
      727.3,
      537.6
     ],
     [
      728.1,
      537.2
     ],
     [
      728.6,
      536.3
     ],
     [
      728,
      535
     ],
     [
      726.3,
      533.6
     ],
     [
      721.8,
      531.2
     ],
     [
      719.8,
      529.3
     ],
     [
      716,
      522.5
     ],
     [
      715.9,
      521.6
     ],
     [
      716.3,
      520.5
     ],
     [
      721.2,
      519.1
     ],
     [
      725.6,
      519.5
     ],
     [
      726.8,
      519.3
     ],
     [
      731.2,
      514
     ],
     [
      735.7,
      510.9
     ],
     [
      738.5,
      509.6
     ],
     [
      748.4,
      507
     ],
     [
      758.4,
      505.6
     ],
     [
      762.2,
      503.5
     ],
     [
      771.4,
      500.3
     ],
     [
      783.8,
      494
     ],
     [
      791.6,
      488.9
     ],
     [
      793.7,
      487.2
     ],
     [
      793.9,
      486.7
     ],
     [
      802.1,
      484.5
     ],
     [
      811.9,
      483.5
     ],
     [
      813.6,
      487.4
     ],
     [
      817.2,
      493.2
     ],
     [
      818.2,
      497.7
     ],
     [
      819.2,
      500.3
     ],
     [
      820.9,
      502.9
     ],
     [
      824.6,
      506.3
     ],
     [
      825.4,
      507.4
     ],
     [
      825.8,
      510.1
     ],
     [
      824.9,
      514.9
     ]
    ]
   ]
  },
  "isparta": {
   "paths": [
    "m670.73,502.05s-3.85,1.79-7.57,5.67c-3.71,3.88-3.63,4.38-12.96,4.71-9.33.33-38.97-6.61-46.79-8.21-7.82-1.59-12.61,1.77-15.91,3.36-3.3,1.6-19.71,6.88-26.32,8.75-6.62,1.88-15.9-2.69-15.9-2.69,0,0-5.93-6.21-7.58-5.8-1.65.42-7.23-.2-7.67-1.58-.08-.25-.18-.48-.32-.68-.05-.08-.1-.16-.17-.23-.14-.17-.32-.32-.52-.43-.05-.03-.11-.06-.17-.09-.03-.01-.05-.02-.07-.03-.08-.03-.15-.06-.23-.08,2.34-1.21,4.12-7.18,5.83-11.5,1.87-4.74,4.18-9.03,3.96-13.37-.22-4.35,1.22-7.55,5.81-12.18,2.34-2.36,4.01-5.02,4.95-7.37,1.6-1.34,4.63-3.58,6.89-3.4,3.22.25,5.98,5.45,8.54,4.91s9.75-9.12,14-8.17c4.25.95,4.46,7.18,9.45,7.8,5,.62,8.55,1.78,10.24,4.42,1.69,2.64,3.54,13.43,10.8,16.18,7,2.65,12.01.07,22.53-2.43,0,.08,0,.16,0,.24.07,1,.34,1.84.97,2.3,2.2,1.6,6.11,2.97,8.97,3.03,2.86.05,9.47,1.59,11.23,2.04,1.76.44,12.99,7.12,14.97,10.26.83,1.32,1.83,2.97,3.03,4.57Z"
   ],
   "label": [
    600,
    487
   ],
   "bbox": [
    529,
    453.5,
    671,
    516.5
   ],
   "geoNeighbors": [
    "antalya",
    "aydin",
    "konya",
    "kutahya",
    "usak"
   ],
   "poly": [
    [
     [
      670.7,
      502.1
     ],
     [
      665.9,
      505.2
     ],
     [
      660.9,
      510
     ],
     [
      658.8,
      511.4
     ],
     [
      655.6,
      512.1
     ],
     [
      648.2,
      512.4
     ],
     [
      640.1,
      511.5
     ],
     [
      626.2,
      509
     ],
     [
      603.4,
      504.2
     ],
     [
      598.1,
      503.9
     ],
     [
      593.8,
      504.7
     ],
     [
      585.7,
      508.3
     ],
     [
      575.6,
      511.9
     ],
     [
      561.2,
      516.3
     ],
     [
      558.6,
      516.8
     ],
     [
      555.9,
      516.7
     ],
     [
      550.7,
      515.7
     ],
     [
      546.8,
      514.3
     ],
     [
      545.3,
      513.6
     ],
     [
      542.1,
      510.6
     ],
     [
      538.5,
      508
     ],
     [
      533.4,
      507.7
     ],
     [
      531.2,
      507.1
     ],
     [
      528.6,
      504.7
     ],
     [
      530.2,
      503
     ],
     [
      531.7,
      500.1
     ],
     [
      537.1,
      486.4
     ],
     [
      538.1,
      483.1
     ],
     [
      538.5,
      476.8
     ],
     [
      539.4,
      473.9
     ],
     [
      541.3,
      470.9
     ],
     [
      547.2,
      464
     ],
     [
      549.1,
      460.3
     ],
     [
      552.3,
      458
     ],
     [
      554.2,
      457.2
     ],
     [
      556,
      456.9
     ],
     [
      558.3,
      457.8
     ],
     [
      562.6,
      461.3
     ],
     [
      564.5,
      461.8
     ],
     [
      574.9,
      454.4
     ],
     [
      576.8,
      453.7
     ],
     [
      578.5,
      453.6
     ],
     [
      581.1,
      455.2
     ],
     [
      585,
      460.1
     ],
     [
      586.3,
      461
     ],
     [
      594.3,
      462.9
     ],
     [
      596.6,
      464.1
     ],
     [
      598.2,
      465.9
     ],
     [
      602.9,
      476.4
     ],
     [
      604.5,
      478.7
     ],
     [
      606.5,
      480.7
     ],
     [
      609,
      482
     ],
     [
      611.6,
      482.8
     ],
     [
      616.5,
      483.1
     ],
     [
      621.6,
      482.2
     ],
     [
      631.6,
      479.6
     ],
     [
      631.8,
      481.2
     ],
     [
      632.5,
      482.2
     ],
     [
      636.8,
      484.2
     ],
     [
      650.6,
      486.7
     ],
     [
      652.7,
      487.2
     ],
     [
      655.5,
      488.6
     ],
     [
      660.1,
      491.3
     ],
     [
      666.6,
      496.2
     ],
     [
      670.7,
      502.1
     ]
    ]
   ]
  },
  "usak": {
   "paths": [
    "m549.68,454.94c.54,1.12.32,3.09-.58,5.36-.94,2.35-2.61,5.01-4.95,7.37-4.59,4.63-6.03,7.83-5.81,12.18.22,4.34-2.09,8.63-3.96,13.37-1.71,4.32-3.49,10.29-5.83,11.5h-.01c-.1-.03-.21-.05-.32-.07s-.23-.03-.35-.03c-.52-.02-1.13.1-1.86.37-2.36.89-5.78,7.11-7.81,6.56-2.04-.56-4.52-3.53-4.68-5.62-.17-2.09-1.98-5.78-3.36-6.88-1.38-1.1-5.2-3.22-6.85-4.46-1.65-1.24-5.29-1.32-5.45-3.55-.17-2.23-2.48-5.61-4.38-7.35-1.9-1.73-3.8-3.88-4.68-6.42-.88-2.55.94-6.07,1.38-7.72.44-1.66,5.34-2.43,7.21-4.39,1.87-1.95,4.29-3.54,4.95-4.97.67-1.43-2.5-2.95-3.74-4.85-1.24-1.9-2.09-4.07-1.1-5.89.99-1.83.33-6.55-.55-8.75-.88-2.2-3.85-4.73-6.11-5.52-2.26-.78-5.34-.64-6.99-3.4-1.65-2.75-3.85-6.27-5.4-8.34-1.54-2.08-6.6-2.33-9.13-1.78-2.54.55-3.42-.67-6.06-3.07-2.64-2.41-9.14-.13-11.78-.02-2.64.11-4.62-.44-5.89-3.55-1.27-3.11-4.06-2.83-6.31-3.62-2.25-.78-2.09-3.92-2.94-5.65-.81-1.68-5.18-1.65-5.47-1.65,0-.82-.12-1.67-.46-2.55-2.03-5.25-1.72-14.13,0-19.41,1.71-5.27,2.59-13.38,1.81-14.42-.79-1.03-2.27-4.7-2.65-6.19-.37-1.48-1.19-6.11-1.4-7.14-.21-1.03-2.72-6.63-2.72-6.63.87.38,1.63.51,3.05-.12,2.56-1.13,5.64,1.69,7.35,2.84,1.71,1.16,2.15,1.54,4.13,1.1,1.98-.44,4.46.58,7.76.75,3.3.16,3.14-.42,2.81,3.13-.33,3.55,1.65,4.13,3.71,4.13s2.73.74,5.86,6.19c3.14,5.45,3.89,5.45,5.54,6.03,1.65.58,6.02-1.32,7.01-2.64,1-1.32,2.73-2.4,6.03-1.98,3.31.41,7.64-2.56,8.3-2.64.61-.08,3.19.4,3.58.48.66,1.1,2.14,3.14,4.22,3.77,2.89.86,7.76-.33,10.16,3.63,2.39,3.96,4.05,6.17,3.96,9.71-.08,3.54.33,4.58,1.7,6.31,1.36,1.73,7.72,5.74,14.4,5.08,6.69-.66,9.58-4.63,14.54-7.68,4.95-3.06,12.22-4.54,13.78.49.89,2.85,2.37,5.53,2.58,8.49.17,2.26-.41,4.68-2.58,7.45-4.98,6.38-3.1,8.28-1.56,10.75,1.54,2.46,8.69,8.08,9.35,12.26.66,4.18-6.71,11.67-11.67,15.19-4.95,3.52-.88,12.18.22,14.46Z"
   ],
   "label": [
    523,
    429
   ],
   "bbox": [
    425,
    347,
    561,
    511
   ],
   "geoNeighbors": [
    "aydin",
    "balikesir",
    "eskisehir",
    "isparta",
    "izmir",
    "kutahya"
   ],
   "poly": [
    [
     [
      549.7,
      454.9
     ],
     [
      549.9,
      455.9
     ],
     [
      549.6,
      458.7
     ],
     [
      547.1,
      464
     ],
     [
      541.3,
      470.9
     ],
     [
      539.4,
      473.9
     ],
     [
      538.5,
      476.8
     ],
     [
      538.1,
      483.1
     ],
     [
      537.1,
      486.4
     ],
     [
      531.7,
      500.1
     ],
     [
      530.2,
      503
     ],
     [
      528.5,
      504.7
     ],
     [
      526,
      505
     ],
     [
      525.1,
      505.5
     ],
     [
      519,
      511.5
     ],
     [
      518.2,
      511.6
     ],
     [
      516.6,
      510.7
     ],
     [
      514,
      507.6
     ],
     [
      513.1,
      504.1
     ],
     [
      511.2,
      500.3
     ],
     [
      510.2,
      499.1
     ],
     [
      503.3,
      494.6
     ],
     [
      498.5,
      492.4
     ],
     [
      496.3,
      487.2
     ],
     [
      490.8,
      480.8
     ],
     [
      488.8,
      477.3
     ],
     [
      488.6,
      475.2
     ],
     [
      489,
      473.1
     ],
     [
      490.5,
      469
     ],
     [
      497.4,
      465.2
     ],
     [
      502.3,
      460.2
     ],
     [
      502.2,
      459.1
     ],
     [
      498.6,
      455.3
     ],
     [
      497.2,
      452.4
     ],
     [
      497.1,
      450.9
     ],
     [
      498,
      447.6
     ],
     [
      497.9,
      445.2
     ],
     [
      496.9,
      440.7
     ],
     [
      495.9,
      439
     ],
     [
      492.6,
      436.1
     ],
     [
      485.3,
      433.4
     ],
     [
      483.8,
      431.8
     ],
     [
      478.4,
      423.4
     ],
     [
      476.7,
      422.2
     ],
     [
      474.3,
      421.6
     ],
     [
      471.6,
      421.4
     ],
     [
      467.7,
      421.7
     ],
     [
      466.3,
      421.2
     ],
     [
      462.1,
      417.9
     ],
     [
      460.7,
      417.6
     ],
     [
      457.4,
      417.6
     ],
     [
      451.5,
      418.6
     ],
     [
      448,
      418
     ],
     [
      446.7,
      416.9
     ],
     [
      444.4,
      413.3
     ],
     [
      442.8,
      412.3
     ],
     [
      439.3,
      411.4
     ],
     [
      438,
      410.4
     ],
     [
      436.3,
      405.8
     ],
     [
      435.2,
      404.8
     ],
     [
      430.9,
      404.1
     ],
     [
      429.3,
      397
     ],
     [
      429,
      391.9
     ],
     [
      429.4,
      386.7
     ],
     [
      432.2,
      373.3
     ],
     [
      432.4,
      368.4
     ],
     [
      430,
      363
     ],
     [
      428.2,
      354.4
     ],
     [
      425.4,
      347.8
     ],
     [
      426.8,
      348.1
     ],
     [
      430.5,
      347.4
     ],
     [
      432.5,
      348.2
     ],
     [
      437.8,
      351.6
     ],
     [
      441.6,
      351.5
     ],
     [
      450.5,
      352.6
     ],
     [
      450.5,
      356.7
     ],
     [
      451.5,
      358.9
     ],
     [
      452.8,
      359.4
     ],
     [
      455.6,
      359.8
     ],
     [
      456.8,
      360.6
     ],
     [
      462.8,
      369.9
     ],
     [
      464.5,
      371.4
     ],
     [
      465.7,
      371.8
     ],
     [
      467.3,
      371.8
     ],
     [
      469.4,
      371.2
     ],
     [
      471.4,
      370.2
     ],
     [
      474.8,
      367.5
     ],
     [
      481.3,
      367
     ],
     [
      487,
      364.6
     ],
     [
      490.6,
      365
     ],
     [
      492.2,
      367.1
     ],
     [
      494.8,
      368.8
     ],
     [
      500.1,
      369.5
     ],
     [
      502.8,
      370.3
     ],
     [
      505,
      372.4
     ],
     [
      507.9,
      377.4
     ],
     [
      508.7,
      379.7
     ],
     [
      509.2,
      386
     ],
     [
      510.6,
      388.5
     ],
     [
      514,
      391
     ],
     [
      520.1,
      393.3
     ],
     [
      525,
      393.5
     ],
     [
      529.4,
      392.5
     ],
     [
      532.9,
      390.6
     ],
     [
      539.6,
      385.9
     ],
     [
      545.7,
      383.3
     ],
     [
      549.6,
      383.2
     ],
     [
      551.2,
      383.7
     ],
     [
      552.5,
      384.7
     ],
     [
      555.6,
      392.7
     ],
     [
      555.9,
      396.6
     ],
     [
      554.7,
      400.3
     ],
     [
      550.8,
      406.3
     ],
     [
      550.1,
      409.1
     ],
     [
      550.7,
      411.2
     ],
     [
      551.8,
      413
     ],
     [
      559.6,
      422
     ],
     [
      561.1,
      425.3
     ],
     [
      561,
      427
     ],
     [
      559,
      431
     ],
     [
      553.5,
      437.2
     ],
     [
      548,
      442
     ],
     [
      547.3,
      443.9
     ],
     [
      547.3,
      448.2
     ],
     [
      549.7,
      454.9
     ]
    ]
   ]
  },
  "kutahya": {
   "paths": [
    "m638.31,407.56c-.44,2.76-.99,9.15,1.43,12.23,2.42,3.08,4.93,13.7,5.01,15.19.08,1.48-.66,3.19-5.07,5.06-4.4,1.87-3.9,2.75-3.24,5.62.66,2.86,1.87,9.85,1.1,11.94-.77,2.09-2.2,6.5-5.29,9.41-1.59,2.43.28,4.79.28,6.06,0,.87-1.05,4.1-.98,6.54-10.52,2.5-15.53,5.08-22.53,2.43-7.26-2.75-9.11-13.54-10.8-16.18-1.69-2.64-5.24-3.8-10.24-4.42-4.99-.62-5.2-6.85-9.45-7.8-4.25-.95-11.44,7.63-14,8.17s-5.32-4.66-8.54-4.91c-2.26-.18-5.29,2.06-6.89,3.4.9-2.27,1.12-4.24.58-5.36-1.1-2.28-5.17-10.94-.22-14.46,4.96-3.52,12.33-11.01,11.67-15.19-.66-4.18-7.81-9.8-9.35-12.26-1.54-2.47-3.42-4.37,1.56-10.75,2.17-2.77,2.75-5.19,2.58-7.45-.07-1.06-.31-2.08-.63-3.09,4.9-1.41,12.18-3.44,18.01-4.76,9.74-2.21,15.98-10.13,29.93-8.15,13.94,1.98,20.11-1.76,29.57-4.4,6.33-1.77,11.28-2.24,16.17-2.39-.56,1.41-.44,3.06-.18,4.15.5,2.06,1.9,5.36-1.23,9.74-3.14,4.38-3.06,5.7-3.14,8.59-.08,2.89-5.67,10.29-6.11,13.04Z"
   ],
   "label": [
    598,
    430
   ],
   "bbox": [
    547,
    372.5,
    649,
    483.5
   ],
   "geoNeighbors": [
    "eskisehir",
    "isparta",
    "konya",
    "usak"
   ],
   "poly": [
    [
     [
      638.3,
      407.6
     ],
     [
      638,
      413.6
     ],
     [
      638.4,
      417
     ],
     [
      641.5,
      423.3
     ],
     [
      643.8,
      430.3
     ],
     [
      644.7,
      435
     ],
     [
      644.6,
      436.1
     ],
     [
      643.9,
      437.4
     ],
     [
      642.3,
      438.7
     ],
     [
      637.2,
      441.3
     ],
     [
      636.2,
      442.5
     ],
     [
      636,
      443.8
     ],
     [
      637.5,
      451.9
     ],
     [
      637.7,
      456.6
     ],
     [
      635.8,
      462
     ],
     [
      634.3,
      464.6
     ],
     [
      632.2,
      467
     ],
     [
      631.6,
      468.8
     ],
     [
      632.5,
      473.1
     ],
     [
      631.5,
      479.6
     ],
     [
      621.6,
      482.2
     ],
     [
      616.5,
      483.1
     ],
     [
      611.6,
      482.8
     ],
     [
      609,
      482
     ],
     [
      606.5,
      480.7
     ],
     [
      604.5,
      478.7
     ],
     [
      602.9,
      476.4
     ],
     [
      598.2,
      465.9
     ],
     [
      596.6,
      464.1
     ],
     [
      594.3,
      462.9
     ],
     [
      586.3,
      461
     ],
     [
      585,
      460.1
     ],
     [
      581.1,
      455.2
     ],
     [
      578.5,
      453.6
     ],
     [
      576.8,
      453.7
     ],
     [
      574.9,
      454.4
     ],
     [
      564.5,
      461.8
     ],
     [
      562.6,
      461.3
     ],
     [
      558.3,
      457.8
     ],
     [
      556,
      456.9
     ],
     [
      554.2,
      457.2
     ],
     [
      552.3,
      458
     ],
     [
      549.1,
      460.3
     ],
     [
      549.9,
      455.9
     ],
     [
      547.3,
      448.2
     ],
     [
      547.3,
      443.9
     ],
     [
      548,
      442
     ],
     [
      553.5,
      437.2
     ],
     [
      557.4,
      433.1
     ],
     [
      560.3,
      428.9
     ],
     [
      561,
      427
     ],
     [
      561.1,
      425.3
     ],
     [
      559.6,
      422
     ],
     [
      551.8,
      413
     ],
     [
      550.7,
      411.2
     ],
     [
      550.1,
      409.1
     ],
     [
      550.8,
      406.3
     ],
     [
      554.7,
      400.3
     ],
     [
      555.5,
      398.4
     ],
     [
      555.9,
      394.8
     ],
     [
      555.3,
      391.7
     ],
     [
      576.8,
      385.9
     ],
     [
      586.7,
      381.3
     ],
     [
      594,
      379
     ],
     [
      598.3,
      378.5
     ],
     [
      608.1,
      379.3
     ],
     [
      616.2,
      379
     ],
     [
      619.7,
      378.4
     ],
     [
      637.3,
      373.3
     ],
     [
      649,
      372
     ],
     [
      648.6,
      374.2
     ],
     [
      649.5,
      380.2
     ],
     [
      649.1,
      382.9
     ],
     [
      644.8,
      390.8
     ],
     [
      644.4,
      394.5
     ],
     [
      638.3,
      407.6
     ]
    ]
   ]
  },
  "eskisehir": {
   "paths": [
    "m665.83,357.91c-1.1,2.42-7.09,3.2-7.18,4.74-.01.18-.12.69-.2,1.04,0,.04-.02.09-.03.13,0,.01-.01.02-.01.03-.59,1.99-2.36,5.1-5.82,5.57-.23.03-.45.07-.66.12-1.61.39-2.51,1.37-2.96,2.5-4.89.15-9.84.62-16.17,2.39-9.46,2.64-15.63,6.38-29.57,4.4-13.95-1.98-20.19,5.94-29.93,8.15-5.83,1.32-13.11,3.35-18.01,4.76-.56-1.81-1.38-3.57-1.95-5.4-1.56-5.03-8.83-3.55-13.78-.49-4.96,3.05-7.85,7.02-14.54,7.68-6.68.66-13.04-3.35-14.4-5.08-1.37-1.73-1.78-2.77-1.7-6.31.09-3.54-1.57-5.75-3.96-9.71-2.4-3.96-7.27-2.77-10.16-3.63-2.08-.63-3.56-2.67-4.22-3.77.03.01.05.01.05.01,0,0,.04-.63.21-3.49.17-2.87,5.23-4.85,7.87-7.47,2.64-2.63,5.18-8.94,5.51-12.35.33-3.41-1.21-7.6-4.74-7.82-3.52-.22-7.59-5.83-9.74-6.82-2.15-.99-9.74-5.73-13.71-7.71-3.96-1.98-6.49-7.82-6.82-11.56-.33-3.74-5.18-9.47-5.96-11.58-.78-2.1.34-7.02.01-9.89-.16-1.37,1.37-3.67,3.01-5.7h.01c6.29-.46,13.25-.67,16.03.42,5.34,2.09,12.22-.83,14.77-.63,2.55.19,3.72,1.59,10.58,3.02,4.63.97,5.69-2.39,5.46-5,1.79-.05,3.92-.41,4.89-1.69,1.81-2.39,7.67-5.78,13.12-6.52,5.45-.74,15.44-2.39,16.93-3.47,1.49-1.07,8.01,1.74,9.99,5.87,1.98,4.12,6.52,10.98,11.73,10.65,5.2-.33,9.49-3.06,14.2.08,4.65,3.11,7.62,2.17,9.11,1.83.53,1.53,3.53,9.94,6.35,11.03,2.17.84,4.69,1.16,6.25,1.85.68.29,1.18.65,1.41,1.14.74,1.65.08,7.85,2.89,7.85s8.01-3.06,9.82-1.74c1.82,1.32,3.12,1.17,4.63-.16,1.5-1.34,7.59,1.07,12.46,1.24,4.88.16,6.47.08,8.56-.25,2.1-.33,5.48,2.41,5.98,6.12.49,3.7,7.34,4.53,6.19,9.15-1.16,4.63-.34,6.11.66,7.8.99,1.7,1.27,3.79,3.69,6.65,2.42,2.87,3.75,10.9,3.03,13.22-.72,2.31,1.92,6.38.82,8.8Z"
   ],
   "label": [
    565,
    330
   ],
   "bbox": [
    463.5,
    266.5,
    666.5,
    393.5
   ],
   "geoNeighbors": [
    "ankara",
    "balikesir",
    "izmit",
    "kastamonu",
    "konya",
    "kutahya",
    "sakarya",
    "usak"
   ],
   "poly": [
    [
     [
      665.8,
      357.9
     ],
     [
      664.3,
      359.5
     ],
     [
      658.9,
      362.1
     ],
     [
      657.7,
      365.5
     ],
     [
      656.6,
      367.2
     ],
     [
      654.9,
      368.6
     ],
     [
      650.9,
      369.9
     ],
     [
      649,
      372
     ],
     [
      637.3,
      373.3
     ],
     [
      619.7,
      378.4
     ],
     [
      616.2,
      379
     ],
     [
      608.1,
      379.3
     ],
     [
      598.3,
      378.5
     ],
     [
      594,
      379
     ],
     [
      586.7,
      381.3
     ],
     [
      576.8,
      385.9
     ],
     [
      555.3,
      391.7
     ],
     [
      552.5,
      384.7
     ],
     [
      551.2,
      383.7
     ],
     [
      547.7,
      383.1
     ],
     [
      543.6,
      383.9
     ],
     [
      539.6,
      385.8
     ],
     [
      532.9,
      390.6
     ],
     [
      529.4,
      392.5
     ],
     [
      527.4,
      393.1
     ],
     [
      522.5,
      393.6
     ],
     [
      520.1,
      393.3
     ],
     [
      515.8,
      391.9
     ],
     [
      511.4,
      389.2
     ],
     [
      509.8,
      387.2
     ],
     [
      509,
      384.4
     ],
     [
      508.7,
      379.7
     ],
     [
      507.9,
      377.4
     ],
     [
      504,
      371.2
     ],
     [
      502.8,
      370.3
     ],
     [
      500.1,
      369.5
     ],
     [
      494.8,
      368.8
     ],
     [
      492.2,
      367.1
     ],
     [
      490.6,
      365
     ],
     [
      490.8,
      361.6
     ],
     [
      491.8,
      359.5
     ],
     [
      498.7,
      354.1
     ],
     [
      500.6,
      351.5
     ],
     [
      502.3,
      348.2
     ],
     [
      504.2,
      341.7
     ],
     [
      504.1,
      339.1
     ],
     [
      503.3,
      336.6
     ],
     [
      501.8,
      334.7
     ],
     [
      496.8,
      332.9
     ],
     [
      490.6,
      327.7
     ],
     [
      476,
      319.4
     ],
     [
      473.3,
      317.3
     ],
     [
      471.3,
      314.3
     ],
     [
      469.9,
      310.9
     ],
     [
      468.2,
      304.7
     ],
     [
      463.3,
      296.2
     ],
     [
      463,
      294.2
     ],
     [
      463.4,
      285.2
     ],
     [
      466.3,
      280.7
     ],
     [
      475.6,
      280.3
     ],
     [
      479.5,
      280.5
     ],
     [
      486.5,
      281.8
     ],
     [
      497.1,
      280.4
     ],
     [
      507.7,
      283.5
     ],
     [
      510.5,
      283.5
     ],
     [
      512.2,
      282.3
     ],
     [
      513,
      280.5
     ],
     [
      513.1,
      278.5
     ],
     [
      517.1,
      277.6
     ],
     [
      520.1,
      274.8
     ],
     [
      523.2,
      272.9
     ],
     [
      527,
      271.2
     ],
     [
      543.5,
      268.2
     ],
     [
      548.8,
      266.6
     ],
     [
      551.4,
      267.1
     ],
     [
      555.9,
      269.8
     ],
     [
      557.1,
      271.2
     ],
     [
      560,
      276.1
     ],
     [
      562.7,
      279.6
     ],
     [
      566,
      282.4
     ],
     [
      567.9,
      283.1
     ],
     [
      569.8,
      283.3
     ],
     [
      577.1,
      282
     ],
     [
      580.5,
      282
     ],
     [
      582.2,
      282.5
     ],
     [
      587.2,
      285
     ],
     [
      589.7,
      285.6
     ],
     [
      593.1,
      285.2
     ],
     [
      595.4,
      290.9
     ],
     [
      598.4,
      295.5
     ],
     [
      599.4,
      296.2
     ],
     [
      605.7,
      298.1
     ],
     [
      607.1,
      299.2
     ],
     [
      607.8,
      303.8
     ],
     [
      608.5,
      306.1
     ],
     [
      609.1,
      306.8
     ],
     [
      610,
      307.1
     ],
     [
      612.5,
      306.6
     ],
     [
      617.9,
      305.1
     ],
     [
      619,
      305
     ],
     [
      622.2,
      306.3
     ],
     [
      625.2,
      304.8
     ],
     [
      626.3,
      304.8
     ],
     [
      636.9,
      306.4
     ],
     [
      645.5,
      306.2
     ],
     [
      647.2,
      306.5
     ],
     [
      649.1,
      307.7
     ],
     [
      650.6,
      309.7
     ],
     [
      651.9,
      313.6
     ],
     [
      657.2,
      318.6
     ],
     [
      657.7,
      319.9
     ],
     [
      657.1,
      324.4
     ],
     [
      657.6,
      328
     ],
     [
      660.5,
      333.9
     ],
     [
      662.8,
      337.2
     ],
     [
      664.7,
      342.7
     ],
     [
      665.8,
      357.9
     ]
    ]
   ]
  },
  "trabzon": {
   "paths": [
    "m1263.56,233.68c-14.65,3.88-31.95,8.18-34.06,18.98-2.64,13.55-4.62,13.66-9.46,14.21-4.84.55-8.04-.44-11.57-5.4-3.52-4.95-8.58-16.07-16.84-15.19s-11.12,20.15-13.32,20.92-7.6-2.76-11.23-1.98c-3.63.77-9.91,4.73-13.54,3.19-3.64-1.54-1.21-12.44-4.7-13.57-3.49-1.12-10.5-1.4-16.99,4.32-6.5,5.72-20.15,11.12-31.21,15.43-11.06,4.32-21.58-8.05-23.07-4.79-1.48,3.27,0,16.06-4.12,20.24-4.13,4.19,1.32,15.14-2.48,20.75-3.8,5.62-21.47,3.97-29.87.73-8.4-3.23-16.54-6.34-23.46-7.23-6.92-.89-14.99.28-14.99.28-1.37-1.92-4.1-4.08-7.53-6.77-5.62-4.4-5.62-9.8-6.5-13.76-.88-3.96-3.52-7.49-3.74-9.58-.04-.34-.1-.74-.2-1.19-.46-2.32-1.61-6.12-3-11.47-1.65-6.38-.66-11.56,1.33-15.19.48-.89.96-2.62,1.41-4.74,2.15.42,7.07.11,9.76,1.22,2.81,1.15,6.11,1.4,8.17,1.24,2.07-.17,5.62-2.98,7.1-3.47,1.49-.5,5.21.58,6.36,0,1.16-.58,4.54-3.14,6.69-3.64,2.15-.49,1.57-1.81,3.8-2.06s7.46.11,9.33-1.21c1.87-1.32,2.2-1.76,3.52-1.43,1.32.33,3.63,2.86,6.39,2.2,2.75-.66,5.06-4.4,7.7-3.63,2.65.77,4.63,3.08,7.38,5.61,2.75,2.53,7.93.99,10.02,1.76,2.09.77,4.18,3.09,6.38,2.98,2.21-.11,5.73-.33,9.25,1.54,3.52,1.87,10.24-.99,12.22-3.2,1.98-2.2,6.17-3.85,9.36-3.85s7.93-1.65,10.02-3.08c2.09-1.43,5.5-5.95,8.69-6.39,3.2-.44,9.58-2.75,11.34-4.4,1.77-1.65,11.56-8.15,15.97-10.35,2.65-1.33,5.25-4.47,6.88-6.76.07-.09.13-.17.19-.25.02-.04.05-.08.08-.12.13-.19.25-.36.36-.53.42-.61.73-1.1.92-1.41.04-.06.07-.11.1-.16.02-.03.04-.05.05-.08.03-.03.05-.06.07-.09.31.08,6.75,1.98,8.25,2.46,1.54.5,4.9,1.93,6.93,2.76,2.04.82,3.69-2.42,5.62-3.91,1.92-1.49,2.03-1.6,4.18-.66,2.15.93,2.64.44,6.11.27,3.47-.16,4.4.77,6.66,1.05,2.26.27,3.19.94,6.44,1.82,3.25.88,4.02,1.98,6.22,1.7,2.2-.27,1.32-2.81,2.97-3.58,1.66-.77,1.82-5.72,2.37-6.6.55-.88,5.07-.88,8.09-.33,3.03.55,4.21.88,2.98,3.44-1.24,2.56.24,4.46,2.8,4.54,2.56.08,2.31-1.57,4.38.83,2.06,2.39,3.8,6.11,5.61,7.22,1.82,1.12,1.57,2.06,5.33,3.22,3.76,1.16,1.94,3.55,1.98,4.42.04.87,2.31,4.83,3.3,4.75.99-.09,6.9-.95,8.43-.75,1.52.21,2.62,4.48,2.24,5.91-.2.74-.08,1.81.15,2.81Z"
   ],
   "label": [
    1122,
    253
   ],
   "bbox": [
    980.5,
    197,
    1263.5,
    315
   ],
   "geoNeighbors": [
    "erzurum",
    "gyumri",
    "kars",
    "samsun",
    "sivas"
   ],
   "poly": [
    [
     [
      1263.6,
      233.7
     ],
     [
      1252.4,
      236.8
     ],
     [
      1241.8,
      240.6
     ],
     [
      1237.3,
      242.9
     ],
     [
      1233.7,
      245.7
     ],
     [
      1231,
      248.9
     ],
     [
      1230.1,
      250.7
     ],
     [
      1227.6,
      260.5
     ],
     [
      1226.6,
      263
     ],
     [
      1225.6,
      264.6
     ],
     [
      1223.2,
      266.3
     ],
     [
      1216.7,
      267
     ],
     [
      1213.8,
      266.2
     ],
     [
      1211.1,
      264.5
     ],
     [
      1209.8,
      263.1
     ],
     [
      1201.8,
      251.7
     ],
     [
      1199.7,
      249.4
     ],
     [
      1197.3,
      247.6
     ],
     [
      1194.6,
      246.5
     ],
     [
      1191.6,
      246.3
     ],
     [
      1188.8,
      247.4
     ],
     [
      1186.4,
      249.8
     ],
     [
      1184.4,
      253.1
     ],
     [
      1179.2,
      266.1
     ],
     [
      1178.3,
      267.2
     ],
     [
      1176.1,
      267.1
     ],
     [
      1168.5,
      265.1
     ],
     [
      1167.1,
      265.2
     ],
     [
      1156.7,
      268.7
     ],
     [
      1153.5,
      268.4
     ],
     [
      1152.4,
      267.4
     ],
     [
      1151.8,
      265.8
     ],
     [
      1150.5,
      257.2
     ],
     [
      1149.9,
      255.7
     ],
     [
      1148.8,
      254.8
     ],
     [
      1147.4,
      254.5
     ],
     [
      1143.6,
      254.2
     ],
     [
      1139.2,
      255
     ],
     [
      1136.8,
      255.9
     ],
     [
      1134.3,
      257.3
     ],
     [
      1129.1,
      261.3
     ],
     [
      1122,
      265.4
     ],
     [
      1109.3,
      271.2
     ],
     [
      1098.6,
      275.2
     ],
     [
      1096.5,
      275.5
     ],
     [
      1092.6,
      275.2
     ],
     [
      1088.9,
      274.1
     ],
     [
      1080.2,
      269.8
     ],
     [
      1078,
      269.4
     ],
     [
      1077.1,
      271.4
     ],
     [
      1075.6,
      285.6
     ],
     [
      1074.7,
      288.1
     ],
     [
      1072.3,
      291.9
     ],
     [
      1071.9,
      294.3
     ],
     [
      1072.4,
      305.8
     ],
     [
      1072,
      308.5
     ],
     [
      1071,
      310.8
     ],
     [
      1068.9,
      312.6
     ],
     [
      1065.9,
      313.7
     ],
     [
      1062.1,
      314.3
     ],
     [
      1053.2,
      314.2
     ],
     [
      1044.6,
      312.6
     ],
     [
      1028.8,
      307
     ],
     [
      1023,
      305.3
     ],
     [
      1017.6,
      304.3
     ],
     [
      1012.4,
      304
     ],
     [
      1002.7,
      304.6
     ],
     [
      999.7,
      301.5
     ],
     [
      993.3,
      296.1
     ],
     [
      991.9,
      294.4
     ],
     [
      990.1,
      290.8
     ],
     [
      988.6,
      284
     ],
     [
      984.9,
      274.5
     ],
     [
      981.7,
      261.8
     ],
     [
      980.9,
      257.2
     ],
     [
      981,
      253.2
     ],
     [
      981.7,
      249.6
     ],
     [
      983.7,
      244.7
     ],
     [
      984.4,
      241.9
     ],
     [
      991.8,
      242.5
     ],
     [
      998.5,
      244.2
     ],
     [
      1002.4,
      244.3
     ],
     [
      1004.1,
      243.8
     ],
     [
      1009.5,
      240.9
     ],
     [
      1015.8,
      240.9
     ],
     [
      1026.3,
      235.2
     ],
     [
      1033.7,
      234.7
     ],
     [
      1038.3,
      232.4
     ],
     [
      1043.6,
      234.7
     ],
     [
      1045.5,
      234.7
     ],
     [
      1051.3,
      231.2
     ],
     [
      1052.3,
      231
     ],
     [
      1055.1,
      231.9
     ],
     [
      1060.6,
      236.7
     ],
     [
      1063.1,
      237.9
     ],
     [
      1070.6,
      238.5
     ],
     [
      1075.4,
      241.1
     ],
     [
      1083.7,
      241.9
     ],
     [
      1087.7,
      243.5
     ],
     [
      1089.4,
      243.6
     ],
     [
      1093,
      242.9
     ],
     [
      1096.2,
      241.5
     ],
     [
      1100.3,
      238.3
     ],
     [
      1102.7,
      237
     ],
     [
      1105.3,
      236.2
     ],
     [
      1110.5,
      235.6
     ],
     [
      1115.9,
      233.9
     ],
     [
      1117.9,
      232.9
     ],
     [
      1124.2,
      227.4
     ],
     [
      1132.8,
      224.7
     ],
     [
      1137,
      222.7
     ],
     [
      1144.9,
      217.1
     ],
     [
      1155.8,
      210.4
     ],
     [
      1157.7,
      208.7
     ],
     [
      1162.5,
      202.3
     ],
     [
      1170.8,
      204.8
     ],
     [
      1178.4,
      207.7
     ],
     [
      1180.6,
      206.4
     ],
     [
      1183.3,
      203.6
     ],
     [
      1185.3,
      202.4
     ],
     [
      1188.9,
      203.4
     ],
     [
      1193.6,
      203.2
     ],
     [
      1197.4,
      203.6
     ],
     [
      1203.1,
      205
     ],
     [
      1211.5,
      207.8
     ],
     [
      1212.9,
      207.8
     ],
     [
      1214.1,
      207.2
     ],
     [
      1215,
      205.1
     ],
     [
      1216.9,
      203
     ],
     [
      1218.3,
      197.6
     ],
     [
      1219.3,
      197.1
     ],
     [
      1221.4,
      196.9
     ],
     [
      1226.4,
      197.3
     ],
     [
      1229.4,
      198.3
     ],
     [
      1229.8,
      199.2
     ],
     [
      1228.9,
      202.5
     ],
     [
      1229.3,
      203.9
     ],
     [
      1230.4,
      204.9
     ],
     [
      1232.1,
      205.3
     ],
     [
      1235.3,
      205
     ],
     [
      1236.5,
      206.1
     ],
     [
      1240.8,
      212.1
     ],
     [
      1242.1,
      213.3
     ],
     [
      1245.3,
      215.7
     ],
     [
      1249.4,
      217.6
     ],
     [
      1249.8,
      218.9
     ],
     [
      1249.4,
      221
     ],
     [
      1249.8,
      222.1
     ],
     [
      1252.3,
      225.6
     ],
     [
      1260.4,
      224.9
     ],
     [
      1261.7,
      225.2
     ],
     [
      1263,
      227.5
     ],
     [
      1263.4,
      229.4
     ],
     [
      1263.6,
      233.7
     ]
    ]
   ]
  },
  "diyarbakir": {
   "paths": [
    "m1177.54,499.36c-6.6,2.14-7.74.13-13.27,2.5-5.78,2.47-6.77.16-11.72.49-4.96.33-8.43-.16-13.05-1.32-4.62-1.15-15.19-1.98-19.16.33-3.96,2.31-12.71,4.46-16.84,5.95-4.13,1.48-6.11,3.46-8.26,5.94-2.14,2.48-10.23,4.96-18.99,8.42-8.75,3.47-8.14,2.26-14.42,4.13-6.27,1.87-20.7,3.53-25.32,2.09-4.62-1.43-19.27-.6-20.92-1.04-1.65-.44-7.54-8.09-11.06-10.02-3.52-1.93-11.89-3.63-15.25-3.47-3.36.17-6.83,2.2-8.09,3.14-1.09.81-2.38,2.3-4.54,2.88-.67-3.21-1.74-6.1-1.79-7.23-.11-2.2-2.64-6.27-3.74-8.7-1.11-2.42-1.77-5.72-1.22-8.03.55-2.31,1.33-2.2.77-4.85-.55-2.64,1.37-5.63,3.97-8.69,1.72-2.04,3.29-2.83,3.32-3.58,7.78,3.27,18.53-3.61,23.24-3.77,4.7-.17,8.92-6.36,15.36-8.84,6.44-2.47,10.32-13.04,11.39-16.02,1.07-2.97,11.56-12.13,13.29-13.75,1.74-1.62,1.66-4.91-1.32-6.89-2.97-1.98-2.14-6.85-1.15-8.64.99-1.78,8.01-2.01,10.59-1.08,2.58.92,5.84-2.5,10.05-2.42,4.21.09,8.92-1.23,11.39-2.64,2.48-1.4,1.82-5.03,4.38-5.53,2.56-.5,3.96,1.32,5.28,2.23,1.32.91,17.48-.08,17.48-.08,0,0,6.14,1.21,8.71-2.59,2.58-3.8,5.82-7.54,11.44-7.1,5.61.44,12.71.99,18.77-2.48,6.05-3.47,8.42-4.95,11.17-3.91,2.75,1.05,2.37,5.29,5.51,8.81,3.13,3.52,3.8,2.31,7.21,2.09,1.31-.08,2.5-.12,3.5.04,1.61.25,2.76.99,3.16,2.82.66,2.98,3.47,11.73,2.48,15.28-.99,3.55-5.54,11.15-10.74,14.12-5.2,2.97-1.73,10.73,3.3,13.54,5.04,2.81,12.14,6.03,13.88,13.05,1.73,7.01,3.13,12.22-1.74,16.3-4.48,3.76-4.91,10.7,2.95,18.52Z"
   ],
   "label": [
    1090,
    480
   ],
   "bbox": [
    970,
    394,
    1178,
    528
   ],
   "geoNeighbors": [
    "aleppo",
    "elazig",
    "erzurum",
    "maras",
    "van"
   ],
   "poly": [
    [
     [
      1177.5,
      499.4
     ],
     [
      1173.5,
      500.3
     ],
     [
      1167.7,
      500.8
     ],
     [
      1160.7,
      502.9
     ],
     [
      1154.2,
      502.3
     ],
     [
      1145.9,
      502.2
     ],
     [
      1135.1,
      500.3
     ],
     [
      1129.7,
      499.9
     ],
     [
      1122.1,
      500.6
     ],
     [
      1116.6,
      503.1
     ],
     [
      1100.8,
      508.5
     ],
     [
      1098.6,
      509.9
     ],
     [
      1094.2,
      514.2
     ],
     [
      1092.6,
      515.1
     ],
     [
      1073.4,
      522.8
     ],
     [
      1069.5,
      524
     ],
     [
      1055.9,
      527.1
     ],
     [
      1048.6,
      528.1
     ],
     [
      1041.5,
      528.4
     ],
     [
      1031.5,
      527.2
     ],
     [
      1015.6,
      526.9
     ],
     [
      1013.7,
      525.4
     ],
     [
      1007.5,
      519.1
     ],
     [
      1004.5,
      516.8
     ],
     [
      1001.1,
      515.5
     ],
     [
      992.6,
      513.6
     ],
     [
      989.3,
      513.4
     ],
     [
      986.8,
      513.8
     ],
     [
      982.5,
      515.6
     ],
     [
      978.1,
      518.8
     ],
     [
      976.7,
      519.4
     ],
     [
      974.4,
      510.2
     ],
     [
      971.1,
      503.5
     ],
     [
      969.9,
      499.4
     ],
     [
      969.7,
      497.3
     ],
     [
      970.9,
      492.1
     ],
     [
      970.7,
      488.5
     ],
     [
      971.5,
      486.4
     ],
     [
      974.6,
      481.9
     ],
     [
      978,
      478.3
     ],
     [
      981,
      479.1
     ],
     [
      984.2,
      479.1
     ],
     [
      987.5,
      478.6
     ],
     [
      999.2,
      474.9
     ],
     [
      1002.9,
      474.2
     ],
     [
      1004.7,
      473.4
     ],
     [
      1012.1,
      468.1
     ],
     [
      1018.9,
      464.4
     ],
     [
      1020.9,
      462.6
     ],
     [
      1024.3,
      457.9
     ],
     [
      1028.8,
      448.3
     ],
     [
      1034.3,
      442.3
     ],
     [
      1041.2,
      435.9
     ],
     [
      1042.2,
      434.4
     ],
     [
      1042.4,
      432.6
     ],
     [
      1041.6,
      430.7
     ],
     [
      1039,
      428.2
     ],
     [
      1038.3,
      427.1
     ],
     [
      1037.9,
      424.6
     ],
     [
      1038.1,
      422.2
     ],
     [
      1038.8,
      420.4
     ],
     [
      1039.4,
      419.8
     ],
     [
      1043.5,
      418.8
     ],
     [
      1051.4,
      419.3
     ],
     [
      1056.4,
      417.4
     ],
     [
      1062.6,
      416.7
     ],
     [
      1068.6,
      415.3
     ],
     [
      1070.8,
      414.3
     ],
     [
      1072.2,
      412.9
     ],
     [
      1073.8,
      409.6
     ],
     [
      1075.2,
      408.7
     ],
     [
      1076.9,
      408.7
     ],
     [
      1080.5,
      411
     ],
     [
      1081.6,
      411.2
     ],
     [
      1101.3,
      411
     ],
     [
      1104.2,
      410.3
     ],
     [
      1105.5,
      409.5
     ],
     [
      1108.7,
      405.5
     ],
     [
      1111.2,
      403.1
     ],
     [
      1114.3,
      401.6
     ],
     [
      1116.1,
      401.2
     ],
     [
      1127.3,
      401.4
     ],
     [
      1132.2,
      400.6
     ],
     [
      1134.5,
      399.8
     ],
     [
      1143.7,
      395.1
     ],
     [
      1146,
      394.5
     ],
     [
      1148,
      394.8
     ],
     [
      1148.9,
      395.3
     ],
     [
      1149.6,
      396.1
     ],
     [
      1151.7,
      400.9
     ],
     [
      1153.5,
      403.6
     ],
     [
      1155.5,
      405.4
     ],
     [
      1157,
      406
     ],
     [
      1160.8,
      405.7
     ],
     [
      1165.4,
      406
     ],
     [
      1167,
      407.4
     ],
     [
      1167.4,
      408.6
     ],
     [
      1170,
      420.4
     ],
     [
      1169.9,
      423.8
     ],
     [
      1168.5,
      427.1
     ],
     [
      1166.1,
      431.1
     ],
     [
      1162.9,
      435
     ],
     [
      1157.6,
      439.3
     ],
     [
      1156.8,
      440.9
     ],
     [
      1156.6,
      442.8
     ],
     [
      1157.8,
      446.8
     ],
     [
      1160.7,
      450.2
     ],
     [
      1170.6,
      456.4
     ],
     [
      1174.1,
      459.9
     ],
     [
      1175.4,
      462.1
     ],
     [
      1177.5,
      469.5
     ],
     [
      1177.9,
      473.8
     ],
     [
      1177.7,
      475.7
     ],
     [
      1176.1,
      479.3
     ],
     [
      1173.1,
      482.4
     ],
     [
      1172.1,
      484.2
     ],
     [
      1171.5,
      486.3
     ],
     [
      1171.4,
      488.6
     ],
     [
      1172,
      491.1
     ],
     [
      1173.1,
      493.7
     ],
     [
      1175,
      496.5
     ],
     [
      1177.5,
      499.4
     ]
    ]
   ]
  },
  "hatay": {
   "paths": [
    "m903.23,557.8c-2.23-.5-3.34-.5-4.29.25-.95.74-1.57,1.61-3.39,1.11s-2.85,2.93-2.72,5.41c.12,2.48-.27,8.41-2.08,8.3-1.82-.11-3.36.93-3.85,2.06-.5,1.13-3.25,1.6-4.11,1.98-.85.39-1.29,4.1-1.4,5.56-.11,1.46-1.43,1.16-1.87.39s-1.76-1.82-2.73-1.76c-.96.05-2.39-.06-3.27-.39-.88-.33.3-3.11-.19-3.69-.5-.58-1.82.09-1.96.2-.14.11-1.76.77-2.9.77.15-.27.28-.72.44-1.3.03-.12.06-.24.09-.35.01-.04.02-.08.03-.13.3-1.15.68-2.68,1.34-4.33,1.11-2.81.12-3.84-.5-5.5-.62-1.65-2.41-4.41-4.33-7-1.93-2.59-2.81-5.28-3.03-6.39-.22-1.1,2.53-2.36,3.03-3.57.49-1.21,2.25-3.25,3.02-4.19.78-.93,3.31-1.76,4.08-2.97.77-1.21,3.71-3.87,8.3-6.3,4.58-2.44,2.64-8.67,2.64-12.02s-3.14-6.81-6.4-9.7c-3.26-2.89-6.23.5-7.23,2.03-.28.43-.67.92-1.15,1.44-.68-1.87-1.19-4.7.7-6.83,3.08-3.46,11.1-9.13,22.64-2.91,9.34,5.03,13.43,7.11,16.31,11.74-1.53.96-2.45,3.44-2.99,3.99-.79.78.41,2.76-.54,3.55-.95.78.03.2-1.51,3.84-1.54,3.63-.18,13.58-.3,15.31-.13,1.74,1.9,4.71,3.34,4.96,1.45.25,1.03,1.57,2.02,4.25.99,2.68-3.01,2.68-5.24,2.19Z"
   ],
   "label": [
    884,
    550
   ],
   "bbox": [
    863,
    505,
    909,
    583
   ],
   "geoNeighbors": [
    "aleppo",
    "maras"
   ],
   "poly": [
    [
     [
      903.2,
      557.8
     ],
     [
      900.6,
      557.5
     ],
     [
      898.9,
      558.1
     ],
     [
      897.6,
      559.1
     ],
     [
      894.3,
      559.4
     ],
     [
      893.5,
      560.7
     ],
     [
      892.9,
      562.6
     ],
     [
      892.5,
      569.7
     ],
     [
      891.9,
      572
     ],
     [
      891.4,
      572.6
     ],
     [
      888.3,
      573.4
     ],
     [
      886.2,
      575.7
     ],
     [
      882.8,
      576.9
     ],
     [
      881.8,
      579.3
     ],
     [
      881.1,
      583.3
     ],
     [
      880,
      583.3
     ],
     [
      878.4,
      581.7
     ],
     [
      876.8,
      581.1
     ],
     [
      873.5,
      580.7
     ],
     [
      873.2,
      580.1
     ],
     [
      873.3,
      577
     ],
     [
      872.8,
      576.8
     ],
     [
      868.5,
      578
     ],
     [
      870.8,
      570.1
     ],
     [
      870.8,
      568.7
     ],
     [
      869.2,
      565
     ],
     [
      864.3,
      557.4
     ],
     [
      862.5,
      553
     ],
     [
      862.8,
      552.1
     ],
     [
      864.8,
      550.3
     ],
     [
      868.6,
      545.2
     ],
     [
      872.6,
      542.3
     ],
     [
      875.4,
      539.6
     ],
     [
      882.4,
      534.9
     ],
     [
      883.3,
      533.5
     ],
     [
      884,
      530.3
     ],
     [
      883.6,
      523.9
     ],
     [
      883,
      521.4
     ],
     [
      881.6,
      518.9
     ],
     [
      877.2,
      514.2
     ],
     [
      874.8,
      513.1
     ],
     [
      872.7,
      513.6
     ],
     [
      871,
      514.9
     ],
     [
      868.8,
      517.7
     ],
     [
      868.2,
      514.4
     ],
     [
      868.5,
      512.6
     ],
     [
      869.5,
      510.9
     ],
     [
      872.7,
      508.1
     ],
     [
      877.6,
      505.8
     ],
     [
      880.7,
      505.2
     ],
     [
      884.2,
      505.3
     ],
     [
      888,
      506.2
     ],
     [
      892.1,
      508
     ],
     [
      902.7,
      514
     ],
     [
      906,
      516.6
     ],
     [
      908.5,
      519.7
     ],
     [
      907.4,
      520.7
     ],
     [
      905.5,
      523.7
     ],
     [
      904.9,
      527.2
     ],
     [
      904.5,
      527.7
     ],
     [
      903,
      532.7
     ],
     [
      902.7,
      539.5
     ],
     [
      903.4,
      547.9
     ],
     [
      905.3,
      550.7
     ],
     [
      907.2,
      551.8
     ],
     [
      908.6,
      556.5
     ],
     [
      908.4,
      557.2
     ],
     [
      907.1,
      557.9
     ],
     [
      903.2,
      557.8
     ]
    ]
   ]
  },
  "maras": {
   "paths": [
    "m974.64,481.88c-2.6,3.06-4.52,6.05-3.97,8.69.56,2.65-.22,2.54-.77,4.85-.55,2.31.11,5.61,1.22,8.03,1.1,2.43,3.63,6.5,3.74,8.7.05,1.13,1.12,4.02,1.79,7.23-.35.09-.73.16-1.13.2-2.86.28-8.37,4.02-9.74,4.57-1.38.55-4.68-.16-6.72.55-2.04.72-5.61,3.19-6.99,4.35-1.38,1.16-1.87,2.04-3.63,2.37-1.77.33-4.52-.5-7.16-1.6-2.64-1.1-9.56-.84-10.39-.38-.83.45-1.98,1.32-3.14,1.32s-1.52-2.6-1.03-4.13c.5-1.53-1.4-1.61-2.06-2.97-.66-1.37-1.82-.83-2.93-1.33-1.12-.49-3.06-.82-4.63-.86-1.57-.04-3.18-.25-6.23-1.82-.94-.48-1.74-.36-2.42.06-2.88-4.63-6.97-6.71-16.31-11.74-11.54-6.22-19.56-.55-22.64,2.91-1.89,2.13-1.38,4.96-.7,6.83-1.23,1.33-3.05,2.92-5.12,4.46-2.89,2.15-6.67,1.38-8.38,1.71-1.71.33-1.24,1.76-1.38,2.28-.14.52,1.08,1.46,2.04,2.15.96.68-.25.96-1.87,1.1-1.63.14-.94,1.04-.64,2.5.31,1.46-1.78,3.31-3.05,3.58-1.27.28-3.41-.77-3.85-.94-.44-.16-5.01.33-6.94,1.82-1.93,1.49-5.34-1.26-7.05-2.48-1.28-.91-7.05-4.44-10.44-6.32,1.54-1.57,2.71-3.13,2.46-4.08-.66-2.48-.24-6.03.33-8.59.58-2.56,2.4-7.1-1.48-9.71-3.88-2.62-5.53-7.05-5.53-9.77s-4.05-6.11-6.03-11.97h0c-1.98-5.87.66-8.68,2.14-10.57,1.49-1.9-1.15-6.44-1.03-7.97.13-1.53,1.28-3.64,2.73-3.26,1.44.37,5.05.22,5.6.16.55-.05,3.77-.52,4.35-1.04.57-.53,5.2-5.4,5.89-5.7.68-.3,2.39-.41,6.79.03,4.41.44,10.71,2.69,12.33,3.44,1.63.74,3.56-.53,4.46-1.52.91-.99-.9-9.74-.57-11.39.33-1.65,3.88-3.3,5.61-4.3,1.73-.99,14.16-10.98,15.19-12.55,1.04-1.56,3.88-7.76,5.91-11.89,2.02-4.12,8.83-6.27,11.32-5.78,2.49.5,4.32,5.7,6.43,7.85,2.1,2.15,4.29-2.02,6.56-3.3,2.27-1.28,2.69-7.31,4.38-10.94,1.69-3.64,6.85-3.65,8.92-3.95,2.06-.31,6.63.24,8.06,1.45,1.43,1.22,4.71.61,6.83.61s7.42-.93,7.42-.93c-2.77,1.6-2.77,3.21-2.66,5.55.11,2.43.55,3.64,2.64,3.64s19.6,4.73,22.35,8.58c2.75,3.86,1.65,13.55-1.65,18.5-3.31,4.95-5.18,11.69-7.16,14.37-1.98,2.69-2.97,5.26-5.28,6.9-2.31,1.63-4.08,8.23,1.65,11.1,5.72,2.86,8.04,4.62,11.45,3.74,3.41-.88,11.27,1.21,14.11,2.75.95.52,1.34.89,1.32,1.27-.03.75-1.6,1.54-3.32,3.58Z"
   ],
   "label": [
    895,
    469
   ],
   "bbox": [
    811.5,
    401,
    978.5,
    537
   ],
   "geoNeighbors": [
    "adana",
    "aleppo",
    "diyarbakir",
    "elazig",
    "hatay",
    "sivas"
   ],
   "poly": [
    [
     [
      974.6,
      481.9
     ],
     [
      971.5,
      486.4
     ],
     [
      970.7,
      488.5
     ],
     [
      970.9,
      492.1
     ],
     [
      969.7,
      497.3
     ],
     [
      969.9,
      499.4
     ],
     [
      971.1,
      503.5
     ],
     [
      974.4,
      510.2
     ],
     [
      976.7,
      519.4
     ],
     [
      973,
      520.3
     ],
     [
      965.8,
      524.2
     ],
     [
      959.1,
      524.7
     ],
     [
      955.3,
      526.7
     ],
     [
      949.6,
      531.1
     ],
     [
      946.9,
      531.5
     ],
     [
      940.1,
      529.5
     ],
     [
      935.4,
      529
     ],
     [
      931.5,
      529.3
     ],
     [
      927.8,
      530.8
     ],
     [
      927,
      530.3
     ],
     [
      926.6,
      529.3
     ],
     [
      926.7,
      525.7
     ],
     [
      924.1,
      522.9
     ],
     [
      919.6,
      521.7
     ],
     [
      914.5,
      521.1
     ],
     [
      909.6,
      519.3
     ],
     [
      908.5,
      519.7
     ],
     [
      906,
      516.6
     ],
     [
      902.7,
      514
     ],
     [
      892.1,
      508
     ],
     [
      888,
      506.2
     ],
     [
      884.2,
      505.3
     ],
     [
      880.7,
      505.2
     ],
     [
      877.6,
      505.8
     ],
     [
      875,
      506.8
     ],
     [
      872.7,
      508.1
     ],
     [
      869.5,
      510.9
     ],
     [
      868.5,
      512.6
     ],
     [
      868.2,
      514.4
     ],
     [
      868.8,
      517.7
     ],
     [
      863.7,
      522.2
     ],
     [
      861.4,
      523.3
     ],
     [
      855.3,
      523.9
     ],
     [
      854.4,
      524.3
     ],
     [
      854,
      524.9
     ],
     [
      854,
      526.6
     ],
     [
      856.3,
      528.7
     ],
     [
      853.3,
      529.7
     ],
     [
      853.3,
      533
     ],
     [
      851.5,
      535
     ],
     [
      849.3,
      535.5
     ],
     [
      845.6,
      534.6
     ],
     [
      841.4,
      535.4
     ],
     [
      838.8,
      536.7
     ],
     [
      837.9,
      536.8
     ],
     [
      836,
      536.1
     ],
     [
      822.1,
      527.6
     ],
     [
      824.5,
      524.3
     ],
     [
      824.3,
      519.2
     ],
     [
      825.8,
      510.1
     ],
     [
      825.4,
      507.4
     ],
     [
      824.6,
      506.3
     ],
     [
      820.9,
      502.9
     ],
     [
      819.2,
      500.3
     ],
     [
      818.2,
      497.7
     ],
     [
      817.7,
      494.4
     ],
     [
      813.6,
      487.4
     ],
     [
      811.9,
      483.4
     ],
     [
      811.2,
      479.6
     ],
     [
      811.6,
      476.7
     ],
     [
      814.4,
      472.1
     ],
     [
      814.5,
      471
     ],
     [
      813,
      464.9
     ],
     [
      813.9,
      462.6
     ],
     [
      814.7,
      461.8
     ],
     [
      821.3,
      461.8
     ],
     [
      824.8,
      461.1
     ],
     [
      825.7,
      460.8
     ],
     [
      831.6,
      455.1
     ],
     [
      832.3,
      454.9
     ],
     [
      838.3,
      455.1
     ],
     [
      845.6,
      456.7
     ],
     [
      850.7,
      458.5
     ],
     [
      851.9,
      458.8
     ],
     [
      853.2,
      458.4
     ],
     [
      855.1,
      457
     ],
     [
      855.4,
      456.3
     ],
     [
      854.5,
      446.6
     ],
     [
      854.6,
      445.6
     ],
     [
      855.3,
      444.4
     ],
     [
      863.1,
      439.2
     ],
     [
      874.5,
      429.7
     ],
     [
      876.4,
      426.8
     ],
     [
      881.3,
      416.9
     ],
     [
      883.5,
      414.2
     ],
     [
      886.8,
      412.3
     ],
     [
      890.1,
      411.2
     ],
     [
      892.6,
      411.1
     ],
     [
      894.3,
      412.2
     ],
     [
      899,
      419
     ],
     [
      900.6,
      419.5
     ],
     [
      902.2,
      418.6
     ],
     [
      906.4,
      415
     ],
     [
      910,
      404.7
     ],
     [
      910.7,
      403.5
     ],
     [
      911.8,
      402.6
     ],
     [
      914.3,
      401.5
     ],
     [
      920.8,
      400.7
     ],
     [
      925.4,
      401.4
     ],
     [
      928.3,
      402.8
     ],
     [
      930.1,
      403
     ],
     [
      935.8,
      402.7
     ],
     [
      941.2,
      401.9
     ],
     [
      939.6,
      403.1
     ],
     [
      938.8,
      404.4
     ],
     [
      938.5,
      405.8
     ],
     [
      938.7,
      409
     ],
     [
      939.1,
      410.2
     ],
     [
      939.9,
      410.9
     ],
     [
      948.4,
      412.8
     ],
     [
      955.8,
      415.3
     ],
     [
      961.9,
      418.2
     ],
     [
      963.5,
      419.7
     ],
     [
      964.4,
      421.4
     ],
     [
      965.1,
      425.9
     ],
     [
      965,
      428.5
     ],
     [
      963.9,
      433.7
     ],
     [
      955.5,
      451.4
     ],
     [
      951,
      458
     ],
     [
      948.6,
      460.3
     ],
     [
      947.9,
      461.5
     ],
     [
      947.2,
      464.5
     ],
     [
      947.4,
      466.2
     ],
     [
      948.1,
      467.8
     ],
     [
      949.3,
      469.3
     ],
     [
      957.7,
      473.8
     ],
     [
      960.1,
      474.5
     ],
     [
      965.8,
      474.1
     ],
     [
      969.8,
      474.7
     ],
     [
      976.6,
      477
     ],
     [
      978,
      478.3
     ],
     [
      974.6,
      481.9
     ]
    ]
   ]
  },
  "lesbos": {
   "paths": [
    "m376.48,362.94c-.87-1.07-2.07-2.14-2.86-2.77-.87-.7-3.38-1.81-3.34-3.92.07-3.67-2.39-5.74-5.33-6.15-2.93-.41-5.86,1.78-6.15,2.85-.29,1.07-4.38,2.81-9.04,2.72-4.67-.08-7.02,2.31-7.35,3.96s.45,3.88,2.02,5.74c1.57,1.86,8.17,3.39,9.74,3.1s2.44-3.3,4.87-5.53c2.44-2.23,4.05-1.82,5-1.28.95.54,1.4,1.94.21,3.06-1.2,1.11-5.57,3.43-7.18,4.21-1.61.78.74,4.38,2.19,4.58,1.44.21,3.51-.21,6.73,1.69,3.22,1.9,8.88,1.36,9.74,0,.87-1.36-1.61-3.05-1.86-5.08-.25-2.02,1.36-1.86,2.56-.83,1.2,1.03.78,3.22,1.73,4.33.95,1.11,2.64-.45,2.89-1.49.25-1.03-3.72-8.13-4.58-9.21Z",
    "m356.91,409.99c1.21-1.71.61-3.63-1.71-4.73-2.31-1.1-3.19-3.25-4.13-3.25s-2.64,1.71-4.46,1.27c-1.82-.44-5.83.88-4.51,3.52,1.32,2.64,6.77,6.99,6.99,9.36.22,2.37.39,5.34-2.26,6.06-2.64.72-5.17,2.26-2.09,5.23,3.08,2.97,3.8,3.25,6.8,2.64,3.34-.67,4.36-3.1,5.41-5.53,1.05-2.42,1.03-3.34.4-6.47,0,0-1.65-6.39-.44-8.09Z",
    "m320.42,305.34c-1.71.06-3.63,1.21-5.01,2.2-1.38.99-3.47.99-5.67.83-2.2-.17-4.24-1.16-7.43.39-3.19,1.54-1.87,8.37-.94,8.81s1.1-.44,1.82-.39,1.87,2.48,2.64,3.52c.77,1.05,2.86-.22,2.37-1.27s-.06-3.74.5-4.68c.55-.94,3.08-1.1,2.81.77-.28,1.87,1.27,4.29,2.53,5.78,1.27,1.49,2.26-.39,1.98-1.49-.28-1.1.5-4.18.5-5.72s3.14-5.72,3.14-5.72c1.2-1.71,2.48-3.08.77-3.03Z"
   ],
   "label": [
    356,
    360
   ],
   "bbox": [
    300.5,
    305.5,
    381.5,
    430
   ],
   "geoNeighbors": [
    "balikesir"
   ],
   "poly": [
    [
     [
      376.5,
      362.9
     ],
     [
      380.6,
      370.4
     ],
     [
      381.1,
      372.1
     ],
     [
      380.6,
      373
     ],
     [
      379,
      374
     ],
     [
      378.2,
      373.6
     ],
     [
      376.4,
      369.3
     ],
     [
      374.6,
      368.6
     ],
     [
      374,
      369
     ],
     [
      373.9,
      370.1
     ],
     [
      375.8,
      374.1
     ],
     [
      375.7,
      375.2
     ],
     [
      374.3,
      376
     ],
     [
      371.7,
      376.4
     ],
     [
      368.7,
      376.2
     ],
     [
      363.8,
      374.2
     ],
     [
      359.3,
      373.5
     ],
     [
      358.1,
      372.8
     ],
     [
      357,
      371.4
     ],
     [
      356.5,
      369.9
     ],
     [
      357.1,
      368.9
     ],
     [
      364.3,
      364.7
     ],
     [
      364.9,
      363
     ],
     [
      364,
      361.7
     ],
     [
      362.1,
      361.3
     ],
     [
      360.7,
      361.7
     ],
     [
      359,
      362.9
     ],
     [
      355.3,
      367.8
     ],
     [
      354.2,
      368.5
     ],
     [
      353.4,
      368.5
     ],
     [
      349.3,
      367.7
     ],
     [
      345.2,
      366
     ],
     [
      343.4,
      363.9
     ],
     [
      342.7,
      362.4
     ],
     [
      342.4,
      359.6
     ],
     [
      343,
      358.3
     ],
     [
      344.5,
      357
     ],
     [
      346.7,
      356
     ],
     [
      353.1,
      355.4
     ],
     [
      355.9,
      354.7
     ],
     [
      357.9,
      353.8
     ],
     [
      360.9,
      351
     ],
     [
      362.8,
      350.2
     ],
     [
      365,
      350.1
     ],
     [
      367,
      350.7
     ],
     [
      368.7,
      352
     ],
     [
      369.9,
      353.8
     ],
     [
      370.7,
      357.7
     ],
     [
      376.5,
      362.9
     ]
    ],
    [
     [
      356.9,
      410
     ],
     [
      356.5,
      412
     ],
     [
      357.8,
      421.6
     ],
     [
      357,
      424.6
     ],
     [
      355.1,
      428
     ],
     [
      353.6,
      429.3
     ],
     [
      351.5,
      430.1
     ],
     [
      348.2,
      430.1
     ],
     [
      344.7,
      427.5
     ],
     [
      343.8,
      426.4
     ],
     [
      343.4,
      424.7
     ],
     [
      343.6,
      424
     ],
     [
      345,
      422.9
     ],
     [
      348.3,
      421.3
     ],
     [
      349,
      419.8
     ],
     [
      349.1,
      416.2
     ],
     [
      348.1,
      414.1
     ],
     [
      342.8,
      407.9
     ],
     [
      341.8,
      405.9
     ],
     [
      342,
      405.1
     ],
     [
      343.2,
      403.9
     ],
     [
      345,
      403.3
     ],
     [
      347.9,
      403.3
     ],
     [
      351.1,
      402
     ],
     [
      356.6,
      406.2
     ],
     [
      357.4,
      407.4
     ],
     [
      357.5,
      408.7
     ],
     [
      356.9,
      410
     ]
    ],
    [
     [
      320.4,
      305.3
     ],
     [
      321.2,
      305.6
     ],
     [
      321.1,
      306.2
     ],
     [
      318.1,
      310.7
     ],
     [
      316.5,
      314.1
     ],
     [
      316,
      320.7
     ],
     [
      315.6,
      321.5
     ],
     [
      314.9,
      321.9
     ],
     [
      314,
      321.3
     ],
     [
      312.2,
      318.6
     ],
     [
      311.3,
      314.5
     ],
     [
      310.4,
      314.1
     ],
     [
      308.7,
      314.7
     ],
     [
      308.1,
      317
     ],
     [
      308.1,
      320.2
     ],
     [
      307.5,
      320.9
     ],
     [
      306.6,
      321.1
     ],
     [
      305.8,
      320.7
     ],
     [
      303.2,
      317.2
     ],
     [
      301.9,
      317.7
     ],
     [
      301,
      317.1
     ],
     [
      300.3,
      313.6
     ],
     [
      300.7,
      310.7
     ],
     [
      301.3,
      309.6
     ],
     [
      302.3,
      308.8
     ],
     [
      304.5,
      308
     ],
     [
      306.4,
      307.9
     ],
     [
      312.9,
      308.4
     ],
     [
      314.3,
      308.1
     ],
     [
      317.8,
      306.1
     ],
     [
      320.4,
      305.3
     ]
    ]
   ]
  },
  "konya": {
   "paths": [
    "m793.93,486.64h0c-.02.26-.09.45-.23.6-1.15,1.24-9.85,7.19-13.15,8.51-3.31,1.32-8.37,4.62-12.11,5.83-3.75,1.21-5.43,1.24-8,2.99-2.57,1.75-5.54,1.54-9.07,1.97-3.52.44-8.92,1.76-12.88,3.08-3.96,1.32-7.26,4.16-8.7,5.82-1.43,1.67-2.42,4.53-4.18,4.09s-4.36-.66-5.56-.25c-1.2.41-3.3.91-3.71,1.24-.42.33-.87,1.61.28,3.01,1.16,1.41,2.46,4.28,2.69,5,.23.71,2.23,2.8,3.59,3.26,1.36.45,5.9,2.89,5.66,4.5-.25,1.61-2.03,1.73-3.1.78s-2.31-.12-2.56.6c-.25.72-.45,3.94-1.69,4.4-1.24.45-5.37.58-6.9.82-1.53.25-3.01,2.36-4.91,2.03-1.9-.33-3.84-.13-5.2-.29-1.36-.17-5.06.91-5.06.91,0,0-.06-.58-1.05-1.9-.99-1.32-6.06-7.71-7.88-11.19-1.83-3.48-6.54-11.05-7.31-14.19-.78-3.15-1.55-8.75-5.95-10.73-2.54-1.15-4.58-3.28-6.22-5.48-1.2-1.6-2.2-3.25-3.03-4.57-1.98-3.14-13.21-9.82-14.97-10.26-1.76-.45-8.37-1.99-11.23-2.04-2.86-.06-6.77-1.43-8.97-3.03-.63-.46-.9-1.3-.97-2.3,0-.08,0-.16,0-.24-.07-2.44.98-5.67.98-6.54,0-1.27-1.87-3.63-.28-6.06,3.09-2.91,4.52-7.32,5.29-9.41.77-2.09-.44-9.08-1.1-11.94-.66-2.87-1.16-3.75,3.24-5.62,4.41-1.87,5.15-3.58,5.07-5.06-.08-1.49-2.59-12.11-5.01-15.19-2.42-3.08-1.87-9.47-1.43-12.23.44-2.75,6.03-10.15,6.11-13.04.08-2.89,0-4.21,3.14-8.59,3.13-4.38,1.73-7.68,1.23-9.74-.46-1.96-.49-5.76,3.14-6.65.21-.05.43-.09.66-.12,3.46-.47,5.23-3.58,5.82-5.57,0-.01.01-.02.01-.03.01-.04.03-.09.03-.13.03-.09.05-.17.07-.25,10.75,8.61,13.92,7.35,16.23,6.91,2.31-.44,6.93.11,9.14.99,2.2.88,4.07,3.2,5.94,1.92,1.87-1.28,5.95-3.13,9.31-2.8,3.36.33,4.01-.88,6.1-3.08,2.1-2.2,4.19-3.19,6.6-2.64,2.41.55,5.62,4.29,6.61.66,1-3.63,2.54-6.83,9.25-3.74,6.72,3.08,10.24,11.33,9.03,17.39-1.21,6.06,1.98,15.74,6.39,16.95,4.4,1.22,21.79-4.62,22.01-10.47.22-5.86,6.83-6.48,14.98-3.39.4.15.78.28,1.15.37,0,0,.01.03.01.08.17.84,1.63,8.38.38,10.77-1.32,2.53-.65,7.62,3.52,7.65,4.17.03,4.68,1.05,3.74,3.86-.93,2.8.99,7.84,2.81,11.54,1.82,3.7-4.79,13.97-8.09,18.33-3.3,4.37-6.94,9.98-3.14,13.61,3.8,3.64,9.91,11.07,10.57,14.04.66,2.97-3.8,9.74-1.65,13.87,1.9,3.65,4.7,8.47,4.52,10.38Z"
   ],
   "label": [
    713,
    455
   ],
   "bbox": [
    632,
    360.5,
    794,
    545.5
   ],
   "geoNeighbors": [
    "adana",
    "ankara",
    "antalya",
    "eskisehir",
    "isparta",
    "kutahya",
    "sivas"
   ],
   "poly": [
    [
     [
      793.9,
      486.6
     ],
     [
      793.7,
      487.2
     ],
     [
      791.6,
      488.9
     ],
     [
      783.8,
      494
     ],
     [
      771.4,
      500.3
     ],
     [
      762.2,
      503.5
     ],
     [
      758.4,
      505.6
     ],
     [
      748.4,
      507
     ],
     [
      738.5,
      509.6
     ],
     [
      735.7,
      510.9
     ],
     [
      731.2,
      514
     ],
     [
      726.8,
      519.3
     ],
     [
      725.6,
      519.5
     ],
     [
      721.2,
      519.1
     ],
     [
      716.3,
      520.5
     ],
     [
      715.9,
      521.6
     ],
     [
      716,
      522.5
     ],
     [
      719.8,
      529.3
     ],
     [
      721.8,
      531.2
     ],
     [
      726.3,
      533.6
     ],
     [
      728,
      535
     ],
     [
      728.6,
      536.3
     ],
     [
      728.1,
      537.2
     ],
     [
      727.3,
      537.6
     ],
     [
      726.4,
      537.6
     ],
     [
      724.6,
      536.7
     ],
     [
      723.9,
      536.7
     ],
     [
      722.9,
      537.7
     ],
     [
      722,
      541.3
     ],
     [
      721.2,
      542.1
     ],
     [
      714.3,
      542.9
     ],
     [
      710.8,
      544.8
     ],
     [
      702.8,
      544.7
     ],
     [
      699.1,
      545.5
     ],
     [
      692.1,
      535.5
     ],
     [
      686.2,
      525.2
     ],
     [
      683.4,
      519.6
     ],
     [
      681.3,
      512.5
     ],
     [
      679.6,
      509.6
     ],
     [
      678.4,
      508.4
     ],
     [
      673.5,
      505.2
     ],
     [
      670.7,
      502.1
     ],
     [
      666.6,
      496.2
     ],
     [
      660.1,
      491.3
     ],
     [
      653.8,
      487.7
     ],
     [
      647.5,
      486.1
     ],
     [
      639.2,
      484.9
     ],
     [
      636.8,
      484.2
     ],
     [
      632.5,
      482.2
     ],
     [
      631.8,
      481.2
     ],
     [
      631.6,
      479.6
     ],
     [
      632.5,
      473.1
     ],
     [
      631.6,
      468.8
     ],
     [
      632.3,
      467
     ],
     [
      634.3,
      464.6
     ],
     [
      635.8,
      462
     ],
     [
      637.8,
      456.6
     ],
     [
      637.5,
      451.9
     ],
     [
      636.1,
      443.8
     ],
     [
      636.2,
      442.5
     ],
     [
      637.2,
      441.3
     ],
     [
      642.4,
      438.7
     ],
     [
      643.9,
      437.4
     ],
     [
      644.6,
      436.1
     ],
     [
      644.8,
      435
     ],
     [
      643.8,
      430.3
     ],
     [
      641.5,
      423.3
     ],
     [
      638.4,
      417
     ],
     [
      638,
      413.6
     ],
     [
      638.3,
      407.6
     ],
     [
      644.4,
      394.5
     ],
     [
      644.9,
      390.8
     ],
     [
      649.2,
      382.8
     ],
     [
      649.5,
      380.2
     ],
     [
      648.6,
      374.4
     ],
     [
      648.8,
      372.5
     ],
     [
      649.9,
      370.7
     ],
     [
      650.7,
      370
     ],
     [
      654.9,
      368.6
     ],
     [
      656.6,
      367.2
     ],
     [
      658.5,
      363.4
     ],
     [
      665.3,
      368.2
     ],
     [
      669.8,
      370.3
     ],
     [
      672.8,
      370.7
     ],
     [
      676.9,
      370.2
     ],
     [
      681.9,
      370.8
     ],
     [
      683.9,
      371.3
     ],
     [
      688.4,
      373.6
     ],
     [
      693.9,
      371.3
     ],
     [
      696.5,
      370.6
     ],
     [
      701.2,
      370.4
     ],
     [
      702.7,
      369.9
     ],
     [
      706.8,
      366
     ],
     [
      710.1,
      364.6
     ],
     [
      711.9,
      364.7
     ],
     [
      715.7,
      366.6
     ],
     [
      717.3,
      366.9
     ],
     [
      718,
      366.4
     ],
     [
      719.4,
      362.8
     ],
     [
      720.9,
      361
     ],
     [
      723.6,
      360.4
     ],
     [
      725.4,
      360.8
     ],
     [
      730.1,
      363
     ],
     [
      732.1,
      364.8
     ],
     [
      735.2,
      369.2
     ],
     [
      736.8,
      374.2
     ],
     [
      736.6,
      384.1
     ],
     [
      737.8,
      389.3
     ],
     [
      740.1,
      393.7
     ],
     [
      741.5,
      395.2
     ],
     [
      744.1,
      396.1
     ],
     [
      748.4,
      395.7
     ],
     [
      752,
      394.8
     ],
     [
      759.2,
      391.7
     ],
     [
      762.2,
      389.8
     ],
     [
      764.3,
      387.7
     ],
     [
      764.9,
      386.6
     ],
     [
      765.5,
      383.6
     ],
     [
      766.4,
      382.1
     ],
     [
      767.8,
      381.1
     ],
     [
      769.7,
      380.5
     ],
     [
      774.4,
      380.5
     ],
     [
      781.3,
      382.5
     ],
     [
      782.2,
      390.8
     ],
     [
      781.1,
      395.6
     ],
     [
      781.4,
      398.1
     ],
     [
      782.7,
      400.2
     ],
     [
      783.8,
      400.8
     ],
     [
      787.7,
      401.2
     ],
     [
      789,
      401.9
     ],
     [
      789.3,
      403.1
     ],
     [
      788.7,
      407.3
     ],
     [
      789.3,
      410.3
     ],
     [
      791.7,
      416.4
     ],
     [
      792,
      418.1
     ],
     [
      791.7,
      420.2
     ],
     [
      789.6,
      425.3
     ],
     [
      786.6,
      430.6
     ],
     [
      781.2,
      438.2
     ],
     [
      779.4,
      441.8
     ],
     [
      778.9,
      445.3
     ],
     [
      779.4,
      446.9
     ],
     [
      780.5,
      448.4
     ],
     [
      787,
      455.6
     ],
     [
      789.7,
      459.5
     ],
     [
      791.1,
      462.4
     ],
     [
      790.8,
      465.2
     ],
     [
      788.9,
      472.8
     ],
     [
      788.9,
      474.6
     ],
     [
      793.6,
      484.7
     ],
     [
      793.9,
      486.6
     ]
    ]
   ]
  },
  "ankara": {
   "paths": [
    "m793.32,374.87c-2.87,1.42-6.27,7.71-12.05,7.72,0-.05-.01-.08-.01-.08-.37-.09-.75-.22-1.15-.37-8.15-3.09-14.76-2.47-14.98,3.39-.22,5.85-17.61,11.69-22.01,10.47-4.41-1.21-7.6-10.89-6.39-16.95,1.21-6.06-2.31-14.31-9.03-17.39-6.71-3.09-8.25.11-9.25,3.74-.99,3.63-4.2-.11-6.61-.66-2.41-.55-4.5.44-6.6,2.64-2.09,2.2-2.74,3.41-6.1,3.08-3.36-.33-7.44,1.52-9.31,2.8-1.87,1.28-3.74-1.04-5.94-1.92-2.21-.88-6.83-1.43-9.14-.99-2.31.44-5.48,1.7-16.23-6.91-.02.08-.04.16-.07.25.08-.35.19-.86.2-1.04.09-1.54,6.08-2.32,7.18-4.74,1.1-2.42-1.54-6.49-.82-8.8.72-2.32-.61-10.35-3.03-13.22-2.42-2.86-2.7-4.95-3.69-6.65-1-1.69-1.82-3.17-.66-7.8,1.15-4.62-5.7-5.45-6.19-9.15-.5-3.71-3.88-6.45-5.98-6.12-2.09.33-3.68.41-8.56.25-4.87-.17-10.96-2.58-12.46-1.24-1.51,1.33-2.81,1.48-4.63.16-1.81-1.32-7.02,1.74-9.82,1.74s-2.15-6.2-2.89-7.85c-.23-.49-.73-.85-1.41-1.14.14-.95.78-3.2,3.61-4.14,3.63-1.21,7.26-7.49,7.15-10.46s5.56-2.53,8.32-.38c2.75,2.14,7.04,1.32,8.42.66,1.37-.66,3.21,2.4,6.33,2.64,3.12.23,4.93-.56,7.38-1.21,2.44-.66,11.5-.44,13.65-1.43,2.14-1,24.06-1.82,28.1-9.75,4.04-7.92,5.58-12.11,15.49-9.47,9.91,2.65,14.53,13.44,23.78,17.84,9.25,4.4,7.8,1.32,12.27.66,4.2-.62,21.17,2.29,27.41,6.56h.01c.4.27.75.55,1.05.83,5.06,4.72,2.2,6.25,3.85,9.5,1.65,3.26-.99,6.27-1.1,10.16-.11,3.89-1.54,8.51,3.63,11.04,5.18,2.53,8.04,4.74,11.45,6.72,3.41,1.98,5.84,4.62,7.71,8.25,1.87,3.64,10.9,10.13,8.36,12.55-2.53,2.43-1.1,6.17-.22,10.02.89,3.86.01,4.41.67,7.49.66,3.08-6.32,7.02-9.69,8.7Z"
   ],
   "label": [
    704,
    330
   ],
   "bbox": [
    605.5,
    264,
    802.5,
    396
   ],
   "geoNeighbors": [
    "eskisehir",
    "kastamonu",
    "konya",
    "sivas"
   ],
   "poly": [
    [
     [
      793.3,
      374.9
     ],
     [
      788.4,
      379.3
     ],
     [
      785.2,
      381.6
     ],
     [
      783.3,
      382.3
     ],
     [
      781.3,
      382.6
     ],
     [
      777.1,
      381.2
     ],
     [
      771.8,
      380.3
     ],
     [
      767.8,
      381.1
     ],
     [
      766.4,
      382.1
     ],
     [
      765.5,
      383.6
     ],
     [
      764.9,
      386.6
     ],
     [
      764.3,
      387.7
     ],
     [
      762.2,
      389.8
     ],
     [
      759.2,
      391.7
     ],
     [
      752,
      394.8
     ],
     [
      748.4,
      395.7
     ],
     [
      744.1,
      396.1
     ],
     [
      741.5,
      395.2
     ],
     [
      740.1,
      393.7
     ],
     [
      737.8,
      389.3
     ],
     [
      736.6,
      384.1
     ],
     [
      736.8,
      374.2
     ],
     [
      735.2,
      369.2
     ],
     [
      732.1,
      364.8
     ],
     [
      730.1,
      363
     ],
     [
      725.4,
      360.8
     ],
     [
      723.6,
      360.4
     ],
     [
      720.9,
      361
     ],
     [
      719.4,
      362.8
     ],
     [
      718,
      366.4
     ],
     [
      717.3,
      366.9
     ],
     [
      715.7,
      366.6
     ],
     [
      711.8,
      364.7
     ],
     [
      710.1,
      364.6
     ],
     [
      706.8,
      366
     ],
     [
      702.7,
      369.9
     ],
     [
      701.2,
      370.4
     ],
     [
      696.5,
      370.6
     ],
     [
      693.9,
      371.3
     ],
     [
      688.4,
      373.6
     ],
     [
      683.9,
      371.3
     ],
     [
      681.9,
      370.8
     ],
     [
      676.8,
      370.2
     ],
     [
      671.4,
      370.6
     ],
     [
      667.8,
      369.5
     ],
     [
      662.2,
      366.2
     ],
     [
      658.5,
      363.4
     ],
     [
      658.5,
      363.7
     ],
     [
      658.9,
      362.1
     ],
     [
      664.3,
      359.5
     ],
     [
      665.8,
      357.9
     ],
     [
      664.7,
      342.7
     ],
     [
      662.8,
      337.2
     ],
     [
      660.5,
      333.9
     ],
     [
      657.6,
      328
     ],
     [
      657.1,
      324.4
     ],
     [
      657.7,
      319.9
     ],
     [
      657.2,
      318.6
     ],
     [
      651.9,
      313.6
     ],
     [
      650.6,
      309.7
     ],
     [
      649.1,
      307.7
     ],
     [
      647.2,
      306.5
     ],
     [
      645.5,
      306.2
     ],
     [
      636.9,
      306.4
     ],
     [
      626.3,
      304.8
     ],
     [
      625.2,
      304.8
     ],
     [
      622.2,
      306.3
     ],
     [
      619,
      305
     ],
     [
      617.9,
      305.1
     ],
     [
      610,
      307.1
     ],
     [
      609.1,
      306.8
     ],
     [
      608.5,
      306.1
     ],
     [
      607.1,
      299.2
     ],
     [
      605.7,
      298.1
     ],
     [
      605.9,
      297.2
     ],
     [
      607.6,
      294.9
     ],
     [
      612,
      292.2
     ],
     [
      614.3,
      289.4
     ],
     [
      615.9,
      286.2
     ],
     [
      616.7,
      282.5
     ],
     [
      618.3,
      281.5
     ],
     [
      622.3,
      281.8
     ],
     [
      627.1,
      284.2
     ],
     [
      629.5,
      284.5
     ],
     [
      634.3,
      283.9
     ],
     [
      637.4,
      285.8
     ],
     [
      639.5,
      286.4
     ],
     [
      643.5,
      286.1
     ],
     [
      648.1,
      285
     ],
     [
      657.9,
      284.3
     ],
     [
      673.9,
      281.5
     ],
     [
      682.9,
      278.7
     ],
     [
      686.4,
      276.7
     ],
     [
      688.7,
      274
     ],
     [
      692.7,
      266.8
     ],
     [
      694.2,
      265.3
     ],
     [
      695.9,
      264.3
     ],
     [
      698.1,
      263.8
     ],
     [
      700.8,
      263.9
     ],
     [
      704.1,
      264.6
     ],
     [
      707.6,
      265.9
     ],
     [
      710.7,
      267.8
     ],
     [
      724.6,
      280.5
     ],
     [
      730.9,
      283.7
     ],
     [
      734.7,
      284.7
     ],
     [
      740.2,
      283.1
     ],
     [
      745.4,
      283.2
     ],
     [
      753.1,
      284.5
     ],
     [
      761.3,
      286.7
     ],
     [
      764.8,
      288.1
     ],
     [
      768.7,
      290.4
     ],
     [
      770.2,
      292.1
     ],
     [
      771.7,
      294.7
     ],
     [
      771.9,
      297.7
     ],
     [
      773,
      302.4
     ],
     [
      771.4,
      310.1
     ],
     [
      771.2,
      316.1
     ],
     [
      772.3,
      318.9
     ],
     [
      773.4,
      320.1
     ],
     [
      788.9,
      329.5
     ],
     [
      790.9,
      331.4
     ],
     [
      795.2,
      337.6
     ],
     [
      802.6,
      346.2
     ],
     [
      803,
      347.6
     ],
     [
      801.3,
      350.7
     ],
     [
      801.2,
      353.1
     ],
     [
      802.7,
      361
     ],
     [
      802.9,
      367.4
     ],
     [
      802.2,
      368.6
     ],
     [
      799.7,
      371
     ],
     [
      793.3,
      374.9
     ]
    ]
   ]
  },
  "elazig": {
   "paths": [
    "m1101.63,386.26c1.04,1.6-.28,5.9-1.16,6.58-.88.69-3.57-.14-4.13.8-.55.93-2.53,5.01-2.25,6.11.27,1.1,3.47,6.16,3.63,8.23.17,2.06.22,2.89.22,2.89,0,0-16.16.99-17.48.08-1.32-.91-2.72-2.73-5.28-2.23-2.56.5-1.9,4.13-4.38,5.53-2.47,1.41-7.18,2.73-11.39,2.64-4.21-.08-7.47,3.34-10.05,2.42-2.58-.93-9.6-.7-10.59,1.08-.99,1.79-1.82,6.66,1.15,8.64,2.98,1.98,3.06,5.27,1.32,6.89-1.73,1.62-12.22,10.78-13.29,13.75-1.07,2.98-4.95,13.55-11.39,16.02-6.44,2.48-10.66,8.67-15.36,8.84-4.71.16-15.46,7.04-23.24,3.77.02-.38-.37-.75-1.32-1.27-2.84-1.54-10.7-3.63-14.11-2.75-3.41.88-5.73-.88-11.45-3.74-5.73-2.87-3.96-9.47-1.65-11.1,2.31-1.64,3.3-4.21,5.28-6.9,1.98-2.68,3.85-9.42,7.16-14.37,3.3-4.95,4.4-14.64,1.65-18.5-2.75-3.85-20.26-8.58-22.35-8.58s-2.53-1.21-2.64-3.64c-.11-2.34-.11-3.95,2.66-5.55.1-.06.2-.11.31-.17,3.08-1.65,10.02-8.7,12.6-10.49,2.59-1.78,2.48-8.78,2.04-11.86-.44-3.08,5.4-2.64,8.37-2.42,2.97.22,5.28-2.42,9.03-4.32,3.74-1.89,10.13-2.18,13.54-2.18,2.65,0,6.9-3.59,9.33-5.7,0,0,3.03,2.4,8.04,2.9,5,.49,11.27,4.56,13.19,8.2,1.92,3.63.04,6.38,6.1,6.71,6.05.33,14.38.58,22.79,4.63,8.41,4.04,7.48,3.41,11.01,1.65,3.52-1.76,9.47.11,12.44-2.09,2.97-2.21,9.03-8.41,7.48-14.17-1.54-5.76,2.57-2.5,5.58-3.75,3.01-1.24,13.91-8.41,16.11-8.9,2.2-.49,4.84,2.14,1.76,6.67-3.07,4.53-5.06,6.83-3.52,10.79s3.19,7.26,4.24,8.86Z"
   ],
   "label": [
    1020,
    405
   ],
   "bbox": [
    938,
    360.5,
    1102,
    479.5
   ],
   "geoNeighbors": [
    "diyarbakir",
    "erzurum",
    "maras",
    "sivas"
   ],
   "poly": [
    [
     [
      1101.6,
      386.3
     ],
     [
      1102,
      387.9
     ],
     [
      1101.2,
      391.8
     ],
     [
      1100.5,
      392.8
     ],
     [
      1097.1,
      393.2
     ],
     [
      1096.3,
      393.6
     ],
     [
      1094.2,
      398.5
     ],
     [
      1094.1,
      399.8
     ],
     [
      1097.1,
      406
     ],
     [
      1097.7,
      408
     ],
     [
      1097.9,
      410.9
     ],
     [
      1081.6,
      411.2
     ],
     [
      1080.5,
      411
     ],
     [
      1076.9,
      408.7
     ],
     [
      1075.2,
      408.7
     ],
     [
      1073.8,
      409.6
     ],
     [
      1072.2,
      412.9
     ],
     [
      1070.8,
      414.2
     ],
     [
      1068.6,
      415.3
     ],
     [
      1062.6,
      416.7
     ],
     [
      1056.4,
      417.4
     ],
     [
      1051.4,
      419.3
     ],
     [
      1043.5,
      418.8
     ],
     [
      1039.4,
      419.8
     ],
     [
      1038.8,
      420.4
     ],
     [
      1038.1,
      422.2
     ],
     [
      1037.9,
      424.6
     ],
     [
      1038.3,
      427.1
     ],
     [
      1039,
      428.2
     ],
     [
      1041.6,
      430.7
     ],
     [
      1042.4,
      432.6
     ],
     [
      1042.2,
      434.4
     ],
     [
      1041.2,
      435.9
     ],
     [
      1034.3,
      442.3
     ],
     [
      1028.8,
      448.3
     ],
     [
      1024.3,
      457.9
     ],
     [
      1020.9,
      462.6
     ],
     [
      1018.9,
      464.4
     ],
     [
      1012.1,
      468.1
     ],
     [
      1004.7,
      473.4
     ],
     [
      987.5,
      478.6
     ],
     [
      984.2,
      479.1
     ],
     [
      981,
      479.1
     ],
     [
      978,
      478.3
     ],
     [
      977.7,
      477.7
     ],
     [
      975.4,
      476.4
     ],
     [
      969.8,
      474.7
     ],
     [
      965.8,
      474.1
     ],
     [
      960.1,
      474.5
     ],
     [
      957.7,
      473.8
     ],
     [
      951.1,
      470.5
     ],
     [
      949.3,
      469.3
     ],
     [
      948.1,
      467.8
     ],
     [
      947.2,
      464.5
     ],
     [
      947.9,
      461.5
     ],
     [
      948.6,
      460.3
     ],
     [
      951,
      458
     ],
     [
      955.5,
      451.4
     ],
     [
      963.9,
      433.7
     ],
     [
      965,
      428.5
     ],
     [
      964.9,
      423.5
     ],
     [
      963.5,
      419.7
     ],
     [
      961.9,
      418.2
     ],
     [
      959.2,
      416.7
     ],
     [
      948.4,
      412.8
     ],
     [
      939.9,
      410.9
     ],
     [
      939.1,
      410.2
     ],
     [
      938.7,
      409
     ],
     [
      938.5,
      405.8
     ],
     [
      938.8,
      404.4
     ],
     [
      939.6,
      403.1
     ],
     [
      944.4,
      399.6
     ],
     [
      954.9,
      390.3
     ],
     [
      956.3,
      385.8
     ],
     [
      956.1,
      379.4
     ],
     [
      956.3,
      378.4
     ],
     [
      956.8,
      377.7
     ],
     [
      959,
      376.9
     ],
     [
      966.6,
      376.6
     ],
     [
      973.5,
      372.6
     ],
     [
      976.8,
      371.5
     ],
     [
      980.4,
      370.8
     ],
     [
      987.1,
      370.5
     ],
     [
      989.3,
      369.9
     ],
     [
      991.8,
      368.4
     ],
     [
      996.4,
      364.8
     ],
     [
      1001.1,
      367
     ],
     [
      1008.4,
      368.6
     ],
     [
      1012.2,
      370.6
     ],
     [
      1016.7,
      374.5
     ],
     [
      1017.6,
      375.9
     ],
     [
      1019.1,
      380.5
     ],
     [
      1020.5,
      381.9
     ],
     [
      1023.7,
      382.6
     ],
     [
      1034.3,
      383.5
     ],
     [
      1040.3,
      384.8
     ],
     [
      1053.9,
      390.2
     ],
     [
      1060.6,
      388.1
     ],
     [
      1067.3,
      387.8
     ],
     [
      1070,
      386.8
     ],
     [
      1072.6,
      384.4
     ],
     [
      1076.6,
      379
     ],
     [
      1077.7,
      374.8
     ],
     [
      1077.1,
      370.8
     ],
     [
      1077.3,
      369.7
     ],
     [
      1077.8,
      369.2
     ],
     [
      1083,
      368.8
     ],
     [
      1099.1,
      359.9
     ],
     [
      1100.8,
      360.1
     ],
     [
      1101.5,
      360.6
     ],
     [
      1102.3,
      362.4
     ],
     [
      1102.2,
      363.6
     ],
     [
      1101.8,
      365
     ],
     [
      1097.4,
      372.2
     ],
     [
      1096.9,
      374.7
     ],
     [
      1097,
      376
     ],
     [
      1098.6,
      380.2
     ],
     [
      1101.6,
      386.3
     ]
    ]
   ]
  },
  "gelibolu": {
   "paths": [
    "m345.59,291.39c-1.58.25-3.92,2.23-6.3,1.89-2.02-.29-6.14.39-6.14,3.59,0,2.28,3.95,5.28,9.62,2.97,5.67-2.31,9.7-9.55,2.82-8.45Z",
    "m366.45,300.25c17.31-18.27,18.45-25.51,39.94-34.03-5.31-1.69-9.74-1.82-12.96-1.48-1.54,8.43-20.23,10.88-28.25,18.72-8.41,5.46,2.2,5.29-.49,11.51-4.08,6.07-8.89,13.8,1.76,5.28Z"
   ],
   "label": [
    372,
    281
   ],
   "bbox": [
    333,
    264.5,
    406,
    303.5
   ],
   "geoNeighbors": [
    "canakkale",
    "edirne"
   ],
   "poly": [
    [
     [
      345.6,
      291.4
     ],
     [
      347.7,
      291.3
     ],
     [
      348.8,
      291.9
     ],
     [
      349.2,
      293
     ],
     [
      348.9,
      294.3
     ],
     [
      346.6,
      297.4
     ],
     [
      342.8,
      299.8
     ],
     [
      340.7,
      300.5
     ],
     [
      337.2,
      300.5
     ],
     [
      334.7,
      299.4
     ],
     [
      333.3,
      297.7
     ],
     [
      333.3,
      295.8
     ],
     [
      333.8,
      294.9
     ],
     [
      335.5,
      293.8
     ],
     [
      337.5,
      293.3
     ],
     [
      341.1,
      293.2
     ],
     [
      345.6,
      291.4
     ]
    ],
    [
     [
      366.5,
      300.3
     ],
     [
      362,
      303.4
     ],
     [
      360.1,
      303.9
     ],
     [
      360,
      303.1
     ],
     [
      360.6,
      301.6
     ],
     [
      364.7,
      295
     ],
     [
      365.1,
      292.9
     ],
     [
      364.7,
      291.3
     ],
     [
      362,
      287.9
     ],
     [
      362.2,
      286
     ],
     [
      363.8,
      284.4
     ],
     [
      368.6,
      280.8
     ],
     [
      372.8,
      278.4
     ],
     [
      385.9,
      272.3
     ],
     [
      389.5,
      270.1
     ],
     [
      392.1,
      267.6
     ],
     [
      393.4,
      264.7
     ],
     [
      399.1,
      264.7
     ],
     [
      406.4,
      266.2
     ],
     [
      396.2,
      271
     ],
     [
      388.9,
      275.9
     ],
     [
      381,
      283.7
     ],
     [
      366.5,
      300.3
     ]
    ]
   ]
  },
  "canakkale": {
   "paths": [
    "m418.06,277.6c-.05-1.65-1.53-3.01-3.97-1.2-2.43,1.82-3.38.71-4.58.33-1.2-.37-3.26.38-4.95,3.18-1.7,2.81-4.96,1.49-6.32.29-1.36-1.2-8.19-1.28-9.18-.51-.99.77-23.23,26.64-23.23,26.64,0,0-4.75.38-6.32,1.24-1.56.87-1.94,8.78-1.83,9.61.01.12.03.42.05.84,15.85,1.33,22.8-17.4,29.34-23.3,6.82-6.17,21.79-7.05,26.75-9.8,1.75-.97,3.81-2.45,5.1-4.27-.58-1.05-.84-2.12-.86-3.05Z"
   ],
   "label": [
    394,
    309
   ],
   "bbox": [
    357.5,
    275.5,
    418.5,
    318.5
   ],
   "geoNeighbors": [
    "balikesir",
    "gelibolu"
   ],
   "poly": [
    [
     [
      418.1,
      277.6
     ],
     [
      418.9,
      280.7
     ],
     [
      416.5,
      283.1
     ],
     [
      413.8,
      284.9
     ],
     [
      411.5,
      285.9
     ],
     [
      401.1,
      288.5
     ],
     [
      393.4,
      291
     ],
     [
      390,
      292.6
     ],
     [
      387.1,
      294.7
     ],
     [
      384.6,
      297.5
     ],
     [
      375.9,
      309.1
     ],
     [
      372.3,
      312.8
     ],
     [
      368.1,
      315.8
     ],
     [
      363.3,
      317.6
     ],
     [
      357.7,
      318
     ],
     [
      358,
      312.4
     ],
     [
      359,
      308.2
     ],
     [
      359.5,
      307.6
     ],
     [
      361.2,
      307
     ],
     [
      365.8,
      306.3
     ],
     [
      389.1,
      279.7
     ],
     [
      390.7,
      279.3
     ],
     [
      396.4,
      279.5
     ],
     [
      401.3,
      281.6
     ],
     [
      403,
      281.3
     ],
     [
      403.9,
      280.8
     ],
     [
      405.9,
      278.2
     ],
     [
      408.5,
      276.7
     ],
     [
      411.3,
      277.4
     ],
     [
      412.5,
      277.3
     ],
     [
      415.7,
      275.6
     ],
     [
      417,
      275.7
     ],
     [
      417.8,
      276.5
     ],
     [
      418.1,
      277.6
     ]
    ]
   ]
  },
  "kars": {
   "paths": [
    "M1205.9,262.6 L1206.4,262.5 L1206.9,262.4 L1207.4,262.3 L1207.8,262.2 L1208.3,262.2 L1208.8,262.1 L1208.8,261.9 L1209.1,262.3 L1209.3,262.6 L1209.6,262.9 L1209.9,263.3 L1210.2,263.6 L1210.5,263.9 L1210.8,264.2 L1211.1,264.5 L1211.4,264.8 L1211.8,265.1 L1212.1,265.3 L1212.5,265.6 L1212.9,265.8 L1213.3,266 L1213.7,266.2 L1214.1,266.4 L1214.5,266.5 L1214.9,266.6 L1215.3,266.7 L1215.7,266.8 L1216.2,266.9 L1216.6,266.9 L1217,267 L1217.5,267 L1217.9,267 L1218.3,267 L1218.8,267 L1219.2,266.9 L1219.6,266.9 L1220.1,266.9 L1220.5,266.8 L1220.9,266.8 L1221.4,266.7 L1221.8,266.6 L1222.2,266.6 L1222.7,266.5 L1223.1,266.4 L1223.5,266.2 L1223.9,266 L1224.3,265.8 L1224.6,265.6 L1225,265.3 L1225.3,265 L1225.6,264.7 L1225.8,264.3 L1226.1,264 L1226.3,263.6 L1226.5,263.2 L1226.7,262.8 L1226.9,262.4 L1227.1,262 L1227.2,261.6 L1227.4,261.2 L1227.5,260.8 L1227.6,260.4 L1227.8,259.9 L1227.9,259.5 L1228,259.1 L1228.1,258.7 L1228.3,258.3 L1228.4,257.8 L1228.5,257.4 L1228.6,257 L1228.7,256.6 L1228.8,256.1 L1228.9,255.7 L1229,255.3 L1229.1,254.9 L1229.1,254.4 L1229.2,254 L1229.3,253.6 L1229.4,253.1 L1229.5,252.7 L1229.6,252.3 L1229.7,251.9 L1229.8,251.5 L1229.9,251 L1230.1,250.6 L1230.3,250.2 L1230.5,249.8 L1230.7,249.4 L1230.9,249.1 L1231.1,248.7 L1231.3,248.3 L1231.6,248 L1231.9,247.6 L1232.1,247.3 L1232.4,246.9 L1232.7,246.6 L1233,246.3 L1233.3,246 L1233.6,245.7 L1234,245.4 L1234.3,245.1 L1234.6,244.8 L1235,244.6 L1235.3,244.3 L1235.7,244 L1236,243.8 L1236.4,243.6 L1236.7,243.3 L1237.1,243.1 L1237.5,242.8 L1237.9,242.6 L1238.2,242.4 L1238.6,242.2 L1239,242 L1239.4,241.8 L1239.8,241.6 L1240.2,241.4 L1240.6,241.2 L1240.9,241 L1241.3,240.8 L1241.7,240.6 L1242.1,240.4 L1242.5,240.3 L1242.9,240.1 L1243.3,239.9 L1243.7,239.8 L1244.1,239.6 L1244.5,239.4 L1245,239.3 L1245.4,239.1 L1245.8,239 L1246.2,238.8 L1246.6,238.7 L1247,238.5 L1247.4,238.4 L1247.8,238.2 L1248.2,238.1 L1248.7,237.9 L1249.1,237.8 L1249.5,237.7 L1249.9,237.5 L1250.3,237.4 L1250.7,237.3 L1251.1,237.1 L1251.6,237 L1252,236.9 L1252.4,236.8 L1252.8,236.6 L1253.2,236.5 L1253.7,236.4 L1254.1,236.3 L1254.5,236.1 L1254.9,236 L1255.3,235.9 L1255.8,235.8 L1256.2,235.7 L1256.6,235.5 L1263.5,234.3 L1263.5,234.3 L1263.5,234.3 L1263.5,234.3 L1263.5,234.3 L1263.5,234.2 L1263.5,234.1 L1263.5,234.1 L1263.5,234 L1263.5,234 L1263.5,234 L1263.5,233.9 L1263.5,233.9 L1263.5,233.9 L1263.5,233.7 L1263.4,233.7 L1263.5,233.9 L1263.6,234.3 L1263.7,234.7 L1263.8,235.2 L1263.9,235.6 L1264.1,236 L1264.2,236.4 L1264.6,236.9 L1265,237.2 L1265.4,237.5 L1265.7,237.7 L1266.1,238 L1266.5,238.2 L1266.9,238.4 L1267.2,238.6 L1267.6,238.9 L1268,239.1 L1268.4,239.3 L1268.7,239.5 L1269.1,239.8 L1269.5,240 L1269.9,240.2 L1270.3,240.4 L1270.6,240.6 L1271,240.8 L1271.4,241.1 L1271.8,241.3 L1272.2,241.5 L1272.5,241.7 L1272.9,241.9 L1273.3,242.1 L1273.7,242.3 L1274.1,242.6 L1274.4,242.8 L1274.7,243 L1274.9,243.1 L1275,243.5 L1275,243.9 L1275,244.3 L1275,244.8 L1274.9,245.2 L1274.9,245.6 L1274.9,246.1 L1274.9,246.5 L1274.9,247 L1274.8,247.4 L1274.8,247.8 L1274.9,248.3 L1274.9,248.7 L1275,249.1 L1275.1,249.6 L1275.3,250 L1275.4,250.4 L1275.6,250.8 L1275.7,251.2 L1275.9,251.6 L1276.1,252 L1276.2,252.4 L1276.4,252.8 L1276.6,253.2 L1276.7,253.6 L1276.9,254 L1277,254.4 L1277.2,254.8 L1277.4,255.3 L1277.6,255.7 L1277.7,256.1 L1277.9,256.5 L1278,256.8 L1278,257.3 L1278.1,257.7 L1278.1,258.1 L1278.2,258.6 L1278.2,259 L1278.2,259.4 L1278.1,259.9 L1278.1,260.3 L1278,260.7 L1278,261.1 L1277.8,261.6 L1277.7,262 L1277.6,262.4 L1277.5,262.9 L1277.4,263.2 L1277.2,263.7 L1277,264.1 L1276.8,264.5 L1276.6,264.9 L1276.4,265.3 L1276.1,265.7 L1275.9,266 L1275.6,266.4 L1275.4,266.8 L1275.1,267.2 L1274.9,267.5 L1274.6,267.8 L1274.3,268.2 L1274,268.6 L1273.8,268.9 L1273.5,269.2 L1273.2,269.5 L1272.9,269.9 L1272.6,270.2 L1272.3,270.5 L1272,270.8 L1271.6,271.2 L1271.3,271.4 L1270.9,271.7 L1270.6,272 L1270.2,272.2 L1269.9,272.5 L1269.5,272.7 L1269.2,273 L1269,273.2 L1268.8,273.6 L1268.7,273.9 L1268.7,274.3 L1268.7,274.7 L1268.7,275.2 L1268.9,275.6 L1269.1,276 L1269.3,276.5 L1269.6,276.8 L1269.9,277.1 L1270.2,277.5 L1270.6,277.8 L1270.8,278 L1271,278.3 L1271,278.7 L1270.9,279.1 L1270.8,279.6 L1270.7,280 L1270.6,280.4 L1270.5,280.8 L1270.4,281.3 L1270.4,281.7 L1270.4,282.1 L1270.4,282.6 L1270.5,283 L1270.5,283.4 L1270.5,283.8 L1270.7,284.3 L1270.9,284.7 L1271.1,285.1 L1271.3,285.5 L1271.4,285.8 L1271.7,286.3 L1272,286.7 L1272.3,287.1 L1272.5,287.3 L1272.8,287.7 L1273.1,288 L1273.4,288.4 L1273.7,288.7 L1274,289 L1274.3,289.3 L1274.4,289.6 L1274.5,290 L1274.7,290.3 L1274.6,290.8 L1274.5,291.2 L1274.3,291.6 L1274.1,292 L1274,292.4 L1274,292.7 L1274.2,293.3 L1274.5,293.7 L1274.8,294 L1275,294.3 L1275.4,294.7 L1275.6,295 L1275.8,295.3 L1276.1,295.7 L1276.1,295.7 L1276.1,295.7 L1275.7,296.6 L1275.4,296.8 L1275,297.1 L1274.8,297.3 L1274.5,297.6 L1274.3,297.9 L1274.2,298.2 L1274.1,298.6 L1273.8,298.7 L1273.2,298.8 L1272.3,299.1 L1271.1,299.4 L1269.6,299.8 L1267.8,300.3 L1265.7,300.9 L1263.4,301.5 L1261.2,302.2 L1259.2,302.9 L1257.5,303.6 L1255.9,304.4 L1254.6,305.1 L1253.4,305.9 L1252.5,306.7 L1251.8,307.6 L1251.2,308.3 L1250.6,308.9 L1250.2,309.5 L1249.8,309.9 L1249.6,310.2 L1249.4,310.4 L1249.3,310.5 L1248.8,310.3 L1248.6,310.3 L1248.2,310.2 L1247.5,310.2 L1246.7,310.1 L1245.6,310 L1244.3,309.9 L1242.8,309.8 L1241.1,309.7 L1239.3,309.6 L1237.5,309.7 L1235.6,309.8 L1233.6,310.1 L1231.6,310.4 L1229.5,310.9 L1227.3,311.4 L1225.1,312.1 L1223,312.6 L1221,313 L1219.1,313.3 L1217.3,313.5 L1215.6,313.6 L1214.1,313.5 L1212.7,313.4 L1211.3,313.1 L1210.1,312.8 L1208.9,312.3 L1207.9,311.7 L1206.9,311.1 L1206,310.3 L1205.1,309.5 L1204.4,308.5 L1203.7,307.5 L1203,306.5 L1202.3,305.5 L1201.5,304.5 L1200.7,303.6 L1199.8,302.8 L1199,301.9 L1198,301.1 L1197.1,300.4 L1196.1,299.7 L1195.2,299 L1194.2,298.5 L1193.3,298 L1192.3,297.5 L1191.4,297.1 L1190.5,296.8 L1189.5,296.6 L1188.7,296.3 L1187.8,295.9 L1187.1,295.5 L1186.4,295 L1185.7,294.5 L1185.1,294 L1184.6,293.3 L1184.1,292.7 L1183.6,292 L1183.3,291.4 L1183.1,290.8 L1182.9,290.2 L1182.9,289.6 L1182.9,289.1 L1183,288.6 L1183.2,288.1 L1183.7,287.4 L1184.5,286.7 L1185.6,285.9 L1187,285 L1188.7,284 L1190.6,282.9 L1192.9,281.7 L1195.5,280.4 L1197.7,279.1 L1199.6,277.9 L1201.2,276.7 L1202.4,275.6 L1203.3,274.5 L1203.8,273.4 L1204,272.4 L1203.8,271.5 L1203.7,270.5 L1203.7,269.7 L1203.7,268.8 L1203.7,268 L1203.8,267.2 L1204,266.4 L1204.2,265.7 L1204.5,265.1 L1204.7,264.5 L1204.9,264 L1205.1,263.5 L1205.2,263.2 L1205.3,263 L1205.4,262.8 L1205.4,262.7 Z"
   ],
   "label": [
    1230,
    284
   ],
   "bbox": [
    1182.9,
    233.7,
    1278.2,
    313.6
   ],
   "geoNeighbors": [
    "erzurum",
    "gyumri",
    "igdir",
    "trabzon",
    "yerevan"
   ],
   "poly": [
    [
     [
      1205.9,
      262.6
     ],
     [
      1208.8,
      261.9
     ],
     [
      1212.5,
      265.6
     ],
     [
      1216.2,
      266.9
     ],
     [
      1220.9,
      266.8
     ],
     [
      1224.3,
      265.8
     ],
     [
      1225.6,
      264.7
     ],
     [
      1227.1,
      262
     ],
     [
      1228.3,
      258.3
     ],
     [
      1229.9,
      251
     ],
     [
      1231.3,
      248.3
     ],
     [
      1234.6,
      244.8
     ],
     [
      1238.2,
      242.4
     ],
     [
      1244.5,
      239.4
     ],
     [
      1256.6,
      235.5
     ],
     [
      1263.5,
      234.3
     ],
     [
      1263.5,
      233.7
     ],
     [
      1264.6,
      236.9
     ],
     [
      1274.9,
      243.1
     ],
     [
      1275.1,
      249.6
     ],
     [
      1278,
      256.8
     ],
     [
      1278,
      261.1
     ],
     [
      1276.4,
      265.3
     ],
     [
      1273.8,
      268.9
     ],
     [
      1271.6,
      271.2
     ],
     [
      1269.5,
      272.7
     ],
     [
      1268.7,
      273.9
     ],
     [
      1268.7,
      275.2
     ],
     [
      1269.3,
      276.5
     ],
     [
      1271,
      278.3
     ],
     [
      1270.4,
      281.3
     ],
     [
      1270.5,
      283.8
     ],
     [
      1271.7,
      286.3
     ],
     [
      1274.3,
      289.3
     ],
     [
      1274.7,
      290.3
     ],
     [
      1274,
      292.7
     ],
     [
      1276.1,
      295.7
     ],
     [
      1275.7,
      296.6
     ],
     [
      1274.5,
      297.6
     ],
     [
      1274.1,
      298.6
     ],
     [
      1261.2,
      302.2
     ],
     [
      1255.9,
      304.4
     ],
     [
      1252.5,
      306.7
     ],
     [
      1249.3,
      310.5
     ],
     [
      1239.3,
      309.6
     ],
     [
      1235.6,
      309.8
     ],
     [
      1231.6,
      310.4
     ],
     [
      1221,
      313
     ],
     [
      1215.6,
      313.6
     ],
     [
      1212.7,
      313.4
     ],
     [
      1208.9,
      312.3
     ],
     [
      1205.1,
      309.5
     ],
     [
      1201.5,
      304.5
     ],
     [
      1199,
      301.9
     ],
     [
      1195.2,
      299
     ],
     [
      1191.4,
      297.1
     ],
     [
      1187.8,
      295.9
     ],
     [
      1185.7,
      294.5
     ],
     [
      1183.6,
      292
     ],
     [
      1182.9,
      290.2
     ],
     [
      1183.2,
      288.1
     ],
     [
      1184.5,
      286.7
     ],
     [
      1197.7,
      279.1
     ],
     [
      1202.4,
      275.6
     ],
     [
      1203.8,
      273.4
     ],
     [
      1203.8,
      267.2
     ],
     [
      1205.4,
      262.7
     ]
    ]
   ]
  },
  "igdir": {
   "paths": [
    "M1274.1,299.1 L1274.1,299.6 L1274.2,300 L1274.6,300.4 L1275.1,300.8 L1275.5,301 L1275.9,301.2 L1276.2,301.4 L1276.7,301.5 L1277.1,301.7 L1277.5,301.8 L1278,301.9 L1278.4,302.1 L1278.7,302.2 L1279.2,302.4 L1279.5,302.5 L1279.9,302.7 L1280.3,302.9 L1280.6,303.1 L1281,303.3 L1281.4,303.5 L1281.9,303.6 L1282.3,303.8 L1282.7,304 L1283.1,304.2 L1283.5,304.3 L1283.9,304.5 L1284.4,304.7 L1284.7,304.8 L1285.2,305 L1285.6,305.2 L1286,305.3 L1286.4,305.4 L1286.8,305.6 L1287.2,305.7 L1287.6,305.8 L1288,306 L1288.5,306.2 L1288.9,306.3 L1289.3,306.4 L1289.7,306.6 L1290.1,306.7 L1290.5,306.9 L1290.9,307 L1291.4,307.2 L1291.8,307.3 L1292.3,307.5 L1292.7,307.5 L1293.1,307.6 L1293.6,307.7 L1294.1,307.7 L1294.6,307.6 L1295,307.6 L1295.5,307.5 L1295.9,307.5 L1296.4,307.3 L1296.8,307.3 L1297.2,307.2 L1297.7,307.1 L1298.1,307 L1298.6,306.9 L1299,306.8 L1299.4,306.7 L1299.9,306.6 L1300.3,306.5 L1300.7,306.4 L1301.1,306.3 L1301.5,306.2 L1301.9,306.2 L1302.3,306.1 L1302.8,306 L1303.2,306 L1303.6,305.9 L1304,305.9 L1304.4,305.8 L1304.8,305.8 L1305.3,305.8 L1305.7,305.8 L1306.1,305.7 L1306.6,305.7 L1307,305.8 L1307.5,305.8 L1307.9,305.8 L1308.3,305.8 L1308.8,305.9 L1309.2,305.9 L1309.6,305.9 L1309.9,306 L1310.3,306.1 L1310.7,306.2 L1311.1,306.3 L1311.6,306.4 L1312,306.5 L1312.4,306.7 L1312.8,306.8 L1313.1,306.9 L1313.4,307.1 L1313.8,307.3 L1314.2,307.5 L1314.6,307.8 L1315,308 L1315.3,308.2 L1315.7,308.5 L1315.9,308.6 L1316.2,308.9 L1316.6,309.2 L1316.9,309.5 L1317.2,309.8 L1317.5,310.1 L1317.9,310.4 L1318.2,310.7 L1318.4,311 L1318.7,311.3 L1319,311.7 L1319.2,312 L1319.6,312.4 L1319.8,312.7 L1320.1,313 L1320.4,313.4 L1320.6,313.7 L1320.8,314.1 L1321.1,314.4 L1321.3,314.8 L1321.5,315.1 L1321.8,315.5 L1322,315.9 L1322.2,316.2 L1322.4,316.6 L1322.7,317 L1322.9,317.4 L1323.1,317.8 L1323.3,318.1 L1323.5,318.5 L1323.7,318.9 L1323.9,319.2 L1324.1,319.6 L1324.4,320 L1324.6,320.4 L1324.8,320.7 L1324.9,321.1 L1324.8,321.5 L1324.8,321.9 L1324.7,322.3 L1324.3,322.9 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1318.1,327.8 L1317.8,328 L1317.4,328.3 L1317.2,328.7 L1317.2,329.1 L1317.2,329.5 L1317.3,329.9 L1317,330.2 L1316.7,330.5 L1316.3,330.8 L1315.9,331.1 L1315.7,331.5 L1315.6,332 L1315.7,332.5 L1315.8,333 L1315.8,333.5 L1315.9,333.9 L1316,334.4 L1315.9,334.9 L1315.9,335.4 L1315.5,335.1 L1315.1,334.8 L1314.7,334.6 L1314.2,334.5 L1313.7,334.3 L1313.3,334.2 L1313.1,334.2 L1312.8,334.3 L1312.3,334.4 L1311.6,334.6 L1310.7,334.7 L1309.7,335 L1308.5,335.2 L1307.1,335.5 L1305.6,335.7 L1304,335.9 L1302.2,336 L1300.3,336 L1298.2,335.9 L1296,335.8 L1293.7,335.6 L1291.3,335.4 L1289.1,335.1 L1287.2,334.9 L1285.6,334.6 L1284.3,334.3 L1283.3,334 L1282.6,333.7 L1282.1,333.5 L1282,333.2 L1281.7,332.8 L1281.3,332.5 L1280.8,332.2 L1280.2,331.8 L1279.4,331.5 L1278.6,331.1 L1277.6,330.7 L1276.6,330.3 L1275.6,329.9 L1274.7,329.4 L1273.9,328.9 L1273.1,328.4 L1272.5,327.9 L1271.9,327.3 L1271.5,326.7 L1271.1,326.1 L1270.7,325.5 L1270.2,324.9 L1269.7,324.4 L1269.2,323.9 L1268.6,323.5 L1267.9,323 L1267.2,322.6 L1266.5,322.3 L1265.7,322 L1264.8,321.8 L1263.8,321.8 L1262.8,321.8 L1261.7,321.9 L1260.5,322.2 L1259.3,322.5 L1258,322.9 L1256.8,323.2 L1255.7,323.4 L1254.8,323.5 L1254,323.5 L1253.3,323.4 L1252.8,323.2 L1252.4,322.9 L1252.1,322.5 L1251.8,322 L1251.5,321.4 L1251.3,320.7 L1251.1,319.9 L1250.9,319 L1250.8,318.1 L1250.6,317 L1250.6,315.9 L1250.5,314.9 L1250.4,314 L1250.3,313.3 L1250.3,312.8 L1250.2,312.3 L1250.2,312 L1250.2,311.9 L1249.3,310.5 L1249.4,310.4 L1249.6,310.2 L1249.8,309.9 L1250.2,309.5 L1250.6,308.9 L1251.2,308.3 L1251.8,307.6 L1252.5,306.7 L1253.4,305.9 L1254.6,305.1 L1255.9,304.4 L1257.5,303.6 L1259.2,302.9 L1261.2,302.2 L1263.4,301.5 L1265.7,300.9 L1267.8,300.3 L1269.6,299.8 L1271.1,299.4 L1272.3,299.1 L1273.2,298.8 L1273.8,298.7 L1274.1,298.6 Z"
   ],
   "label": [
    1303,
    321
   ],
   "bbox": [
    1249.3,
    298.6,
    1324.9,
    336
   ],
   "geoNeighbors": [
    "erzurum",
    "kars",
    "yerevan"
   ],
   "poly": [
    [
     [
      1274.1,
      299.1
     ],
     [
      1274.2,
      300
     ],
     [
      1276.2,
      301.4
     ],
     [
      1292.3,
      307.5
     ],
     [
      1295.9,
      307.5
     ],
     [
      1301.5,
      306.2
     ],
     [
      1306.1,
      305.7
     ],
     [
      1309.6,
      305.9
     ],
     [
      1313.1,
      306.9
     ],
     [
      1316.6,
      309.2
     ],
     [
      1320.1,
      313
     ],
     [
      1324.8,
      320.7
     ],
     [
      1324.7,
      322.3
     ],
     [
      1324,
      323.2
     ],
     [
      1317.4,
      328.3
     ],
     [
      1317.3,
      329.9
     ],
     [
      1315.7,
      331.5
     ],
     [
      1315.9,
      335.4
     ],
     [
      1314.7,
      334.6
     ],
     [
      1313.1,
      334.2
     ],
     [
      1307.1,
      335.5
     ],
     [
      1302.2,
      336
     ],
     [
      1291.3,
      335.4
     ],
     [
      1283.3,
      334
     ],
     [
      1282.1,
      333.5
     ],
     [
      1281.7,
      332.8
     ],
     [
      1280.2,
      331.8
     ],
     [
      1275.6,
      329.9
     ],
     [
      1273.1,
      328.4
     ],
     [
      1269.2,
      323.9
     ],
     [
      1265.7,
      322
     ],
     [
      1261.7,
      321.9
     ],
     [
      1254.8,
      323.5
     ],
     [
      1253.3,
      323.4
     ],
     [
      1252.4,
      322.9
     ],
     [
      1251.3,
      320.7
     ],
     [
      1250.2,
      311.9
     ],
     [
      1249.3,
      310.5
     ],
     [
      1252.5,
      306.7
     ],
     [
      1254.6,
      305.1
     ],
     [
      1259.2,
      302.9
     ],
     [
      1274.1,
      298.6
     ]
    ]
   ]
  }
 },
 "background": [
  "m1433.07,221.9c-1.54,3.36-4.07,9.31-7.62,10.13-3.55.83-5.21.41-7.85-1.24-2.64-1.65-6.03-4.87-9.82-5.12-3.8-.24-10.16.99-13.46.09-3.3-.91-10.32-2.23-11.89-5.95-1.57-3.71.07-4.04.49-4.79.42-.74-5.01-1.37-7.04-2.31-2.04-.93-5.13-3.74-6.55-4.68-1.43-.93-2.26.28-3.2.77-.93.5-4.07-2.14-5.56-2.47-1.48-.33-5.17,1.98-6.33,2.97-.74.64-6.47,6.21-10.43,10.09-1.3.05-2.51.64-3.82.85-.37.06-.76.09-1.16.07-2.89-.17-5.08-.91-5.06,2.23.02,3.13-4.68,2.06-6.25.82-1.57-1.24-5.31,1.57-6.96,1.02-1.65-.55-2.76.44-4.85.55-2.09.11-4.84-.11-7.15-.55-2.32-.44-5.51-2.09-7.16-.11-1.65,1.98-.44,2.31-3.41,1.65-2.97-.66-8.49-.11-10.68.99-2.2,1.1-1.08,2.5-12.31,2.56,0,0-6.31-.67-11.62.13-.3-1.74-1.15-3.83-2.2-3.97-1.53-.2-7.44.66-8.43.75-1,.08-3.26-3.88-3.3-4.75-.04-.87,1.78-3.26-1.98-4.42-3.76-1.16-3.51-2.1-5.33-3.22-1.81-1.11-3.55-4.83-5.61-7.22-2.07-2.4-1.82-.75-4.38-.83s-4.04-1.98-2.8-4.54c1.23-2.56.05-2.89-2.98-3.44-3.02-.55-7.54-.55-8.09.33-.55.88-.71,5.83-2.37,6.6-1.66.77-.77,3.31-2.97,3.58-2.2.28-2.97-.82-6.22-1.7-3.25-.88-4.18-1.55-6.44-1.82-2.26-.28-3.19-1.21-6.66-1.05-3.47.17-3.96.66-6.12-.27-2.14-.94-2.25-.83-4.17.66-1.93,1.49-3.58,4.73-5.62,3.91-2.03-.83-5.39-2.26-6.93-2.76-1.49-.47-7.85-2.35-8.24-2.46,1.81-2.71,4.51-6.71,5.79-8.56,2.02-2.93,9-10.39,8.34-13.86-.67-3.46-3.03-10.29-2.87-12,.17-1.7-4.07-14.31-5.17-17.83-1.1-3.52-3.19-7.49-4.51-9.14-1.33-1.65-1.21-6.05-1.44-9.69-.22-3.63-2.43-13.98-5.83-16.29-3.41-2.31-10.24-2.42-12.55-3.08-2.31-.66-3.63-5.73-4.51-9.03-.88-3.3-2.87-3.96-5.62-4.51-2.75-.55-8.15-6.17-11.23-6.39-3.08-.22-10.02-.22-11.67-2.2s-3.74-2.64-6.27-3.08c-2.54-.44-3.86.88-4.63,0s-3.08-3.31-3.52-6.28c-.37-2.53-3.69-7.29-9.89-9.33-.04-.01-.07-.02-.11-.03-.47-.16-.95-.29-1.46-.41-.63-.15-1.29-.27-1.97-.36-.02-.09-.03-.2-.04-.33-.09-2.56,3.06-11.72,4.17-12.8,1.15-1.12,7.29-2.14,9-1.73,1.7.41,4.37,2.42,6.91,2.31,2.53-.11,3.63,1.43,5.39,1.76,1.76.33,5.17-1.32,6.61-1.98,1.43-.66,4.95,1.54,6.49,2.75,1.54,1.22,5.07,1.44,6.5,2.21,1.43.77.77,3.41,3.3,3.85,2.53.44,4.73.88,5.94,2.09,1.22,1.21,2.98.22,4.52.33,1.54.11,4.84,1.54,6.04,2.31,1.22.77,3.43,1.54,5.19.55s3.96.44,4.73,2.21c.77,1.76,2.64,3.85,4.74,4.51,2.09.66,2.97,3.19,5.28,3.19s5.06-.55,6.49.11c1.44.66,2.76,1.1,3.86.33,1.1-.77.99-1.76,3.63-.99,2.64.77,6.17,2.31,7.38,1.98,1.2-.33,5.28-.88,7.59-1.21,2.32-.33,6.61-.22,8.36-1.32,1.77-1.1,4.3.22,5.74,1.54,1.43,1.32,6.88,6.77,10.84,4.96,3.96-1.82.99-3.14,7.92-1.65,6.94,1.48,8.92,3.96,10.41,7.76,1.49,3.79,5.45,6.11,9.08,7.76,3.64,1.65,8.59,5.45,11.89,4.95,3.3-.49,7.27,2.31,11.07,4.46,3.79,2.15,7.15,8.64,2.42,12.5-4.74,3.85-5.4,5.5-4.08,7.26,1.33,1.76,4.41,4.41,8.7,4.08,4.3-.33,6.61-4.63,9.91-5.62,3.3-.99,12.33-2.42,14.53-2.09,2.2.33,6.06-2.53,6.82-3.85.78-1.32,5.84-7.38,12.12-7.49,6.27-.11,6.6,5.61,9.47,8.37,2.86,2.75,3.85.11,4.73-2.43.88-2.53,3.52-4.4,5.61-3.74,2.1.66,2.21,3.08,4.52,2.2,2.3-.88,4.07-1.76,7.15,2.43,3.09,4.18,5.4,5.39,6.94,7.48,1.54,2.09,1.98,1.76,6.94,1.43,4.95-.33,7.34.61,12.3,1.76,4.95,1.16,2.72,5.04,2.39,7.44-.33,2.39.75,8.34-2.39,7.92-3.14-.41-5.78,4.46-2.89,6.44,2.89,1.98,5.53,4.79,7.02,5.29,1.48.49,6.69.16,7.59,1.48.91,1.32.42,4.3,1.99,4.54,1.56.25,5.36-.24,6.26.91.92,1.16,1.58,1.32,3.81,1.32s4.21-.66,5.04.66c.82,1.33,1.23,2.56,3.13,2.73,1.9.16,2.65.91,3.47,1.65.83.74,2.3,3.06,2.15,4.05-.04.27-.19.75-.43,1.32-.59,1.46-1.73,3.48-3.04,3.96-1.82.66-8.26,2.64-8.67,5.2-.41,2.56,8.5,16.68,17.42,22.05,3.44,2.07,5.9,3.8,7.53,5.35,2.6,2.46,3.11,4.42,2.16,6.48Z",
  "m1622.17,497.23v465.69c-5.76-7.11-11.55-16.1-12.18-20.3-.91-6.03-2.87-10.26-6.86-9.83-3.98.43-15.35,8.34-17.83,10.16-2.48,1.82-6.61,2.89-7.1-2.31-.5-5.2-3.06-5.37-5.67-5.56-2.61-.19-7.13.69-8.2-.97-1.08-1.65-.66-14.03-2.48-14.61-1.82-.58-5.45-2.23-10.35,1.43-4.9,3.66-1.87,7.49-1.09,11.62.79,4.12-1.07,8.25-2.39,10.36-1.32,2.1-9.89.75-11.19.67-1.29-.08-1.58,1.19-1.9,3.06-.32,1.81-4.81,1.4-5.08,1.37.17-.29.27-.51.3-.61.01-.03.02-.05.02-.05,0,0-2.64-.77-4.07-1.32-1.43-.55-3.42-5.28-3.86-7.04-.44-1.77-1.29-2.04-.64-6.32.33-2.19-4.5-4.91-5-5.99-.49-1.07-2.68-2.31-4.17-1.9-1.48.42-2.85-.66-2.89-4.37-.04-3.72-8.39-3.51-8.83-3.63-.44-.13-.13-32.04-.13-32.04l-17.58-.04.74-25,9.25-17.98s1.65-2.56-.5-5.82c-2.14-3.26-6.64-8.01-6.89-9.7-.25-1.7-3.68-5.7-3.55-6.32.12-.62-4.5-.67-5.38-2.57-.88-1.9.63-2.76,1.26-3.8.64-1.05-1.15-1.73-1.81-2.48-.66-.74-.77-2.78-2.62-4.46-1.84-1.68-1.21-1.76-.85-3.08.36-1.32-.55-3.44-1.52-4.21-.96-.77-3.61-3.18-5.39-3.26-1.78-.08-2.64,1.03-3.96,1.36-1.32.33-4.67,1.28-7.85-1.44-3.18-2.73-14.36-12.8-18.04-16.72-3.67-3.93-9.62-6.44-11.93-8.63-2.31-2.19-6.91-4.01-10.65-4.12-3.74-.11-8.51.08-9.3-.19-.8-.28-2.78-.61-2.67-1.9.11-1.29,2.34-1.18,2.58-1.87.25-.69.5-2.56-.79-3-1.3-.44-4.08-.88-3.94-2.42.14-1.54,3.41-.36,4.18-.77.77-.42,5.81-4.6,2.01-9.39-3.8-4.79-10.29-18.88-14.03-20.75-3.75-1.87-11.23-5.4-16.08-13.76-4.84-8.37-8.48-8.81-7.15-11.56.99-2.06,3.03-4.75,4.36-7.08.44-.77.8-1.51,1.02-2.17.08-.24.17-.53.25-.85.03-.11.05-.22.08-.34.05-.22.1-.47.15-.72.3-1.55.5-3.52.4-5.34-.02-.28-.04-.56-.08-.83-.06-.65-.18-1.27-.36-1.82-.07-.22-.15-.44-.24-.64-.05-.11-.1-.22-.16-.33-.11-.21-.24-.41-.39-.59-.21-.26-.46-.48-.74-.65-2.97-1.76-5.17-6.17-3.19-8.04,1.98-1.87,2.14-1.34,1.96-3.88-.19-2.54.41-4,1.15-3.71.75.29,2.6,2.78,3.84,2.56,1.16-.22,6.17,1.28,6.78.64.03-.04.05-.09.05-.15,0-.59-.81-3.79-1.8-6.68-.1-.31-.21-.61-.32-.9-.1-.3-.21-.58-.32-.86-.11-.28-.22-.54-.33-.79-.38-.89-.76-1.6-1.1-2-1.57-1.81,1.56-6.19,2.97-7.18,1.4-.99,4.18-2.59,6.05-5.01,1.87-2.42,1.87-11.78,4.85-11.23,1.93.36,7.42.25,10.11-2.55.1-.09.19-.19.27-.29.09-.1.17-.21.26-.33.22-.33.42-.68.58-1.07.05-.12.1-.26.14-.4.27-.85.35-1.83.19-2.99-.1-.67-.27-1.39-.55-2.17-.18-.53-.38-1.05-.57-1.57-.4-1.03-.83-2.03-1.26-3.01-.21-.49-.44-.97-.66-1.45-.22-.47-.44-.94-.67-1.4l-.33-.69c-.22-.46-.45-.91-.66-1.35-.77-1.54-1.49-3.01-2.1-4.38-.17-.4-.34-.78-.49-1.16-1.17-2.86-1.7-5.32-.85-7.34,2.09-4.95,7.16-6.82,9.58-8.14,2.42-1.32,8.47-5.62-2.75-7.27-11.23-1.65-16.85,4.51-23.34-3.52-.27-.34-.54-.66-.81-.96-.27-.3-.54-.59-.81-.86-3.95-4-7.64-4.63-10.3-4.54-.15,0-.29.01-.42.02-.27.01-.53.03-.78.06-.75.07-1.38.18-1.86.22-2.42.22-3.35-2.42-2.14-5.56.84-2.16-.21-4.02-1.19-5.4-.22-.31-.43-.6-.62-.86s-.35-.5-.47-.71c-.7-1.28-.53-3.47-1.41-4.69-.06-.08-.12-.16-.19-.23-1.12-1.15-.29-1.98-.38-4.99-.08-3.02-.61-7.39-3.63-6.86-3.01.54-5.53,2.11-6.65-.7-1.11-2.8-1.28-4.17-2.31-4.83-1.03-.66-1.69-2.31-.37-4.41,1.32-2.11,2.4-6.2,1.12-9.25-1.28-3.06-4.09-1.65-5.04-3.1-.95-1.44-6.69.79-5.49-2.93,1.2-3.72,3.76-2.89,3.14-5.16-.62-2.27-1.7-4.58-1.04-5.86s-1.11-3.26-2.89-4.01c-1.77-.74-4.04-2.97-3.84-5.08.21-2.1.83-3.46.83-3.46,0,0-.07-.26-.16-.65-.22-.94-.58-2.63-.46-3.11v-.03c.19-.6,1.82-1.7,2.01-2.42.04-.16.05-.38-.01-.65-.17-.88-.95-2.3-2.8-4.06-2.39-2.28-3.47-2.5-4.07-2.56-.61-.05-.74-.16-1.05-.77-.31-.6-.19-.96-.85-1.43-.66-.47-1.13-1.24-1.27-1.73-.13-.5-1.07-1.24-1.23-1.6-.05-.1-.04-.35,0-.67.11-.86.46-2.24.68-2.66.26-.48.45-.94.32-1.45h0c-.02-.12-.06-.23-.12-.34-.15-.29-.19-1.05-.16-1.85.02-.99.12-2.05.18-2.39.06-.31.1-.52.01-.76-.07-.22-.25-.46-.62-.83-.6-.61-.81-.82-.59-1.35h0c.06-.14.15-.3.27-.5.57-.93,2.23-1.76,2.17-2.86,0-.1-.02-.2-.04-.32-.27-1.23-1.65-3.52-2.65-3.89-1.11-.41-3.28-1.02-4.05-.72-.77.31-1.73-.55-2.15-1.09-.41-.54-1.34-1.16-2.02-1.24-.69-.08-1.01-.56-1.03-.99-.02-.43-.66-2.23-1.18-2.48-.52-.24-6.46-.26-6.98-.76-.41-.4-.89-.99-.74-1.95.03-.22.1-.45.21-.71.57-1.39,4.64-10.95,5.82-12.38,1.19-1.43,2.58-4.18,2.41-5.48-.01-.04-.01-.09-.01-.14.02-.15.03-.3.01-.43.01-.01.01-.02,0-.03.15-1.7,1.22-5.03,2.41-5.54,1.11-.47,3.14-2.93,2.85-4.57-.06-.36-.24-.68-.56-.93-1.79-1.4-3.58-.55-5.23-.63-1.65-.09-3.64-.28-3.92-1.24-.08-.27-.1-1.1-.1-2.17.02-2.67.26-6.87.38-7.73.05-.34.08-1.04.07-1.87-.03-2.09-.26-5.02-.75-5.1-.66-.13-1.29-.28-1.11-1.44,0-.03,0-.06.01-.09.08-.4.09-.77.05-1.11-.07-.7-.31-1.27-.48-1.8-.17-.56-.41-1.04-.26-1.51.05-.18.17-.37.37-.56.72-.66-.07-3.02,1.14-3.84.51-.35.65-.85.53-1.39-.15-.75-.8-1.58-1.63-2.19-1.43-1.05-2.92-2.86-3.41-4.79-.29-1.1-.43-2.64-.4-3.95-.01-.07-.01-.13,0-.2.02-.9.12-1.68.29-2.12.23-.57.26-1.57.24-2.56,0-.85-.04-1.7-.02-2.28-.01-.04,0-.08,0-.12,0-.07,0-.15-.01-.24v-.11c-.15-1.58-1.33-5.55-2.86-6.36-1.65-.88-3.3-3.8-3.35-5.78-.02-.52-.19-1.2-.43-1.92-.67-2.01-1.89-4.4-1.89-5.13,0-.14,0-.3.03-.46.12-.96.78-2.11,4.27-2.02,4.07.11,3.74.17,4.95-.27,1.21-.44,2.53,3.25,4.19,2.37,1.65-.89,1.65-2.15,3.63-2.1,1.98.06,3.69-.75,3.69-2.36,0-.11,0-.24-.02-.39,0,0,.01-.02,0-.04-.08-1.43-.48-4.24-.43-5.92v-.02c.01-.63.1-1.1.28-1.27.74-.7,3.22-4.17,3.18-5.29,0-.1-.02-.22-.05-.34-.17-.89-.82-2.18-.64-3,.05-.24.17-.44.4-.58.89-.53,4.89-4.21,6.39-5.62,2.4,2.28,8.18,7.79,10.7,10.25,3.22,3.13,6.03,9.82,7.35,12.22,1.32,2.39,8.34,8.5,9,10.15.66,1.65-.55,5.86,1.87,6.31.08.01.16.03.25.06.06.02.14.04.21.07.12.04.25.09.4.15.12.05.26.1.39.17,1.8.83,4.65,2.69,7.36,4.9.4.33.8.66,1.19,1s.78.69,1.15,1.04c1.55,1.46,2.91,2.97,3.81,4.39,3.19,5.06,6.27,3.3,11.45,5.06.81.28,1.74.55,2.75.82.6.17,1.23.33,1.89.49.65.16,1.31.31,1.99.46,1.38.32,2.82.63,4.25.93.47.1.94.2,1.4.3.47.09.94.19,1.4.29.23.05.46.1.69.15.43.09.84.18,1.25.27.48.1.95.2,1.41.3.6.14,1.17.27,1.72.4.32.08.63.15.93.23.27.06.54.13.79.2,5.4,1.43,5.51,2.43,5.51,2.43,0,0,7.87-3.58,9.52-4.24,1.65-.66,6.77,1.73,8.34,1.57,1.57-.17,1.49-1,1.49-1,0,0,0-.01-.01-.03l5.43-2.25c1.87-.78,6.71-5.72,8-8.7,1.29-2.97,6.8-4.29,9.61-4.46,2.81-.16,5.12-4.62,8.26-8.25,3.14-3.64,2.81-3.8,7.93-6.61,5.11-2.81,4.62-3.63,7.43-6.6,2.8-2.98,13.13-10.9,16.26-10.9s8.26-4.13,9.84-5.33c1.59-1.2,7.5,1.98,7.5,1.98,0,0,11.7,13.97,13.9,16.78,2.2,2.81-.88,3.41-2.26,3.74-1.37.33-6.93,3.52-7.48,4.13-.55.61-.83,1.65,0,4.68.82,3.03,4.43,5.31,7.57,7.95,3.13,2.65.08,7.68-.99,8.84-1.08,1.15-7.64.82-9.83,2.14-2.18,1.33-4.38,3.72-3.38,6.69.99,2.98,10.23,7.35,10.32,8.92.08,1.57,1.98,3.96,3.55,5.45s2.23.83,3.22.58,3.13-1.65,3.3-.58c.16,1.07,1.49,3.63,2.89,5.37,1.4,1.73,4.38,7.17,6.25,9.47,1.86,2.29,5.67-.47,8.35-2.45,2.48-1.83,5.39-.04,5.88,2.16.04.18.06.36.07.54.08,2.42,1.3,17.06,2.82,28.59,1.51,11.53,7.92,19.15,14.54,25.33,6.62,6.17,17.71,6.36,23.38,7.13,5.67.78,18.69,2.89,22.12,3.66,3.42.76,6.01-1.17,7.36,5.94.67,3.53,3.17,7.37,5.88,10.77Z",
  "m228.44,369.97c.7.54,1.9,1.07,2.85.41.95-.66,1.9-1.78,2.02-2.06s-3.72-1.86-4.29-2.52c-.58-.66-2.81-2.19-2.81-2.19,0,0-1.44-.99-1.9-.87-.45.12.37.83.95,2.06.58,1.24,2.48,4.62,3.18,5.16Z",
  "m237.85,366.17c.83-.25,1.86-.99,2.56-1.9s1.94-3.34,2.35-4.05.78-2.27.29-2.72c-.5-.45-1.46-.58-2.15.5,0,0-1.49,2.23-1.78,3.06s-.83,2.52-1.49,3.26c-.66.74-.62,2.11.21,1.86Z",
  "m270.61,385.24c1.09.8,2.46,1.05,3.34,1.36.89.31,1.07,1.28.74,2-.33.72-.06,2.95,2.48,2.68,2.54-.27,2.97-.47,2.58-1.53s-1.2-3.06-2-3.55c-.8-.5-1.88.02-2.44-2.31-.02-.06-.17-2.08-1.32-3.88-1.16-1.8-3.16-2.21-3.92-2.37-.76-.17-1.22,1.01-.83,3.26.39,2.25.27,3.53,1.36,4.33Z",
  "m285.82,451.38c1.07.29,2.72,5,4.09,6.19,1.36,1.2,3.43,3.92,3.8,4.83.37.91,1.53.95,1.78,0,.25-.95,1.32-2.27.91-3.43-.41-1.16.21-8.85-2.23-9,0,0-3.47,0-4.21-.66-.74-.66-1.36-.95-1.24-2.02.12-1.07-.21-2.15-1.2-2.44-.99-.29-1.57-1.53-2.72-1.24-1.16.29-3.96,1.36-3.06,3.8.91,2.44,3.01,3.67,4.09,3.96Z",
  "m306.42,473.01c2.35,0,3.34-.41,3.43-2.52.08-2.11-1.24-2.6-2.77-2.93-1.53-.33-4.5-1.44-5.53-1.73-.72-.2-2.69-1.13-3.96-.96-.75.1-.99,1.07-.44,1.58,1.9,1.74,7.34,6.57,9.27,6.57Z",
  "m314.39,481.43c.91.58,3.22-.29,4.13-1.24.91-.95,1.32-2.64-.37-3.43-1.69-.78-4.28-1.2-4.33,0,0,0-.33,4.09.58,4.67Z",
  "m292.68,475.65c-1.04.03-1.82,2.34-1.98,4-.06.66-.33,3.48,1.07,4.05.87.35,2.15-.26,2.68-1.16.23-.39.25-.83.29-1.69.06-1.36.1-2.26-.33-3.26-.13-.3-.84-1.97-1.73-1.94Z",
  "m262.46,464.16c-1.58.49-2.22,2.14-2.7,3.36-.85,2.17-1.43,5.79-.22,6.39,1.23.61,3.95-2.11,5.23-4.68.5-1,1.62-3.23.61-4.46-.66-.8-1.99-.89-2.92-.61Z",
  "m267.82,479.3c-1.23-.75-1.84-1.13-2.42-.91-1.06.4-1.46,2.43-.83,3.06.36.36.8.02,1.18.36.58.52-.05,1.69-.14,3.96-.04,1.1-.07,2.02.28,2.15.45.17,1.31-1.2,3.03-3.94,1.03-1.63,1.24-2.11,1.1-2.67-.18-.78-.9-1.21-2.2-2.01Z",
  "m268.03,498.77c.44,1.29,1.97,2.36,3.26,1.86,1.09-.42,1.54-1.77,1.4-2.81-.15-1.13-1.02-2.22-2.19-2.39-.13-.02-.96-.13-1.69.41-.92.68-1.11,1.98-.78,2.93Z",
  "m278.47,506.08c-.28.29-.09.87.08,1.4,1.4,4.25,1.54,4.65,2.11,5.37.68.87,1.22,1.56,1.86,1.49.93-.11,1.61-1.81,1.61-3.18,0-2.66-2.55-4.43-4.09-5-.34-.12-1.22-.45-1.57-.08Z",
  "m306.88,500.22c-1.74.61-2.54,2.18-3.67,4.42-.67,1.31-1,1.98-.87,2.81.26,1.64,2.05,3.07,3.8,3.1,2.34.03,3.72-2.48,4.33-3.59.27-.49,2.33-4.24.58-6.11-1.05-1.11-2.97-1.04-4.17-.62Z",
  "m315.55,503.23c-.23.74.23,1.22,1.24,3.14,1.62,3.08,1.6,4.09,3.1,5.53.63.61,1.07,1.02,1.78,1.16,1.76.33,3.38-1.44,3.88-1.98,1.86-2.02,2.14-4.38,2.56-7.89.43-3.58-.1-4.6-.45-5.12-.13-.19-1.45-2.05-3.14-1.78-.72.12-1.23.58-1.49.87-1.73,2.35-3.49,3.55-4.83,4.21-1.21.6-2.34.89-2.64,1.86Z",
  "m311.01,524.44c-.49,2.24,1.52,4.03,1.76,4.24.74.64,2.59,1.88,3.74,1.16,1.17-.73.96-3.06.28-4.51-.87-1.84-3.07-3.45-4.51-2.81-.94.42-1.2,1.63-1.27,1.93Z",
  "m317.07,551.25c.13.73,2.02,1.36,3.43.78,2.36-.96,2.28-4.84,2.27-5.04-.08-2.44-1.53-5.06-2.72-5-.71.04-1.17,1.01-1.2,1.07-.86,1.87,1.49,3.5.87,5.45-.54,1.7-2.79,1.9-2.64,2.72Z",
  "m338.09,523.72c1.97.68,3.97-.51,5.39-1.38,3.27-1.99,3.04-3.54,6.55-5.78,1.77-1.13,2.94-1.44,2.86-1.98-.1-.74-2.51-1.54-4.35-.77-1.99.83-1.57,2.75-3.85,3.8-1.32.61-2.32.35-3.03,1.32-.58.78-.17,1.28-.66,1.93-1.17,1.52-4.6.22-4.9.99-.17.45.8,1.46,1.98,1.87Z",
  "m372.73,533.12c-.76-.79-2.14-1.46-2.81-.99-.85.6.19,2.49-.74,3.26-.52.43-1.05.02-3.06.08-1.51.05-2.32.07-2.72.62-.59.79-.14,2.44.91,3.22,1.06.79,2.55.57,3.47,0,1.36-.85,1.01-2.2,2.19-2.72,1.41-.62,2.74.94,3.51.33.71-.57.39-2.61-.74-3.8Z",
  "m263.82,531.59c2.03,1.29,4.66,0,6.69-.99,1.58-.77,2.83-1.39,3.06-2.64.24-1.34-.85-2.69-1.94-3.3-1.46-.82-3.54-.68-3.96.17-.45.9,1.16,2.31.66,2.93-.29.36-1.06.19-1.36.12-2.13-.47-2.66-2.52-3.67-2.35-.79.13-1.26,1.52-1.32,2.44-.1,1.46.71,2.91,1.86,3.63Z",
  "m360.77,622.03c-2.42,1.54-3.96,3.41-6.06,1.98-2.09-1.43-4.62.11-6.72,1.43-2.09,1.32-8.15,4.84-10.13,3.52-1.98-1.32-3.74-3.53-2.97-7.33.77-3.79-1.76-6.55-6.83-4.45-5.06,2.09-17.39-1.32-20.37-1.32s-3.96.33-6.39-1.54c-2.42-1.87-11.56-2.97-14.86-2.97s-8.48,2.2-12.77,2.31c-4.29.11-13.21,2.53-14.42.55-1.21-1.98-2.09-3.3-4.95-4.95-2.86-1.65-9.91-4.95-12.77-5.06-2.86-.11-12.88.55-14.53.55s-3.96,1.65-4.62,4.18c-.66,2.53-1.1,9.36.77,10.68,1.87,1.32,3.41,3.3,7.71,3.19,4.29-.11,17.72,2.42,20.92,3.08,3.19.66,11.78.11,13.87.22,2.09.11,5.83,4.29,8.59,4.95,2.75.66,5.17,1.1,8.26,1.65,3.08.55,4.4,4.07,2.75,5.5s-.88,4.07,3.96,4.07,12.11.44,15.3-.66c3.19-1.1,11.89-3.41,19.82-3.08,7.93.33,18.83-1.32,22.24-1.87,3.41-.55,4.79.55,7.29,1.21,2.5.66,9.99.33,10.54-4.84s.92-5.88,0-9.03c0,0-1.21-3.52-3.63-1.98Z",
  "m274.52,442.75c-.74,1.03-1.82,3.05-3.06,2.39-1.23-.66-3.22-3.42-4.45-3.51-1.24-.08-.87,1.45-1.45,1.9-.58.46-3.96-.82-4.17-2.72-.21-1.9-.74-3.51-1.82-3.64-1.07-.12-3.67-1.73-3.67-3.55s.58-3.84-.45-4.83c-1.04-.99-3.06-2.39-3.27-3.55-.2-1.15-3.86-3.85-4.08-5.94-.22-2.09-1.38-3.25-3.42-3.52-2.03-.28-12.33.44-13.76-.23-1.43-.66-5.34-.66-5.01,1.05.33,1.71,1.88,3.08,4.46,3.63,2.59.55,7.43,2.26,8.87,2.65,1.43.38,6.22,3.19,7.21,4.78.99,1.6,2.58,3.58,1.76,4.3-.83.71-2.86,1.26-3.64,2.04-.77.77-.66,3.08-.11,4.29.56,1.21,1.44,5.78,1.05,6.6-.38.83.11,3.8.55,4.63.44.82.33,3.91.77,5.01.44,1.1,1.93,6.44.88,8.14-1.04,1.71-3.25,2.81-5.12.61-1.87-2.2-3.41-5.73-4.68-6.77-1.26-1.05-4.23-1.1-5.06-2.37-.83-1.26-4.02-6-4.57-6.6-.55-.61-3.3-1.9-4.21-2.89-.91-.99.91-3.72-1.98-4.71-2.89-.99-4.38,1.16-5.37,1.73-.99.58-3.96,2.15-6.36,2.23-2.39.09-8.17,1.16-9.16,2.07-.99.91-8.67,2.31-9,3.22-.33.91-.41,4.29,4.87,4.54,5.28.25,4.87,3.96,4.05,4.87-.83.91-1.41.12-.99,2.7.41,2.59.3,5.72.96,6.38.66.66,1.98,1.16,3.3,2.48,1.32,1.32,2.97,2.53,4.74,2.86,1.76.33,2.25-1.65,1.92-2.8-.33-1.16-2.75-2.65-1.48-3.09,1.26-.44,4.23-.66,4.29.22.05.88.44,2.92-.28,3.58-.71.66-.66,2.04.06,2.75.71.72,1.54,1.82,2.59.66,1.04-1.15,2.09-1.76,2.58-1.15.5.6.66,1.98.06,2.42-.61.44.33,2.04.66,2.75.33.72.05,2.59-2.42,2.81-2.48.22-8.87.55-9.75,1.16-.88.6-.88,3.02-1.81,3.3-.94.27-2.87.88-2.98,1.7-.11.83-.44,1.82-.99,1.66-.55-.17-1.15-.55-1.81-1.6-.66-1.05-3.86-2.97-2.64-3.63,1.21-.66,3.08-3.8.93-4.35-2.15-.55-9.74-3.14-11.39-4.3-1.65-1.15-3.31-2.47-5.78-2.72-2.48-.25-2.4,3.3-1.98,5.04.41,1.73,3.38,10.27,4.37,11.57.99,1.31,3.8,5.11,3.88,6.18.08,1.07-.91,4.04.41,4.95,1.33.91,2.32,1.9,2.98,3.47.66,1.57,2.39,7.02,2.56,8.26.16,1.24,1.15,5.03,1.9,6.03.74.99,1.65,2.72,2.06,3.79.41,1.08.63,3.5.08,3.8-.55.3-1.59.19-1.98.55-.38.36-.66,2.15-.63,2.89.03.74.33,5.51,1.59,6.83,1.27,1.32,2.87,2.23,3.06,2.64.19.41,1.02,3.99,1.51,4.29.5.31,2.62,2.1,1.93,2.37-.69.28-4.57.74-5.48-1.29-.91-2.04-2.64-3.75-3.41-3.86-.77-.11-4.9-3.11-5.31-4.18s-4.79-5.12-5.23-7.82c-.44-2.69-.06-5.06-1.93-5.83s-9.69-.11-10.46.52-1.13,2.75-1.57,3.3c-.44.55-.96,1.55-.85,2.32.11.77-.96,3.92-1.54,4.66-.58.74-1.73,1.36-1.73,2.02s-.33,3.8,0,4.75c.33.95,1.52,2.6,1.44,3.35-.08.74,0,2.6-1.98,1.44-1.98-1.15-4.38-2.19-4.67-3.3-.28-1.12,1.33-4.34,1.08-5.7-.25-1.36-2.11-8.59-2.97-9.7-.87-1.12-4.55-8.96-5.7-9.83-1.16-.86-4.63-3.01-4.5-4.25.12-1.24.62-4.17-.46-4.79-1.07-.62-4.87-.04-6.79.73-1.93.77-3.11,2.59-3.47,3.88-.36,1.3-.28,7.54,0,8.89.27,1.35-1.58,5.45-2.29,5.86-.7.42-3.46-3.71-3.84-4.54-.37-.82-5.9.04-5.94-1.15-.04-1.2-1.45-5.7-.79-7.19.67-1.48-1.89-3.96-3.05-6.19-1.16-2.23-5.12-8.83-2.73-10.98,2.4-2.15,7.02-6.85,6.03-9.83-.99-2.97-6.6-13.29-8.25-14.69-1.66-1.41-8.01-6.39-10-7.27-1.98-.88-1.54-4.73-2.86-6.38-1.32-1.66-7.15-4.52-7.92-6.39-.78-1.87.88-4.18,3.74-5.83,2.86-1.66,5.83-6.39,6.93-8.92,1.11-2.53,1.55-6.94,3.42-6.94s6.49,1.43,8.69,1.54c2.21.11,7.55-2.5,7.96-3.71.41-1.21.69-4.38,3.05-5.92,2.37-1.54,6.88-3.36,12.66,2.31,5.78,5.67,9.69,7.43,11.78,7.27,2.1-.17,5.62,2.14,7.82,2.31,2.2.17,5.51,2.04,7.87,2.81,2.37.77,7.05,2.25,8.45,4.07,1.41,1.82,5.37,7.6,8.01,6.77,2.64-.82,7.27-1.82,5.04-3.38-2.23-1.57-2.97-4.3-.09-4.71,2.89-.41,9.83-.08,10.99-1.24,1.15-1.15,3.3-4.87.49-6.03-2.81-1.15-6.19-2.47-8.25-2.97-2.07-.49-11.81-3.22-13.46-4.87-1.65-1.65-2.87-4.82-3.53-6.36-.66-1.54-4.51-1.59-5.23.44-.71,2.04-.66,3.75-1.7,3.69-1.05-.05-1.6-4.24-2.75-5.67-1.16-1.43-2.87-2.42-4.57-2.09-1.71.33-2.54,1.4-2.98,2.9-.44,1.5-1.04,2.22-2.25,2.33-1.21.11-8.26.55-9.58-.5-1.32-1.04-5.45-3.36-7.54-3.19-2.09.17-11.34,1.98-12.61,2.75-1.26.77-10.13,2.09-12.93.66-2.81-1.43-6.22-2.47-7.16-4.46-.94-1.98-2.04-5.01-2.59-5.12-.55-.11-.71,2.92-.55,3.8.17.88,0,3.69-.66,3.97-.66.27-3.58,1.59-3.96,2.42-.39.82-3.96,1.59-4.7.33-.75-1.27-1.25-4.18-.7-6.11.56-1.93-3.02-6.47-4.18-7.87-1.15-1.41-1.48-6.2-2.39-7.19-.91-.99-3.22-.74-3.8-2.06-.58-1.32-1.85-4.57-2.07-6-.22-1.43-2.53-1.32-3.24-.77-.72.55-3.25.88-3.58,2.2-.33,1.32-.22,5.28-1.87,6.61-1.65,1.32-11.23,1.32-6.5-6.5,4.74-7.82,5.51-5.94,8.04-7.05,2.53-1.1,4.02-3.19,5.34-3.52,1.32-.33,6.49-.49,8.03.06,1.55.55,3.91,1.48,5.01.93,1.1-.55,2.32-1.15,2.21-2.91-.11-1.77-1.38-6.72-2.65-7.49-1.26-.77-1.7.22-2.97.88-1.27.66-6.38,2.37-7.71,1.76-1.32-.6-4.23-1.87-5.5-1.43s-1.05,2.59-2.31,2.37c-1.27-.22-4.6-6.8-7.49-10.1-2.89-3.31-6.93-5.12-6.93-7.35s-4.63-1.65-5.62-2.07c-.99-.41-3.41-2.72-4.84-5.8-1.43-3.09-1.54-3.86-.66-5.51.88-1.65-.99-4.29-2.21-5.39-1.21-1.1-2.24-1.75-1.62-3.4.62-1.65-.99-3.51-2.27-3.92-1.28-.42-1.24-1.28-1.24-1.28l.43.02,4.24.18s1.4-1.77,2.39-1.73c.99.04,1.65-1.45,2.02-2.23.38-.79.46-.95.17-3.63-.29-2.69,1.9-2.52,3.05-2.32,1.16.21,4.88-1.03,2.94-3.79-1.94-2.77-3.8-5.99-3.6-7.11.21-1.11-.42-1.84.6-2.17,1.01-.33,2.8-2.06,3.49-3.69.69-1.62,1.74-1.37,3.06-1.4,1.32-.03,2.91-.22,4.21-.3,1.29-.09,3.82-1.52,4.92-1.63,1.1-.11,2.26-3.08,2.18-3.88-.08-.8-.25-2.78.36-3.47.6-.68.38-3.74.6-4.81.22-1.08,2.09-2.78,2.4-3.31.12-.21.3-.99.52-1.98,1.55.34,3,.7,3.55.96,1.4.66,2.92,4.7,4.18,6.34,1.25,1.63,3.94,5.56,2.73,8.09-.42.87-.36,1.88-.06,2.86.57,1.86,1.99,3.64,2.64,4.29,1,.99,1.93,3.69,1.24,5.71-.7,2.02,2.08,6.29,3.39,5.74,1.31-.54,5.01.11,8.64,1.32,3.63,1.22,3.41.78,5.62-.93,2.2-1.71,5.39-1.05,8.42-.55,3.03.49,9.74,2.1,10.78,1.87,1.04-.24,3.91-.51,5.62-.77,1.71-.26,0-3.96-.55-4.9-.55-.94-.16-.94-.05-2.09.11-1.16,4.26-3.03,4.67-4.46.42-1.43,3.42-4.34,3.8-5.23.38-.89,3.42-4.16,4.67-5.7.45-.55.81-.77,1.12-.85.72.4,1.59.96,1.77,1.38.31.74.41,2.57,2.04,2.41,1.63-.16,5.61-2.47,5.88-1.29.27,1.19,2.85,7.69,4.8,9.2,1.95,1.5,3.26,5.18,9.62,5.1,2.71-.03,4.73.03,6.59-.15,1.35,1.85,2.17,5.11,3.67,6.47,1.82,1.65,5.45,4.87,5.78,9.08.33,4.21.82,7.85,3.96,9.99,3.14,2.15,5.37,3.47,6.69,5.12,1.32,1.65,6.39,7.02,7.27,8.84.88,1.81,3.19,4.46,3.85,6,.66,1.54,2.37,5.72.93,6.88-1.43,1.15-4.29,3.47-5.72,3.8s-1.98-.39-.83-1.66c1.16-1.26,2.87-5.45.17-7.98-2.7-2.53-10.62-7.87-12.94-7.32-2.31.55-7.43,7.54-6.19,9.19,1.24,1.66,7.68,11.07,9.25,11.89,1.57.83,2.15,2.71.74,4.54-1.4,1.82-6.03,5.62-10.73,5.62s-10.98-.5-11.4,1.32c-.41,1.82.42,3.06,9.83,5.45,9.41,2.4,12.96,2.48,13.62,3.8.66,1.32,1.16,5.7,3.72,6.11,2.56.41,5.94-.66,7.93,0,1.98.66,2.97,6.27,3.79,7.84.83,1.57,1.82,1.9,3.72,2.07,1.9.16,7.43,1.65,9.16,1.07,1.74-.58,4.05-2.48,1.82-4.29-2.23-1.82-5.37-3.64-6.44-5.29-1.07-1.65-5.45-5.03-6.27-6.19-.83-1.16-4.46-5.2-5.7-5.78-1.24-.58-6.03-2.72-7.43-3.05-1.41-.34-5.54-1.74-3.97-4.22,1.57-2.47,4.96-6.11,8.1-6.77,3.13-.66,6.68-1.57,8.83.66,2.15,2.23,2.31,7.19,4.46,9.33,2.15,2.15,4.79,5.37,7.1,6.36,2.31.99,3.72,1.24,5.12.99,1.4-.24,4.87,4.05,8.01,4.79,3.14.74,7.59,1.41,8.83.83s6.77.41,7.6.91c.82.49-1.24,2.97-.41,4.37.82,1.41,4.95,3.63,4.04,4.79-.91,1.16-2.23,3.88-1.81,5.78.41,1.9,1.12,6.74,1.62,7.79.5,1.05,2.7,3.8,2.64,5.34-.05,1.54-.6,2.59,1.38,3.19,1.98.61,4.22,2.22,5.05,2.09.82-.12,4.83,1.41,5.86,1.12,1.03-.29,3.39.78,3.72,3.09.33,2.32.2,5.5-.54,6.53Z",
  "m799.49,593.19c-2.78,1.62-7.54,3.1-10.82,4.37-.05.02-.1.04-.14.07-2.28,1.43-5.19,4.06-7.97,4.14-3.09-.18-3.91,3.55-6.72,4.4-1.49.44-4.51,3.91-5.89,3.69-5.21,0-11.2,3.04-16.57,4.79-8.13,3.04-27.84,2.81-37-1.28-.56-.25-1.18.22-1.09.83,3.76,26.63-11.12,4.65-21.18,14.58-.08.08-.15.18-.19.29-5.91,15.26-14.12-6.19-12.11,7.04,0,.04.02.08.03.12,11.97,39.82,30.71,13.84,33.68,28.26.07.34.34.6.68.64,1.61.16,3.62.75,3.47-1.15-1.31-11.28,11.52-2.37,29.79-15.1,1.43,0,2.92-3.47,3.14-6.11.22-2.64,4.13-4.9,7.6-2.92,5.07,3.57,7.43-1.74,11.84.06,8.75.41-7.28-11.02-6.17-14.37.22-2.2,1.43-7.6,5.12-8.09,3.69-.5,3.03-.55,3.63-1.6,3.83-6.47,13.84-8.55,18.2-14.49.05-.07.09-.15.11-.23.78-2.47,4.69-2.48,6.13-3.95,1.07-1.18,5.05-2.92,2.42-4.02Z",
  "m193.73,190.21c-1.57,1.45-3.02,3.72-3.45,4.36-.43.64.12,4.58.21,5.28.08.7-.36,9.34-.36,9.34l.33,5.47c-1.34-.09-3.35.41-6.85.12-4.04-.34-3.38,2.64-3.38,5.11s-.91,8.26-1.66,8.43c-.74.16-3.22-2.48-4.04-1.24-.83,1.24-3.39,2.47-6.44,2.97-3.06.5-5.53,0-7.02.08-1.49.09-2.81-.49-4.54-1.32-1.74-.82-5.62-1.57-6.94-.74-1.32.82-2.06,1.82-3.38.82-1.32-.99-2.23-1.81-3.14-.82-.91.99-.99.91-3.72,1.98-2.72,1.07-3.71,2.81-4.04,4.62-.33,1.82-2.81,3.31-4.21,4.79-1.41,1.49-2.15,3.8-2.73,4.21-.15.11-.37.16-.65.18-.78.06-2.07-.06-3.89.48-2.48.75-2.72,1.66-4.79,2.48-2.06.83-4.95-2.15-8.5-1.98-3.55.17-5.53,2.48-7.52,2.81-.62.11-1.4.21-2.19.31-1.75.23-3.58.45-3.92.68-.27.18-3.14.14-5.69.06-2.26-4.12-6.95-3.62-9.45-2.73-2.56.91-3.8-.33-3.82-1.9-.03-1.57-2.89-10.4-4.38-10.46-1.49-.05-2.51-2.67-3.28-3.82-.77-1.16-5.28-8.98-3.02-13.11,2.25-4.12.99-6.66-1.76-9.68-2.76-3.03-1.88-5.73.33-5.89,2.2-.17,2.53-1.74,2.69-3.18.17-1.45-2.27-7.52-1.48-8.67.13-.2.29-.51.45-.9.81-1.88,1.87-5.56,1.94-6.62.06-.85.53-1.34,1.3-1.4.37-.04.81.03,1.3.21,1.49.53,4.09-.69,6.57-2.18,2.47-1.48.55-10.9,2.42-12.55,1.87-1.65,16.13-10.02,18.44-8.75,2.31,1.27,2.64,4.73,4.07,5.78,1.43,1.05,4.02-.55,5.4-4.18,1.37-3.64,6.16-7.44,9.35-6.99,3.2.44,12.22.99,14.92-1.27,2.7-2.26,7.65-4.35,8.48-3.52.82.82,9.03,2.09,10.9,1.59,1.87-.49,6.66-4.24,6.66-4.24l2.62,1.35c-.49.13-1,.18-1.46.21-1.12.08-.87,1.86.04,2.89.58.65,3.58,4.88,6.52,8.34,1.68,1.99,3.34,3.73,4.5,4.39,3.2,1.81,7.27,2.64,9.09,5.23.23.33.49.75.76,1.22,1.86,3.18,4.5,9.01,5.84,10.45,1.54,1.65,2.09,4.24,3.52,5.67,1.44,1.43,4.61,4.79,3.05,6.23Z",
  "m89.57,260.11c1.65,2.22.33,9.02-1.22,10.18-1.54,1.15-2.42,3.03-3.46,4.35-1.05,1.32-2.87-.17-4.79.44-1.93.6-2.97,2.42-3.53,4.29-.33,1.12-.72,3.05-1.04,4.54-.22.99-.4,1.77-.52,1.98-.31.53-2.18,2.23-2.4,3.31-.22,1.07,0,4.13-.6,4.81-.61.69-.44,2.67-.36,3.47.08.8-1.08,3.77-2.18,3.88-1.1.11-3.63,1.54-4.92,1.63-1.3.08-2.89.27-4.21.3-1.32.03-2.37-.22-3.06,1.4-.69,1.63-2.48,3.36-3.49,3.69-1.02.33-.39,1.06-.6,2.17-.2,1.12,1.66,4.34,3.6,7.11,1.94,2.76-1.78,4-2.94,3.79-1.15-.2-3.34-.37-3.05,2.32.29,2.68.21,2.84-.17,3.63-.37.78-1.03,2.27-2.02,2.23-.99-.04-2.39,1.73-2.39,1.73l-4.24-.18c-2.82-2.83-2.6-9.64-2.43-12.42.21-3.39-.47-10.1-8.39-13.96-7.93-3.85-18.5-13.76-23.23-17.06-4.74-3.3-.55-7.49.44-4.96.99,2.54,3.19,4.41,5.39,1.13,2.2-3.27.11-9.49-1.87-11.36-1.98-1.88-6.27-5.51-5.28-8.48.99-2.97,2.97-5.95,3.19-8.04.22-2.09.55-5.17,2.75-7.92,2.2-2.76.66-8.04,0-10.35-.11-.39-.18-.83-.21-1.32-.16-2.4.56-5.68,1.2-7.05.77-1.65.77-7.93-.88-9.69-1.65-1.76-1.32-6.6-.22-8.59,1.1-1.98,2.64-12.22,4.62-17.94,1.99-5.73-3.74-10.02-7.48-11.34-3.74-1.32-3.52-4.4-3.08-7.05.44-2.64,2.31-9.24.77-11.78-1.18-1.95-2.11-4.54-1.87-6.49.07-.59.24-1.11.55-1.55,1.32-1.87,9.19-17.61,11.67-20.03,2.47-2.42,1.98-4.24,4.56-7.49,2.59-3.24,5.62-1.37,5.51.45-.11,1.81-.5,2.31.27,5.72.77,3.41,3.87,2.71,7.09,1.97,3.22-.75,2.31-.54,6.28-3.39.5-.36,1.03-.52,1.57-.49,3.68.12,7.84,8.29,8.62,11.82.91,4.04,2.43,3.41,7.82,5.06.36.11.7.24,1.03.41l.36.18s.06.04.09.05c.14.09.28.17.41.26.12.07.24.16.35.24.17.12.34.26.51.4.16.14.33.28.48.44.14.13.27.26.4.4.11.12.23.25.33.38.11.12.21.24.31.37.6.75,1.14,1.59,1.64,2.49.08.16.17.33.25.49.17.32.33.65.48.99.13.27.25.55.37.83.01.02.02.05.03.07.12.28.23.56.34.85.12.31.24.62.35.93s.22.62.33.93c.12.38.25.76.36,1.14.36,1.16.67,2.29.94,3.35,1.43,5.61,1.76,8.14,1.32,11.33-.2,1.45.21,3.45.72,5.22-.77.06-1.24.55-1.3,1.4-.07,1.06-1.13,4.74-1.94,6.62-.16.39-.32.7-.45.9-.79,1.15,1.65,7.22,1.48,8.67-.16,1.44-.49,3.01-2.69,3.18-2.21.16-3.09,2.86-.33,5.89,2.75,3.02,4.01,5.56,1.76,9.68-2.26,4.13,2.25,11.95,3.02,13.11.77,1.15,1.79,3.77,3.28,3.82.55.02,1.29,1.24,1.99,2.84,1.22,2.74,2.37,6.63,2.39,7.62.02,1.57,1.26,2.81,3.82,1.9,2.5-.89,7.19-1.39,9.45,2.73-2.14-.05-4.05-.14-4.05-.14,0,0,.41,1.15-.41,3.71-.83,2.56,1.15,5.62,2.81,7.85Z",
  "m191.51,89.79c-2.15,2.1-5.17,5.4-6.99,6.83-1.82,1.43-3.69,3.58-4.07,5.45-.39,1.87-1.26,5.22-4.25,4.89s-5.02-.82-5.74-.1c-.72.72-1.16.3-2.15.38-.99.09-1.16,1.08-2.29,1.6-1.12.52-2.45,1.29-2.64,1.76s2.11,4.06,2.64,5.26c.54,1.19.83,1.94-.53,2.64-1.36.7-1.03,4.46-1.53,5.24-.5.79-1.03,4.26.45,5.66,1.49,1.4,4.63,2.93,4.55,4.33-.09,1.41-.25,7.43-1.86,7.43s-3.06,2.07-3.59,3.23c-.32.67-.94,1.01-1.64,1.19l-2.62-1.35s-4.79,3.75-6.66,4.24c-1.87.5-10.08-.77-10.9-1.59-.83-.83-5.78,1.26-8.48,3.52-2.7,2.26-11.72,1.71-14.92,1.27-3.19-.45-7.98,3.35-9.35,6.99-1.38,3.63-3.97,5.23-5.4,4.18-1.43-1.05-1.76-4.51-4.07-5.78-2.31-1.27-16.57,7.1-18.44,8.75-.06.05-.11.11-.16.18-.02.03-.04.06-.06.09-.36.55-.54,1.48-.64,2.61-.01.16-.02.32-.03.49-.1,1.7-.06,3.74-.21,5.48-.01.17-.02.33-.04.48-.04.3-.08.59-.13.87-.04.26-.1.52-.16.75-.01.05-.02.09-.04.13-.06.21-.14.4-.22.57-.03.09-.08.17-.13.24-.15.29-.36.51-.6.66-2.48,1.49-5.08,2.71-6.57,2.18-.49-.18-.93-.25-1.3-.21-.51-1.77-.92-3.77-.72-5.22.44-3.19.11-5.72-1.32-11.33-.27-1.06-.58-2.19-.94-3.35-.11-.38-.24-.76-.36-1.14-.11-.31-.22-.62-.33-.93s-.23-.62-.35-.93c-.11-.29-.22-.57-.34-.85-.01-.02-.02-.05-.03-.07-.12-.28-.24-.56-.37-.83-.15-.34-.31-.67-.48-.99-.08-.17-.17-.33-.25-.49-.5-.9-1.04-1.74-1.64-2.49-.1-.13-.2-.25-.31-.37-.1-.13-.22-.26-.33-.38-.13-.14-.26-.27-.4-.4-.15-.16-.32-.3-.48-.44-.17-.14-.34-.28-.51-.4-.11-.08-.23-.17-.35-.24-.13-.09-.27-.18-.41-.26-.03-.01-.06-.03-.09-.05-.12-.06-.24-.13-.36-.18-.33-.17-.67-.3-1.03-.41-5.39-1.65-6.91-1.02-7.82-5.06-.78-3.53-4.94-11.7-8.62-11.82.99-3.35,2.5-7.24,1.25-8.88-1.76-2.31-3.09-5.39-1.43-6.16,1.65-.77,5.83.88,8.69,1.21,2.87.33,1.88-2.32,2.54-3.97.66-1.65,4.51-1.9,4.51-1.9,0,0-.33-1.89-.83-4.21-.49-2.31-3.3-2.47-5.36-3.79-2.07-1.33-4.96-2.65-6.61-2.81-1.65-.17-2.81-1.57-4.29-3.47-1.49-1.9-1.32-4.71-5.04-5.04-3.71-.33-3.55.09-4.79-1.4-1.24-1.49-4.21-1.82-7.18-2.73-2.97-.9-3.3-3.71-5.7-5.2-2.39-1.48-3.22-3.8-3.71-5.53-.5-1.73-2.84-5.09-7.13-7.62-2.47-1.46-5.2-4.08-6.94-6.55v-6.01c2.81-.75,8.33-.1,12.44-.43,5.51-.44-.99-13.1-5.94-16.74-4.96-3.63-8.37-13.98-2.76-11.23,5.62,2.76,11.12.77,13.66-.88,2.53-1.65-1.66-6.05-4.85-8.36C10.24,17.68.88,1.83.88,1.83h176.15l.46,8.57c-.43-.06-.88-.09-1.32-.06-1.28.08-2.51.61-3.04,2.06-1.08,2.97,1.07,7.18-.67,8.17-1.73.99-3.46.66-4.04,2.32-.58,1.65-2.31,1.48-4.38,1.98-2.06.49-3.13,6.77-3.13,8.17s-2.07,6.36-.58,10.24c1.48,3.88,4.87,6.19,5.03,9.41.17,3.22,1.08,10.74,3.72,12.39,2.64,1.65,12.96,6.44,14.28,9.16,1.32,2.73,2.07,6.86,5.45,8.26,3.39,1.4,4.85,5.2,2.7,7.29Z",
  "m58.46,112s-3.85.25-4.51,1.9c-.66,1.65.33,4.3-2.54,3.97-2.86-.33-7.04-1.98-8.69-1.21-1.66.77-.33,3.85,1.43,6.16,1.25,1.64-.26,5.53-1.25,8.88-.54-.03-1.07.13-1.57.49-3.97,2.85-3.06,2.64-6.28,3.39-3.22.74-6.32,1.44-7.09-1.97-.77-3.41-.38-3.91-.27-5.72.11-1.82-2.92-3.69-5.51-.45-2.58,3.25-2.09,5.07-4.56,7.49-2.48,2.42-10.35,18.16-11.67,20.03-.31.44-.48.96-.55,1.55H.88V63.65c1.74,2.47,4.47,5.09,6.94,6.55,4.29,2.53,6.63,5.89,7.13,7.62.49,1.73,1.32,4.05,3.71,5.53,2.4,1.49,2.73,4.3,5.7,5.2,2.97.91,5.94,1.24,7.18,2.73,1.24,1.49,1.08,1.07,4.79,1.4,3.72.33,3.55,3.14,5.04,5.04,1.48,1.9,2.64,3.3,4.29,3.47,1.65.16,4.54,1.48,6.61,2.81,2.06,1.32,4.87,1.48,5.36,3.79.5,2.32.83,4.21.83,4.21Z",
  "m18.28,28.36c-2.54,1.65-8.04,3.64-13.66.88-5.61-2.75-2.2,7.6,2.76,11.23,4.95,3.64,11.45,16.3,5.94,16.74-4.11.33-9.63-.32-12.44.43V1.83s9.36,15.85,12.55,18.17c3.19,2.31,7.38,6.71,4.85,8.36Z",
  "m488.64,37.36c-.85,1.74-2.2,4.74-3.6,7.55.06-.32.1-.47.1-.47,0,0-11.79.08-14.6-.33-2.81-.42-12.97-3.64-15.03-6.11-2.06-2.48-3.47-6.28-3.8-8.51-.33-2.23-1.15-4.13-2.06-3.96-.91.16-1.82,1.81-4.05,2.64-2.23.83-5.45,1.24-6.69.16-1.23-1.07-1.23-4.37-2.64-5.44-1.4-1.08-1.57,1.32-3.05,1.32s-10.16,1.15-11.07.16c-.91-.99-2.89-2.97-4.13-4.46-1.23-1.48-2.39-2.89-4.12-3.13-1.74-.25-6.03-1.08-8.51-1.41-2.48-.33-8.59,1.32-10.57,1.9-1.98.58-5.61,2.89-9,3.06-3.38.16-9.49,2.64-13.62,2.39s-17.18,5.28-24.19,12.96c-7.02,7.68-15.86,13.38-20.23,14.62-4.38,1.24-12.8,3.14-16.1-.33-.21-.22-.41-.42-.62-.6-3.08-2.74-5.94-1.79-7.72-1.71-1.9.08-10.88-1.9-12.86-1.3-1.98.61-5.67,2.81-7.59,2.04-1.93-.77-6.66-5.4-9.36-5.4s-5.95,2.92-9.91,4.24c-3.96,1.32-15.03-.22-20.86-2.47-5.84-2.26-8.86-3.69-10.52-4.19-1.65-.49-7.92,1.13-10.73-.85-2.81-1.98-9-2.4-11.64-2.73s-8.59,2.48-10.57,2.73-9.17-.74-11.64-1.98c-2.48-1.24-4.79-4.87-2.07-6.94,2.73-2.06,4.3-5.7,6.69-6.44,2.4-.74,3.22-3.3,2.15-4.54-1.08-1.24-3.8.25-5.04-1.4-1.24-1.65-8.5-6.77-9.82-7.43-.45-.23-1.22-.48-2.08-.6l-.46-8.57h312.66s-.19,16.62,0,17.7c.19,1.07.6,14.45-1.05,17.83Z",
  "m1608.44,284.33c-3.14,0-12.05,1.81-15.03-.66-2.47,1.48-.82,4.95-4.46,5.11-3.63.17-16.67,6.94-17.66,9.91-1,2.98-1.82,14.48-1.49,17.78.33,3.31-1.1,11.78-3.3,14.09-2.21,2.32-3.86,9.14-2.98,12.55.88,3.42,5.07,6.94,5.62,7.82.55.88,0,3.14-2.53,2.37-2.54-.77-5.18-.9-5.18.16s-.8,11.62-2.53,12.2c-1.73.57-5.2,2.06-9.25-4.38-4.04-6.44-5.2,15.19-5.53,17.5-.28,1.96,1.13,25.71,1.88,36.49-.49-2.2-3.4-3.99-5.88-2.16-2.68,1.98-6.49,4.74-8.35,2.45-1.87-2.3-4.85-7.74-6.25-9.47-1.4-1.74-2.73-4.3-2.89-5.37-.17-1.07-2.31.33-3.3.58s-1.65.91-3.22-.58-3.47-3.88-3.55-5.45c-.09-1.57-9.33-5.94-10.32-8.92-1-2.97,1.2-5.36,3.38-6.69,2.19-1.32,8.75-.99,9.83-2.14,1.07-1.16,4.12-6.19.99-8.84-3.14-2.64-6.75-4.92-7.57-7.95-.83-3.03-.55-4.07,0-4.68.55-.61,6.11-3.8,7.48-4.13,1.38-.33,4.46-.93,2.26-3.74-2.2-2.81-13.9-16.78-13.9-16.78,0,0-5.91-3.18-7.5-1.98-1.58,1.2-6.71,5.33-9.84,5.33s-13.46,7.92-16.26,10.9c-2.81,2.97-2.32,3.79-7.43,6.6-5.12,2.81-4.79,2.97-7.93,6.61-3.14,3.63-5.45,8.09-8.26,8.25-2.81.17-8.32,1.49-9.61,4.46-1.29,2.98-6.13,7.92-8,8.7l-5.43,2.25c-.13-.47-1.68-6.33-.57-8.39,1.15-2.14-4.38-8.75-4.38-10.81s2.07-10.57-.33-12.55c-2.39-1.99-2.31-3.72-2.39-5.12-.09-1.41,1.47-.75,3.05-1.32,1.57-.58,3.96-4.38,5.04-5.78,1.07-1.41-6.25-8.6-18-4.05,0,0-5.4-3.77-6.83-6.08-1.43-2.31-7.37-6.61-9.47-7.6-2.09-.99-5.17-4.4-5.17-7.38s-4.18-2.42-6.49-4.07c-.96-.69-1.24-1.58-.87-2.34.53-1.08,2.35-1.9,5.38-1.51,5.17.66,9.25-1.1,9.91-5.73.66-4.62,2.86-10.35-2.87-12.66-5.72-2.31-10.12-4.18-11.67-4.62-1.54-.44-.55-3.41-3.41-4.29-2.86-.89-7.81-4.41-8.59-9.03-.77-4.63-5.5-8.7-3.3-10.24,2.2-1.54,8.26-4.29,9.8-6.06,1.54-1.76,3.08-5.06.33-6.82-2.75-1.76-21.37-10.68-26.53-11.56,0,0,.33-1.27,2.31-2.48,1.98-1.21,4.18-.38,4.62-1.43s-3.46-6.82-6.77-9.8c-1.27-1.15-2.39-1.46-3.44-1.41,3.96-3.88,9.69-9.45,10.43-10.09,1.16-.99,4.85-3.3,6.33-2.97,1.49.33,4.63,2.97,5.56,2.47.94-.49,1.77-1.7,3.2-.77,1.42.94,4.51,3.75,6.55,4.68,2.03.94,7.46,1.57,7.04,2.31-.42.75-2.06,1.08-.49,4.79,1.57,3.72,8.59,5.04,11.89,5.95,3.3.9,9.66-.33,13.46-.09,3.79.25,7.18,3.47,9.82,5.12,2.64,1.65,4.3,2.07,7.85,1.24,3.55-.82,6.08-6.77,7.62-10.13.95-2.06.44-4.02-2.16-6.48-1.63-1.55-4.09-3.28-7.53-5.35-8.92-5.37-17.83-19.49-17.42-22.05.41-2.56,6.85-4.54,8.67-5.2,1.31-.48,2.45-2.5,3.04-3.96.74.14,1.24.29,1.41.44,1.32,1.21.33,4.51,3.53,3.63,3.19-.88,6.6-2.38,7.59-2.84s1.43,6.69,4.52,8.79c3.08,2.09,5.83,4.18,7.04,6.05,1.21,1.87.11,6.94,2.09,6.61,1.99-.33,4.52-1.95,6.28.01,1.76,1.97,4.07,18.04,11.23,18.92,7.15.88,9.47,3.42,10.13,4.52s2.75-.99,4.95-1.21c2.2-.23,5.62,3.08,7.05,2.53,1.43-.55,3.74-1.54,5.06-1.43,1.32.11.99-5.4,1.43-6.39s3.31.55,3.53-2.31c.22-2.86,3.08-4.29,3.52-6.28.44-1.98,2.42-3.41,3.41-4.29s12.55-.55,16.4-8.04c3.3-6.4,7.24-14.01,8.32-16.08.17-.35.27-.54.27-.54l2.56,2.62,2.29,2.33s21.85,24.77,24,34.85c2.14,10.07,3.3,19.32,6.44,22.13,3.13,2.8,9.74,9.08,12.05,11.23,2.31,2.14.66,9.08,4.29,11.06,3.64,1.98,18.83,2.31,22.96,3.8,4.13,1.48,11.39,4.29,17.34,12.71,5.94,8.43-5.78,2.65-8.92,2.65Z",
  "m1525.16,181.49c-1.08,2.07-5.02,9.68-8.32,16.08-3.85,7.49-15.41,7.16-16.4,8.04s-2.97,2.31-3.41,4.29c-.44,1.99-3.3,3.42-3.52,6.28-.22,2.86-3.09,1.32-3.53,2.31s-.11,6.5-1.43,6.39c-1.32-.11-3.63.88-5.06,1.43-1.43.55-4.85-2.76-7.05-2.53-2.2.22-4.29,2.31-4.95,1.21s-2.98-3.64-10.13-4.52c-7.16-.88-9.47-16.95-11.23-18.92-1.76-1.96-4.29-.34-6.28-.01-1.98.33-.88-4.74-2.09-6.61-1.21-1.87-3.96-3.96-7.04-6.05-3.09-2.1-3.53-9.25-4.52-8.79s-4.4,1.96-7.59,2.84c-3.2.88-2.21-2.42-3.53-3.63-.17-.15-.67-.3-1.41-.44.24-.57.39-1.05.43-1.32.15-.99-1.32-3.31-2.15-4.05-.82-.74-1.57-1.49-3.47-1.65-1.9-.17-2.31-1.4-3.13-2.73-.83-1.32-2.81-.66-5.04-.66s-2.89-.16-3.81-1.32c-.9-1.15-4.7-.66-6.26-.91-1.57-.24-1.08-3.22-1.99-4.54-.9-1.32-6.11-.99-7.59-1.48-1.49-.5-4.13-3.31-7.02-5.29-2.89-1.98-.25-6.85,2.89-6.44,3.14.42,2.06-5.53,2.39-7.92.33-2.4,2.56-6.28-2.39-7.44-4.96-1.15-7.35-2.09-12.3-1.76-4.96.33-5.4.66-6.94-1.43-1.54-2.09-3.85-3.3-6.94-7.48-3.08-4.19-4.85-3.31-7.15-2.43-2.31.88-2.42-1.54-4.52-2.2-2.09-.66-4.73,1.21-5.61,3.74-.88,2.54-1.87,5.18-4.73,2.43-2.87-2.76-3.2-8.48-9.47-8.37-6.28.11-11.34,6.17-12.12,7.49-.76,1.32-4.62,4.18-6.82,3.85-2.2-.33-11.23,1.1-14.53,2.09-3.3.99-5.61,5.29-9.91,5.62-4.29.33-7.37-2.32-8.7-4.08-1.32-1.76-.66-3.41,4.08-7.26,4.73-3.86,1.37-10.35-2.42-12.5-3.8-2.15-7.77-4.95-11.07-4.46-3.3.5-8.25-3.3-11.89-4.95-3.63-1.65-7.59-3.97-9.08-7.76-1.49-3.8-3.47-6.28-10.41-7.76-6.93-1.49-3.96-.17-7.92,1.65-3.96,1.81-9.41-3.64-10.84-4.96-1.44-1.32-3.97-2.64-5.74-1.54-1.75,1.1-6.04.99-8.36,1.32-2.31.33-6.39.88-7.59,1.21-1.21.33-4.74-1.21-7.38-1.98-2.64-.77-2.53.22-3.63.99-1.1.77-2.42.33-3.86-.33-1.43-.66-4.18-.11-6.49-.11s-3.19-2.53-5.28-3.19c-2.1-.66-3.97-2.75-4.74-4.51-.77-1.77-2.97-3.2-4.73-2.21s-3.97.22-5.19-.55c-1.2-.77-4.5-2.2-6.04-2.31-1.54-.11-3.3.88-4.52-.33-1.21-1.21-3.41-1.65-5.94-2.09-2.53-.44-1.87-3.08-3.3-3.85-1.43-.77-4.96-.99-6.5-2.21-1.54-1.21-5.06-3.41-6.49-2.75-1.44.66-4.85,2.31-6.61,1.98-1.76-.33-2.86-1.87-5.39-1.76-2.54.11-5.21-1.9-6.91-2.31-1.71-.41-7.85.61-9,1.73-1.11,1.08-4.26,10.24-4.17,12.8-10.45-3.99-17.78-13.07-21.05-16.79-3.63-4.12-23.78-25.43-28.07-29.23-4.3-3.79-22.74-22.73-22.74-22.73h440.21s2.97,7.54,4.12,11.34c1.16,3.8,5.45,13.05,6.44,15.03,1,1.98,5.45,19.32,7.44,14.86,1.98-4.46,11.68-6.11,11.68-6.11,0,0-3.76,6.11-5.41,10.4-1.65,4.3-4.29,15.69-5.61,19.43-1.33,3.75,1.32,13.44,1.1,17.18-.22,3.74-1.76,14.97.66,18.93,2.42,3.97,7.26,5.51,9.26,9.69,2,4.19-1.56,9.47,1.31,12.77,2.86,3.31,11.56,15.31,16.07,18.85,4.51,3.55,11.12,20.13,14.09,25.52,2.05,3.73,8.5,8.93,12.28,11.77Z",
  "m1519.11,1030.97h-38.9c-1.5-1.54-3.86-3.98-4.62-4.85-1.16-1.32-1.57-13.04-1.57-13.04,0,0-3.39-5.86-4.96-7.93-1.56-2.06-6.19-1.4-6.19-1.4l-36.31-5.37c2.86-3.59,7.85-9.88,8.16-10.51.22-.45,1.94-2.9,3.56-5.19,1.57-2.21,3.05-4.28,3.05-4.28l7.04-14.31s5.95-14.76,7.71-16.96,10.79-9.47,21.8-6.38c8.97,2.51,14.8,5.67,18.19,6.16,3.17,19.63,6.88,20.24,7.84,22.65.99,2.48.41,2.81-4.46,1.24-4.87-1.57-11.48,5.53-14.28,8.59-2.81,3.05,1.4,4.46,4.21,5.04,2.8.57,8.5-.66,10.81,1.15,2.32,1.82,2.65,9.58,2.65,10.9s1.23,7.6,2.31,9.17c1.07,1.57,4.7,5.12,5.61,6.44s.83,5.61.83,5.61c0,0,3.8,2.89,4.54,5.29.56,1.81,2.21,6.03,2.98,7.98Z",
  "m1501.01,949.21c-1.06.86-1.46,2.3-.96,3.56,1.64,4.16,5.37,13.56,5.76,14.07.5.66,1.73.91,3.55,0,1.82-.91,6.69-5.61,5.12-8.92-1.57-3.3-6.03-9.5-6.03-9.5,0,0-2.54-3.21-7.44.78Z",
  "m1480.21,1030.97h-670.4c-.02-1.43-.04-3.64.03-4.85.11-1.87,2.09-15.74,2.31-20.14.22-4.41,5.61-23.29,5.61-23.29l57.3,10.41,21.97-18.83,14.86-22.62,38.15-7.76,8.91-20.81,16.02-9.25-51.08-60,102.94-30.33,17.17-15.17,1.88,5.23-5.7,3.47,12.47,2.5,49.79,9.97,88.43,51.19,136.84,114.88,86.97,7.71,9.91-2.42s.81-1.02,1.97-2.48l36.31,5.37s4.63-.66,6.19,1.4c1.57,2.07,4.96,7.93,4.96,7.93,0,0,.41,11.72,1.57,13.04.76.87,3.12,3.31,4.62,4.85Z",
  "m903.74,690.54c-1.86,1.98-4.34,5.03-4.5,6.19-.17,1.16-2.59,2.81-4.02,2.15-1.43-.66-2.31,2.58-3.86,3.79-1.54,1.22-5.83,4.24-2.09,6,3.75,1.77,5.4,3.91,2.53,3.58-2.86-.33-7.83-1.24-9.61-.41-1.78.82-6.07,1.82-7.97,4.21-1.9,2.39-6.69,8.42-2.89,9.66,1.83.6,3.2,1.56,3.88,2.44.75.95.7,1.81-.42,2.02-2.14.41-3.96.08-4.34,1.9-.16.75-.18,1.36-.25,1.89-6.51,2.96-13.91,9.66-17.59,10.27-4.46.75-4.88,8.26-6.61,11.4-1.73,3.14-10.07.16-10.98-.74-.91-.91-9.66-.58-9.66-.58.82-.5,1.56-1.21,2.22-2.03h0s.01-.02.01-.02c2.38-2.97,3.76-7.48,4.53-9.68.99-2.8,8.59-20.14,11.23-25.92,2.64-5.78,9-16.19,9.49-18.33.5-2.15,1.16-15.86,2.89-19,1.74-3.13,10.82-9.99,14.37-12.55,1.53-1.1,1.65-3.39,1.29-5.64,1.58.01,11.5.22,12.39.03.91-.19,3.97-1.29,5.54-1.16,1.57.14,4.87,1.35,6.08,2.15,1.21.8-.36,3.3-2.01,4.27-1.65.96-3.47,2.89-1.71,3,1.77.11,4.7-.24,4.76.26.06.49.64,2.78,1.4,3.14.77.35,4.98,2.18,4.15,3.67-.82,1.49-.49,2.56.11,3.39.59.82,1.13,1.4,1.5,2.31.37.91.54,4.17.83,6.11.29,1.94,1.15.24-.7,2.23Z",
  "m1026.83,823.5l-102.94,30.33,51.08,60-16.02,9.25-8.91,20.81-38.15,7.76-14.86,22.62-21.97,18.83-57.3-10.41s1.32-11.28-.55-10.51c-1.52.63-2.97,2.12-3.46,2.66-.06.08-.12.15-.17.2,0,0-12.66-48-13.76-50.42-1.1-2.42-3.75-3.63-3.75-5.62s-.33-4.62-1.54-5.72c-1.21-1.1-1.1-6.83-1.1-6.83,0,0-12.55-34.56-14.53-41.5,20.81-12.44,31.43-53.84,32.17-55.4.75-1.57.99-10.57,1.57-12.55.58-1.99,2.81-10.82,3.72-18.42.91-7.59,3.71-5.12,5.61-5.12s1.79-13.48,1.63-16.13c-.16-2.56,3.74-4.91,3.98-5.05-.66.82-1.4,1.53-2.22,2.03,0,0,8.75-.33,9.66.58.91.9,9.25,3.88,10.98.74,1.73-3.14,2.15-10.65,6.61-11.4,3.68-.61,11.08-7.31,17.59-10.27-.08.77-.26,1.36-1.07,1.91-1.38.93-3.64,2.47-4.3,2.97-.66.49-1.43,2.86-1.76,3.25-.33.38.33,2.03,1.32,4.18.99,2.15,2.4,6.77,1.74,8.01-.67,1.24-.58,4.62,0,6.69.57,2.06,1.81,4.04,1.48,5.86-.33,1.82-3.55,8.26-4.29,9.25-.75.99-.91,4.29,2.06,5.2,2.97.91,5.12,1.49,6.33,2.92,1.21,1.43,2.97,10.02,5.29,9.85,2.31-.16,4.68-.66,5.94-.44,1.27.22,6.33,4.4,7.54,5.45,1.21,1.05,3.2,4.51,5.34,4.4,2.15-.11,18.72,3.75,20.2,3.47.99-.18,61.51-38.92,102.86-65.37l15.64,54.13-5.57.78,2.95,10.47,10.67-2.6,1.43,3.99-17.17,15.17Z",
  "m813.58,975.04c-1.32,1.32-4.9,5.34-9.85,16.24-4.96,10.9-4.63,27.08-4.96,31.29-.23,2.93-2.57,6.5-3.96,8.4h-66.64c-2.03-3.06-2.07-10.43-1.81-13.02.33-3.3-.74-10.98-2.73-14.95-1.98-3.96-15.85-16.92-18.41-20.22-2.56-3.31-6.03-17.34-6.6-22.22-.58-4.87-3.97-13.62-7.85-11.14-3.88,2.47-5.04,8.01-8.09,15.11-3.06,7.1,3.14,11.64,6.61,14.45,3.46,2.8,6.68,12.71,7.43,16.26.74,3.55-1.57,7.02-1.08,13.05.5,6.03,6.2,7.93,9.5,11.97,2.46,3.02,4.19,8.25,4.91,10.71h-411.1c.01-2.38.01-7.63.01-13.62,0-9.59.02-21.06,0-25.64,0-1.08,0-1.77-.01-1.97-.05-1.76-4.26-10.93-5.91-14.23-1.65-3.3,1.57-7.6.99-9.41-.58-1.82-4.21-10.99-4.3-12.22-.08-1.24-.82-8.59-2.89-13.63-2.06-5.03-2.31-7.18-1.89-9.58.41-2.39,5.45-9.41,8.25-12.05,2.81-2.64,3.39-8.09,4.3-10.4.9-2.32,2.06-10.9,1.98-12.89-.08-1.98-6.69-18.08-7.35-20.47-.66-2.4.82-9.25.25-12.47-.58-3.22,3.3-6.19,6.52-8.17,3.22-1.99,5.94-9.09,5.94-9.09.08.22.17.44.26.65h0c5.71,13.6,26.96,4.6,35.41,2.33,8.59-2.32,36,4.29,48.89,7.59,12.88,3.3,48.22,19.49,72.66,22.79,24.44,3.3,42.93,17.84,55.81,18.5,12.88.66,39.86-22.79,55.05-32.04,15.19-9.25,43.59-18.06,53.28-13.65,9.69,4.4,21.36,4.62,27.97,3.52,6.6-1.1,10.78,2.64,12.55,8.71,1.76,6.07,17.61,11.55,23.12,14.63,5.5,3.08,15.85,4.4,20.91,2.64,5.07-1.76,8.37-5.72,9.91-5.72s2.2,5.72,2.2,5.72c0,0,11.45-2.64,23.78-3.3,12.33-.66,32.26-12.55,32.26-12.55,1.98,6.94,14.53,41.5,14.53,41.5,0,0-.11,5.73,1.1,6.83,1.21,1.1,1.54,3.74,1.54,5.72s2.65,3.2,3.75,5.62c1.1,2.42,13.76,50.42,13.76,50.42Z",
  "m305.1,845.78c-.09-.21-.18-.43-.26-.65,0,0-2.72,7.1-5.94,9.09-3.22,1.98-7.1,4.95-6.52,8.17.57,3.22-.91,10.07-.25,12.47.66,2.39,7.27,18.49,7.35,20.47.08,1.99-1.08,10.57-1.98,12.89-.91,2.31-1.49,7.76-4.3,10.4-2.8,2.64-7.84,9.66-8.25,12.05-.42,2.4-.17,4.55,1.89,9.58,2.07,5.04,2.81,12.39,2.89,13.63.09,1.23,3.72,10.4,4.3,12.22.58,1.81-2.64,6.11-.99,9.41,1.65,3.3,5.86,12.47,5.91,14.23.01.2.01.89.01,1.97,0,1.14,0,2.72,0,4.59.01,5.61.01,13.86,0,21.05,0,5.99,0,11.24-.01,13.62H.88v-103.27s23.34-8.37,31.6-18.82c8.25-10.46,17.94-23.34,16.51-30.28-1.43-6.93-9.91-22.24-10.35-28.18-.44-5.95-6.05-37.65,20.81-53.29,26.86-15.63,35.67-19.48,37.32-20.47,1.65-.99,13.54-.33,15.63-.99,2.1-.67,9.91-8.81,13.22-9.69,3.3-.88,12.22,3.19,14.86,2.31,2.64-.88,8.36-2.97,10.46-1.21,2.09,1.76,4.84,2.64,8.03,2.31,3.2-.33,7.05,4.07,10.57,4.73,3.52.66,18.39,9.36,23.34,8.81,4.96-.55,9.36,6.17,8.26,10.57-1.1,4.4-2.97,8.04,4.84,13.65,7.82,5.62,15.42,6.83,18.72,5.95,3.3-.88,17.72,2.31,22.13,5.94,4.4,3.63,11.56,5.18,17.28,5.07,5.73-.11,12.99,1.54,18.17-.44,5.17-1.99,22.73-.55,22.82,22.11Z"
 ]
}